//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.15.10.0 (NJsonSchema v10.6.10.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

import { mergeMap as _observableMergeMap, catchError as _observableCatch } from 'rxjs/operators';
import { Observable, throwError as _observableThrow, of as _observableOf } from 'rxjs';
import { Injectable, Inject, Optional, InjectionToken } from '@angular/core';
import { HttpClient, HttpHeaders, HttpResponse, HttpResponseBase } from '@angular/common/http';

export const API_BASE_URL = new InjectionToken<string>('API_BASE_URL');

export interface IAuditEntityClient {
    getAuditHistory(entityId: number | undefined): Observable<AuditModel[]>;
    getAuditsHistory(entityId: number): Observable<AuditsModel[]>;
}

@Injectable({
    providedIn: 'root'
})
export class AuditEntityClient implements IAuditEntityClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    getAuditHistory(entityId: number | undefined): Observable<AuditModel[]> {
        let url_ = this.baseUrl + "/api/AuditEntity/GetAuditHistory?";
        if (entityId === null)
            throw new Error("The parameter 'entityId' cannot be null.");
        else if (entityId !== undefined)
            url_ += "entityId=" + encodeURIComponent("" + entityId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAuditHistory(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAuditHistory(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AuditModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AuditModel[]>;
        }));
    }

    protected processGetAuditHistory(response: HttpResponseBase): Observable<AuditModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AuditModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<AuditModel[]>(null as any);
    }

    getAuditsHistory(entityId: number): Observable<AuditsModel[]> {
        let url_ = this.baseUrl + "/api/AuditEntity/GetAuditsHistory/{entityId}";
        if (entityId === undefined || entityId === null)
            throw new Error("The parameter 'entityId' must be defined.");
        url_ = url_.replace("{entityId}", encodeURIComponent("" + entityId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAuditsHistory(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAuditsHistory(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AuditsModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AuditsModel[]>;
        }));
    }

    protected processGetAuditsHistory(response: HttpResponseBase): Observable<AuditsModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AuditsModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<AuditsModel[]>(null as any);
    }
}

export interface IBmwChatsClient {
    addBmwChatHistoryByTourId(tourId: number, message: string | null | undefined, isBmwRole: boolean | undefined): Observable<BmwChatHistoryModel>;
    getBmwChatHistoryByTourId(tourId: number, amcoId: number | undefined): Observable<BmwChatHistoryModel[]>;
}

@Injectable({
    providedIn: 'root'
})
export class BmwChatsClient implements IBmwChatsClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    addBmwChatHistoryByTourId(tourId: number, message: string | null | undefined, isBmwRole: boolean | undefined): Observable<BmwChatHistoryModel> {
        let url_ = this.baseUrl + "/api/BmwChats/AddBmwChatHistoryByTourId/{tourId}?";
        if (tourId === undefined || tourId === null)
            throw new Error("The parameter 'tourId' must be defined.");
        url_ = url_.replace("{tourId}", encodeURIComponent("" + tourId));
        if (message !== undefined && message !== null)
            url_ += "message=" + encodeURIComponent("" + message) + "&";
        if (isBmwRole === null)
            throw new Error("The parameter 'isBmwRole' cannot be null.");
        else if (isBmwRole !== undefined)
            url_ += "isBmwRole=" + encodeURIComponent("" + isBmwRole) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddBmwChatHistoryByTourId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddBmwChatHistoryByTourId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BmwChatHistoryModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BmwChatHistoryModel>;
        }));
    }

    protected processAddBmwChatHistoryByTourId(response: HttpResponseBase): Observable<BmwChatHistoryModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BmwChatHistoryModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<BmwChatHistoryModel>(null as any);
    }

    getBmwChatHistoryByTourId(tourId: number, amcoId: number | undefined): Observable<BmwChatHistoryModel[]> {
        let url_ = this.baseUrl + "/api/BmwChats/GetBmwChatHistoryByTourId/{tourId}?";
        if (tourId === undefined || tourId === null)
            throw new Error("The parameter 'tourId' must be defined.");
        url_ = url_.replace("{tourId}", encodeURIComponent("" + tourId));
        if (amcoId === null)
            throw new Error("The parameter 'amcoId' cannot be null.");
        else if (amcoId !== undefined)
            url_ += "amcoId=" + encodeURIComponent("" + amcoId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetBmwChatHistoryByTourId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetBmwChatHistoryByTourId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BmwChatHistoryModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BmwChatHistoryModel[]>;
        }));
    }

    protected processGetBmwChatHistoryByTourId(response: HttpResponseBase): Observable<BmwChatHistoryModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(BmwChatHistoryModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<BmwChatHistoryModel[]>(null as any);
    }
}

export interface IConnectionTestClient {
    get(): Observable<ConnectionResponseModel>;
}

@Injectable({
    providedIn: 'root'
})
export class ConnectionTestClient implements IConnectionTestClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    get(): Observable<ConnectionResponseModel> {
        let url_ = this.baseUrl + "/api/ConnectionTest";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ConnectionResponseModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ConnectionResponseModel>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<ConnectionResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ConnectionResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ConnectionResponseModel>(null as any);
    }
}

export interface IControlTowerClient {
    getControlTowerTours(): Observable<ControlTowerTourModel[]>;
    getEscalatedTours(): Observable<EscalatedToursModel[]>;
    getControlTowerDashboards(): Observable<DashboardModel[]>;
    markTourResolved(id: number | undefined, tourId: number): Observable<EscalatedToursModel>;
    changeEscalationPriority(id: number | undefined, tourId: number, priority: string | null | undefined): Observable<EscalatedToursModel>;
    escalateTourById(tourId: number, topic: string | null | undefined, message: string | null | undefined, isControlRoom: boolean | undefined, priority: number | undefined): Observable<EscalatedToursModel>;
    getEscalatedHistoryById(tourId: number, linkedTopic: string | null | undefined): Observable<EscalationHistoryModel[]>;
    addEscalationHistoryById(tourId: number, message: string | null | undefined, isControlRoom: boolean | undefined, linkedTopic: string | null | undefined): Observable<EscalationHistoryModel>;
}

@Injectable({
    providedIn: 'root'
})
export class ControlTowerClient implements IControlTowerClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    getControlTowerTours(): Observable<ControlTowerTourModel[]> {
        let url_ = this.baseUrl + "/api/ControlTower/GetControlTowerTours";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetControlTowerTours(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetControlTowerTours(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ControlTowerTourModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ControlTowerTourModel[]>;
        }));
    }

    protected processGetControlTowerTours(response: HttpResponseBase): Observable<ControlTowerTourModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ControlTowerTourModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ControlTowerTourModel[]>(null as any);
    }

    getEscalatedTours(): Observable<EscalatedToursModel[]> {
        let url_ = this.baseUrl + "/api/ControlTower/GetEscalatedTours";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEscalatedTours(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEscalatedTours(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EscalatedToursModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EscalatedToursModel[]>;
        }));
    }

    protected processGetEscalatedTours(response: HttpResponseBase): Observable<EscalatedToursModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(EscalatedToursModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<EscalatedToursModel[]>(null as any);
    }

    getControlTowerDashboards(): Observable<DashboardModel[]> {
        let url_ = this.baseUrl + "/api/ControlTower/GetControlTowerDashboards";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetControlTowerDashboards(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetControlTowerDashboards(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DashboardModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DashboardModel[]>;
        }));
    }

    protected processGetControlTowerDashboards(response: HttpResponseBase): Observable<DashboardModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DashboardModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<DashboardModel[]>(null as any);
    }

    markTourResolved(id: number | undefined, tourId: number): Observable<EscalatedToursModel> {
        let url_ = this.baseUrl + "/api/ControlTower/MarkTourResolved/{tourId}?";
        if (tourId === undefined || tourId === null)
            throw new Error("The parameter 'tourId' must be defined.");
        url_ = url_.replace("{tourId}", encodeURIComponent("" + tourId));
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processMarkTourResolved(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processMarkTourResolved(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EscalatedToursModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EscalatedToursModel>;
        }));
    }

    protected processMarkTourResolved(response: HttpResponseBase): Observable<EscalatedToursModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = EscalatedToursModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<EscalatedToursModel>(null as any);
    }

    changeEscalationPriority(id: number | undefined, tourId: number, priority: string | null | undefined): Observable<EscalatedToursModel> {
        let url_ = this.baseUrl + "/api/ControlTower/ChangeEscalationPriority/{tourId}?";
        if (tourId === undefined || tourId === null)
            throw new Error("The parameter 'tourId' must be defined.");
        url_ = url_.replace("{tourId}", encodeURIComponent("" + tourId));
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        if (priority !== undefined && priority !== null)
            url_ += "priority=" + encodeURIComponent("" + priority) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processChangeEscalationPriority(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processChangeEscalationPriority(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EscalatedToursModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EscalatedToursModel>;
        }));
    }

    protected processChangeEscalationPriority(response: HttpResponseBase): Observable<EscalatedToursModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = EscalatedToursModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<EscalatedToursModel>(null as any);
    }

    escalateTourById(tourId: number, topic: string | null | undefined, message: string | null | undefined, isControlRoom: boolean | undefined, priority: number | undefined): Observable<EscalatedToursModel> {
        let url_ = this.baseUrl + "/api/ControlTower/EscalateTourById/{tourId}?";
        if (tourId === undefined || tourId === null)
            throw new Error("The parameter 'tourId' must be defined.");
        url_ = url_.replace("{tourId}", encodeURIComponent("" + tourId));
        if (topic !== undefined && topic !== null)
            url_ += "topic=" + encodeURIComponent("" + topic) + "&";
        if (message !== undefined && message !== null)
            url_ += "message=" + encodeURIComponent("" + message) + "&";
        if (isControlRoom === null)
            throw new Error("The parameter 'isControlRoom' cannot be null.");
        else if (isControlRoom !== undefined)
            url_ += "isControlRoom=" + encodeURIComponent("" + isControlRoom) + "&";
        if (priority === null)
            throw new Error("The parameter 'priority' cannot be null.");
        else if (priority !== undefined)
            url_ += "priority=" + encodeURIComponent("" + priority) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processEscalateTourById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processEscalateTourById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EscalatedToursModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EscalatedToursModel>;
        }));
    }

    protected processEscalateTourById(response: HttpResponseBase): Observable<EscalatedToursModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = EscalatedToursModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<EscalatedToursModel>(null as any);
    }

    getEscalatedHistoryById(tourId: number, linkedTopic: string | null | undefined): Observable<EscalationHistoryModel[]> {
        let url_ = this.baseUrl + "/api/ControlTower/GetEscalatedHistoryById/{tourId}?";
        if (tourId === undefined || tourId === null)
            throw new Error("The parameter 'tourId' must be defined.");
        url_ = url_.replace("{tourId}", encodeURIComponent("" + tourId));
        if (linkedTopic !== undefined && linkedTopic !== null)
            url_ += "linkedTopic=" + encodeURIComponent("" + linkedTopic) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEscalatedHistoryById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEscalatedHistoryById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EscalationHistoryModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EscalationHistoryModel[]>;
        }));
    }

    protected processGetEscalatedHistoryById(response: HttpResponseBase): Observable<EscalationHistoryModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(EscalationHistoryModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<EscalationHistoryModel[]>(null as any);
    }

    addEscalationHistoryById(tourId: number, message: string | null | undefined, isControlRoom: boolean | undefined, linkedTopic: string | null | undefined): Observable<EscalationHistoryModel> {
        let url_ = this.baseUrl + "/api/ControlTower/AddEscalationHistoryById/{tourId}?";
        if (tourId === undefined || tourId === null)
            throw new Error("The parameter 'tourId' must be defined.");
        url_ = url_.replace("{tourId}", encodeURIComponent("" + tourId));
        if (message !== undefined && message !== null)
            url_ += "message=" + encodeURIComponent("" + message) + "&";
        if (isControlRoom === null)
            throw new Error("The parameter 'isControlRoom' cannot be null.");
        else if (isControlRoom !== undefined)
            url_ += "isControlRoom=" + encodeURIComponent("" + isControlRoom) + "&";
        if (linkedTopic !== undefined && linkedTopic !== null)
            url_ += "linkedTopic=" + encodeURIComponent("" + linkedTopic) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddEscalationHistoryById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddEscalationHistoryById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EscalationHistoryModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EscalationHistoryModel>;
        }));
    }

    protected processAddEscalationHistoryById(response: HttpResponseBase): Observable<EscalationHistoryModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = EscalationHistoryModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<EscalationHistoryModel>(null as any);
    }
}

export interface ICustomerClient {
    getCustomerList(): Observable<CustomerModel[]>;
    linkUserByCustomerNumber(userId: string | undefined, customerId: number[]): Observable<UserCustomerModel>;
    getCustomersByUserId(userId: string | undefined): Observable<UserCustomerModel[]>;
    getCustomerContactPersonById(): Observable<CustomerContactPersonModel[]>;
    addCustomerContactPerson(email: string | null | undefined, tourId: number | undefined): Observable<TourModel>;
    deleteCustomerContactPerson(id: number | undefined): Observable<TourModel>;
    deleteEmailContact(id: number | undefined): Observable<TourModel>;
    editCustomerContactById(tourId: number | undefined, email: TourEmailModel[]): Observable<TourModel>;
    updateCarrierContactEmail(email: string | null | undefined, tourId: number | undefined): Observable<TourModel>;
}

@Injectable({
    providedIn: 'root'
})
export class CustomerClient implements ICustomerClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    getCustomerList(): Observable<CustomerModel[]> {
        let url_ = this.baseUrl + "/api/Customer/GetCustomerList";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCustomerList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCustomerList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CustomerModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CustomerModel[]>;
        }));
    }

    protected processGetCustomerList(response: HttpResponseBase): Observable<CustomerModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CustomerModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CustomerModel[]>(null as any);
    }

    linkUserByCustomerNumber(userId: string | undefined, customerId: number[]): Observable<UserCustomerModel> {
        let url_ = this.baseUrl + "/api/Customer/LinkUserByCustomerNumber?";
        if (userId === null)
            throw new Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "UserId=" + encodeURIComponent("" + userId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(customerId);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processLinkUserByCustomerNumber(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLinkUserByCustomerNumber(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserCustomerModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserCustomerModel>;
        }));
    }

    protected processLinkUserByCustomerNumber(response: HttpResponseBase): Observable<UserCustomerModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserCustomerModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UserCustomerModel>(null as any);
    }

    getCustomersByUserId(userId: string | undefined): Observable<UserCustomerModel[]> {
        let url_ = this.baseUrl + "/api/Customer/GetCustomersByUserId?";
        if (userId === null)
            throw new Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "UserId=" + encodeURIComponent("" + userId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCustomersByUserId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCustomersByUserId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserCustomerModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserCustomerModel[]>;
        }));
    }

    protected processGetCustomersByUserId(response: HttpResponseBase): Observable<UserCustomerModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(UserCustomerModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UserCustomerModel[]>(null as any);
    }

    getCustomerContactPersonById(): Observable<CustomerContactPersonModel[]> {
        let url_ = this.baseUrl + "/api/Customer/GetCustomerContactPerson";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCustomerContactPersonById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCustomerContactPersonById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CustomerContactPersonModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CustomerContactPersonModel[]>;
        }));
    }

    protected processGetCustomerContactPersonById(response: HttpResponseBase): Observable<CustomerContactPersonModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CustomerContactPersonModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CustomerContactPersonModel[]>(null as any);
    }

    addCustomerContactPerson(email: string | null | undefined, tourId: number | undefined): Observable<TourModel> {
        let url_ = this.baseUrl + "/api/Customer/AddCustomerContactPerson?";
        if (email !== undefined && email !== null)
            url_ += "Email=" + encodeURIComponent("" + email) + "&";
        if (tourId === null)
            throw new Error("The parameter 'tourId' cannot be null.");
        else if (tourId !== undefined)
            url_ += "TourId=" + encodeURIComponent("" + tourId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddCustomerContactPerson(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddCustomerContactPerson(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TourModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TourModel>;
        }));
    }

    protected processAddCustomerContactPerson(response: HttpResponseBase): Observable<TourModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TourModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TourModel>(null as any);
    }

    deleteCustomerContactPerson(id: number | undefined): Observable<TourModel> {
        let url_ = this.baseUrl + "/api/Customer/DeleteCustomerContactPersonById?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteCustomerContactPerson(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteCustomerContactPerson(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TourModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TourModel>;
        }));
    }

    protected processDeleteCustomerContactPerson(response: HttpResponseBase): Observable<TourModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TourModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TourModel>(null as any);
    }

    deleteEmailContact(id: number | undefined): Observable<TourModel> {
        let url_ = this.baseUrl + "/api/Customer/DeleteEmailContact?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteEmailContact(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteEmailContact(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TourModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TourModel>;
        }));
    }

    protected processDeleteEmailContact(response: HttpResponseBase): Observable<TourModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TourModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TourModel>(null as any);
    }

    editCustomerContactById(tourId: number | undefined, email: TourEmailModel[]): Observable<TourModel> {
        let url_ = this.baseUrl + "/api/Customer/EditCustomerContactById?";
        if (tourId === null)
            throw new Error("The parameter 'tourId' cannot be null.");
        else if (tourId !== undefined)
            url_ += "TourId=" + encodeURIComponent("" + tourId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(email);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processEditCustomerContactById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processEditCustomerContactById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TourModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TourModel>;
        }));
    }

    protected processEditCustomerContactById(response: HttpResponseBase): Observable<TourModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TourModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TourModel>(null as any);
    }

    updateCarrierContactEmail(email: string | null | undefined, tourId: number | undefined): Observable<TourModel> {
        let url_ = this.baseUrl + "/api/Customer/UpdateCarrierContactEmail?";
        if (email !== undefined && email !== null)
            url_ += "Email=" + encodeURIComponent("" + email) + "&";
        if (tourId === null)
            throw new Error("The parameter 'tourId' cannot be null.");
        else if (tourId !== undefined)
            url_ += "TourId=" + encodeURIComponent("" + tourId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateCarrierContactEmail(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateCarrierContactEmail(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TourModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TourModel>;
        }));
    }

    protected processUpdateCarrierContactEmail(response: HttpResponseBase): Observable<TourModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TourModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TourModel>(null as any);
    }
}

export interface ICustomsClient {
    getCustomsList(): Observable<CustomsModel[]>;
    getCustomsHistory(command: GetCustomsHistoryQuery): Observable<PagedListingResponseOfTourListHistoryModel>;
    updatedCustomsSignalR(query: SendCustomsToUiQuery): Observable<FileResponse>;
    getListOfOpenChats(): Observable<DashboardModel2[]>;
    addCustomsHistoryById(tourId: number, message: string | null | undefined, isCustomsRole: boolean | undefined): Observable<CustomsHistoryModel>;
    getCustomsHistoryById(tourId: number, amcoId: number | undefined): Observable<CustomsHistoryModel[]>;
    markChatResolved(id: number | undefined, tourId: number): Observable<TourModel>;
    updateCustomByTourId(tourId: number, estimatedDateTime: Date | undefined, updateType: number | undefined, note: string | null | undefined): Observable<TourModel>;
    allocateUserByTourId(id: number): Observable<TourModel>;
    getDocumentsByAmcoId(amcoId: number): Observable<DocumentsModel[]>;
    downloadDocument(amcoId: number, fileName: string | null): Observable<DownloadDocumentResult>;
    uploadDocument(): Observable<DocumentsModel[]>;
    getDocumentTypes(amcoId: number | undefined): Observable<FileAuditModel[]>;
    updateDocumentType(amcoId: number, fileName: string | null | undefined, docCat: string | null | undefined): Observable<FileAuditModel>;
    updateDocumentsChecked(amcoId: number): Observable<boolean>;
    updateUncChecked(amcoId: number): Observable<boolean>;
    updateTadClosed(amcoId: number): Observable<boolean>;
}

@Injectable({
    providedIn: 'root'
})
export class CustomsClient implements ICustomsClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    getCustomsList(): Observable<CustomsModel[]> {
        let url_ = this.baseUrl + "/api/Customs/GetCustomsList";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCustomsList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCustomsList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CustomsModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CustomsModel[]>;
        }));
    }

    protected processGetCustomsList(response: HttpResponseBase): Observable<CustomsModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CustomsModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CustomsModel[]>(null as any);
    }

    getCustomsHistory(command: GetCustomsHistoryQuery): Observable<PagedListingResponseOfTourListHistoryModel> {
        let url_ = this.baseUrl + "/api/Customs/GetCustomsHistory";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCustomsHistory(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCustomsHistory(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedListingResponseOfTourListHistoryModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedListingResponseOfTourListHistoryModel>;
        }));
    }

    protected processGetCustomsHistory(response: HttpResponseBase): Observable<PagedListingResponseOfTourListHistoryModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedListingResponseOfTourListHistoryModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedListingResponseOfTourListHistoryModel>(null as any);
    }

    updatedCustomsSignalR(query: SendCustomsToUiQuery): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/Customs/UpdatedCustomsSignalR";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdatedCustomsSignalR(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdatedCustomsSignalR(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processUpdatedCustomsSignalR(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse>(null as any);
    }

    getListOfOpenChats(): Observable<DashboardModel2[]> {
        let url_ = this.baseUrl + "/api/Customs/GetListOfOpenChats";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetListOfOpenChats(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetListOfOpenChats(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DashboardModel2[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DashboardModel2[]>;
        }));
    }

    protected processGetListOfOpenChats(response: HttpResponseBase): Observable<DashboardModel2[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DashboardModel2.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<DashboardModel2[]>(null as any);
    }

    addCustomsHistoryById(tourId: number, message: string | null | undefined, isCustomsRole: boolean | undefined): Observable<CustomsHistoryModel> {
        let url_ = this.baseUrl + "/api/Customs/AddCustomsHistoryById/{tourId}?";
        if (tourId === undefined || tourId === null)
            throw new Error("The parameter 'tourId' must be defined.");
        url_ = url_.replace("{tourId}", encodeURIComponent("" + tourId));
        if (message !== undefined && message !== null)
            url_ += "message=" + encodeURIComponent("" + message) + "&";
        if (isCustomsRole === null)
            throw new Error("The parameter 'isCustomsRole' cannot be null.");
        else if (isCustomsRole !== undefined)
            url_ += "isCustomsRole=" + encodeURIComponent("" + isCustomsRole) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddCustomsHistoryById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddCustomsHistoryById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CustomsHistoryModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CustomsHistoryModel>;
        }));
    }

    protected processAddCustomsHistoryById(response: HttpResponseBase): Observable<CustomsHistoryModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CustomsHistoryModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CustomsHistoryModel>(null as any);
    }

    getCustomsHistoryById(tourId: number, amcoId: number | undefined): Observable<CustomsHistoryModel[]> {
        let url_ = this.baseUrl + "/api/Customs/GetCustomsHistoryById/{tourId}?";
        if (tourId === undefined || tourId === null)
            throw new Error("The parameter 'tourId' must be defined.");
        url_ = url_.replace("{tourId}", encodeURIComponent("" + tourId));
        if (amcoId === null)
            throw new Error("The parameter 'amcoId' cannot be null.");
        else if (amcoId !== undefined)
            url_ += "amcoId=" + encodeURIComponent("" + amcoId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCustomsHistoryById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCustomsHistoryById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CustomsHistoryModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CustomsHistoryModel[]>;
        }));
    }

    protected processGetCustomsHistoryById(response: HttpResponseBase): Observable<CustomsHistoryModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CustomsHistoryModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CustomsHistoryModel[]>(null as any);
    }

    markChatResolved(id: number | undefined, tourId: number): Observable<TourModel> {
        let url_ = this.baseUrl + "/api/Customs/MarkChatResolved/{tourId}?";
        if (tourId === undefined || tourId === null)
            throw new Error("The parameter 'tourId' must be defined.");
        url_ = url_.replace("{tourId}", encodeURIComponent("" + tourId));
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processMarkChatResolved(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processMarkChatResolved(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TourModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TourModel>;
        }));
    }

    protected processMarkChatResolved(response: HttpResponseBase): Observable<TourModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TourModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TourModel>(null as any);
    }

    updateCustomByTourId(tourId: number, estimatedDateTime: Date | undefined, updateType: number | undefined, note: string | null | undefined): Observable<TourModel> {
        let url_ = this.baseUrl + "/api/Customs/UpdateCustomByTourId/{tourId}?";
        if (tourId === undefined || tourId === null)
            throw new Error("The parameter 'tourId' must be defined.");
        url_ = url_.replace("{tourId}", encodeURIComponent("" + tourId));
        if (estimatedDateTime === null)
            throw new Error("The parameter 'estimatedDateTime' cannot be null.");
        else if (estimatedDateTime !== undefined)
            url_ += "estimatedDateTime=" + encodeURIComponent(estimatedDateTime ? "" + estimatedDateTime.toISOString() : "") + "&";
        if (updateType === null)
            throw new Error("The parameter 'updateType' cannot be null.");
        else if (updateType !== undefined)
            url_ += "updateType=" + encodeURIComponent("" + updateType) + "&";
        if (note !== undefined && note !== null)
            url_ += "note=" + encodeURIComponent("" + note) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateCustomByTourId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateCustomByTourId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TourModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TourModel>;
        }));
    }

    protected processUpdateCustomByTourId(response: HttpResponseBase): Observable<TourModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TourModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TourModel>(null as any);
    }

    allocateUserByTourId(id: number): Observable<TourModel> {
        let url_ = this.baseUrl + "/api/Customs/AllocateUserByTourId/{Id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{Id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAllocateUserByTourId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAllocateUserByTourId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TourModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TourModel>;
        }));
    }

    protected processAllocateUserByTourId(response: HttpResponseBase): Observable<TourModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TourModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TourModel>(null as any);
    }

    getDocumentsByAmcoId(amcoId: number): Observable<DocumentsModel[]> {
        let url_ = this.baseUrl + "/api/Customs/GetDocumentsByAmcoId/{amcoId}";
        if (amcoId === undefined || amcoId === null)
            throw new Error("The parameter 'amcoId' must be defined.");
        url_ = url_.replace("{amcoId}", encodeURIComponent("" + amcoId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDocumentsByAmcoId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDocumentsByAmcoId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DocumentsModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DocumentsModel[]>;
        }));
    }

    protected processGetDocumentsByAmcoId(response: HttpResponseBase): Observable<DocumentsModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DocumentsModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<DocumentsModel[]>(null as any);
    }

    downloadDocument(amcoId: number, fileName: string | null): Observable<DownloadDocumentResult> {
        let url_ = this.baseUrl + "/api/Customs/DownloadDocument/{amcoId}/{fileName}";
        if (amcoId === undefined || amcoId === null)
            throw new Error("The parameter 'amcoId' must be defined.");
        url_ = url_.replace("{amcoId}", encodeURIComponent("" + amcoId));
        if (fileName === undefined || fileName === null)
            throw new Error("The parameter 'fileName' must be defined.");
        url_ = url_.replace("{fileName}", encodeURIComponent("" + fileName));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDownloadDocument(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDownloadDocument(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DownloadDocumentResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DownloadDocumentResult>;
        }));
    }

    protected processDownloadDocument(response: HttpResponseBase): Observable<DownloadDocumentResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DownloadDocumentResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<DownloadDocumentResult>(null as any);
    }

    uploadDocument(): Observable<DocumentsModel[]> {
        let url_ = this.baseUrl + "/api/Customs/UploadDocument";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUploadDocument(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUploadDocument(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DocumentsModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DocumentsModel[]>;
        }));
    }

    protected processUploadDocument(response: HttpResponseBase): Observable<DocumentsModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DocumentsModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<DocumentsModel[]>(null as any);
    }

    getDocumentTypes(amcoId: number | undefined): Observable<FileAuditModel[]> {
        let url_ = this.baseUrl + "/api/Customs/GetDocumentTypes?";
        if (amcoId === null)
            throw new Error("The parameter 'amcoId' cannot be null.");
        else if (amcoId !== undefined)
            url_ += "amcoId=" + encodeURIComponent("" + amcoId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDocumentTypes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDocumentTypes(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileAuditModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileAuditModel[]>;
        }));
    }

    protected processGetDocumentTypes(response: HttpResponseBase): Observable<FileAuditModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(FileAuditModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileAuditModel[]>(null as any);
    }

    updateDocumentType(amcoId: number, fileName: string | null | undefined, docCat: string | null | undefined): Observable<FileAuditModel> {
        let url_ = this.baseUrl + "/api/Customs/UpdateDocumentType/{amcoId}?";
        if (amcoId === undefined || amcoId === null)
            throw new Error("The parameter 'amcoId' must be defined.");
        url_ = url_.replace("{amcoId}", encodeURIComponent("" + amcoId));
        if (fileName !== undefined && fileName !== null)
            url_ += "fileName=" + encodeURIComponent("" + fileName) + "&";
        if (docCat !== undefined && docCat !== null)
            url_ += "docCat=" + encodeURIComponent("" + docCat) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateDocumentType(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateDocumentType(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileAuditModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileAuditModel>;
        }));
    }

    protected processUpdateDocumentType(response: HttpResponseBase): Observable<FileAuditModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileAuditModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileAuditModel>(null as any);
    }

    updateDocumentsChecked(amcoId: number): Observable<boolean> {
        let url_ = this.baseUrl + "/api/Customs/UpdateDocumentsChecked/{amcoId}";
        if (amcoId === undefined || amcoId === null)
            throw new Error("The parameter 'amcoId' must be defined.");
        url_ = url_.replace("{amcoId}", encodeURIComponent("" + amcoId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateDocumentsChecked(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateDocumentsChecked(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processUpdateDocumentsChecked(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(null as any);
    }

    updateUncChecked(amcoId: number): Observable<boolean> {
        let url_ = this.baseUrl + "/api/Customs/UpdateUncChecked/{amcoId}";
        if (amcoId === undefined || amcoId === null)
            throw new Error("The parameter 'amcoId' must be defined.");
        url_ = url_.replace("{amcoId}", encodeURIComponent("" + amcoId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateUncChecked(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateUncChecked(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processUpdateUncChecked(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(null as any);
    }

    updateTadClosed(amcoId: number): Observable<boolean> {
        let url_ = this.baseUrl + "/api/Customs/UpdateTadClosed/{amcoId}";
        if (amcoId === undefined || amcoId === null)
            throw new Error("The parameter 'amcoId' must be defined.");
        url_ = url_.replace("{amcoId}", encodeURIComponent("" + amcoId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateTadClosed(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateTadClosed(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processUpdateTadClosed(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(null as any);
    }
}

export interface IDashboardsClient {
    getDashboards(): Observable<DashboardModel[]>;
    getControlTowerDashboard(): Observable<DashboardModel[]>;
    getCustomsDashboard(): Observable<DashboardModel[]>;
    getNoVehicleDash(): Observable<DashboardModel[]>;
    getCollectPodJobCount(): Observable<DashboardModel[]>;
    getPodOnlyJobCount(): Observable<DashboardModel[]>;
    getBmwJobCount(): Observable<DashboardModel[]>;
    getBmwCollectionTrackingWarningCount(): Observable<DashboardModel[]>;
    getBmwNoLocationWarningCount(): Observable<DashboardModel[]>;
}

@Injectable({
    providedIn: 'root'
})
export class DashboardsClient implements IDashboardsClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    getDashboards(): Observable<DashboardModel[]> {
        let url_ = this.baseUrl + "/api/Dashboards/GetDashboards";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDashboards(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDashboards(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DashboardModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DashboardModel[]>;
        }));
    }

    protected processGetDashboards(response: HttpResponseBase): Observable<DashboardModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DashboardModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<DashboardModel[]>(null as any);
    }

    getControlTowerDashboard(): Observable<DashboardModel[]> {
        let url_ = this.baseUrl + "/api/Dashboards/GetControlTowerDashboard";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetControlTowerDashboard(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetControlTowerDashboard(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DashboardModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DashboardModel[]>;
        }));
    }

    protected processGetControlTowerDashboard(response: HttpResponseBase): Observable<DashboardModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DashboardModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<DashboardModel[]>(null as any);
    }

    getCustomsDashboard(): Observable<DashboardModel[]> {
        let url_ = this.baseUrl + "/api/Dashboards/GetCustomsDashboard";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCustomsDashboard(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCustomsDashboard(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DashboardModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DashboardModel[]>;
        }));
    }

    protected processGetCustomsDashboard(response: HttpResponseBase): Observable<DashboardModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DashboardModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<DashboardModel[]>(null as any);
    }

    getNoVehicleDash(): Observable<DashboardModel[]> {
        let url_ = this.baseUrl + "/api/Dashboards/GetNoVehicleDash";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetNoVehicleDash(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetNoVehicleDash(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DashboardModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DashboardModel[]>;
        }));
    }

    protected processGetNoVehicleDash(response: HttpResponseBase): Observable<DashboardModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DashboardModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<DashboardModel[]>(null as any);
    }

    getCollectPodJobCount(): Observable<DashboardModel[]> {
        let url_ = this.baseUrl + "/api/Dashboards/GetCollectPodJobCount";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCollectPodJobCount(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCollectPodJobCount(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DashboardModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DashboardModel[]>;
        }));
    }

    protected processGetCollectPodJobCount(response: HttpResponseBase): Observable<DashboardModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DashboardModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<DashboardModel[]>(null as any);
    }

    getPodOnlyJobCount(): Observable<DashboardModel[]> {
        let url_ = this.baseUrl + "/api/Dashboards/GetPodOnlyJobCount";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPodOnlyJobCount(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPodOnlyJobCount(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DashboardModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DashboardModel[]>;
        }));
    }

    protected processGetPodOnlyJobCount(response: HttpResponseBase): Observable<DashboardModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DashboardModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<DashboardModel[]>(null as any);
    }

    getBmwJobCount(): Observable<DashboardModel[]> {
        let url_ = this.baseUrl + "/api/Dashboards/GetBmwJobCount";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetBmwJobCount(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetBmwJobCount(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DashboardModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DashboardModel[]>;
        }));
    }

    protected processGetBmwJobCount(response: HttpResponseBase): Observable<DashboardModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DashboardModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<DashboardModel[]>(null as any);
    }

    getBmwCollectionTrackingWarningCount(): Observable<DashboardModel[]> {
        let url_ = this.baseUrl + "/api/Dashboards/GetBmwCollectionTrackingWarningCount";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetBmwCollectionTrackingWarningCount(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetBmwCollectionTrackingWarningCount(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DashboardModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DashboardModel[]>;
        }));
    }

    protected processGetBmwCollectionTrackingWarningCount(response: HttpResponseBase): Observable<DashboardModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DashboardModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<DashboardModel[]>(null as any);
    }

    getBmwNoLocationWarningCount(): Observable<DashboardModel[]> {
        let url_ = this.baseUrl + "/api/Dashboards/GetBmwNoLocationWarningCount";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetBmwNoLocationWarningCount(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetBmwNoLocationWarningCount(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DashboardModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DashboardModel[]>;
        }));
    }

    protected processGetBmwNoLocationWarningCount(response: HttpResponseBase): Observable<DashboardModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DashboardModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<DashboardModel[]>(null as any);
    }
}

export interface IDevicesClient {
    confirmLogout(command: ConfirmLogoutCommand): Observable<UserModel>;
    createUpdateDevice(command: CreateUpdateDeviceCommand): Observable<UserModel>;
}

@Injectable({
    providedIn: 'root'
})
export class DevicesClient implements IDevicesClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    confirmLogout(command: ConfirmLogoutCommand): Observable<UserModel> {
        let url_ = this.baseUrl + "/api/Devices/ConfirmLogout";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processConfirmLogout(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processConfirmLogout(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserModel>;
        }));
    }

    protected processConfirmLogout(response: HttpResponseBase): Observable<UserModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UserModel>(null as any);
    }

    createUpdateDevice(command: CreateUpdateDeviceCommand): Observable<UserModel> {
        let url_ = this.baseUrl + "/api/Devices/CreateUpdateDeviceIfNeeded";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateUpdateDevice(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateUpdateDevice(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserModel>;
        }));
    }

    protected processCreateUpdateDevice(response: HttpResponseBase): Observable<UserModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UserModel>(null as any);
    }
}

export interface IDriverTrackingClient {
    addDriverTracking(command: AddDriverTrackingCommand): Observable<AddDriverTrackingResponse>;
    getConsignmentNumbers(tourNumber: string | null | undefined): Observable<GetConsignmentNumbersResponse>;
    recordTrackStatus(command: RecordTrackingCommand): Observable<RecordTrackStatusModel>;
    completePod(command: CompletePodCommand): Observable<CompletePodResponse>;
    registerDriver(command: RegisterDriverCommand): Observable<RegisterDriverResponse>;
    sendConsignmentStatus(command: SendConsignmentStatusCommand): Observable<SendConsignmentStatusResponse>;
    reportParcelCountDiscrepancy(command: ReportParcelCountDiscrepancyCommand): Observable<ReportParcelCountDiscrepancyResponse>;
    reportDelay(command: ReportDelayCommand): Observable<ReportDelayResponse>;
    reportDelayByTourNumber(command: ReportDelayByTourNumberCommand): Observable<ReportDelayResponse>;
}

@Injectable({
    providedIn: 'root'
})
export class DriverTrackingClient implements IDriverTrackingClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    addDriverTracking(command: AddDriverTrackingCommand): Observable<AddDriverTrackingResponse> {
        let url_ = this.baseUrl + "/api/DriverTracking/AddDriverTracking";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddDriverTracking(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddDriverTracking(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AddDriverTrackingResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AddDriverTrackingResponse>;
        }));
    }

    protected processAddDriverTracking(response: HttpResponseBase): Observable<AddDriverTrackingResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AddDriverTrackingResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<AddDriverTrackingResponse>(null as any);
    }

    getConsignmentNumbers(tourNumber: string | null | undefined): Observable<GetConsignmentNumbersResponse> {
        let url_ = this.baseUrl + "/api/DriverTracking/GetConsignmentNumbers?";
        if (tourNumber !== undefined && tourNumber !== null)
            url_ += "tourNumber=" + encodeURIComponent("" + tourNumber) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetConsignmentNumbers(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetConsignmentNumbers(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetConsignmentNumbersResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetConsignmentNumbersResponse>;
        }));
    }

    protected processGetConsignmentNumbers(response: HttpResponseBase): Observable<GetConsignmentNumbersResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetConsignmentNumbersResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetConsignmentNumbersResponse>(null as any);
    }

    recordTrackStatus(command: RecordTrackingCommand): Observable<RecordTrackStatusModel> {
        let url_ = this.baseUrl + "/api/DriverTracking/RecordTrackStatus";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRecordTrackStatus(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRecordTrackStatus(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RecordTrackStatusModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RecordTrackStatusModel>;
        }));
    }

    protected processRecordTrackStatus(response: HttpResponseBase): Observable<RecordTrackStatusModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RecordTrackStatusModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<RecordTrackStatusModel>(null as any);
    }

    completePod(command: CompletePodCommand): Observable<CompletePodResponse> {
        let url_ = this.baseUrl + "/api/DriverTracking/CompletePod";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCompletePod(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCompletePod(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CompletePodResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CompletePodResponse>;
        }));
    }

    protected processCompletePod(response: HttpResponseBase): Observable<CompletePodResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CompletePodResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CompletePodResponse>(null as any);
    }

    registerDriver(command: RegisterDriverCommand): Observable<RegisterDriverResponse> {
        let url_ = this.baseUrl + "/api/DriverTracking/RegisterDriver";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRegisterDriver(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRegisterDriver(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RegisterDriverResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RegisterDriverResponse>;
        }));
    }

    protected processRegisterDriver(response: HttpResponseBase): Observable<RegisterDriverResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RegisterDriverResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<RegisterDriverResponse>(null as any);
    }

    sendConsignmentStatus(command: SendConsignmentStatusCommand): Observable<SendConsignmentStatusResponse> {
        let url_ = this.baseUrl + "/api/DriverTracking/SendConsignmentStatus";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSendConsignmentStatus(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSendConsignmentStatus(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SendConsignmentStatusResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SendConsignmentStatusResponse>;
        }));
    }

    protected processSendConsignmentStatus(response: HttpResponseBase): Observable<SendConsignmentStatusResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SendConsignmentStatusResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SendConsignmentStatusResponse>(null as any);
    }

    reportParcelCountDiscrepancy(command: ReportParcelCountDiscrepancyCommand): Observable<ReportParcelCountDiscrepancyResponse> {
        let url_ = this.baseUrl + "/api/DriverTracking/ReportParcelCountDiscrepancy";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processReportParcelCountDiscrepancy(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processReportParcelCountDiscrepancy(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ReportParcelCountDiscrepancyResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ReportParcelCountDiscrepancyResponse>;
        }));
    }

    protected processReportParcelCountDiscrepancy(response: HttpResponseBase): Observable<ReportParcelCountDiscrepancyResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ReportParcelCountDiscrepancyResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ReportParcelCountDiscrepancyResponse>(null as any);
    }

    reportDelay(command: ReportDelayCommand): Observable<ReportDelayResponse> {
        let url_ = this.baseUrl + "/api/DriverTracking/ReportDelay";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processReportDelay(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processReportDelay(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ReportDelayResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ReportDelayResponse>;
        }));
    }

    protected processReportDelay(response: HttpResponseBase): Observable<ReportDelayResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ReportDelayResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ReportDelayResponse>(null as any);
    }

    reportDelayByTourNumber(command: ReportDelayByTourNumberCommand): Observable<ReportDelayResponse> {
        let url_ = this.baseUrl + "/api/DriverTracking/ReportDelayByTourNumber";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processReportDelayByTourNumber(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processReportDelayByTourNumber(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ReportDelayResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ReportDelayResponse>;
        }));
    }

    protected processReportDelayByTourNumber(response: HttpResponseBase): Observable<ReportDelayResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ReportDelayResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ReportDelayResponse>(null as any);
    }
}

export interface IEmailTriggerClient {
    createEmailDetails(tourId: number): Observable<EmailDetailsModel>;
}

@Injectable({
    providedIn: 'root'
})
export class EmailTriggerClient implements IEmailTriggerClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    createEmailDetails(tourId: number): Observable<EmailDetailsModel> {
        let url_ = this.baseUrl + "/api/EmailTrigger/SaveEmailDetailsByTourId/{tourId}";
        if (tourId === undefined || tourId === null)
            throw new Error("The parameter 'tourId' must be defined.");
        url_ = url_.replace("{tourId}", encodeURIComponent("" + tourId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateEmailDetails(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateEmailDetails(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EmailDetailsModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EmailDetailsModel>;
        }));
    }

    protected processCreateEmailDetails(response: HttpResponseBase): Observable<EmailDetailsModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = EmailDetailsModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<EmailDetailsModel>(null as any);
    }
}

export interface IEtaClient {
    getAdvancedEtaByTourId(tourId: number): Observable<AdvancedEtaResult>;
}

@Injectable({
    providedIn: 'root'
})
export class EtaClient implements IEtaClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    getAdvancedEtaByTourId(tourId: number): Observable<AdvancedEtaResult> {
        let url_ = this.baseUrl + "/api/Eta/GetAdvancedEta/{tourId}";
        if (tourId === undefined || tourId === null)
            throw new Error("The parameter 'tourId' must be defined.");
        url_ = url_.replace("{tourId}", encodeURIComponent("" + tourId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAdvancedEtaByTourId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAdvancedEtaByTourId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AdvancedEtaResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AdvancedEtaResult>;
        }));
    }

    protected processGetAdvancedEtaByTourId(response: HttpResponseBase): Observable<AdvancedEtaResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AdvancedEtaResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<AdvancedEtaResult>(null as any);
    }
}

export interface IHistoryClient {
    getVehicleEventsByTourId(id: number): Observable<VehicleEventsModel[]>;
    getVehicleLocFromEvents(tourid: number): Observable<VehicleEventsModel>;
    replayGeofencing(tourId: number): Observable<GeofenceReplayMarkerModel[]>;
    getGeofenceLocations(): Observable<GeofenceLocationModel[]>;
}

@Injectable({
    providedIn: 'root'
})
export class HistoryClient implements IHistoryClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    getVehicleEventsByTourId(id: number): Observable<VehicleEventsModel[]> {
        let url_ = this.baseUrl + "/api/History/GetVehicleEventsByTourId/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetVehicleEventsByTourId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetVehicleEventsByTourId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<VehicleEventsModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<VehicleEventsModel[]>;
        }));
    }

    protected processGetVehicleEventsByTourId(response: HttpResponseBase): Observable<VehicleEventsModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(VehicleEventsModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<VehicleEventsModel[]>(null as any);
    }

    getVehicleLocFromEvents(tourid: number): Observable<VehicleEventsModel> {
        let url_ = this.baseUrl + "/api/History/GetVehicleLocFromEvents/{tourid}";
        if (tourid === undefined || tourid === null)
            throw new Error("The parameter 'tourid' must be defined.");
        url_ = url_.replace("{tourid}", encodeURIComponent("" + tourid));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetVehicleLocFromEvents(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetVehicleLocFromEvents(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<VehicleEventsModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<VehicleEventsModel>;
        }));
    }

    protected processGetVehicleLocFromEvents(response: HttpResponseBase): Observable<VehicleEventsModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = VehicleEventsModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<VehicleEventsModel>(null as any);
    }

    replayGeofencing(tourId: number): Observable<GeofenceReplayMarkerModel[]> {
        let url_ = this.baseUrl + "/api/History/ReplayGeofencing/{tourId}";
        if (tourId === undefined || tourId === null)
            throw new Error("The parameter 'tourId' must be defined.");
        url_ = url_.replace("{tourId}", encodeURIComponent("" + tourId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processReplayGeofencing(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processReplayGeofencing(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GeofenceReplayMarkerModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GeofenceReplayMarkerModel[]>;
        }));
    }

    protected processReplayGeofencing(response: HttpResponseBase): Observable<GeofenceReplayMarkerModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GeofenceReplayMarkerModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GeofenceReplayMarkerModel[]>(null as any);
    }

    getGeofenceLocations(): Observable<GeofenceLocationModel[]> {
        let url_ = this.baseUrl + "/api/History/GetGeofenceLocations";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetGeofenceLocations(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetGeofenceLocations(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GeofenceLocationModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GeofenceLocationModel[]>;
        }));
    }

    protected processGetGeofenceLocations(response: HttpResponseBase): Observable<GeofenceLocationModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GeofenceLocationModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GeofenceLocationModel[]>(null as any);
    }
}

export interface ILookupsClient {
    getDepartments(): Observable<LookupModel[]>;
    getQuoteStatusLookups(): Observable<LookupModel[]>;
    getTypeLookups(departmentIds: string | null): Observable<LookupModel[]>;
    getCategories(): Observable<LookupModel[]>;
    getTicketTypes(): Observable<LookupModel[]>;
    getFrequencyUpdateTypes(): Observable<LookupModel[]>;
    getCauseOfIssueUpdateTypes(): Observable<LookupModel[]>;
    getImpactUpdateTypes(): Observable<LookupModel[]>;
    getReasonForIssueUpdateTypes(): Observable<LookupModel[]>;
    getShipmentModes(): Observable<LookupModel[]>;
    getCustomsDep(): Observable<LookupModel[]>;
    getDeclarationTypes(): Observable<LookupModel[]>;
    getAllTypes(): Observable<LookupModel[]>;
    getDelayReasons(): Observable<LookupModel[]>;
    getCountries(): Observable<CountryLookupModel[]>;
}

@Injectable({
    providedIn: 'root'
})
export class LookupsClient implements ILookupsClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    getDepartments(): Observable<LookupModel[]> {
        let url_ = this.baseUrl + "/api/Lookups/GetDepartments";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDepartments(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDepartments(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LookupModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LookupModel[]>;
        }));
    }

    protected processGetDepartments(response: HttpResponseBase): Observable<LookupModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(LookupModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<LookupModel[]>(null as any);
    }

    getQuoteStatusLookups(): Observable<LookupModel[]> {
        let url_ = this.baseUrl + "/api/Lookups/GetQuoteStatusLookups";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetQuoteStatusLookups(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetQuoteStatusLookups(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LookupModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LookupModel[]>;
        }));
    }

    protected processGetQuoteStatusLookups(response: HttpResponseBase): Observable<LookupModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(LookupModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<LookupModel[]>(null as any);
    }

    getTypeLookups(departmentIds: string | null): Observable<LookupModel[]> {
        let url_ = this.baseUrl + "/api/Lookups/GetTypeLookups/{departmentIds}";
        if (departmentIds === undefined || departmentIds === null)
            throw new Error("The parameter 'departmentIds' must be defined.");
        url_ = url_.replace("{departmentIds}", encodeURIComponent("" + departmentIds));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTypeLookups(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTypeLookups(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LookupModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LookupModel[]>;
        }));
    }

    protected processGetTypeLookups(response: HttpResponseBase): Observable<LookupModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(LookupModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<LookupModel[]>(null as any);
    }

    getCategories(): Observable<LookupModel[]> {
        let url_ = this.baseUrl + "/api/Lookups/GetCategories";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCategories(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCategories(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LookupModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LookupModel[]>;
        }));
    }

    protected processGetCategories(response: HttpResponseBase): Observable<LookupModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(LookupModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<LookupModel[]>(null as any);
    }

    getTicketTypes(): Observable<LookupModel[]> {
        let url_ = this.baseUrl + "/api/Lookups/GetTicketTypes";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTicketTypes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTicketTypes(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LookupModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LookupModel[]>;
        }));
    }

    protected processGetTicketTypes(response: HttpResponseBase): Observable<LookupModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(LookupModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<LookupModel[]>(null as any);
    }

    getFrequencyUpdateTypes(): Observable<LookupModel[]> {
        let url_ = this.baseUrl + "/api/Lookups/GetFrequencyUpdateTypes";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetFrequencyUpdateTypes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFrequencyUpdateTypes(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LookupModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LookupModel[]>;
        }));
    }

    protected processGetFrequencyUpdateTypes(response: HttpResponseBase): Observable<LookupModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(LookupModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<LookupModel[]>(null as any);
    }

    getCauseOfIssueUpdateTypes(): Observable<LookupModel[]> {
        let url_ = this.baseUrl + "/api/Lookups/GetCauseOfIssueUpdateTypes";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCauseOfIssueUpdateTypes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCauseOfIssueUpdateTypes(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LookupModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LookupModel[]>;
        }));
    }

    protected processGetCauseOfIssueUpdateTypes(response: HttpResponseBase): Observable<LookupModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(LookupModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<LookupModel[]>(null as any);
    }

    getImpactUpdateTypes(): Observable<LookupModel[]> {
        let url_ = this.baseUrl + "/api/Lookups/GetImpactUpdateTypes";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetImpactUpdateTypes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetImpactUpdateTypes(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LookupModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LookupModel[]>;
        }));
    }

    protected processGetImpactUpdateTypes(response: HttpResponseBase): Observable<LookupModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(LookupModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<LookupModel[]>(null as any);
    }

    getReasonForIssueUpdateTypes(): Observable<LookupModel[]> {
        let url_ = this.baseUrl + "/api/Lookups/GetReasonForIssueUpdateTypes";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetReasonForIssueUpdateTypes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetReasonForIssueUpdateTypes(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LookupModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LookupModel[]>;
        }));
    }

    protected processGetReasonForIssueUpdateTypes(response: HttpResponseBase): Observable<LookupModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(LookupModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<LookupModel[]>(null as any);
    }

    getShipmentModes(): Observable<LookupModel[]> {
        let url_ = this.baseUrl + "/api/Lookups/GetShipmentModes";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetShipmentModes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetShipmentModes(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LookupModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LookupModel[]>;
        }));
    }

    protected processGetShipmentModes(response: HttpResponseBase): Observable<LookupModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(LookupModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<LookupModel[]>(null as any);
    }

    getCustomsDep(): Observable<LookupModel[]> {
        let url_ = this.baseUrl + "/api/Lookups/GetCustomsDep";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCustomsDep(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCustomsDep(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LookupModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LookupModel[]>;
        }));
    }

    protected processGetCustomsDep(response: HttpResponseBase): Observable<LookupModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(LookupModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<LookupModel[]>(null as any);
    }

    getDeclarationTypes(): Observable<LookupModel[]> {
        let url_ = this.baseUrl + "/api/Lookups/GetDeclarationTypes";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDeclarationTypes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDeclarationTypes(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LookupModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LookupModel[]>;
        }));
    }

    protected processGetDeclarationTypes(response: HttpResponseBase): Observable<LookupModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(LookupModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<LookupModel[]>(null as any);
    }

    getAllTypes(): Observable<LookupModel[]> {
        let url_ = this.baseUrl + "/api/Lookups/GetAllTypes";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllTypes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllTypes(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LookupModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LookupModel[]>;
        }));
    }

    protected processGetAllTypes(response: HttpResponseBase): Observable<LookupModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(LookupModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<LookupModel[]>(null as any);
    }

    getDelayReasons(): Observable<LookupModel[]> {
        let url_ = this.baseUrl + "/api/Lookups/GetDelayReasons";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDelayReasons(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDelayReasons(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LookupModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LookupModel[]>;
        }));
    }

    protected processGetDelayReasons(response: HttpResponseBase): Observable<LookupModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(LookupModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<LookupModel[]>(null as any);
    }

    getCountries(): Observable<CountryLookupModel[]> {
        let url_ = this.baseUrl + "/api/Lookups/GetCountries";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCountries(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCountries(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CountryLookupModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CountryLookupModel[]>;
        }));
    }

    protected processGetCountries(response: HttpResponseBase): Observable<CountryLookupModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CountryLookupModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CountryLookupModel[]>(null as any);
    }
}

export interface IMobileLoggingClient {
    addLogs(command: AddLogsCommand): Observable<UserModel>;
}

@Injectable({
    providedIn: 'root'
})
export class MobileLoggingClient implements IMobileLoggingClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    addLogs(command: AddLogsCommand): Observable<UserModel> {
        let url_ = this.baseUrl + "/api/MobileLogging";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddLogs(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddLogs(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserModel>;
        }));
    }

    protected processAddLogs(response: HttpResponseBase): Observable<UserModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UserModel>(null as any);
    }
}

export interface IMyToursClient {
    getMyTourList(): Observable<TourModel[]>;
    getActiveTours(): Observable<ActiveTourModel[]>;
    getActiveTourDetails(query: GetActiveTourDetailsQuery): Observable<ActiveTourDetailModel>;
    getAllActiveTourDetails(query: GetAllActiveTourDetailsQuery): Observable<ActiveTourDetailModel[]>;
    getMyTourHistory(command: GetMyTourHistoryQuery): Observable<PagedListingResponseOfTourListHistoryModel>;
    getMyCustomsHistory(command: GetMyCustomsHistoryQuery): Observable<PagedListingResponseOfTourListHistoryModel>;
    getMyCustomsList(): Observable<CustomsDetails[]>;
    getMyCustomsDashboard(): Observable<DashboardModel[]>;
}

@Injectable({
    providedIn: 'root'
})
export class MyToursClient implements IMyToursClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    getMyTourList(): Observable<TourModel[]> {
        let url_ = this.baseUrl + "/api/MyTours/GetMyTourList";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMyTourList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMyTourList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TourModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TourModel[]>;
        }));
    }

    protected processGetMyTourList(response: HttpResponseBase): Observable<TourModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(TourModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TourModel[]>(null as any);
    }

    getActiveTours(): Observable<ActiveTourModel[]> {
        let url_ = this.baseUrl + "/api/MyTours/GetActiveTours";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetActiveTours(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetActiveTours(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ActiveTourModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ActiveTourModel[]>;
        }));
    }

    protected processGetActiveTours(response: HttpResponseBase): Observable<ActiveTourModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ActiveTourModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ActiveTourModel[]>(null as any);
    }

    getActiveTourDetails(query: GetActiveTourDetailsQuery): Observable<ActiveTourDetailModel> {
        let url_ = this.baseUrl + "/api/MyTours/GetActiveTourDetails";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetActiveTourDetails(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetActiveTourDetails(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ActiveTourDetailModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ActiveTourDetailModel>;
        }));
    }

    protected processGetActiveTourDetails(response: HttpResponseBase): Observable<ActiveTourDetailModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ActiveTourDetailModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ActiveTourDetailModel>(null as any);
    }

    getAllActiveTourDetails(query: GetAllActiveTourDetailsQuery): Observable<ActiveTourDetailModel[]> {
        let url_ = this.baseUrl + "/api/MyTours/GetAllActiveTourDetails";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllActiveTourDetails(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllActiveTourDetails(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ActiveTourDetailModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ActiveTourDetailModel[]>;
        }));
    }

    protected processGetAllActiveTourDetails(response: HttpResponseBase): Observable<ActiveTourDetailModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ActiveTourDetailModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ActiveTourDetailModel[]>(null as any);
    }

    getMyTourHistory(command: GetMyTourHistoryQuery): Observable<PagedListingResponseOfTourListHistoryModel> {
        let url_ = this.baseUrl + "/api/MyTours/GetMyTourHistory";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMyTourHistory(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMyTourHistory(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedListingResponseOfTourListHistoryModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedListingResponseOfTourListHistoryModel>;
        }));
    }

    protected processGetMyTourHistory(response: HttpResponseBase): Observable<PagedListingResponseOfTourListHistoryModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedListingResponseOfTourListHistoryModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedListingResponseOfTourListHistoryModel>(null as any);
    }

    getMyCustomsHistory(command: GetMyCustomsHistoryQuery): Observable<PagedListingResponseOfTourListHistoryModel> {
        let url_ = this.baseUrl + "/api/MyTours/GetMyCustomsHistory";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMyCustomsHistory(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMyCustomsHistory(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedListingResponseOfTourListHistoryModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedListingResponseOfTourListHistoryModel>;
        }));
    }

    protected processGetMyCustomsHistory(response: HttpResponseBase): Observable<PagedListingResponseOfTourListHistoryModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedListingResponseOfTourListHistoryModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedListingResponseOfTourListHistoryModel>(null as any);
    }

    getMyCustomsList(): Observable<CustomsDetails[]> {
        let url_ = this.baseUrl + "/api/MyTours/GetMyCustomsList";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMyCustomsList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMyCustomsList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CustomsDetails[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CustomsDetails[]>;
        }));
    }

    protected processGetMyCustomsList(response: HttpResponseBase): Observable<CustomsDetails[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CustomsDetails.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CustomsDetails[]>(null as any);
    }

    getMyCustomsDashboard(): Observable<DashboardModel[]> {
        let url_ = this.baseUrl + "/api/MyTours/GetMyCustomsDashboard";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMyCustomsDashboard(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMyCustomsDashboard(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DashboardModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DashboardModel[]>;
        }));
    }

    protected processGetMyCustomsDashboard(response: HttpResponseBase): Observable<DashboardModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DashboardModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<DashboardModel[]>(null as any);
    }
}

export interface INotesClient {
    getNotesByTourId(tourId: number): Observable<NotesModel[]>;
    addNoteByTourId(id: number | undefined, tourId: number, note: string | null | undefined): Observable<NotesModel>;
}

@Injectable({
    providedIn: 'root'
})
export class NotesClient implements INotesClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    getNotesByTourId(tourId: number): Observable<NotesModel[]> {
        let url_ = this.baseUrl + "/api/Notes/GetNotesByTourId/{TourId}";
        if (tourId === undefined || tourId === null)
            throw new Error("The parameter 'tourId' must be defined.");
        url_ = url_.replace("{TourId}", encodeURIComponent("" + tourId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetNotesByTourId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetNotesByTourId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<NotesModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<NotesModel[]>;
        }));
    }

    protected processGetNotesByTourId(response: HttpResponseBase): Observable<NotesModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(NotesModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<NotesModel[]>(null as any);
    }

    addNoteByTourId(id: number | undefined, tourId: number, note: string | null | undefined): Observable<NotesModel> {
        let url_ = this.baseUrl + "/api/Notes/AddNoteByTourId/{TourId}?";
        if (tourId === undefined || tourId === null)
            throw new Error("The parameter 'tourId' must be defined.");
        url_ = url_.replace("{TourId}", encodeURIComponent("" + tourId));
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        if (note !== undefined && note !== null)
            url_ += "Note=" + encodeURIComponent("" + note) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddNoteByTourId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddNoteByTourId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<NotesModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<NotesModel>;
        }));
    }

    protected processAddNoteByTourId(response: HttpResponseBase): Observable<NotesModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = NotesModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<NotesModel>(null as any);
    }
}

export interface INotificationClient {
    postNotification(command: SendPushNotificationCommand): Observable<UserModel>;
}

@Injectable({
    providedIn: 'root'
})
export class NotificationClient implements INotificationClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    postNotification(command: SendPushNotificationCommand): Observable<UserModel> {
        let url_ = this.baseUrl + "/api/Notification";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPostNotification(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPostNotification(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserModel>;
        }));
    }

    protected processPostNotification(response: HttpResponseBase): Observable<UserModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UserModel>(null as any);
    }
}

export interface IQuoteClient {
    getQuotes(query: GetQuotesQuery): Observable<PagedListingResponseOfQuoteHeaderModel>;
    getQuoteById(id: number): Observable<QuoteHeaderModel>;
    getQuoteAttachment(quoteId: number, attachmentId: number): Observable<FileResponse>;
    getQuoteAttachmentSheets(quoteId: number, attachmentId: number): Observable<QuoteSheetsModel>;
    updateQuoteStatus(command: UpdateQuoteStatusCommand): Observable<boolean>;
    getVehicleTypes(): Observable<VehicleTypeModel[]>;
    getQuoteVehicleEstimate(query: GetQuoteVehicleEstimateQuery): Observable<QuoteVehicleEstimateModel>;
    assignVehicleType(command: AssignVehicleTypeToQuoteCommand): Observable<boolean>;
    getLockedQuote(id: number): Observable<TourLockedModel>;
    removeLockedQuote(id: number): Observable<FileResponse>;
}

@Injectable({
    providedIn: 'root'
})
export class QuoteClient implements IQuoteClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    getQuotes(query: GetQuotesQuery): Observable<PagedListingResponseOfQuoteHeaderModel> {
        let url_ = this.baseUrl + "/api/Quote/GetQuotes";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetQuotes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetQuotes(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedListingResponseOfQuoteHeaderModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedListingResponseOfQuoteHeaderModel>;
        }));
    }

    protected processGetQuotes(response: HttpResponseBase): Observable<PagedListingResponseOfQuoteHeaderModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedListingResponseOfQuoteHeaderModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedListingResponseOfQuoteHeaderModel>(null as any);
    }

    getQuoteById(id: number): Observable<QuoteHeaderModel> {
        let url_ = this.baseUrl + "/api/Quote/GetQuoteById/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetQuoteById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetQuoteById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<QuoteHeaderModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<QuoteHeaderModel>;
        }));
    }

    protected processGetQuoteById(response: HttpResponseBase): Observable<QuoteHeaderModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = QuoteHeaderModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<QuoteHeaderModel>(null as any);
    }

    getQuoteAttachment(quoteId: number, attachmentId: number): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/Quote/GetQuoteAttachment/{quoteId}/{attachmentId}";
        if (quoteId === undefined || quoteId === null)
            throw new Error("The parameter 'quoteId' must be defined.");
        url_ = url_.replace("{quoteId}", encodeURIComponent("" + quoteId));
        if (attachmentId === undefined || attachmentId === null)
            throw new Error("The parameter 'attachmentId' must be defined.");
        url_ = url_.replace("{attachmentId}", encodeURIComponent("" + attachmentId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetQuoteAttachment(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetQuoteAttachment(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processGetQuoteAttachment(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse>(null as any);
    }

    getQuoteAttachmentSheets(quoteId: number, attachmentId: number): Observable<QuoteSheetsModel> {
        let url_ = this.baseUrl + "/api/Quote/GetQuoteAttachmentSheets/{quoteId}/{attachmentId}";
        if (quoteId === undefined || quoteId === null)
            throw new Error("The parameter 'quoteId' must be defined.");
        url_ = url_.replace("{quoteId}", encodeURIComponent("" + quoteId));
        if (attachmentId === undefined || attachmentId === null)
            throw new Error("The parameter 'attachmentId' must be defined.");
        url_ = url_.replace("{attachmentId}", encodeURIComponent("" + attachmentId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetQuoteAttachmentSheets(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetQuoteAttachmentSheets(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<QuoteSheetsModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<QuoteSheetsModel>;
        }));
    }

    protected processGetQuoteAttachmentSheets(response: HttpResponseBase): Observable<QuoteSheetsModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = QuoteSheetsModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 422) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result422: any = null;
            let resultData422 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result422 = ProblemDetails.fromJS(resultData422);
            return throwException("A server side error occurred.", status, _responseText, _headers, result422);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<QuoteSheetsModel>(null as any);
    }

    updateQuoteStatus(command: UpdateQuoteStatusCommand): Observable<boolean> {
        let url_ = this.baseUrl + "/api/Quote/UpdateQuoteStatus";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateQuoteStatus(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateQuoteStatus(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processUpdateQuoteStatus(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(null as any);
    }

    getVehicleTypes(): Observable<VehicleTypeModel[]> {
        let url_ = this.baseUrl + "/api/Quote/GetVehicleTypes";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetVehicleTypes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetVehicleTypes(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<VehicleTypeModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<VehicleTypeModel[]>;
        }));
    }

    protected processGetVehicleTypes(response: HttpResponseBase): Observable<VehicleTypeModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(VehicleTypeModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<VehicleTypeModel[]>(null as any);
    }

    getQuoteVehicleEstimate(query: GetQuoteVehicleEstimateQuery): Observable<QuoteVehicleEstimateModel> {
        let url_ = this.baseUrl + "/api/Quote/GetQuoteVehicleEstimate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetQuoteVehicleEstimate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetQuoteVehicleEstimate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<QuoteVehicleEstimateModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<QuoteVehicleEstimateModel>;
        }));
    }

    protected processGetQuoteVehicleEstimate(response: HttpResponseBase): Observable<QuoteVehicleEstimateModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = QuoteVehicleEstimateModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<QuoteVehicleEstimateModel>(null as any);
    }

    assignVehicleType(command: AssignVehicleTypeToQuoteCommand): Observable<boolean> {
        let url_ = this.baseUrl + "/api/Quote/AssignVehicleType";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAssignVehicleType(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAssignVehicleType(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processAssignVehicleType(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(null as any);
    }

    getLockedQuote(id: number): Observable<TourLockedModel> {
        let url_ = this.baseUrl + "/api/Quote/GetLockedQuote/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLockedQuote(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLockedQuote(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TourLockedModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TourLockedModel>;
        }));
    }

    protected processGetLockedQuote(response: HttpResponseBase): Observable<TourLockedModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TourLockedModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TourLockedModel>(null as any);
    }

    removeLockedQuote(id: number): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/Quote/RemoveLockedQuote/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRemoveLockedQuote(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRemoveLockedQuote(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processRemoveLockedQuote(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse>(null as any);
    }
}

export interface IQuotesOrderClient {
    ingestNormalOrder(command: IngestNormalOrderCommand): Observable<IngestNormalOrderResponse>;
    ingestQuote(command: IngestQuoteCommand): Observable<IngestQuoteResponse>;
}

@Injectable({
    providedIn: 'root'
})
export class QuotesOrderClient implements IQuotesOrderClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    ingestNormalOrder(command: IngestNormalOrderCommand): Observable<IngestNormalOrderResponse> {
        let url_ = this.baseUrl + "/api/QuotesOrder/Ingest";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processIngestNormalOrder(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processIngestNormalOrder(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<IngestNormalOrderResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<IngestNormalOrderResponse>;
        }));
    }

    protected processIngestNormalOrder(response: HttpResponseBase): Observable<IngestNormalOrderResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = IngestNormalOrderResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<IngestNormalOrderResponse>(null as any);
    }

    ingestQuote(command: IngestQuoteCommand): Observable<IngestQuoteResponse> {
        let url_ = this.baseUrl + "/api/QuotesOrder/IngestQuote";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processIngestQuote(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processIngestQuote(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<IngestQuoteResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<IngestQuoteResponse>;
        }));
    }

    protected processIngestQuote(response: HttpResponseBase): Observable<IngestQuoteResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = IngestQuoteResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<IngestQuoteResponse>(null as any);
    }
}

export interface IRolesClient {
    get(id: RoleEnum, includeUsers: boolean | undefined): Observable<RoleModel>;
    getAll(includeUsers: boolean | undefined): Observable<RoleModel[]>;
}

@Injectable({
    providedIn: 'root'
})
export class RolesClient implements IRolesClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    get(id: RoleEnum, includeUsers: boolean | undefined): Observable<RoleModel> {
        let url_ = this.baseUrl + "/api/Roles/{id}?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (includeUsers === null)
            throw new Error("The parameter 'includeUsers' cannot be null.");
        else if (includeUsers !== undefined)
            url_ += "includeUsers=" + encodeURIComponent("" + includeUsers) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RoleModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RoleModel>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<RoleModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RoleModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<RoleModel>(null as any);
    }

    getAll(includeUsers: boolean | undefined): Observable<RoleModel[]> {
        let url_ = this.baseUrl + "/api/Roles?";
        if (includeUsers === null)
            throw new Error("The parameter 'includeUsers' cannot be null.");
        else if (includeUsers !== undefined)
            url_ += "includeUsers=" + encodeURIComponent("" + includeUsers) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RoleModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RoleModel[]>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<RoleModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(RoleModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<RoleModel[]>(null as any);
    }
}

export interface ITenantsClient {
    get(id: string, includeUsers: boolean | undefined): Observable<TenantModel>;
    getAll(includeUsers: boolean | undefined): Observable<TenantModel[]>;
}

@Injectable({
    providedIn: 'root'
})
export class TenantsClient implements ITenantsClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    get(id: string, includeUsers: boolean | undefined): Observable<TenantModel> {
        let url_ = this.baseUrl + "/api/Tenants/{id}?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (includeUsers === null)
            throw new Error("The parameter 'includeUsers' cannot be null.");
        else if (includeUsers !== undefined)
            url_ += "includeUsers=" + encodeURIComponent("" + includeUsers) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TenantModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TenantModel>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<TenantModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TenantModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TenantModel>(null as any);
    }

    getAll(includeUsers: boolean | undefined): Observable<TenantModel[]> {
        let url_ = this.baseUrl + "/api/Tenants?";
        if (includeUsers === null)
            throw new Error("The parameter 'includeUsers' cannot be null.");
        else if (includeUsers !== undefined)
            url_ += "includeUsers=" + encodeURIComponent("" + includeUsers) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TenantModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TenantModel[]>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<TenantModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(TenantModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TenantModel[]>(null as any);
    }
}

export interface ITicketsClient {
    getAllTickets(): Observable<TicketsModel[]>;
    createTicket(): Observable<TicketsModel>;
}

@Injectable({
    providedIn: 'root'
})
export class TicketsClient implements ITicketsClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    getAllTickets(): Observable<TicketsModel[]> {
        let url_ = this.baseUrl + "/api/Tickets/GetAllTickets";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllTickets(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllTickets(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TicketsModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TicketsModel[]>;
        }));
    }

    protected processGetAllTickets(response: HttpResponseBase): Observable<TicketsModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(TicketsModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TicketsModel[]>(null as any);
    }

    createTicket(): Observable<TicketsModel> {
        let url_ = this.baseUrl + "/api/Tickets/CreateTicket";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateTicket(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateTicket(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TicketsModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TicketsModel>;
        }));
    }

    protected processCreateTicket(response: HttpResponseBase): Observable<TicketsModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TicketsModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TicketsModel>(null as any);
    }
}

export interface ITourClient {
    getTourList(): Observable<TourModel[]>;
    getAdminTourList(command: GetAdminTourListQuery): Observable<PagedListingResponseOfAdminTourModel>;
    getTourHistory(command: GetTourHistoryQuery): Observable<PagedListingResponseOfTourListHistoryModel>;
    auditGoogleApi(command: AuditGoogleApiCommand): Observable<PagedListingResponseOfTourListHistoryModel>;
    getTourById(tourId: number, transportOrderNumber: string | null | undefined): Observable<TourModel>;
    getTourByAmcoId(amcoId: number): Observable<TourModel[]>;
    getTourHistoryByTourId(tourId: number): Observable<TourHistoryModel[]>;
    updateETAByTourId(tourId: number, estimatedDateTime: Date | undefined, updateType: number | undefined, note: string | null | undefined, latitude: number | null | undefined, longitude: number | null | undefined, vehicleDuration: string | null | undefined, vehicleDistance: string | null | undefined, address: string | null | undefined, restStartTime: Date | undefined, restEndTime: Date | undefined, historyId: number | undefined, transportOrderNumber: string | null | undefined): Observable<TourModel>;
    tourLockHistoryByUserId(userId: string | undefined, tourId: number | undefined): Observable<TourHistoryModel>;
    markTourCompleted(tourId: number): Observable<TourModel>;
    assignUserByTourId(id: number, userId: string | undefined): Observable<TourModel>;
    updateTrackingUrl(model: UpdateTrackingUrlCommand): Observable<boolean>;
    assignVehicleByTourId(id: number, vehicleId: number | undefined): Observable<TourModel>;
    cancelTourById(id: number): Observable<TourModel>;
    unCancelTourById(id: number): Observable<TourModel>;
    createHistoryByTourId(id: number, eTA: Date | undefined, isApproved: boolean | undefined, note: string | null | undefined, rejectionComments: string | null | undefined, updateTypeLookupId: number | undefined, requiresValidation: boolean | undefined, vehicleLat: number | null | undefined, vehicleLng: number | null | undefined, vehicleDur: string | null | undefined, vehicleDistance: string | null | undefined, place: string | null | undefined): Observable<TourHistoryModel>;
    updateHistoryItemById(id: number, eTA: Date | undefined, isApproved: boolean | undefined, note: string | null | undefined, rejectionComments: string | null | undefined, requiresValidation: boolean | undefined, isEdit: boolean | undefined): Observable<TourHistoryModel>;
    logAnIssueByTourId(tourId: number, causeOfIssue: string | null | undefined, impact: string | null | undefined, reasonForIssue: string | null | undefined, isLoggedByCustomer: boolean | undefined, hasCustomerBeenCalled: boolean | undefined, hasCarrierBeenCalled: boolean | undefined, notes: string | null | undefined, estimatedDatetime: Date | undefined, historyId: number | undefined, tourHistoryId: number | undefined, status: boolean | undefined, escalateIssue: boolean | undefined, isControlRoom: boolean | undefined, managerActions: string | null | undefined, issueActions: string | null | undefined, priority: string | null | undefined): Observable<LoggedIssueModel>;
    closeIssueById(id: number | undefined, tourId: number | undefined): Observable<LoggedIssueModel>;
    getLoggedIssueByTourId(tourId: number): Observable<LoggedIssueModel[]>;
    disableHistoryItemById(id: number, tourId: number | undefined): Observable<TourHistoryModel>;
    makeTourCriticalById(id: number, isCritical: boolean | undefined): Observable<TourModel>;
    updateTrackingFrequencyById(id: number, frequencyId: number | undefined): Observable<TourModel>;
    makeTourHeldAtCustomsById(id: number, isHeldAtCustoms: boolean | undefined): Observable<TourModel>;
    updatedToursSignalR(query: SendToursToUIQuery): Observable<FileResponse>;
    addTrailerRegByTourId(id: number, regNumber: string | null | undefined): Observable<TourModel>;
    calculateTimeAndDistance(fromLat: number | undefined, fromLong: number | undefined, toLat: number | undefined, toLong: number | undefined, maxSpeed: number | undefined): Observable<DistanceModel>;
    saveRouteData(tourId: number | undefined, vehicleId: number | undefined, routeData: string | null | undefined, eventTrigger: string | null | undefined, suggestedETA: Date | undefined, distance: string | null | undefined): Observable<TourVehicleRouteModel>;
    getRouteByTourId(tourId: number): Observable<TourVehicleRouteModel>;
    getLockedTour(id: number): Observable<TourLockedModel>;
    removeFromCache(id: number): Observable<FileResponse>;
    recalculateUpdateDue(tourId: number | undefined, toNumber: string | null | undefined): Observable<boolean>;
}

@Injectable({
    providedIn: 'root'
})
export class TourClient implements ITourClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    getTourList(): Observable<TourModel[]> {
        let url_ = this.baseUrl + "/api/Tour/GetTourList";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTourList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTourList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TourModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TourModel[]>;
        }));
    }

    protected processGetTourList(response: HttpResponseBase): Observable<TourModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(TourModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TourModel[]>(null as any);
    }

    getAdminTourList(command: GetAdminTourListQuery): Observable<PagedListingResponseOfAdminTourModel> {
        let url_ = this.baseUrl + "/api/Tour/GetAdminTourList";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAdminTourList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAdminTourList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedListingResponseOfAdminTourModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedListingResponseOfAdminTourModel>;
        }));
    }

    protected processGetAdminTourList(response: HttpResponseBase): Observable<PagedListingResponseOfAdminTourModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedListingResponseOfAdminTourModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedListingResponseOfAdminTourModel>(null as any);
    }

    getTourHistory(command: GetTourHistoryQuery): Observable<PagedListingResponseOfTourListHistoryModel> {
        let url_ = this.baseUrl + "/api/Tour/GetTourHistory";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTourHistory(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTourHistory(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedListingResponseOfTourListHistoryModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedListingResponseOfTourListHistoryModel>;
        }));
    }

    protected processGetTourHistory(response: HttpResponseBase): Observable<PagedListingResponseOfTourListHistoryModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedListingResponseOfTourListHistoryModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedListingResponseOfTourListHistoryModel>(null as any);
    }

    auditGoogleApi(command: AuditGoogleApiCommand): Observable<PagedListingResponseOfTourListHistoryModel> {
        let url_ = this.baseUrl + "/api/Tour/AuditGoogleApi";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAuditGoogleApi(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAuditGoogleApi(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedListingResponseOfTourListHistoryModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedListingResponseOfTourListHistoryModel>;
        }));
    }

    protected processAuditGoogleApi(response: HttpResponseBase): Observable<PagedListingResponseOfTourListHistoryModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedListingResponseOfTourListHistoryModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedListingResponseOfTourListHistoryModel>(null as any);
    }

    getTourById(tourId: number, transportOrderNumber: string | null | undefined): Observable<TourModel> {
        let url_ = this.baseUrl + "/api/Tour/GetTourById/{TourId}?";
        if (tourId === undefined || tourId === null)
            throw new Error("The parameter 'tourId' must be defined.");
        url_ = url_.replace("{TourId}", encodeURIComponent("" + tourId));
        if (transportOrderNumber !== undefined && transportOrderNumber !== null)
            url_ += "transportOrderNumber=" + encodeURIComponent("" + transportOrderNumber) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTourById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTourById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TourModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TourModel>;
        }));
    }

    protected processGetTourById(response: HttpResponseBase): Observable<TourModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TourModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TourModel>(null as any);
    }

    getTourByAmcoId(amcoId: number): Observable<TourModel[]> {
        let url_ = this.baseUrl + "/api/Tour/GetTourByAmcoId/{AmcoId}";
        if (amcoId === undefined || amcoId === null)
            throw new Error("The parameter 'amcoId' must be defined.");
        url_ = url_.replace("{AmcoId}", encodeURIComponent("" + amcoId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTourByAmcoId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTourByAmcoId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TourModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TourModel[]>;
        }));
    }

    protected processGetTourByAmcoId(response: HttpResponseBase): Observable<TourModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(TourModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TourModel[]>(null as any);
    }

    getTourHistoryByTourId(tourId: number): Observable<TourHistoryModel[]> {
        let url_ = this.baseUrl + "/api/Tour/GetTourHistoryByTourId/{TourId}";
        if (tourId === undefined || tourId === null)
            throw new Error("The parameter 'tourId' must be defined.");
        url_ = url_.replace("{TourId}", encodeURIComponent("" + tourId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTourHistoryByTourId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTourHistoryByTourId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TourHistoryModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TourHistoryModel[]>;
        }));
    }

    protected processGetTourHistoryByTourId(response: HttpResponseBase): Observable<TourHistoryModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(TourHistoryModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TourHistoryModel[]>(null as any);
    }

    updateETAByTourId(tourId: number, estimatedDateTime: Date | undefined, updateType: number | undefined, note: string | null | undefined, latitude: number | null | undefined, longitude: number | null | undefined, vehicleDuration: string | null | undefined, vehicleDistance: string | null | undefined, address: string | null | undefined, restStartTime: Date | undefined, restEndTime: Date | undefined, historyId: number | undefined, transportOrderNumber: string | null | undefined): Observable<TourModel> {
        let url_ = this.baseUrl + "/api/Tour/UpdateETAByTourId/{tourId}?";
        if (tourId === undefined || tourId === null)
            throw new Error("The parameter 'tourId' must be defined.");
        url_ = url_.replace("{tourId}", encodeURIComponent("" + tourId));
        if (estimatedDateTime === null)
            throw new Error("The parameter 'estimatedDateTime' cannot be null.");
        else if (estimatedDateTime !== undefined)
            url_ += "estimatedDateTime=" + encodeURIComponent(estimatedDateTime ? "" + estimatedDateTime.toISOString() : "") + "&";
        if (updateType === null)
            throw new Error("The parameter 'updateType' cannot be null.");
        else if (updateType !== undefined)
            url_ += "updateType=" + encodeURIComponent("" + updateType) + "&";
        if (note !== undefined && note !== null)
            url_ += "note=" + encodeURIComponent("" + note) + "&";
        if (latitude !== undefined && latitude !== null)
            url_ += "latitude=" + encodeURIComponent("" + latitude) + "&";
        if (longitude !== undefined && longitude !== null)
            url_ += "longitude=" + encodeURIComponent("" + longitude) + "&";
        if (vehicleDuration !== undefined && vehicleDuration !== null)
            url_ += "vehicleDuration=" + encodeURIComponent("" + vehicleDuration) + "&";
        if (vehicleDistance !== undefined && vehicleDistance !== null)
            url_ += "vehicleDistance=" + encodeURIComponent("" + vehicleDistance) + "&";
        if (address !== undefined && address !== null)
            url_ += "address=" + encodeURIComponent("" + address) + "&";
        if (restStartTime === null)
            throw new Error("The parameter 'restStartTime' cannot be null.");
        else if (restStartTime !== undefined)
            url_ += "restStartTime=" + encodeURIComponent(restStartTime ? "" + restStartTime.toISOString() : "") + "&";
        if (restEndTime === null)
            throw new Error("The parameter 'restEndTime' cannot be null.");
        else if (restEndTime !== undefined)
            url_ += "restEndTime=" + encodeURIComponent(restEndTime ? "" + restEndTime.toISOString() : "") + "&";
        if (historyId === null)
            throw new Error("The parameter 'historyId' cannot be null.");
        else if (historyId !== undefined)
            url_ += "historyId=" + encodeURIComponent("" + historyId) + "&";
        if (transportOrderNumber !== undefined && transportOrderNumber !== null)
            url_ += "transportOrderNumber=" + encodeURIComponent("" + transportOrderNumber) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateETAByTourId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateETAByTourId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TourModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TourModel>;
        }));
    }

    protected processUpdateETAByTourId(response: HttpResponseBase): Observable<TourModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TourModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TourModel>(null as any);
    }

    tourLockHistoryByUserId(userId: string | undefined, tourId: number | undefined): Observable<TourHistoryModel> {
        let url_ = this.baseUrl + "/api/Tour/TourLockHistory?";
        if (userId === null)
            throw new Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "UserId=" + encodeURIComponent("" + userId) + "&";
        if (tourId === null)
            throw new Error("The parameter 'tourId' cannot be null.");
        else if (tourId !== undefined)
            url_ += "TourId=" + encodeURIComponent("" + tourId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processTourLockHistoryByUserId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processTourLockHistoryByUserId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TourHistoryModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TourHistoryModel>;
        }));
    }

    protected processTourLockHistoryByUserId(response: HttpResponseBase): Observable<TourHistoryModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TourHistoryModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TourHistoryModel>(null as any);
    }

    markTourCompleted(tourId: number): Observable<TourModel> {
        let url_ = this.baseUrl + "/api/Tour/MarkTourCompleted/{tourId}";
        if (tourId === undefined || tourId === null)
            throw new Error("The parameter 'tourId' must be defined.");
        url_ = url_.replace("{tourId}", encodeURIComponent("" + tourId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processMarkTourCompleted(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processMarkTourCompleted(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TourModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TourModel>;
        }));
    }

    protected processMarkTourCompleted(response: HttpResponseBase): Observable<TourModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TourModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TourModel>(null as any);
    }

    assignUserByTourId(id: number, userId: string | undefined): Observable<TourModel> {
        let url_ = this.baseUrl + "/api/Tour/AssignUserByTourId/{Id}?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{Id}", encodeURIComponent("" + id));
        if (userId === null)
            throw new Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "UserId=" + encodeURIComponent("" + userId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAssignUserByTourId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAssignUserByTourId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TourModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TourModel>;
        }));
    }

    protected processAssignUserByTourId(response: HttpResponseBase): Observable<TourModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TourModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TourModel>(null as any);
    }

    updateTrackingUrl(model: UpdateTrackingUrlCommand): Observable<boolean> {
        let url_ = this.baseUrl + "/api/Tour/UpdateTrackingUrl";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateTrackingUrl(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateTrackingUrl(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processUpdateTrackingUrl(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(null as any);
    }

    assignVehicleByTourId(id: number, vehicleId: number | undefined): Observable<TourModel> {
        let url_ = this.baseUrl + "/api/Tour/AssignVehicleByTourId/{Id}?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{Id}", encodeURIComponent("" + id));
        if (vehicleId === null)
            throw new Error("The parameter 'vehicleId' cannot be null.");
        else if (vehicleId !== undefined)
            url_ += "VehicleId=" + encodeURIComponent("" + vehicleId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAssignVehicleByTourId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAssignVehicleByTourId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TourModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TourModel>;
        }));
    }

    protected processAssignVehicleByTourId(response: HttpResponseBase): Observable<TourModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TourModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TourModel>(null as any);
    }

    cancelTourById(id: number): Observable<TourModel> {
        let url_ = this.baseUrl + "/api/Tour/CancelTourById/{Id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{Id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCancelTourById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCancelTourById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TourModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TourModel>;
        }));
    }

    protected processCancelTourById(response: HttpResponseBase): Observable<TourModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TourModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TourModel>(null as any);
    }

    unCancelTourById(id: number): Observable<TourModel> {
        let url_ = this.baseUrl + "/api/Tour/UnCancelTourById/{Id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{Id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUnCancelTourById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUnCancelTourById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TourModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TourModel>;
        }));
    }

    protected processUnCancelTourById(response: HttpResponseBase): Observable<TourModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TourModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TourModel>(null as any);
    }

    createHistoryByTourId(id: number, eTA: Date | undefined, isApproved: boolean | undefined, note: string | null | undefined, rejectionComments: string | null | undefined, updateTypeLookupId: number | undefined, requiresValidation: boolean | undefined, vehicleLat: number | null | undefined, vehicleLng: number | null | undefined, vehicleDur: string | null | undefined, vehicleDistance: string | null | undefined, place: string | null | undefined): Observable<TourHistoryModel> {
        let url_ = this.baseUrl + "/api/Tour/CreateHistoryByTourId/{Id}?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{Id}", encodeURIComponent("" + id));
        if (eTA === null)
            throw new Error("The parameter 'eTA' cannot be null.");
        else if (eTA !== undefined)
            url_ += "ETA=" + encodeURIComponent(eTA ? "" + eTA.toISOString() : "") + "&";
        if (isApproved === null)
            throw new Error("The parameter 'isApproved' cannot be null.");
        else if (isApproved !== undefined)
            url_ += "IsApproved=" + encodeURIComponent("" + isApproved) + "&";
        if (note !== undefined && note !== null)
            url_ += "Note=" + encodeURIComponent("" + note) + "&";
        if (rejectionComments !== undefined && rejectionComments !== null)
            url_ += "RejectionComments=" + encodeURIComponent("" + rejectionComments) + "&";
        if (updateTypeLookupId === null)
            throw new Error("The parameter 'updateTypeLookupId' cannot be null.");
        else if (updateTypeLookupId !== undefined)
            url_ += "updateTypeLookupId=" + encodeURIComponent("" + updateTypeLookupId) + "&";
        if (requiresValidation === null)
            throw new Error("The parameter 'requiresValidation' cannot be null.");
        else if (requiresValidation !== undefined)
            url_ += "RequiresValidation=" + encodeURIComponent("" + requiresValidation) + "&";
        if (vehicleLat !== undefined && vehicleLat !== null)
            url_ += "vehicleLat=" + encodeURIComponent("" + vehicleLat) + "&";
        if (vehicleLng !== undefined && vehicleLng !== null)
            url_ += "vehicleLng=" + encodeURIComponent("" + vehicleLng) + "&";
        if (vehicleDur !== undefined && vehicleDur !== null)
            url_ += "vehicleDur=" + encodeURIComponent("" + vehicleDur) + "&";
        if (vehicleDistance !== undefined && vehicleDistance !== null)
            url_ += "vehicleDistance=" + encodeURIComponent("" + vehicleDistance) + "&";
        if (place !== undefined && place !== null)
            url_ += "place=" + encodeURIComponent("" + place) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateHistoryByTourId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateHistoryByTourId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TourHistoryModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TourHistoryModel>;
        }));
    }

    protected processCreateHistoryByTourId(response: HttpResponseBase): Observable<TourHistoryModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TourHistoryModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TourHistoryModel>(null as any);
    }

    updateHistoryItemById(id: number, eTA: Date | undefined, isApproved: boolean | undefined, note: string | null | undefined, rejectionComments: string | null | undefined, requiresValidation: boolean | undefined, isEdit: boolean | undefined): Observable<TourHistoryModel> {
        let url_ = this.baseUrl + "/api/Tour/UpdateHistoryItemById/{Id}?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{Id}", encodeURIComponent("" + id));
        if (eTA === null)
            throw new Error("The parameter 'eTA' cannot be null.");
        else if (eTA !== undefined)
            url_ += "ETA=" + encodeURIComponent(eTA ? "" + eTA.toISOString() : "") + "&";
        if (isApproved === null)
            throw new Error("The parameter 'isApproved' cannot be null.");
        else if (isApproved !== undefined)
            url_ += "IsApproved=" + encodeURIComponent("" + isApproved) + "&";
        if (note !== undefined && note !== null)
            url_ += "Note=" + encodeURIComponent("" + note) + "&";
        if (rejectionComments !== undefined && rejectionComments !== null)
            url_ += "RejectionComments=" + encodeURIComponent("" + rejectionComments) + "&";
        if (requiresValidation === null)
            throw new Error("The parameter 'requiresValidation' cannot be null.");
        else if (requiresValidation !== undefined)
            url_ += "RequiresValidation=" + encodeURIComponent("" + requiresValidation) + "&";
        if (isEdit === null)
            throw new Error("The parameter 'isEdit' cannot be null.");
        else if (isEdit !== undefined)
            url_ += "IsEdit=" + encodeURIComponent("" + isEdit) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateHistoryItemById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateHistoryItemById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TourHistoryModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TourHistoryModel>;
        }));
    }

    protected processUpdateHistoryItemById(response: HttpResponseBase): Observable<TourHistoryModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TourHistoryModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TourHistoryModel>(null as any);
    }

    logAnIssueByTourId(tourId: number, causeOfIssue: string | null | undefined, impact: string | null | undefined, reasonForIssue: string | null | undefined, isLoggedByCustomer: boolean | undefined, hasCustomerBeenCalled: boolean | undefined, hasCarrierBeenCalled: boolean | undefined, notes: string | null | undefined, estimatedDatetime: Date | undefined, historyId: number | undefined, tourHistoryId: number | undefined, status: boolean | undefined, escalateIssue: boolean | undefined, isControlRoom: boolean | undefined, managerActions: string | null | undefined, issueActions: string | null | undefined, priority: string | null | undefined): Observable<LoggedIssueModel> {
        let url_ = this.baseUrl + "/api/Tour/LogAnIssueByTourId/{TourId}?";
        if (tourId === undefined || tourId === null)
            throw new Error("The parameter 'tourId' must be defined.");
        url_ = url_.replace("{TourId}", encodeURIComponent("" + tourId));
        if (causeOfIssue !== undefined && causeOfIssue !== null)
            url_ += "CauseOfIssue=" + encodeURIComponent("" + causeOfIssue) + "&";
        if (impact !== undefined && impact !== null)
            url_ += "Impact=" + encodeURIComponent("" + impact) + "&";
        if (reasonForIssue !== undefined && reasonForIssue !== null)
            url_ += "ReasonForIssue=" + encodeURIComponent("" + reasonForIssue) + "&";
        if (isLoggedByCustomer === null)
            throw new Error("The parameter 'isLoggedByCustomer' cannot be null.");
        else if (isLoggedByCustomer !== undefined)
            url_ += "IsLoggedByCustomer=" + encodeURIComponent("" + isLoggedByCustomer) + "&";
        if (hasCustomerBeenCalled === null)
            throw new Error("The parameter 'hasCustomerBeenCalled' cannot be null.");
        else if (hasCustomerBeenCalled !== undefined)
            url_ += "HasCustomerBeenCalled=" + encodeURIComponent("" + hasCustomerBeenCalled) + "&";
        if (hasCarrierBeenCalled === null)
            throw new Error("The parameter 'hasCarrierBeenCalled' cannot be null.");
        else if (hasCarrierBeenCalled !== undefined)
            url_ += "HasCarrierBeenCalled=" + encodeURIComponent("" + hasCarrierBeenCalled) + "&";
        if (notes !== undefined && notes !== null)
            url_ += "Notes=" + encodeURIComponent("" + notes) + "&";
        if (estimatedDatetime === null)
            throw new Error("The parameter 'estimatedDatetime' cannot be null.");
        else if (estimatedDatetime !== undefined)
            url_ += "EstimatedDatetime=" + encodeURIComponent(estimatedDatetime ? "" + estimatedDatetime.toISOString() : "") + "&";
        if (historyId === null)
            throw new Error("The parameter 'historyId' cannot be null.");
        else if (historyId !== undefined)
            url_ += "HistoryId=" + encodeURIComponent("" + historyId) + "&";
        if (tourHistoryId === null)
            throw new Error("The parameter 'tourHistoryId' cannot be null.");
        else if (tourHistoryId !== undefined)
            url_ += "tourHistoryId=" + encodeURIComponent("" + tourHistoryId) + "&";
        if (status === null)
            throw new Error("The parameter 'status' cannot be null.");
        else if (status !== undefined)
            url_ += "status=" + encodeURIComponent("" + status) + "&";
        if (escalateIssue === null)
            throw new Error("The parameter 'escalateIssue' cannot be null.");
        else if (escalateIssue !== undefined)
            url_ += "escalateIssue=" + encodeURIComponent("" + escalateIssue) + "&";
        if (isControlRoom === null)
            throw new Error("The parameter 'isControlRoom' cannot be null.");
        else if (isControlRoom !== undefined)
            url_ += "isControlRoom=" + encodeURIComponent("" + isControlRoom) + "&";
        if (managerActions !== undefined && managerActions !== null)
            url_ += "managerActions=" + encodeURIComponent("" + managerActions) + "&";
        if (issueActions !== undefined && issueActions !== null)
            url_ += "issueActions=" + encodeURIComponent("" + issueActions) + "&";
        if (priority !== undefined && priority !== null)
            url_ += "priority=" + encodeURIComponent("" + priority) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processLogAnIssueByTourId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLogAnIssueByTourId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LoggedIssueModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LoggedIssueModel>;
        }));
    }

    protected processLogAnIssueByTourId(response: HttpResponseBase): Observable<LoggedIssueModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = LoggedIssueModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<LoggedIssueModel>(null as any);
    }

    closeIssueById(id: number | undefined, tourId: number | undefined): Observable<LoggedIssueModel> {
        let url_ = this.baseUrl + "/api/Tour/CloseIssueById?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        if (tourId === null)
            throw new Error("The parameter 'tourId' cannot be null.");
        else if (tourId !== undefined)
            url_ += "tourId=" + encodeURIComponent("" + tourId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCloseIssueById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCloseIssueById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LoggedIssueModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LoggedIssueModel>;
        }));
    }

    protected processCloseIssueById(response: HttpResponseBase): Observable<LoggedIssueModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = LoggedIssueModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<LoggedIssueModel>(null as any);
    }

    getLoggedIssueByTourId(tourId: number): Observable<LoggedIssueModel[]> {
        let url_ = this.baseUrl + "/api/Tour/GetLoggedIssueByTourId/{TourId}";
        if (tourId === undefined || tourId === null)
            throw new Error("The parameter 'tourId' must be defined.");
        url_ = url_.replace("{TourId}", encodeURIComponent("" + tourId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLoggedIssueByTourId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLoggedIssueByTourId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LoggedIssueModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LoggedIssueModel[]>;
        }));
    }

    protected processGetLoggedIssueByTourId(response: HttpResponseBase): Observable<LoggedIssueModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(LoggedIssueModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<LoggedIssueModel[]>(null as any);
    }

    disableHistoryItemById(id: number, tourId: number | undefined): Observable<TourHistoryModel> {
        let url_ = this.baseUrl + "/api/Tour/DisableHistoryItemById/{Id}?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{Id}", encodeURIComponent("" + id));
        if (tourId === null)
            throw new Error("The parameter 'tourId' cannot be null.");
        else if (tourId !== undefined)
            url_ += "TourId=" + encodeURIComponent("" + tourId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDisableHistoryItemById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDisableHistoryItemById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TourHistoryModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TourHistoryModel>;
        }));
    }

    protected processDisableHistoryItemById(response: HttpResponseBase): Observable<TourHistoryModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TourHistoryModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TourHistoryModel>(null as any);
    }

    makeTourCriticalById(id: number, isCritical: boolean | undefined): Observable<TourModel> {
        let url_ = this.baseUrl + "/api/Tour/MakeTourCriticalById/{Id}?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{Id}", encodeURIComponent("" + id));
        if (isCritical === null)
            throw new Error("The parameter 'isCritical' cannot be null.");
        else if (isCritical !== undefined)
            url_ += "isCritical=" + encodeURIComponent("" + isCritical) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processMakeTourCriticalById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processMakeTourCriticalById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TourModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TourModel>;
        }));
    }

    protected processMakeTourCriticalById(response: HttpResponseBase): Observable<TourModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TourModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TourModel>(null as any);
    }

    updateTrackingFrequencyById(id: number, frequencyId: number | undefined): Observable<TourModel> {
        let url_ = this.baseUrl + "/api/Tour/UpdateTrackingFrequencyById/{Id}?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{Id}", encodeURIComponent("" + id));
        if (frequencyId === null)
            throw new Error("The parameter 'frequencyId' cannot be null.");
        else if (frequencyId !== undefined)
            url_ += "FrequencyId=" + encodeURIComponent("" + frequencyId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateTrackingFrequencyById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateTrackingFrequencyById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TourModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TourModel>;
        }));
    }

    protected processUpdateTrackingFrequencyById(response: HttpResponseBase): Observable<TourModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TourModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TourModel>(null as any);
    }

    makeTourHeldAtCustomsById(id: number, isHeldAtCustoms: boolean | undefined): Observable<TourModel> {
        let url_ = this.baseUrl + "/api/Tour/MakeTourHeldAtCustomsById/{Id}?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{Id}", encodeURIComponent("" + id));
        if (isHeldAtCustoms === null)
            throw new Error("The parameter 'isHeldAtCustoms' cannot be null.");
        else if (isHeldAtCustoms !== undefined)
            url_ += "isHeldAtCustoms=" + encodeURIComponent("" + isHeldAtCustoms) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processMakeTourHeldAtCustomsById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processMakeTourHeldAtCustomsById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TourModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TourModel>;
        }));
    }

    protected processMakeTourHeldAtCustomsById(response: HttpResponseBase): Observable<TourModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TourModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TourModel>(null as any);
    }

    updatedToursSignalR(query: SendToursToUIQuery): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/Tour/UpdatedToursSignalR";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdatedToursSignalR(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdatedToursSignalR(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processUpdatedToursSignalR(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse>(null as any);
    }

    addTrailerRegByTourId(id: number, regNumber: string | null | undefined): Observable<TourModel> {
        let url_ = this.baseUrl + "/api/Tour/AddTrailerRegByTourId/{Id}?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{Id}", encodeURIComponent("" + id));
        if (regNumber !== undefined && regNumber !== null)
            url_ += "RegNumber=" + encodeURIComponent("" + regNumber) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddTrailerRegByTourId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddTrailerRegByTourId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TourModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TourModel>;
        }));
    }

    protected processAddTrailerRegByTourId(response: HttpResponseBase): Observable<TourModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TourModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TourModel>(null as any);
    }

    calculateTimeAndDistance(fromLat: number | undefined, fromLong: number | undefined, toLat: number | undefined, toLong: number | undefined, maxSpeed: number | undefined): Observable<DistanceModel> {
        let url_ = this.baseUrl + "/api/Tour/CalculateTimeAndDistance?";
        if (fromLat === null)
            throw new Error("The parameter 'fromLat' cannot be null.");
        else if (fromLat !== undefined)
            url_ += "fromLat=" + encodeURIComponent("" + fromLat) + "&";
        if (fromLong === null)
            throw new Error("The parameter 'fromLong' cannot be null.");
        else if (fromLong !== undefined)
            url_ += "fromLong=" + encodeURIComponent("" + fromLong) + "&";
        if (toLat === null)
            throw new Error("The parameter 'toLat' cannot be null.");
        else if (toLat !== undefined)
            url_ += "toLat=" + encodeURIComponent("" + toLat) + "&";
        if (toLong === null)
            throw new Error("The parameter 'toLong' cannot be null.");
        else if (toLong !== undefined)
            url_ += "toLong=" + encodeURIComponent("" + toLong) + "&";
        if (maxSpeed === null)
            throw new Error("The parameter 'maxSpeed' cannot be null.");
        else if (maxSpeed !== undefined)
            url_ += "maxSpeed=" + encodeURIComponent("" + maxSpeed) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCalculateTimeAndDistance(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCalculateTimeAndDistance(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DistanceModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DistanceModel>;
        }));
    }

    protected processCalculateTimeAndDistance(response: HttpResponseBase): Observable<DistanceModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DistanceModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<DistanceModel>(null as any);
    }

    saveRouteData(tourId: number | undefined, vehicleId: number | undefined, routeData: string | null | undefined, eventTrigger: string | null | undefined, suggestedETA: Date | undefined, distance: string | null | undefined): Observable<TourVehicleRouteModel> {
        let url_ = this.baseUrl + "/api/Tour/SaveRouteData?";
        if (tourId === null)
            throw new Error("The parameter 'tourId' cannot be null.");
        else if (tourId !== undefined)
            url_ += "tourId=" + encodeURIComponent("" + tourId) + "&";
        if (vehicleId === null)
            throw new Error("The parameter 'vehicleId' cannot be null.");
        else if (vehicleId !== undefined)
            url_ += "vehicleId=" + encodeURIComponent("" + vehicleId) + "&";
        if (routeData !== undefined && routeData !== null)
            url_ += "routeData=" + encodeURIComponent("" + routeData) + "&";
        if (eventTrigger !== undefined && eventTrigger !== null)
            url_ += "eventTrigger=" + encodeURIComponent("" + eventTrigger) + "&";
        if (suggestedETA === null)
            throw new Error("The parameter 'suggestedETA' cannot be null.");
        else if (suggestedETA !== undefined)
            url_ += "suggestedETA=" + encodeURIComponent(suggestedETA ? "" + suggestedETA.toISOString() : "") + "&";
        if (distance !== undefined && distance !== null)
            url_ += "distance=" + encodeURIComponent("" + distance) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSaveRouteData(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSaveRouteData(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TourVehicleRouteModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TourVehicleRouteModel>;
        }));
    }

    protected processSaveRouteData(response: HttpResponseBase): Observable<TourVehicleRouteModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TourVehicleRouteModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TourVehicleRouteModel>(null as any);
    }

    getRouteByTourId(tourId: number): Observable<TourVehicleRouteModel> {
        let url_ = this.baseUrl + "/api/Tour/GetRouteByTourId/{TourId}";
        if (tourId === undefined || tourId === null)
            throw new Error("The parameter 'tourId' must be defined.");
        url_ = url_.replace("{TourId}", encodeURIComponent("" + tourId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetRouteByTourId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRouteByTourId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TourVehicleRouteModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TourVehicleRouteModel>;
        }));
    }

    protected processGetRouteByTourId(response: HttpResponseBase): Observable<TourVehicleRouteModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TourVehicleRouteModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TourVehicleRouteModel>(null as any);
    }

    getLockedTour(id: number): Observable<TourLockedModel> {
        let url_ = this.baseUrl + "/api/Tour/GetLockedTour/{Id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{Id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLockedTour(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLockedTour(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TourLockedModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TourLockedModel>;
        }));
    }

    protected processGetLockedTour(response: HttpResponseBase): Observable<TourLockedModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TourLockedModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TourLockedModel>(null as any);
    }

    removeFromCache(id: number): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/Tour/RemoveLockedTour/{Id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{Id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRemoveFromCache(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRemoveFromCache(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processRemoveFromCache(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse>(null as any);
    }

    recalculateUpdateDue(tourId: number | undefined, toNumber: string | null | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/Tour/RecalculateUpdateDue?";
        if (tourId === null)
            throw new Error("The parameter 'tourId' cannot be null.");
        else if (tourId !== undefined)
            url_ += "tourId=" + encodeURIComponent("" + tourId) + "&";
        if (toNumber !== undefined && toNumber !== null)
            url_ += "toNumber=" + encodeURIComponent("" + toNumber) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRecalculateUpdateDue(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRecalculateUpdateDue(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processRecalculateUpdateDue(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(null as any);
    }
}

export interface ITransportClient {
    getTransportList(command: GetTransportQuery): Observable<PagedListingResponseOfTransportModel>;
    getTransportById(id: number): Observable<TransportModel>;
}

@Injectable({
    providedIn: 'root'
})
export class TransportClient implements ITransportClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    getTransportList(command: GetTransportQuery): Observable<PagedListingResponseOfTransportModel> {
        let url_ = this.baseUrl + "/api/Transport/GetTransport";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTransportList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTransportList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedListingResponseOfTransportModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedListingResponseOfTransportModel>;
        }));
    }

    protected processGetTransportList(response: HttpResponseBase): Observable<PagedListingResponseOfTransportModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedListingResponseOfTransportModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedListingResponseOfTransportModel>(null as any);
    }

    getTransportById(id: number): Observable<TransportModel> {
        let url_ = this.baseUrl + "/api/Transport/GetTransportById/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTransportById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTransportById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TransportModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TransportModel>;
        }));
    }

    protected processGetTransportById(response: HttpResponseBase): Observable<TransportModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TransportModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TransportModel>(null as any);
    }
}

export interface IUpdateTypeClient {
    getUpdateTypes(): Observable<UpdateTypeModel[]>;
    getUpdateTypeConnections(): Observable<UpdateTypeConnectionsModel[]>;
    getUpdateTypeConnectionsByParentId(parentId: number): Observable<UpdateTypeConnectionsModel[]>;
}

@Injectable({
    providedIn: 'root'
})
export class UpdateTypeClient implements IUpdateTypeClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    getUpdateTypes(): Observable<UpdateTypeModel[]> {
        let url_ = this.baseUrl + "/api/UpdateType/GetUpdateTypes";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUpdateTypes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUpdateTypes(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UpdateTypeModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UpdateTypeModel[]>;
        }));
    }

    protected processGetUpdateTypes(response: HttpResponseBase): Observable<UpdateTypeModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(UpdateTypeModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UpdateTypeModel[]>(null as any);
    }

    getUpdateTypeConnections(): Observable<UpdateTypeConnectionsModel[]> {
        let url_ = this.baseUrl + "/api/UpdateType/GetUpdateTypeConnections";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUpdateTypeConnections(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUpdateTypeConnections(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UpdateTypeConnectionsModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UpdateTypeConnectionsModel[]>;
        }));
    }

    protected processGetUpdateTypeConnections(response: HttpResponseBase): Observable<UpdateTypeConnectionsModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(UpdateTypeConnectionsModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UpdateTypeConnectionsModel[]>(null as any);
    }

    getUpdateTypeConnectionsByParentId(parentId: number): Observable<UpdateTypeConnectionsModel[]> {
        let url_ = this.baseUrl + "/api/UpdateType/GetUpdateTypeConnectionsByParentId/{parentId}";
        if (parentId === undefined || parentId === null)
            throw new Error("The parameter 'parentId' must be defined.");
        url_ = url_.replace("{parentId}", encodeURIComponent("" + parentId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUpdateTypeConnectionsByParentId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUpdateTypeConnectionsByParentId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UpdateTypeConnectionsModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UpdateTypeConnectionsModel[]>;
        }));
    }

    protected processGetUpdateTypeConnectionsByParentId(response: HttpResponseBase): Observable<UpdateTypeConnectionsModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(UpdateTypeConnectionsModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UpdateTypeConnectionsModel[]>(null as any);
    }
}

export interface IUsersClient {
    authenticateUser(command: AuthenticateUserCommand): Observable<IssuedTokenModel>;
    authenticateMobile(username: string | null | undefined, password: string | null | undefined): Observable<IssuedTokenModel>;
    createUser(command: CreateUserCommand): Observable<UserModel>;
    updateUser(command: UpdateUserCommand): Observable<UserModel>;
    getAllUsers(): Observable<UserModel[]>;
    enableUser(id: string): Observable<FileResponse>;
    disableUser(id: string): Observable<FileResponse>;
    getUserById(id: string): Observable<UserModel>;
    searchActiveDirectoryUsers(username: string | null | undefined): Observable<ActiveDirectoryUserModel[]>;
    getRolesByUserId(userId: string): Observable<UserModel>;
    resetPassword(command: ResetPasswordCommand): Observable<ResetPasswordResponse>;
    requestPasswordReset(command: RequestPasswordResetCommand): Observable<RequestPasswordResetResponse>;
    hasAuthenticatorConfigured(username: string | null): Observable<boolean>;
    registerAuthenticator(username: string | null): Observable<QrCodeSetupModel>;
    unRegisterAuthenticator(username: string | null): Observable<FileResponse>;
    unlockAccountWithAuthenticator(pin: number | undefined, key: string | undefined): Observable<FileResponse>;
    createAuthenticatorPinRequest(username: string | null): Observable<PinRequestModel>;
    enableDisable2FA(username: string | null | undefined, enabled: boolean | undefined): Observable<FileResponse>;
    has2FAEnabled(username: string | null): Observable<boolean>;
    resetPasswordWithAuthenticator(pin: number | undefined, key: string | undefined): Observable<FileResponse>;
    isAccountLocked(username: string | null): Observable<boolean>;
    unlockAccount(username: string | null | undefined, islocked: boolean | undefined): Observable<FileResponse>;
}

@Injectable({
    providedIn: 'root'
})
export class UsersClient implements IUsersClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    authenticateUser(command: AuthenticateUserCommand): Observable<IssuedTokenModel> {
        let url_ = this.baseUrl + "/api/Users/Authenticate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAuthenticateUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAuthenticateUser(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<IssuedTokenModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<IssuedTokenModel>;
        }));
    }

    protected processAuthenticateUser(response: HttpResponseBase): Observable<IssuedTokenModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = IssuedTokenModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<IssuedTokenModel>(null as any);
    }

    authenticateMobile(username: string | null | undefined, password: string | null | undefined): Observable<IssuedTokenModel> {
        let url_ = this.baseUrl + "/api/Users/AuthenticateMobile";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (username !== null && username !== undefined)
            content_.append("Username", username.toString());
        if (password !== null && password !== undefined)
            content_.append("Password", password.toString());

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAuthenticateMobile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAuthenticateMobile(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<IssuedTokenModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<IssuedTokenModel>;
        }));
    }

    protected processAuthenticateMobile(response: HttpResponseBase): Observable<IssuedTokenModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = IssuedTokenModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<IssuedTokenModel>(null as any);
    }

    createUser(command: CreateUserCommand): Observable<UserModel> {
        let url_ = this.baseUrl + "/api/Users";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateUser(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserModel>;
        }));
    }

    protected processCreateUser(response: HttpResponseBase): Observable<UserModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UserModel>(null as any);
    }

    updateUser(command: UpdateUserCommand): Observable<UserModel> {
        let url_ = this.baseUrl + "/api/Users";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateUser(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserModel>;
        }));
    }

    protected processUpdateUser(response: HttpResponseBase): Observable<UserModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UserModel>(null as any);
    }

    getAllUsers(): Observable<UserModel[]> {
        let url_ = this.baseUrl + "/api/Users";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllUsers(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllUsers(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserModel[]>;
        }));
    }

    protected processGetAllUsers(response: HttpResponseBase): Observable<UserModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(UserModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UserModel[]>(null as any);
    }

    enableUser(id: string): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/Users/{id}/Enable";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processEnableUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processEnableUser(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processEnableUser(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse>(null as any);
    }

    disableUser(id: string): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/Users/{id}/Disable";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDisableUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDisableUser(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processDisableUser(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse>(null as any);
    }

    getUserById(id: string): Observable<UserModel> {
        let url_ = this.baseUrl + "/api/Users/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUserById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUserById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserModel>;
        }));
    }

    protected processGetUserById(response: HttpResponseBase): Observable<UserModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UserModel>(null as any);
    }

    searchActiveDirectoryUsers(username: string | null | undefined): Observable<ActiveDirectoryUserModel[]> {
        let url_ = this.baseUrl + "/api/Users/SearchActiveDirectoryUsers?";
        if (username !== undefined && username !== null)
            url_ += "username=" + encodeURIComponent("" + username) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSearchActiveDirectoryUsers(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSearchActiveDirectoryUsers(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ActiveDirectoryUserModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ActiveDirectoryUserModel[]>;
        }));
    }

    protected processSearchActiveDirectoryUsers(response: HttpResponseBase): Observable<ActiveDirectoryUserModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ActiveDirectoryUserModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ActiveDirectoryUserModel[]>(null as any);
    }

    getRolesByUserId(userId: string): Observable<UserModel> {
        let url_ = this.baseUrl + "/api/Users/{userId}/Roles";
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetRolesByUserId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRolesByUserId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserModel>;
        }));
    }

    protected processGetRolesByUserId(response: HttpResponseBase): Observable<UserModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UserModel>(null as any);
    }

    resetPassword(command: ResetPasswordCommand): Observable<ResetPasswordResponse> {
        let url_ = this.baseUrl + "/api/Users/ResetPassword";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processResetPassword(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processResetPassword(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResetPasswordResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResetPasswordResponse>;
        }));
    }

    protected processResetPassword(response: HttpResponseBase): Observable<ResetPasswordResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResetPasswordResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResetPasswordResponse>(null as any);
    }

    requestPasswordReset(command: RequestPasswordResetCommand): Observable<RequestPasswordResetResponse> {
        let url_ = this.baseUrl + "/api/Users/RequestPasswordReset";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRequestPasswordReset(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRequestPasswordReset(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RequestPasswordResetResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RequestPasswordResetResponse>;
        }));
    }

    protected processRequestPasswordReset(response: HttpResponseBase): Observable<RequestPasswordResetResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RequestPasswordResetResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<RequestPasswordResetResponse>(null as any);
    }

    hasAuthenticatorConfigured(username: string | null): Observable<boolean> {
        let url_ = this.baseUrl + "/api/Users/HasAuthenticatorConfigured/{Username}";
        if (username === undefined || username === null)
            throw new Error("The parameter 'username' must be defined.");
        url_ = url_.replace("{Username}", encodeURIComponent("" + username));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processHasAuthenticatorConfigured(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processHasAuthenticatorConfigured(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processHasAuthenticatorConfigured(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(null as any);
    }

    registerAuthenticator(username: string | null): Observable<QrCodeSetupModel> {
        let url_ = this.baseUrl + "/api/Users/RegisterAuthenticator/{username}";
        if (username === undefined || username === null)
            throw new Error("The parameter 'username' must be defined.");
        url_ = url_.replace("{username}", encodeURIComponent("" + username));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRegisterAuthenticator(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRegisterAuthenticator(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<QrCodeSetupModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<QrCodeSetupModel>;
        }));
    }

    protected processRegisterAuthenticator(response: HttpResponseBase): Observable<QrCodeSetupModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = QrCodeSetupModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<QrCodeSetupModel>(null as any);
    }

    unRegisterAuthenticator(username: string | null): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/Users/UnRegisterAuthenticator/{username}";
        if (username === undefined || username === null)
            throw new Error("The parameter 'username' must be defined.");
        url_ = url_.replace("{username}", encodeURIComponent("" + username));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUnRegisterAuthenticator(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUnRegisterAuthenticator(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processUnRegisterAuthenticator(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse>(null as any);
    }

    unlockAccountWithAuthenticator(pin: number | undefined, key: string | undefined): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/Users/UnlockAccountWithAuthenticator?";
        if (pin === null)
            throw new Error("The parameter 'pin' cannot be null.");
        else if (pin !== undefined)
            url_ += "pin=" + encodeURIComponent("" + pin) + "&";
        if (key === null)
            throw new Error("The parameter 'key' cannot be null.");
        else if (key !== undefined)
            url_ += "key=" + encodeURIComponent("" + key) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUnlockAccountWithAuthenticator(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUnlockAccountWithAuthenticator(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processUnlockAccountWithAuthenticator(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse>(null as any);
    }

    createAuthenticatorPinRequest(username: string | null): Observable<PinRequestModel> {
        let url_ = this.baseUrl + "/api/Users/CreateAuthenticatorPinRequest/{username}";
        if (username === undefined || username === null)
            throw new Error("The parameter 'username' must be defined.");
        url_ = url_.replace("{username}", encodeURIComponent("" + username));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateAuthenticatorPinRequest(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateAuthenticatorPinRequest(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PinRequestModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PinRequestModel>;
        }));
    }

    protected processCreateAuthenticatorPinRequest(response: HttpResponseBase): Observable<PinRequestModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PinRequestModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PinRequestModel>(null as any);
    }

    enableDisable2FA(username: string | null | undefined, enabled: boolean | undefined): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/Users/EnableDisable2FA?";
        if (username !== undefined && username !== null)
            url_ += "username=" + encodeURIComponent("" + username) + "&";
        if (enabled === null)
            throw new Error("The parameter 'enabled' cannot be null.");
        else if (enabled !== undefined)
            url_ += "enabled=" + encodeURIComponent("" + enabled) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processEnableDisable2FA(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processEnableDisable2FA(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processEnableDisable2FA(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse>(null as any);
    }

    has2FAEnabled(username: string | null): Observable<boolean> {
        let url_ = this.baseUrl + "/api/Users/Has2FAEnabled/{username}";
        if (username === undefined || username === null)
            throw new Error("The parameter 'username' must be defined.");
        url_ = url_.replace("{username}", encodeURIComponent("" + username));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processHas2FAEnabled(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processHas2FAEnabled(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processHas2FAEnabled(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(null as any);
    }

    resetPasswordWithAuthenticator(pin: number | undefined, key: string | undefined): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/Users/ResetPasswordWithAuthenticator?";
        if (pin === null)
            throw new Error("The parameter 'pin' cannot be null.");
        else if (pin !== undefined)
            url_ += "pin=" + encodeURIComponent("" + pin) + "&";
        if (key === null)
            throw new Error("The parameter 'key' cannot be null.");
        else if (key !== undefined)
            url_ += "key=" + encodeURIComponent("" + key) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processResetPasswordWithAuthenticator(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processResetPasswordWithAuthenticator(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processResetPasswordWithAuthenticator(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse>(null as any);
    }

    isAccountLocked(username: string | null): Observable<boolean> {
        let url_ = this.baseUrl + "/api/Users/IsAccountLocked/{username}";
        if (username === undefined || username === null)
            throw new Error("The parameter 'username' must be defined.");
        url_ = url_.replace("{username}", encodeURIComponent("" + username));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processIsAccountLocked(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processIsAccountLocked(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processIsAccountLocked(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(null as any);
    }

    unlockAccount(username: string | null | undefined, islocked: boolean | undefined): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/Users/UnlockAccount?";
        if (username !== undefined && username !== null)
            url_ += "username=" + encodeURIComponent("" + username) + "&";
        if (islocked === null)
            throw new Error("The parameter 'islocked' cannot be null.");
        else if (islocked !== undefined)
            url_ += "islocked=" + encodeURIComponent("" + islocked) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUnlockAccount(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUnlockAccount(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processUnlockAccount(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse>(null as any);
    }
}

export interface IVehiclesClient {
    getVehicleById(id: number): Observable<VehicleModel>;
    getAllVehicles(searchTerm: string | null | undefined): Observable<VehicleModel[]>;
    getVehicleRegistrationLookup(searchTerm: string | null | undefined): Observable<VehicleRegistrationLookupModel[]>;
    addVehicle(regNumber: string | null, id: number | undefined): Observable<VehicleModel>;
    getVehicleSpeedByType(vehicleType: string | null): Observable<VehicleTypesSpeedModel>;
}

@Injectable({
    providedIn: 'root'
})
export class VehiclesClient implements IVehiclesClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    getVehicleById(id: number): Observable<VehicleModel> {
        let url_ = this.baseUrl + "/api/Vehicles/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetVehicleById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetVehicleById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<VehicleModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<VehicleModel>;
        }));
    }

    protected processGetVehicleById(response: HttpResponseBase): Observable<VehicleModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = VehicleModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<VehicleModel>(null as any);
    }

    getAllVehicles(searchTerm: string | null | undefined): Observable<VehicleModel[]> {
        let url_ = this.baseUrl + "/api/Vehicles?";
        if (searchTerm !== undefined && searchTerm !== null)
            url_ += "searchTerm=" + encodeURIComponent("" + searchTerm) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllVehicles(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllVehicles(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<VehicleModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<VehicleModel[]>;
        }));
    }

    protected processGetAllVehicles(response: HttpResponseBase): Observable<VehicleModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(VehicleModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<VehicleModel[]>(null as any);
    }

    getVehicleRegistrationLookup(searchTerm: string | null | undefined): Observable<VehicleRegistrationLookupModel[]> {
        let url_ = this.baseUrl + "/api/Vehicles/Lookup?";
        if (searchTerm !== undefined && searchTerm !== null)
            url_ += "searchTerm=" + encodeURIComponent("" + searchTerm) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetVehicleRegistrationLookup(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetVehicleRegistrationLookup(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<VehicleRegistrationLookupModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<VehicleRegistrationLookupModel[]>;
        }));
    }

    protected processGetVehicleRegistrationLookup(response: HttpResponseBase): Observable<VehicleRegistrationLookupModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(VehicleRegistrationLookupModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<VehicleRegistrationLookupModel[]>(null as any);
    }

    addVehicle(regNumber: string | null, id: number | undefined): Observable<VehicleModel> {
        let url_ = this.baseUrl + "/api/Vehicles/{regNumber}?";
        if (regNumber === undefined || regNumber === null)
            throw new Error("The parameter 'regNumber' must be defined.");
        url_ = url_.replace("{regNumber}", encodeURIComponent("" + regNumber));
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddVehicle(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddVehicle(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<VehicleModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<VehicleModel>;
        }));
    }

    protected processAddVehicle(response: HttpResponseBase): Observable<VehicleModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = VehicleModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<VehicleModel>(null as any);
    }

    getVehicleSpeedByType(vehicleType: string | null): Observable<VehicleTypesSpeedModel> {
        let url_ = this.baseUrl + "/api/Vehicles/GetVehicleSpeedByType/{vehicleType}";
        if (vehicleType === undefined || vehicleType === null)
            throw new Error("The parameter 'vehicleType' must be defined.");
        url_ = url_.replace("{vehicleType}", encodeURIComponent("" + vehicleType));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetVehicleSpeedByType(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetVehicleSpeedByType(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<VehicleTypesSpeedModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<VehicleTypesSpeedModel>;
        }));
    }

    protected processGetVehicleSpeedByType(response: HttpResponseBase): Observable<VehicleTypesSpeedModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = VehicleTypesSpeedModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<VehicleTypesSpeedModel>(null as any);
    }
}

export interface IWorkSplitClient {
    workSplit(userId: string[] | null | undefined, category: number | undefined): Observable<TourModel[]>;
    workUnSplit(): Observable<TourModel[]>;
}

@Injectable({
    providedIn: 'root'
})
export class WorkSplitClient implements IWorkSplitClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    workSplit(userId: string[] | null | undefined, category: number | undefined): Observable<TourModel[]> {
        let url_ = this.baseUrl + "/api/WorkSplit/WorkSplit?";
        if (userId !== undefined && userId !== null)
            userId && userId.forEach(item => { url_ += "userId=" + encodeURIComponent("" + item) + "&"; });
        if (category === null)
            throw new Error("The parameter 'category' cannot be null.");
        else if (category !== undefined)
            url_ += "category=" + encodeURIComponent("" + category) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processWorkSplit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processWorkSplit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TourModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TourModel[]>;
        }));
    }

    protected processWorkSplit(response: HttpResponseBase): Observable<TourModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(TourModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TourModel[]>(null as any);
    }

    workUnSplit(): Observable<TourModel[]> {
        let url_ = this.baseUrl + "/api/WorkSplit/WorkUnSplit";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processWorkUnSplit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processWorkUnSplit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TourModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TourModel[]>;
        }));
    }

    protected processWorkUnSplit(response: HttpResponseBase): Observable<TourModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(TourModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TourModel[]>(null as any);
    }
}

export class AuditModel implements IAuditModel {
    entityId?: string | undefined;
    entityName?: string | undefined;
    action?: string | undefined;
    fieldName?: string | undefined;
    oldValue?: string | undefined;
    newValue?: string | undefined;
    auditDate?: Date;
    userName?: string | undefined;

    constructor(data?: IAuditModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.entityId = _data["entityId"];
            this.entityName = _data["entityName"];
            this.action = _data["action"];
            this.fieldName = _data["fieldName"];
            this.oldValue = _data["oldValue"];
            this.newValue = _data["newValue"];
            this.auditDate = _data["auditDate"] ? new Date(_data["auditDate"].toString()) : <any>undefined;
            this.userName = _data["userName"];
        }
    }

    static fromJS(data: any): AuditModel {
        data = typeof data === 'object' ? data : {};
        let result = new AuditModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["entityId"] = this.entityId;
        data["entityName"] = this.entityName;
        data["action"] = this.action;
        data["fieldName"] = this.fieldName;
        data["oldValue"] = this.oldValue;
        data["newValue"] = this.newValue;
        data["auditDate"] = this.auditDate ? this.auditDate.toISOString() : <any>undefined;
        data["userName"] = this.userName;
        return data;
    }
}

export interface IAuditModel {
    entityId?: string | undefined;
    entityName?: string | undefined;
    action?: string | undefined;
    fieldName?: string | undefined;
    oldValue?: string | undefined;
    newValue?: string | undefined;
    auditDate?: Date;
    userName?: string | undefined;
}

export class AuditsModel implements IAuditsModel {
    updateType?: string | undefined;
    date?: string | undefined;
    updatedAt?: Date;
    user?: string | undefined;
    note?: string | undefined;

    constructor(data?: IAuditsModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.updateType = _data["updateType"];
            this.date = _data["date"];
            this.updatedAt = _data["updatedAt"] ? new Date(_data["updatedAt"].toString()) : <any>undefined;
            this.user = _data["user"];
            this.note = _data["note"];
        }
    }

    static fromJS(data: any): AuditsModel {
        data = typeof data === 'object' ? data : {};
        let result = new AuditsModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["updateType"] = this.updateType;
        data["date"] = this.date;
        data["updatedAt"] = this.updatedAt ? this.updatedAt.toISOString() : <any>undefined;
        data["user"] = this.user;
        data["note"] = this.note;
        return data;
    }
}

export interface IAuditsModel {
    updateType?: string | undefined;
    date?: string | undefined;
    updatedAt?: Date;
    user?: string | undefined;
    note?: string | undefined;
}

export class BmwChatHistoryModel implements IBmwChatHistoryModel {
    tourId?: number;
    amcoId?: number;
    message?: string | undefined;
    type?: string | undefined;
    createdBy?: string | undefined;
    createdAt?: Date;

    constructor(data?: IBmwChatHistoryModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tourId = _data["tourId"];
            this.amcoId = _data["amcoId"];
            this.message = _data["message"];
            this.type = _data["type"];
            this.createdBy = _data["createdBy"];
            this.createdAt = _data["createdAt"] ? new Date(_data["createdAt"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): BmwChatHistoryModel {
        data = typeof data === 'object' ? data : {};
        let result = new BmwChatHistoryModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tourId"] = this.tourId;
        data["amcoId"] = this.amcoId;
        data["message"] = this.message;
        data["type"] = this.type;
        data["createdBy"] = this.createdBy;
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : <any>undefined;
        return data;
    }
}

export interface IBmwChatHistoryModel {
    tourId?: number;
    amcoId?: number;
    message?: string | undefined;
    type?: string | undefined;
    createdBy?: string | undefined;
    createdAt?: Date;
}

export class ConnectionResponseModel implements IConnectionResponseModel {
    mobileVersionNumber?: string | undefined;

    constructor(data?: IConnectionResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.mobileVersionNumber = _data["mobileVersionNumber"];
        }
    }

    static fromJS(data: any): ConnectionResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new ConnectionResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["mobileVersionNumber"] = this.mobileVersionNumber;
        return data;
    }
}

export interface IConnectionResponseModel {
    mobileVersionNumber?: string | undefined;
}

export class ControlTowerTourModel implements IControlTowerTourModel {
    id?: number;
    tourId?: number;
    amcoId?: number;
    categoryType?: string | undefined;
    regNumber?: string | undefined;
    collectionAddress?: string | undefined;
    collectionLat?: number | undefined;
    collectionLong?: number | undefined;
    destinationAddress?: string | undefined;
    destinationLat?: number | undefined;
    destinationLong?: number | undefined;
    plannedLoadingEnd?: string | undefined;
    plannedDeliveryEnd?: Date;
    estimatedDatetime?: Date;
    updateDueDate?: Date | undefined;
    categoryLookupId?: number | undefined;
    toNumber?: string | undefined;
    currentVehiclePosistionDatetime?: Date | undefined;
    type?: string | undefined;
    vehicleEvents?: LatLngModel[] | undefined;

    constructor(data?: IControlTowerTourModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.tourId = _data["tourId"];
            this.amcoId = _data["amcoId"];
            this.categoryType = _data["categoryType"];
            this.regNumber = _data["regNumber"];
            this.collectionAddress = _data["collectionAddress"];
            this.collectionLat = _data["collectionLat"];
            this.collectionLong = _data["collectionLong"];
            this.destinationAddress = _data["destinationAddress"];
            this.destinationLat = _data["destinationLat"];
            this.destinationLong = _data["destinationLong"];
            this.plannedLoadingEnd = _data["plannedLoadingEnd"];
            this.plannedDeliveryEnd = _data["plannedDeliveryEnd"] ? new Date(_data["plannedDeliveryEnd"].toString()) : <any>undefined;
            this.estimatedDatetime = _data["estimatedDatetime"] ? new Date(_data["estimatedDatetime"].toString()) : <any>undefined;
            this.updateDueDate = _data["updateDueDate"] ? new Date(_data["updateDueDate"].toString()) : <any>undefined;
            this.categoryLookupId = _data["categoryLookupId"];
            this.toNumber = _data["toNumber"];
            this.currentVehiclePosistionDatetime = _data["currentVehiclePosistionDatetime"] ? new Date(_data["currentVehiclePosistionDatetime"].toString()) : <any>undefined;
            this.type = _data["type"];
            if (Array.isArray(_data["vehicleEvents"])) {
                this.vehicleEvents = [] as any;
                for (let item of _data["vehicleEvents"])
                    this.vehicleEvents!.push(LatLngModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ControlTowerTourModel {
        data = typeof data === 'object' ? data : {};
        let result = new ControlTowerTourModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["tourId"] = this.tourId;
        data["amcoId"] = this.amcoId;
        data["categoryType"] = this.categoryType;
        data["regNumber"] = this.regNumber;
        data["collectionAddress"] = this.collectionAddress;
        data["collectionLat"] = this.collectionLat;
        data["collectionLong"] = this.collectionLong;
        data["destinationAddress"] = this.destinationAddress;
        data["destinationLat"] = this.destinationLat;
        data["destinationLong"] = this.destinationLong;
        data["plannedLoadingEnd"] = this.plannedLoadingEnd;
        data["plannedDeliveryEnd"] = this.plannedDeliveryEnd ? this.plannedDeliveryEnd.toISOString() : <any>undefined;
        data["estimatedDatetime"] = this.estimatedDatetime ? this.estimatedDatetime.toISOString() : <any>undefined;
        data["updateDueDate"] = this.updateDueDate ? this.updateDueDate.toISOString() : <any>undefined;
        data["categoryLookupId"] = this.categoryLookupId;
        data["toNumber"] = this.toNumber;
        data["currentVehiclePosistionDatetime"] = this.currentVehiclePosistionDatetime ? this.currentVehiclePosistionDatetime.toISOString() : <any>undefined;
        data["type"] = this.type;
        if (Array.isArray(this.vehicleEvents)) {
            data["vehicleEvents"] = [];
            for (let item of this.vehicleEvents)
                data["vehicleEvents"].push(item.toJSON());
        }
        return data;
    }
}

export interface IControlTowerTourModel {
    id?: number;
    tourId?: number;
    amcoId?: number;
    categoryType?: string | undefined;
    regNumber?: string | undefined;
    collectionAddress?: string | undefined;
    collectionLat?: number | undefined;
    collectionLong?: number | undefined;
    destinationAddress?: string | undefined;
    destinationLat?: number | undefined;
    destinationLong?: number | undefined;
    plannedLoadingEnd?: string | undefined;
    plannedDeliveryEnd?: Date;
    estimatedDatetime?: Date;
    updateDueDate?: Date | undefined;
    categoryLookupId?: number | undefined;
    toNumber?: string | undefined;
    currentVehiclePosistionDatetime?: Date | undefined;
    type?: string | undefined;
    vehicleEvents?: LatLngModel[] | undefined;
}

export class LatLngModel implements ILatLngModel {
    lat?: number | undefined;
    lng?: number | undefined;

    constructor(data?: ILatLngModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.lat = _data["lat"];
            this.lng = _data["lng"];
        }
    }

    static fromJS(data: any): LatLngModel {
        data = typeof data === 'object' ? data : {};
        let result = new LatLngModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["lat"] = this.lat;
        data["lng"] = this.lng;
        return data;
    }
}

export interface ILatLngModel {
    lat?: number | undefined;
    lng?: number | undefined;
}

export class EscalatedToursModel implements IEscalatedToursModel {
    id?: number;
    toNumber?: string | undefined;
    amcoId?: number;
    tourId?: number;
    customer?: string | undefined;
    categoryType?: string | undefined;
    topic?: string | undefined;
    updateBy?: string | undefined;
    updatedAt?: Date;
    status?: boolean;
    priority?: string | undefined;
    closedAt?: Date | undefined;
    createdAt?: Date | undefined;

    constructor(data?: IEscalatedToursModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.toNumber = _data["toNumber"];
            this.amcoId = _data["amcoId"];
            this.tourId = _data["tourId"];
            this.customer = _data["customer"];
            this.categoryType = _data["categoryType"];
            this.topic = _data["topic"];
            this.updateBy = _data["updateBy"];
            this.updatedAt = _data["updatedAt"] ? new Date(_data["updatedAt"].toString()) : <any>undefined;
            this.status = _data["status"];
            this.priority = _data["priority"];
            this.closedAt = _data["closedAt"] ? new Date(_data["closedAt"].toString()) : <any>undefined;
            this.createdAt = _data["createdAt"] ? new Date(_data["createdAt"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): EscalatedToursModel {
        data = typeof data === 'object' ? data : {};
        let result = new EscalatedToursModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["toNumber"] = this.toNumber;
        data["amcoId"] = this.amcoId;
        data["tourId"] = this.tourId;
        data["customer"] = this.customer;
        data["categoryType"] = this.categoryType;
        data["topic"] = this.topic;
        data["updateBy"] = this.updateBy;
        data["updatedAt"] = this.updatedAt ? this.updatedAt.toISOString() : <any>undefined;
        data["status"] = this.status;
        data["priority"] = this.priority;
        data["closedAt"] = this.closedAt ? this.closedAt.toISOString() : <any>undefined;
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : <any>undefined;
        return data;
    }
}

export interface IEscalatedToursModel {
    id?: number;
    toNumber?: string | undefined;
    amcoId?: number;
    tourId?: number;
    customer?: string | undefined;
    categoryType?: string | undefined;
    topic?: string | undefined;
    updateBy?: string | undefined;
    updatedAt?: Date;
    status?: boolean;
    priority?: string | undefined;
    closedAt?: Date | undefined;
    createdAt?: Date | undefined;
}

export class DashboardModel implements IDashboardModel {
    description?: string | undefined;
    count?: number;

    constructor(data?: IDashboardModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.description = _data["description"];
            this.count = _data["count"];
        }
    }

    static fromJS(data: any): DashboardModel {
        data = typeof data === 'object' ? data : {};
        let result = new DashboardModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["description"] = this.description;
        data["count"] = this.count;
        return data;
    }
}

export interface IDashboardModel {
    description?: string | undefined;
    count?: number;
}

export class EscalationHistoryModel implements IEscalationHistoryModel {
    tourId?: number;
    amcoId?: number;
    message?: string | undefined;
    type?: string | undefined;
    createdBy?: string | undefined;
    createdAt?: Date;

    constructor(data?: IEscalationHistoryModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tourId = _data["tourId"];
            this.amcoId = _data["amcoId"];
            this.message = _data["message"];
            this.type = _data["type"];
            this.createdBy = _data["createdBy"];
            this.createdAt = _data["createdAt"] ? new Date(_data["createdAt"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): EscalationHistoryModel {
        data = typeof data === 'object' ? data : {};
        let result = new EscalationHistoryModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tourId"] = this.tourId;
        data["amcoId"] = this.amcoId;
        data["message"] = this.message;
        data["type"] = this.type;
        data["createdBy"] = this.createdBy;
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : <any>undefined;
        return data;
    }
}

export interface IEscalationHistoryModel {
    tourId?: number;
    amcoId?: number;
    message?: string | undefined;
    type?: string | undefined;
    createdBy?: string | undefined;
    createdAt?: Date;
}

export class CustomerModel implements ICustomerModel {
    id?: number;
    customerName?: string | undefined;
    customerNumber?: string | undefined;
    city?: string | undefined;
    country?: string | undefined;

    constructor(data?: ICustomerModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.customerName = _data["customerName"];
            this.customerNumber = _data["customerNumber"];
            this.city = _data["city"];
            this.country = _data["country"];
        }
    }

    static fromJS(data: any): CustomerModel {
        data = typeof data === 'object' ? data : {};
        let result = new CustomerModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["customerName"] = this.customerName;
        data["customerNumber"] = this.customerNumber;
        data["city"] = this.city;
        data["country"] = this.country;
        return data;
    }
}

export interface ICustomerModel {
    id?: number;
    customerName?: string | undefined;
    customerNumber?: string | undefined;
    city?: string | undefined;
    country?: string | undefined;
}

export class UserCustomerModel implements IUserCustomerModel {
    userId?: string;
    customerId?: number;
    userRole?: string | undefined;

    constructor(data?: IUserCustomerModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.customerId = _data["customerId"];
            this.userRole = _data["userRole"];
        }
    }

    static fromJS(data: any): UserCustomerModel {
        data = typeof data === 'object' ? data : {};
        let result = new UserCustomerModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["customerId"] = this.customerId;
        data["userRole"] = this.userRole;
        return data;
    }
}

export interface IUserCustomerModel {
    userId?: string;
    customerId?: number;
    userRole?: string | undefined;
}

export class CustomerContactPersonModel implements ICustomerContactPersonModel {
    id?: number;
    email?: string | undefined;
    isEditing?: boolean | undefined;

    constructor(data?: ICustomerContactPersonModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.email = _data["email"];
            this.isEditing = _data["isEditing"];
        }
    }

    static fromJS(data: any): CustomerContactPersonModel {
        data = typeof data === 'object' ? data : {};
        let result = new CustomerContactPersonModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["email"] = this.email;
        data["isEditing"] = this.isEditing;
        return data;
    }
}

export interface ICustomerContactPersonModel {
    id?: number;
    email?: string | undefined;
    isEditing?: boolean | undefined;
}

export class TourModel implements ITourModel {
    id?: number;
    tourId?: number;
    amcoId?: number;
    destination?: string | undefined;
    targetDateTime?: Date;
    estimatedDateTime?: Date | undefined;
    assignedUser?: string | undefined;
    departmentName?: string | undefined;
    updateTypeName?: string | undefined;
    categoryName?: string | undefined;
    customerName?: string | undefined;
    type?: string | undefined;
    typeName?: string | undefined;
    notesYesNo?: boolean;
    completed?: boolean;
    lastModifiedDate?: Date | undefined;
    lastModifiedBy?: string | undefined;
    vehicleId?: number | undefined;
    destinationLatitude?: number | undefined;
    destinationLongitude?: number | undefined;
    lastLatitude?: number | undefined;
    lastLongitude?: number | undefined;
    regNumber?: string | undefined;
    aheadMinutes?: number | undefined;
    behindMinutes?: number | undefined;
    departmentLookupId?: number;
    categoryLookupId?: number;
    typeLookupId?: number;
    updateTypeLookupId?: number;
    name?: string | undefined;
    city?: string | undefined;
    country?: string | undefined;
    orderNumber?: string | undefined;
    customerNumber?: string | undefined;
    orderdate?: string | undefined;
    orderType?: string | undefined;
    totalSalesInGBP?: string | undefined;
    consignmentNumber?: string | undefined;
    receiverCountry?: string | undefined;
    receiverName?: string | undefined;
    receiverCity?: string | undefined;
    transportOrderNumber?: string | undefined;
    senderCountry?: string | undefined;
    senderName?: string | undefined;
    senderCity?: string | undefined;
    carrier?: string | undefined;
    isCancelled?: boolean;
    collectionAddress?: string | undefined;
    customsAgent?: string | undefined;
    isCritical?: boolean;
    heldAtCustoms?: boolean;
    note?: string | undefined;
    shipmentMode?: string | undefined;
    updateDueSoon?: boolean | undefined;
    updateOverDue?: boolean | undefined;
    trackingUrl?: string | undefined;
    owningUser?: string | undefined;
    deliveryName?: string | undefined;
    collectionLatitude?: number | undefined;
    collectionLongitude?: number | undefined;
    latestNote?: string | undefined;
    latestAction?: string | undefined;
    lastActionDate?: Date | undefined;
    actualCollectionDate?: Date | undefined;
    actualDeliveryDate?: Date | undefined;
    updateDueDate?: Date | undefined;
    actualDepartureFromCollectionDate?: Date | undefined;
    actualArrivalAtDeliveryDate?: Date | undefined;
    plannedDeliveryEnd?: string | undefined;
    plannedDeliveryStart?: Date | undefined;
    etAatLoadingPoint?: Date | undefined;
    etAatUnLoadingPoint?: Date | undefined;
    plannedLoadingStart?: Date | undefined;
    plannedLoadingEnd?: string | undefined;
    etaToCollection?: Date | undefined;
    onsiteCollectionDateTime?: Date | undefined;
    departedLoadingPointDateTime?: Date | undefined;
    etaToDeliveryDateTime?: Date | undefined;
    onsiteDeliveryDateTime?: Date | undefined;
    departedUnloadingpointDateTime?: Date | undefined;
    vehicleLat?: number | undefined;
    vehicleLng?: number | undefined;
    vehicleDistance?: string | undefined;
    vehicleDuration?: string | undefined;
    tourNumber?: number;
    portAirportOfDeparture?: string | undefined;
    portAirportOfArrival?: string | undefined;
    declarationType?: string | undefined;
    poNumber?: string | undefined;
    overseasAgent?: string | undefined;
    customerNumber1?: number | undefined;
    carrierNumber?: number | undefined;
    vechicleTypes?: string | undefined;
    customerContact?: string | undefined;
    sdrNumber?: number | undefined;
    rcvrNumber?: number | undefined;
    sdrRcvrRelations?: string | undefined;
    loadingPointTimeZone?: string | undefined;
    unLoadingPointTimeZone?: string | undefined;
    suggestedETA?: Date | undefined;
    loadingTimeZoneHoursToAddOrSubtract?: number | undefined;
    unloadingTimezoneHoursToAddOrSubtract?: number | undefined;
    hasVehicleEvents?: boolean;
    hasManualVehicleEvents?: number;
    requiresValidation?: boolean | undefined;
    approved?: boolean | undefined;
    eadmrnNo?: string | undefined;
    tadlrnNo?: string | undefined;
    customsEntryNno?: string | undefined;
    hmrcStatus?: string | undefined;
    customsEntryNoSentToCarrier?: number | undefined;
    eadFiled?: number | undefined;
    eadSent?: number | undefined;
    exsFiled?: number | undefined;
    exsSent?: number | undefined;
    gmrFiled?: number | undefined;
    gmrSentToCarrier?: number | undefined;
    tadlrnSent?: number | undefined;
    customsStatus?: string | undefined;
    customerContactEmail?: string | undefined;
    updateBy?: string | undefined;
    latestUpdate?: string | undefined;
    tourHistoryId?: number | undefined;
    customerReferenceNumber?: string | undefined;
    isTourEscalated?: boolean | undefined;
    lastEscalatedTopic?: string | undefined;
    hasOpenChat?: boolean | undefined;
    allocatedUser?: string | undefined;
    customLastModifiedBy?: string | undefined;
    customLastModifiedDateTime?: Date | undefined;
    customUpdateDueDate?: Date | undefined;
    trailerRegNumber?: string | undefined;
    driverName?: string | undefined;
    cellphoneNumber?: string | undefined;
    awaitingUCN?: number | undefined;
    ucnClaimed?: number | undefined;
    cDocsReceived?: number | undefined;
    cDocsChecked?: number | undefined;
    tadClosed?: number | undefined;
    rpaRequired?: number | undefined;
    trackingFrequency?: string | undefined;
    isBmwJob?: boolean | undefined;
    isBmwVehicleEventWarning?: boolean | undefined;
    isBmwCollectionTrackingWarning?: boolean | undefined;
    isBmwNoLocationWarning?: boolean | undefined;
    expectedGoods?: number | undefined;
    actualGoods?: number | undefined;
    goodsWeight?: number | undefined;
    carrierContactEmail?: string | undefined;

    constructor(data?: ITourModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.tourId = _data["tourId"];
            this.amcoId = _data["amcoId"];
            this.destination = _data["destination"];
            this.targetDateTime = _data["targetDateTime"] ? new Date(_data["targetDateTime"].toString()) : <any>undefined;
            this.estimatedDateTime = _data["estimatedDateTime"] ? new Date(_data["estimatedDateTime"].toString()) : <any>undefined;
            this.assignedUser = _data["assignedUser"];
            this.departmentName = _data["departmentName"];
            this.updateTypeName = _data["updateTypeName"];
            this.categoryName = _data["categoryName"];
            this.customerName = _data["customerName"];
            this.type = _data["type"];
            this.typeName = _data["typeName"];
            this.notesYesNo = _data["notesYesNo"];
            this.completed = _data["completed"];
            this.lastModifiedDate = _data["lastModifiedDate"] ? new Date(_data["lastModifiedDate"].toString()) : <any>undefined;
            this.lastModifiedBy = _data["lastModifiedBy"];
            this.vehicleId = _data["vehicleId"];
            this.destinationLatitude = _data["destinationLatitude"];
            this.destinationLongitude = _data["destinationLongitude"];
            this.lastLatitude = _data["lastLatitude"];
            this.lastLongitude = _data["lastLongitude"];
            this.regNumber = _data["regNumber"];
            this.aheadMinutes = _data["aheadMinutes"];
            this.behindMinutes = _data["behindMinutes"];
            this.departmentLookupId = _data["departmentLookupId"];
            this.categoryLookupId = _data["categoryLookupId"];
            this.typeLookupId = _data["typeLookupId"];
            this.updateTypeLookupId = _data["updateTypeLookupId"];
            this.name = _data["name"];
            this.city = _data["city"];
            this.country = _data["country"];
            this.orderNumber = _data["orderNumber"];
            this.customerNumber = _data["customerNumber"];
            this.orderdate = _data["orderdate"];
            this.orderType = _data["orderType"];
            this.totalSalesInGBP = _data["totalSalesInGBP"];
            this.consignmentNumber = _data["consignmentNumber"];
            this.receiverCountry = _data["receiverCountry"];
            this.receiverName = _data["receiverName"];
            this.receiverCity = _data["receiverCity"];
            this.transportOrderNumber = _data["transportOrderNumber"];
            this.senderCountry = _data["senderCountry"];
            this.senderName = _data["senderName"];
            this.senderCity = _data["senderCity"];
            this.carrier = _data["carrier"];
            this.isCancelled = _data["isCancelled"];
            this.collectionAddress = _data["collectionAddress"];
            this.customsAgent = _data["customsAgent"];
            this.isCritical = _data["isCritical"];
            this.heldAtCustoms = _data["heldAtCustoms"];
            this.note = _data["note"];
            this.shipmentMode = _data["shipmentMode"];
            this.updateDueSoon = _data["updateDueSoon"];
            this.updateOverDue = _data["updateOverDue"];
            this.trackingUrl = _data["trackingUrl"];
            this.owningUser = _data["owningUser"];
            this.deliveryName = _data["deliveryName"];
            this.collectionLatitude = _data["collectionLatitude"];
            this.collectionLongitude = _data["collectionLongitude"];
            this.latestNote = _data["latestNote"];
            this.latestAction = _data["latestAction"];
            this.lastActionDate = _data["lastActionDate"] ? new Date(_data["lastActionDate"].toString()) : <any>undefined;
            this.actualCollectionDate = _data["actualCollectionDate"] ? new Date(_data["actualCollectionDate"].toString()) : <any>undefined;
            this.actualDeliveryDate = _data["actualDeliveryDate"] ? new Date(_data["actualDeliveryDate"].toString()) : <any>undefined;
            this.updateDueDate = _data["updateDueDate"] ? new Date(_data["updateDueDate"].toString()) : <any>undefined;
            this.actualDepartureFromCollectionDate = _data["actualDepartureFromCollectionDate"] ? new Date(_data["actualDepartureFromCollectionDate"].toString()) : <any>undefined;
            this.actualArrivalAtDeliveryDate = _data["actualArrivalAtDeliveryDate"] ? new Date(_data["actualArrivalAtDeliveryDate"].toString()) : <any>undefined;
            this.plannedDeliveryEnd = _data["plannedDeliveryEnd"];
            this.plannedDeliveryStart = _data["plannedDeliveryStart"] ? new Date(_data["plannedDeliveryStart"].toString()) : <any>undefined;
            this.etAatLoadingPoint = _data["etAatLoadingPoint"] ? new Date(_data["etAatLoadingPoint"].toString()) : <any>undefined;
            this.etAatUnLoadingPoint = _data["etAatUnLoadingPoint"] ? new Date(_data["etAatUnLoadingPoint"].toString()) : <any>undefined;
            this.plannedLoadingStart = _data["plannedLoadingStart"] ? new Date(_data["plannedLoadingStart"].toString()) : <any>undefined;
            this.plannedLoadingEnd = _data["plannedLoadingEnd"];
            this.etaToCollection = _data["etaToCollection"] ? new Date(_data["etaToCollection"].toString()) : <any>undefined;
            this.onsiteCollectionDateTime = _data["onsiteCollectionDateTime"] ? new Date(_data["onsiteCollectionDateTime"].toString()) : <any>undefined;
            this.departedLoadingPointDateTime = _data["departedLoadingPointDateTime"] ? new Date(_data["departedLoadingPointDateTime"].toString()) : <any>undefined;
            this.etaToDeliveryDateTime = _data["etaToDeliveryDateTime"] ? new Date(_data["etaToDeliveryDateTime"].toString()) : <any>undefined;
            this.onsiteDeliveryDateTime = _data["onsiteDeliveryDateTime"] ? new Date(_data["onsiteDeliveryDateTime"].toString()) : <any>undefined;
            this.departedUnloadingpointDateTime = _data["departedUnloadingpointDateTime"] ? new Date(_data["departedUnloadingpointDateTime"].toString()) : <any>undefined;
            this.vehicleLat = _data["vehicleLat"];
            this.vehicleLng = _data["vehicleLng"];
            this.vehicleDistance = _data["vehicleDistance"];
            this.vehicleDuration = _data["vehicleDuration"];
            this.tourNumber = _data["tourNumber"];
            this.portAirportOfDeparture = _data["portAirportOfDeparture"];
            this.portAirportOfArrival = _data["portAirportOfArrival"];
            this.declarationType = _data["declarationType"];
            this.poNumber = _data["poNumber"];
            this.overseasAgent = _data["overseasAgent"];
            this.customerNumber1 = _data["customerNumber1"];
            this.carrierNumber = _data["carrierNumber"];
            this.vechicleTypes = _data["vechicleTypes"];
            this.customerContact = _data["customerContact"];
            this.sdrNumber = _data["sdrNumber"];
            this.rcvrNumber = _data["rcvrNumber"];
            this.sdrRcvrRelations = _data["sdrRcvrRelations"];
            this.loadingPointTimeZone = _data["loadingPointTimeZone"];
            this.unLoadingPointTimeZone = _data["unLoadingPointTimeZone"];
            this.suggestedETA = _data["suggestedETA"] ? new Date(_data["suggestedETA"].toString()) : <any>undefined;
            this.loadingTimeZoneHoursToAddOrSubtract = _data["loadingTimeZoneHoursToAddOrSubtract"];
            this.unloadingTimezoneHoursToAddOrSubtract = _data["unloadingTimezoneHoursToAddOrSubtract"];
            this.hasVehicleEvents = _data["hasVehicleEvents"];
            this.hasManualVehicleEvents = _data["hasManualVehicleEvents"];
            this.requiresValidation = _data["requiresValidation"];
            this.approved = _data["approved"];
            this.eadmrnNo = _data["eadmrnNo"];
            this.tadlrnNo = _data["tadlrnNo"];
            this.customsEntryNno = _data["customsEntryNno"];
            this.hmrcStatus = _data["hmrcStatus"];
            this.customsEntryNoSentToCarrier = _data["customsEntryNoSentToCarrier"];
            this.eadFiled = _data["eadFiled"];
            this.eadSent = _data["eadSent"];
            this.exsFiled = _data["exsFiled"];
            this.exsSent = _data["exsSent"];
            this.gmrFiled = _data["gmrFiled"];
            this.gmrSentToCarrier = _data["gmrSentToCarrier"];
            this.tadlrnSent = _data["tadlrnSent"];
            this.customsStatus = _data["customsStatus"];
            this.customerContactEmail = _data["customerContactEmail"];
            this.updateBy = _data["updateBy"];
            this.latestUpdate = _data["latestUpdate"];
            this.tourHistoryId = _data["tourHistoryId"];
            this.customerReferenceNumber = _data["customerReferenceNumber"];
            this.isTourEscalated = _data["isTourEscalated"];
            this.lastEscalatedTopic = _data["lastEscalatedTopic"];
            this.hasOpenChat = _data["hasOpenChat"];
            this.allocatedUser = _data["allocatedUser"];
            this.customLastModifiedBy = _data["customLastModifiedBy"];
            this.customLastModifiedDateTime = _data["customLastModifiedDateTime"] ? new Date(_data["customLastModifiedDateTime"].toString()) : <any>undefined;
            this.customUpdateDueDate = _data["customUpdateDueDate"] ? new Date(_data["customUpdateDueDate"].toString()) : <any>undefined;
            this.trailerRegNumber = _data["trailerRegNumber"];
            this.driverName = _data["driverName"];
            this.cellphoneNumber = _data["cellphoneNumber"];
            this.awaitingUCN = _data["awaitingUCN"];
            this.ucnClaimed = _data["ucnClaimed"];
            this.cDocsReceived = _data["cDocsReceived"];
            this.cDocsChecked = _data["cDocsChecked"];
            this.tadClosed = _data["tadClosed"];
            this.rpaRequired = _data["rpaRequired"];
            this.trackingFrequency = _data["trackingFrequency"];
            this.isBmwJob = _data["isBmwJob"];
            this.isBmwVehicleEventWarning = _data["isBmwVehicleEventWarning"];
            this.isBmwCollectionTrackingWarning = _data["isBmwCollectionTrackingWarning"];
            this.isBmwNoLocationWarning = _data["isBmwNoLocationWarning"];
            this.expectedGoods = _data["expectedGoods"];
            this.actualGoods = _data["actualGoods"];
            this.goodsWeight = _data["goodsWeight"];
            this.carrierContactEmail = _data["carrierContactEmail"];
        }
    }

    static fromJS(data: any): TourModel {
        data = typeof data === 'object' ? data : {};
        let result = new TourModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["tourId"] = this.tourId;
        data["amcoId"] = this.amcoId;
        data["destination"] = this.destination;
        data["targetDateTime"] = this.targetDateTime ? this.targetDateTime.toISOString() : <any>undefined;
        data["estimatedDateTime"] = this.estimatedDateTime ? this.estimatedDateTime.toISOString() : <any>undefined;
        data["assignedUser"] = this.assignedUser;
        data["departmentName"] = this.departmentName;
        data["updateTypeName"] = this.updateTypeName;
        data["categoryName"] = this.categoryName;
        data["customerName"] = this.customerName;
        data["type"] = this.type;
        data["typeName"] = this.typeName;
        data["notesYesNo"] = this.notesYesNo;
        data["completed"] = this.completed;
        data["lastModifiedDate"] = this.lastModifiedDate ? this.lastModifiedDate.toISOString() : <any>undefined;
        data["lastModifiedBy"] = this.lastModifiedBy;
        data["vehicleId"] = this.vehicleId;
        data["destinationLatitude"] = this.destinationLatitude;
        data["destinationLongitude"] = this.destinationLongitude;
        data["lastLatitude"] = this.lastLatitude;
        data["lastLongitude"] = this.lastLongitude;
        data["regNumber"] = this.regNumber;
        data["aheadMinutes"] = this.aheadMinutes;
        data["behindMinutes"] = this.behindMinutes;
        data["departmentLookupId"] = this.departmentLookupId;
        data["categoryLookupId"] = this.categoryLookupId;
        data["typeLookupId"] = this.typeLookupId;
        data["updateTypeLookupId"] = this.updateTypeLookupId;
        data["name"] = this.name;
        data["city"] = this.city;
        data["country"] = this.country;
        data["orderNumber"] = this.orderNumber;
        data["customerNumber"] = this.customerNumber;
        data["orderdate"] = this.orderdate;
        data["orderType"] = this.orderType;
        data["totalSalesInGBP"] = this.totalSalesInGBP;
        data["consignmentNumber"] = this.consignmentNumber;
        data["receiverCountry"] = this.receiverCountry;
        data["receiverName"] = this.receiverName;
        data["receiverCity"] = this.receiverCity;
        data["transportOrderNumber"] = this.transportOrderNumber;
        data["senderCountry"] = this.senderCountry;
        data["senderName"] = this.senderName;
        data["senderCity"] = this.senderCity;
        data["carrier"] = this.carrier;
        data["isCancelled"] = this.isCancelled;
        data["collectionAddress"] = this.collectionAddress;
        data["customsAgent"] = this.customsAgent;
        data["isCritical"] = this.isCritical;
        data["heldAtCustoms"] = this.heldAtCustoms;
        data["note"] = this.note;
        data["shipmentMode"] = this.shipmentMode;
        data["updateDueSoon"] = this.updateDueSoon;
        data["updateOverDue"] = this.updateOverDue;
        data["trackingUrl"] = this.trackingUrl;
        data["owningUser"] = this.owningUser;
        data["deliveryName"] = this.deliveryName;
        data["collectionLatitude"] = this.collectionLatitude;
        data["collectionLongitude"] = this.collectionLongitude;
        data["latestNote"] = this.latestNote;
        data["latestAction"] = this.latestAction;
        data["lastActionDate"] = this.lastActionDate ? this.lastActionDate.toISOString() : <any>undefined;
        data["actualCollectionDate"] = this.actualCollectionDate ? this.actualCollectionDate.toISOString() : <any>undefined;
        data["actualDeliveryDate"] = this.actualDeliveryDate ? this.actualDeliveryDate.toISOString() : <any>undefined;
        data["updateDueDate"] = this.updateDueDate ? this.updateDueDate.toISOString() : <any>undefined;
        data["actualDepartureFromCollectionDate"] = this.actualDepartureFromCollectionDate ? this.actualDepartureFromCollectionDate.toISOString() : <any>undefined;
        data["actualArrivalAtDeliveryDate"] = this.actualArrivalAtDeliveryDate ? this.actualArrivalAtDeliveryDate.toISOString() : <any>undefined;
        data["plannedDeliveryEnd"] = this.plannedDeliveryEnd;
        data["plannedDeliveryStart"] = this.plannedDeliveryStart ? this.plannedDeliveryStart.toISOString() : <any>undefined;
        data["etAatLoadingPoint"] = this.etAatLoadingPoint ? this.etAatLoadingPoint.toISOString() : <any>undefined;
        data["etAatUnLoadingPoint"] = this.etAatUnLoadingPoint ? this.etAatUnLoadingPoint.toISOString() : <any>undefined;
        data["plannedLoadingStart"] = this.plannedLoadingStart ? this.plannedLoadingStart.toISOString() : <any>undefined;
        data["plannedLoadingEnd"] = this.plannedLoadingEnd;
        data["etaToCollection"] = this.etaToCollection ? this.etaToCollection.toISOString() : <any>undefined;
        data["onsiteCollectionDateTime"] = this.onsiteCollectionDateTime ? this.onsiteCollectionDateTime.toISOString() : <any>undefined;
        data["departedLoadingPointDateTime"] = this.departedLoadingPointDateTime ? this.departedLoadingPointDateTime.toISOString() : <any>undefined;
        data["etaToDeliveryDateTime"] = this.etaToDeliveryDateTime ? this.etaToDeliveryDateTime.toISOString() : <any>undefined;
        data["onsiteDeliveryDateTime"] = this.onsiteDeliveryDateTime ? this.onsiteDeliveryDateTime.toISOString() : <any>undefined;
        data["departedUnloadingpointDateTime"] = this.departedUnloadingpointDateTime ? this.departedUnloadingpointDateTime.toISOString() : <any>undefined;
        data["vehicleLat"] = this.vehicleLat;
        data["vehicleLng"] = this.vehicleLng;
        data["vehicleDistance"] = this.vehicleDistance;
        data["vehicleDuration"] = this.vehicleDuration;
        data["tourNumber"] = this.tourNumber;
        data["portAirportOfDeparture"] = this.portAirportOfDeparture;
        data["portAirportOfArrival"] = this.portAirportOfArrival;
        data["declarationType"] = this.declarationType;
        data["poNumber"] = this.poNumber;
        data["overseasAgent"] = this.overseasAgent;
        data["customerNumber1"] = this.customerNumber1;
        data["carrierNumber"] = this.carrierNumber;
        data["vechicleTypes"] = this.vechicleTypes;
        data["customerContact"] = this.customerContact;
        data["sdrNumber"] = this.sdrNumber;
        data["rcvrNumber"] = this.rcvrNumber;
        data["sdrRcvrRelations"] = this.sdrRcvrRelations;
        data["loadingPointTimeZone"] = this.loadingPointTimeZone;
        data["unLoadingPointTimeZone"] = this.unLoadingPointTimeZone;
        data["suggestedETA"] = this.suggestedETA ? this.suggestedETA.toISOString() : <any>undefined;
        data["loadingTimeZoneHoursToAddOrSubtract"] = this.loadingTimeZoneHoursToAddOrSubtract;
        data["unloadingTimezoneHoursToAddOrSubtract"] = this.unloadingTimezoneHoursToAddOrSubtract;
        data["hasVehicleEvents"] = this.hasVehicleEvents;
        data["hasManualVehicleEvents"] = this.hasManualVehicleEvents;
        data["requiresValidation"] = this.requiresValidation;
        data["approved"] = this.approved;
        data["eadmrnNo"] = this.eadmrnNo;
        data["tadlrnNo"] = this.tadlrnNo;
        data["customsEntryNno"] = this.customsEntryNno;
        data["hmrcStatus"] = this.hmrcStatus;
        data["customsEntryNoSentToCarrier"] = this.customsEntryNoSentToCarrier;
        data["eadFiled"] = this.eadFiled;
        data["eadSent"] = this.eadSent;
        data["exsFiled"] = this.exsFiled;
        data["exsSent"] = this.exsSent;
        data["gmrFiled"] = this.gmrFiled;
        data["gmrSentToCarrier"] = this.gmrSentToCarrier;
        data["tadlrnSent"] = this.tadlrnSent;
        data["customsStatus"] = this.customsStatus;
        data["customerContactEmail"] = this.customerContactEmail;
        data["updateBy"] = this.updateBy;
        data["latestUpdate"] = this.latestUpdate;
        data["tourHistoryId"] = this.tourHistoryId;
        data["customerReferenceNumber"] = this.customerReferenceNumber;
        data["isTourEscalated"] = this.isTourEscalated;
        data["lastEscalatedTopic"] = this.lastEscalatedTopic;
        data["hasOpenChat"] = this.hasOpenChat;
        data["allocatedUser"] = this.allocatedUser;
        data["customLastModifiedBy"] = this.customLastModifiedBy;
        data["customLastModifiedDateTime"] = this.customLastModifiedDateTime ? this.customLastModifiedDateTime.toISOString() : <any>undefined;
        data["customUpdateDueDate"] = this.customUpdateDueDate ? this.customUpdateDueDate.toISOString() : <any>undefined;
        data["trailerRegNumber"] = this.trailerRegNumber;
        data["driverName"] = this.driverName;
        data["cellphoneNumber"] = this.cellphoneNumber;
        data["awaitingUCN"] = this.awaitingUCN;
        data["ucnClaimed"] = this.ucnClaimed;
        data["cDocsReceived"] = this.cDocsReceived;
        data["cDocsChecked"] = this.cDocsChecked;
        data["tadClosed"] = this.tadClosed;
        data["rpaRequired"] = this.rpaRequired;
        data["trackingFrequency"] = this.trackingFrequency;
        data["isBmwJob"] = this.isBmwJob;
        data["isBmwVehicleEventWarning"] = this.isBmwVehicleEventWarning;
        data["isBmwCollectionTrackingWarning"] = this.isBmwCollectionTrackingWarning;
        data["isBmwNoLocationWarning"] = this.isBmwNoLocationWarning;
        data["expectedGoods"] = this.expectedGoods;
        data["actualGoods"] = this.actualGoods;
        data["goodsWeight"] = this.goodsWeight;
        data["carrierContactEmail"] = this.carrierContactEmail;
        return data;
    }
}

export interface ITourModel {
    id?: number;
    tourId?: number;
    amcoId?: number;
    destination?: string | undefined;
    targetDateTime?: Date;
    estimatedDateTime?: Date | undefined;
    assignedUser?: string | undefined;
    departmentName?: string | undefined;
    updateTypeName?: string | undefined;
    categoryName?: string | undefined;
    customerName?: string | undefined;
    type?: string | undefined;
    typeName?: string | undefined;
    notesYesNo?: boolean;
    completed?: boolean;
    lastModifiedDate?: Date | undefined;
    lastModifiedBy?: string | undefined;
    vehicleId?: number | undefined;
    destinationLatitude?: number | undefined;
    destinationLongitude?: number | undefined;
    lastLatitude?: number | undefined;
    lastLongitude?: number | undefined;
    regNumber?: string | undefined;
    aheadMinutes?: number | undefined;
    behindMinutes?: number | undefined;
    departmentLookupId?: number;
    categoryLookupId?: number;
    typeLookupId?: number;
    updateTypeLookupId?: number;
    name?: string | undefined;
    city?: string | undefined;
    country?: string | undefined;
    orderNumber?: string | undefined;
    customerNumber?: string | undefined;
    orderdate?: string | undefined;
    orderType?: string | undefined;
    totalSalesInGBP?: string | undefined;
    consignmentNumber?: string | undefined;
    receiverCountry?: string | undefined;
    receiverName?: string | undefined;
    receiverCity?: string | undefined;
    transportOrderNumber?: string | undefined;
    senderCountry?: string | undefined;
    senderName?: string | undefined;
    senderCity?: string | undefined;
    carrier?: string | undefined;
    isCancelled?: boolean;
    collectionAddress?: string | undefined;
    customsAgent?: string | undefined;
    isCritical?: boolean;
    heldAtCustoms?: boolean;
    note?: string | undefined;
    shipmentMode?: string | undefined;
    updateDueSoon?: boolean | undefined;
    updateOverDue?: boolean | undefined;
    trackingUrl?: string | undefined;
    owningUser?: string | undefined;
    deliveryName?: string | undefined;
    collectionLatitude?: number | undefined;
    collectionLongitude?: number | undefined;
    latestNote?: string | undefined;
    latestAction?: string | undefined;
    lastActionDate?: Date | undefined;
    actualCollectionDate?: Date | undefined;
    actualDeliveryDate?: Date | undefined;
    updateDueDate?: Date | undefined;
    actualDepartureFromCollectionDate?: Date | undefined;
    actualArrivalAtDeliveryDate?: Date | undefined;
    plannedDeliveryEnd?: string | undefined;
    plannedDeliveryStart?: Date | undefined;
    etAatLoadingPoint?: Date | undefined;
    etAatUnLoadingPoint?: Date | undefined;
    plannedLoadingStart?: Date | undefined;
    plannedLoadingEnd?: string | undefined;
    etaToCollection?: Date | undefined;
    onsiteCollectionDateTime?: Date | undefined;
    departedLoadingPointDateTime?: Date | undefined;
    etaToDeliveryDateTime?: Date | undefined;
    onsiteDeliveryDateTime?: Date | undefined;
    departedUnloadingpointDateTime?: Date | undefined;
    vehicleLat?: number | undefined;
    vehicleLng?: number | undefined;
    vehicleDistance?: string | undefined;
    vehicleDuration?: string | undefined;
    tourNumber?: number;
    portAirportOfDeparture?: string | undefined;
    portAirportOfArrival?: string | undefined;
    declarationType?: string | undefined;
    poNumber?: string | undefined;
    overseasAgent?: string | undefined;
    customerNumber1?: number | undefined;
    carrierNumber?: number | undefined;
    vechicleTypes?: string | undefined;
    customerContact?: string | undefined;
    sdrNumber?: number | undefined;
    rcvrNumber?: number | undefined;
    sdrRcvrRelations?: string | undefined;
    loadingPointTimeZone?: string | undefined;
    unLoadingPointTimeZone?: string | undefined;
    suggestedETA?: Date | undefined;
    loadingTimeZoneHoursToAddOrSubtract?: number | undefined;
    unloadingTimezoneHoursToAddOrSubtract?: number | undefined;
    hasVehicleEvents?: boolean;
    hasManualVehicleEvents?: number;
    requiresValidation?: boolean | undefined;
    approved?: boolean | undefined;
    eadmrnNo?: string | undefined;
    tadlrnNo?: string | undefined;
    customsEntryNno?: string | undefined;
    hmrcStatus?: string | undefined;
    customsEntryNoSentToCarrier?: number | undefined;
    eadFiled?: number | undefined;
    eadSent?: number | undefined;
    exsFiled?: number | undefined;
    exsSent?: number | undefined;
    gmrFiled?: number | undefined;
    gmrSentToCarrier?: number | undefined;
    tadlrnSent?: number | undefined;
    customsStatus?: string | undefined;
    customerContactEmail?: string | undefined;
    updateBy?: string | undefined;
    latestUpdate?: string | undefined;
    tourHistoryId?: number | undefined;
    customerReferenceNumber?: string | undefined;
    isTourEscalated?: boolean | undefined;
    lastEscalatedTopic?: string | undefined;
    hasOpenChat?: boolean | undefined;
    allocatedUser?: string | undefined;
    customLastModifiedBy?: string | undefined;
    customLastModifiedDateTime?: Date | undefined;
    customUpdateDueDate?: Date | undefined;
    trailerRegNumber?: string | undefined;
    driverName?: string | undefined;
    cellphoneNumber?: string | undefined;
    awaitingUCN?: number | undefined;
    ucnClaimed?: number | undefined;
    cDocsReceived?: number | undefined;
    cDocsChecked?: number | undefined;
    tadClosed?: number | undefined;
    rpaRequired?: number | undefined;
    trackingFrequency?: string | undefined;
    isBmwJob?: boolean | undefined;
    isBmwVehicleEventWarning?: boolean | undefined;
    isBmwCollectionTrackingWarning?: boolean | undefined;
    isBmwNoLocationWarning?: boolean | undefined;
    expectedGoods?: number | undefined;
    actualGoods?: number | undefined;
    goodsWeight?: number | undefined;
    carrierContactEmail?: string | undefined;
}

export class TourEmailModel implements ITourEmailModel {
    id?: number;
    email?: string | undefined;

    constructor(data?: ITourEmailModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.email = _data["email"];
        }
    }

    static fromJS(data: any): TourEmailModel {
        data = typeof data === 'object' ? data : {};
        let result = new TourEmailModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["email"] = this.email;
        return data;
    }
}

export interface ITourEmailModel {
    id?: number;
    email?: string | undefined;
}

export class CustomsModel implements ICustomsModel {
    id?: number;
    amcoId?: number;
    customsStatus?: string | undefined;
    consignmentNumber?: string | undefined;
    customerName?: string | undefined;
    customerContact?: string | undefined;
    poNumber?: string | undefined;
    declarationType?: string | undefined;
    plannedLoadingEnd?: string | undefined;
    customsEntryNno?: string | undefined;
    eadmrnNo?: string | undefined;
    tadlrnNo?: string | undefined;
    hmrcStatus?: string | undefined;
    lastModifiedDate?: Date;
    lastModifiedBy?: string | undefined;
    updateDueDate?: Date | undefined;
    departmentLookupId?: number;
    typeLookupId?: number;
    inventoryLinked?: boolean | undefined;
    hasOpenChat?: boolean | undefined;
    tourId?: number;
    goodsCollected?: boolean | undefined;
    etaAtPortOfDeparture?: Date | undefined;
    allocatedUser?: string | undefined;
    targetDateTime?: Date;
    plannedDeliveryEnd?: string | undefined;
    plannedDeliveryStart?: Date;
    plannedLoadingStart?: Date;
    vehicleId?: number | undefined;
    customLastModifiedBy?: string | undefined;
    customLastModifiedDateTime?: Date | undefined;
    customUpdateDueDate?: Date | undefined;

    constructor(data?: ICustomsModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.amcoId = _data["amcoId"];
            this.customsStatus = _data["customsStatus"];
            this.consignmentNumber = _data["consignmentNumber"];
            this.customerName = _data["customerName"];
            this.customerContact = _data["customerContact"];
            this.poNumber = _data["poNumber"];
            this.declarationType = _data["declarationType"];
            this.plannedLoadingEnd = _data["plannedLoadingEnd"];
            this.customsEntryNno = _data["customsEntryNno"];
            this.eadmrnNo = _data["eadmrnNo"];
            this.tadlrnNo = _data["tadlrnNo"];
            this.hmrcStatus = _data["hmrcStatus"];
            this.lastModifiedDate = _data["lastModifiedDate"] ? new Date(_data["lastModifiedDate"].toString()) : <any>undefined;
            this.lastModifiedBy = _data["lastModifiedBy"];
            this.updateDueDate = _data["updateDueDate"] ? new Date(_data["updateDueDate"].toString()) : <any>undefined;
            this.departmentLookupId = _data["departmentLookupId"];
            this.typeLookupId = _data["typeLookupId"];
            this.inventoryLinked = _data["inventoryLinked"];
            this.hasOpenChat = _data["hasOpenChat"];
            this.tourId = _data["tourId"];
            this.goodsCollected = _data["goodsCollected"];
            this.etaAtPortOfDeparture = _data["etaAtPortOfDeparture"] ? new Date(_data["etaAtPortOfDeparture"].toString()) : <any>undefined;
            this.allocatedUser = _data["allocatedUser"];
            this.targetDateTime = _data["targetDateTime"] ? new Date(_data["targetDateTime"].toString()) : <any>undefined;
            this.plannedDeliveryEnd = _data["plannedDeliveryEnd"];
            this.plannedDeliveryStart = _data["plannedDeliveryStart"] ? new Date(_data["plannedDeliveryStart"].toString()) : <any>undefined;
            this.plannedLoadingStart = _data["plannedLoadingStart"] ? new Date(_data["plannedLoadingStart"].toString()) : <any>undefined;
            this.vehicleId = _data["vehicleId"];
            this.customLastModifiedBy = _data["customLastModifiedBy"];
            this.customLastModifiedDateTime = _data["customLastModifiedDateTime"] ? new Date(_data["customLastModifiedDateTime"].toString()) : <any>undefined;
            this.customUpdateDueDate = _data["customUpdateDueDate"] ? new Date(_data["customUpdateDueDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): CustomsModel {
        data = typeof data === 'object' ? data : {};
        let result = new CustomsModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["amcoId"] = this.amcoId;
        data["customsStatus"] = this.customsStatus;
        data["consignmentNumber"] = this.consignmentNumber;
        data["customerName"] = this.customerName;
        data["customerContact"] = this.customerContact;
        data["poNumber"] = this.poNumber;
        data["declarationType"] = this.declarationType;
        data["plannedLoadingEnd"] = this.plannedLoadingEnd;
        data["customsEntryNno"] = this.customsEntryNno;
        data["eadmrnNo"] = this.eadmrnNo;
        data["tadlrnNo"] = this.tadlrnNo;
        data["hmrcStatus"] = this.hmrcStatus;
        data["lastModifiedDate"] = this.lastModifiedDate ? this.lastModifiedDate.toISOString() : <any>undefined;
        data["lastModifiedBy"] = this.lastModifiedBy;
        data["updateDueDate"] = this.updateDueDate ? this.updateDueDate.toISOString() : <any>undefined;
        data["departmentLookupId"] = this.departmentLookupId;
        data["typeLookupId"] = this.typeLookupId;
        data["inventoryLinked"] = this.inventoryLinked;
        data["hasOpenChat"] = this.hasOpenChat;
        data["tourId"] = this.tourId;
        data["goodsCollected"] = this.goodsCollected;
        data["etaAtPortOfDeparture"] = this.etaAtPortOfDeparture ? this.etaAtPortOfDeparture.toISOString() : <any>undefined;
        data["allocatedUser"] = this.allocatedUser;
        data["targetDateTime"] = this.targetDateTime ? this.targetDateTime.toISOString() : <any>undefined;
        data["plannedDeliveryEnd"] = this.plannedDeliveryEnd;
        data["plannedDeliveryStart"] = this.plannedDeliveryStart ? this.plannedDeliveryStart.toISOString() : <any>undefined;
        data["plannedLoadingStart"] = this.plannedLoadingStart ? this.plannedLoadingStart.toISOString() : <any>undefined;
        data["vehicleId"] = this.vehicleId;
        data["customLastModifiedBy"] = this.customLastModifiedBy;
        data["customLastModifiedDateTime"] = this.customLastModifiedDateTime ? this.customLastModifiedDateTime.toISOString() : <any>undefined;
        data["customUpdateDueDate"] = this.customUpdateDueDate ? this.customUpdateDueDate.toISOString() : <any>undefined;
        return data;
    }
}

export interface ICustomsModel {
    id?: number;
    amcoId?: number;
    customsStatus?: string | undefined;
    consignmentNumber?: string | undefined;
    customerName?: string | undefined;
    customerContact?: string | undefined;
    poNumber?: string | undefined;
    declarationType?: string | undefined;
    plannedLoadingEnd?: string | undefined;
    customsEntryNno?: string | undefined;
    eadmrnNo?: string | undefined;
    tadlrnNo?: string | undefined;
    hmrcStatus?: string | undefined;
    lastModifiedDate?: Date;
    lastModifiedBy?: string | undefined;
    updateDueDate?: Date | undefined;
    departmentLookupId?: number;
    typeLookupId?: number;
    inventoryLinked?: boolean | undefined;
    hasOpenChat?: boolean | undefined;
    tourId?: number;
    goodsCollected?: boolean | undefined;
    etaAtPortOfDeparture?: Date | undefined;
    allocatedUser?: string | undefined;
    targetDateTime?: Date;
    plannedDeliveryEnd?: string | undefined;
    plannedDeliveryStart?: Date;
    plannedLoadingStart?: Date;
    vehicleId?: number | undefined;
    customLastModifiedBy?: string | undefined;
    customLastModifiedDateTime?: Date | undefined;
    customUpdateDueDate?: Date | undefined;
}

export class PagedListingResponseOfTourListHistoryModel implements IPagedListingResponseOfTourListHistoryModel {
    results?: TourListHistoryModel[] | undefined;
    totalCount?: number;
    totalPages?: number;
    pageIndex?: number;
    pageSize?: number;

    constructor(data?: IPagedListingResponseOfTourListHistoryModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["results"])) {
                this.results = [] as any;
                for (let item of _data["results"])
                    this.results!.push(TourListHistoryModel.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
            this.totalPages = _data["totalPages"];
            this.pageIndex = _data["pageIndex"];
            this.pageSize = _data["pageSize"];
        }
    }

    static fromJS(data: any): PagedListingResponseOfTourListHistoryModel {
        data = typeof data === 'object' ? data : {};
        let result = new PagedListingResponseOfTourListHistoryModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.results)) {
            data["results"] = [];
            for (let item of this.results)
                data["results"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        data["totalPages"] = this.totalPages;
        data["pageIndex"] = this.pageIndex;
        data["pageSize"] = this.pageSize;
        return data;
    }
}

export interface IPagedListingResponseOfTourListHistoryModel {
    results?: TourListHistoryModel[] | undefined;
    totalCount?: number;
    totalPages?: number;
    pageIndex?: number;
    pageSize?: number;
}

export class TourListHistoryModel implements ITourListHistoryModel {
    id?: number;
    tourId?: number;
    amcoId?: number;
    destination?: string | undefined;
    targetDateTime?: Date;
    estimatedDateTime?: Date | undefined;
    assignedUser?: string | undefined;
    departmentName?: string | undefined;
    updateTypeName?: string | undefined;
    categoryName?: string | undefined;
    customerName?: string | undefined;
    type?: string | undefined;
    typeName?: string | undefined;
    notesYesNo?: boolean;
    completed?: boolean;
    lastModifiedDate?: Date | undefined;
    lastModifiedBy?: string | undefined;
    vehicleId?: number | undefined;
    destinationLatitude?: number | undefined;
    destinationLongitude?: number | undefined;
    lastLatitude?: number | undefined;
    lastLongitude?: number | undefined;
    regNumber?: string | undefined;
    aheadMinutes?: number | undefined;
    behindMinutes?: number | undefined;
    transportOrderNumber?: string | undefined;
    departmentLookupId?: number;
    categoryLookupId?: number;
    typeLookupId?: number;
    updateTypeLookupId?: number;
    name?: string | undefined;
    city?: string | undefined;
    country?: string | undefined;
    orderNumber?: string | undefined;
    customerNumber?: string | undefined;
    orderdate?: string | undefined;
    orderType?: string | undefined;
    totalSalesInGBP?: string | undefined;
    consignmentNumber?: string | undefined;
    receiverCountry?: string | undefined;
    receiverName?: string | undefined;
    receiverCity?: string | undefined;
    senderCountry?: string | undefined;
    senderName?: string | undefined;
    senderCity?: string | undefined;
    carrier?: string | undefined;
    isCancelled?: boolean;
    collectionAddress?: string | undefined;
    customsAgent?: string | undefined;
    isCritical?: boolean;
    heldAtCustoms?: boolean;
    note?: string | undefined;
    shipmentMode?: string | undefined;
    updateDueSoon?: boolean | undefined;
    updateOverDue?: boolean | undefined;
    trackingUrl?: string | undefined;
    owningUser?: string | undefined;
    deliveryName?: string | undefined;
    lastActionDate?: Date | undefined;
    actualCollectionDate?: Date | undefined;
    actualDeliveryDate?: Date | undefined;
    updateDueDate?: Date | undefined;
    actualDepartureFromCollectionDate?: Date | undefined;
    actualArrivalAtDeliveryDate?: Date | undefined;
    poNumber?: string | undefined;
    plannedDeliveryEnd?: string | undefined;
    plannedDeliveryStart?: string | undefined;
    etAatLoadingPoint?: string | undefined;
    etAatUnLoadingPoint?: string | undefined;
    plannedLoadingStart?: string | undefined;
    plannedLoadingEnd?: string | undefined;
    inRecycleBin?: number;
    lockStatus?: number;
    lastFleetComStatus?: number;
    trackingFrequency?: string | undefined;
    isBmwJob?: boolean | undefined;
    customsStatus?: string | undefined;
    customerContact?: string | undefined;
    declarationType?: string | undefined;
    customsEntryNno?: string | undefined;
    eadmrnNo?: string | undefined;
    tadlrnNo?: string | undefined;
    hmrcStatus?: string | undefined;

    constructor(data?: ITourListHistoryModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.tourId = _data["tourId"];
            this.amcoId = _data["amcoId"];
            this.destination = _data["destination"];
            this.targetDateTime = _data["targetDateTime"] ? new Date(_data["targetDateTime"].toString()) : <any>undefined;
            this.estimatedDateTime = _data["estimatedDateTime"] ? new Date(_data["estimatedDateTime"].toString()) : <any>undefined;
            this.assignedUser = _data["assignedUser"];
            this.departmentName = _data["departmentName"];
            this.updateTypeName = _data["updateTypeName"];
            this.categoryName = _data["categoryName"];
            this.customerName = _data["customerName"];
            this.type = _data["type"];
            this.typeName = _data["typeName"];
            this.notesYesNo = _data["notesYesNo"];
            this.completed = _data["completed"];
            this.lastModifiedDate = _data["lastModifiedDate"] ? new Date(_data["lastModifiedDate"].toString()) : <any>undefined;
            this.lastModifiedBy = _data["lastModifiedBy"];
            this.vehicleId = _data["vehicleId"];
            this.destinationLatitude = _data["destinationLatitude"];
            this.destinationLongitude = _data["destinationLongitude"];
            this.lastLatitude = _data["lastLatitude"];
            this.lastLongitude = _data["lastLongitude"];
            this.regNumber = _data["regNumber"];
            this.aheadMinutes = _data["aheadMinutes"];
            this.behindMinutes = _data["behindMinutes"];
            this.transportOrderNumber = _data["transportOrderNumber"];
            this.departmentLookupId = _data["departmentLookupId"];
            this.categoryLookupId = _data["categoryLookupId"];
            this.typeLookupId = _data["typeLookupId"];
            this.updateTypeLookupId = _data["updateTypeLookupId"];
            this.name = _data["name"];
            this.city = _data["city"];
            this.country = _data["country"];
            this.orderNumber = _data["orderNumber"];
            this.customerNumber = _data["customerNumber"];
            this.orderdate = _data["orderdate"];
            this.orderType = _data["orderType"];
            this.totalSalesInGBP = _data["totalSalesInGBP"];
            this.consignmentNumber = _data["consignmentNumber"];
            this.receiverCountry = _data["receiverCountry"];
            this.receiverName = _data["receiverName"];
            this.receiverCity = _data["receiverCity"];
            this.senderCountry = _data["senderCountry"];
            this.senderName = _data["senderName"];
            this.senderCity = _data["senderCity"];
            this.carrier = _data["carrier"];
            this.isCancelled = _data["isCancelled"];
            this.collectionAddress = _data["collectionAddress"];
            this.customsAgent = _data["customsAgent"];
            this.isCritical = _data["isCritical"];
            this.heldAtCustoms = _data["heldAtCustoms"];
            this.note = _data["note"];
            this.shipmentMode = _data["shipmentMode"];
            this.updateDueSoon = _data["updateDueSoon"];
            this.updateOverDue = _data["updateOverDue"];
            this.trackingUrl = _data["trackingUrl"];
            this.owningUser = _data["owningUser"];
            this.deliveryName = _data["deliveryName"];
            this.lastActionDate = _data["lastActionDate"] ? new Date(_data["lastActionDate"].toString()) : <any>undefined;
            this.actualCollectionDate = _data["actualCollectionDate"] ? new Date(_data["actualCollectionDate"].toString()) : <any>undefined;
            this.actualDeliveryDate = _data["actualDeliveryDate"] ? new Date(_data["actualDeliveryDate"].toString()) : <any>undefined;
            this.updateDueDate = _data["updateDueDate"] ? new Date(_data["updateDueDate"].toString()) : <any>undefined;
            this.actualDepartureFromCollectionDate = _data["actualDepartureFromCollectionDate"] ? new Date(_data["actualDepartureFromCollectionDate"].toString()) : <any>undefined;
            this.actualArrivalAtDeliveryDate = _data["actualArrivalAtDeliveryDate"] ? new Date(_data["actualArrivalAtDeliveryDate"].toString()) : <any>undefined;
            this.poNumber = _data["poNumber"];
            this.plannedDeliveryEnd = _data["plannedDeliveryEnd"];
            this.plannedDeliveryStart = _data["plannedDeliveryStart"];
            this.etAatLoadingPoint = _data["etAatLoadingPoint"];
            this.etAatUnLoadingPoint = _data["etAatUnLoadingPoint"];
            this.plannedLoadingStart = _data["plannedLoadingStart"];
            this.plannedLoadingEnd = _data["plannedLoadingEnd"];
            this.inRecycleBin = _data["inRecycleBin"];
            this.lockStatus = _data["lockStatus"];
            this.lastFleetComStatus = _data["lastFleetComStatus"];
            this.trackingFrequency = _data["trackingFrequency"];
            this.isBmwJob = _data["isBmwJob"];
            this.customsStatus = _data["customsStatus"];
            this.customerContact = _data["customerContact"];
            this.declarationType = _data["declarationType"];
            this.customsEntryNno = _data["customsEntryNno"];
            this.eadmrnNo = _data["eadmrnNo"];
            this.tadlrnNo = _data["tadlrnNo"];
            this.hmrcStatus = _data["hmrcStatus"];
        }
    }

    static fromJS(data: any): TourListHistoryModel {
        data = typeof data === 'object' ? data : {};
        let result = new TourListHistoryModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["tourId"] = this.tourId;
        data["amcoId"] = this.amcoId;
        data["destination"] = this.destination;
        data["targetDateTime"] = this.targetDateTime ? this.targetDateTime.toISOString() : <any>undefined;
        data["estimatedDateTime"] = this.estimatedDateTime ? this.estimatedDateTime.toISOString() : <any>undefined;
        data["assignedUser"] = this.assignedUser;
        data["departmentName"] = this.departmentName;
        data["updateTypeName"] = this.updateTypeName;
        data["categoryName"] = this.categoryName;
        data["customerName"] = this.customerName;
        data["type"] = this.type;
        data["typeName"] = this.typeName;
        data["notesYesNo"] = this.notesYesNo;
        data["completed"] = this.completed;
        data["lastModifiedDate"] = this.lastModifiedDate ? this.lastModifiedDate.toISOString() : <any>undefined;
        data["lastModifiedBy"] = this.lastModifiedBy;
        data["vehicleId"] = this.vehicleId;
        data["destinationLatitude"] = this.destinationLatitude;
        data["destinationLongitude"] = this.destinationLongitude;
        data["lastLatitude"] = this.lastLatitude;
        data["lastLongitude"] = this.lastLongitude;
        data["regNumber"] = this.regNumber;
        data["aheadMinutes"] = this.aheadMinutes;
        data["behindMinutes"] = this.behindMinutes;
        data["transportOrderNumber"] = this.transportOrderNumber;
        data["departmentLookupId"] = this.departmentLookupId;
        data["categoryLookupId"] = this.categoryLookupId;
        data["typeLookupId"] = this.typeLookupId;
        data["updateTypeLookupId"] = this.updateTypeLookupId;
        data["name"] = this.name;
        data["city"] = this.city;
        data["country"] = this.country;
        data["orderNumber"] = this.orderNumber;
        data["customerNumber"] = this.customerNumber;
        data["orderdate"] = this.orderdate;
        data["orderType"] = this.orderType;
        data["totalSalesInGBP"] = this.totalSalesInGBP;
        data["consignmentNumber"] = this.consignmentNumber;
        data["receiverCountry"] = this.receiverCountry;
        data["receiverName"] = this.receiverName;
        data["receiverCity"] = this.receiverCity;
        data["senderCountry"] = this.senderCountry;
        data["senderName"] = this.senderName;
        data["senderCity"] = this.senderCity;
        data["carrier"] = this.carrier;
        data["isCancelled"] = this.isCancelled;
        data["collectionAddress"] = this.collectionAddress;
        data["customsAgent"] = this.customsAgent;
        data["isCritical"] = this.isCritical;
        data["heldAtCustoms"] = this.heldAtCustoms;
        data["note"] = this.note;
        data["shipmentMode"] = this.shipmentMode;
        data["updateDueSoon"] = this.updateDueSoon;
        data["updateOverDue"] = this.updateOverDue;
        data["trackingUrl"] = this.trackingUrl;
        data["owningUser"] = this.owningUser;
        data["deliveryName"] = this.deliveryName;
        data["lastActionDate"] = this.lastActionDate ? this.lastActionDate.toISOString() : <any>undefined;
        data["actualCollectionDate"] = this.actualCollectionDate ? this.actualCollectionDate.toISOString() : <any>undefined;
        data["actualDeliveryDate"] = this.actualDeliveryDate ? this.actualDeliveryDate.toISOString() : <any>undefined;
        data["updateDueDate"] = this.updateDueDate ? this.updateDueDate.toISOString() : <any>undefined;
        data["actualDepartureFromCollectionDate"] = this.actualDepartureFromCollectionDate ? this.actualDepartureFromCollectionDate.toISOString() : <any>undefined;
        data["actualArrivalAtDeliveryDate"] = this.actualArrivalAtDeliveryDate ? this.actualArrivalAtDeliveryDate.toISOString() : <any>undefined;
        data["poNumber"] = this.poNumber;
        data["plannedDeliveryEnd"] = this.plannedDeliveryEnd;
        data["plannedDeliveryStart"] = this.plannedDeliveryStart;
        data["etAatLoadingPoint"] = this.etAatLoadingPoint;
        data["etAatUnLoadingPoint"] = this.etAatUnLoadingPoint;
        data["plannedLoadingStart"] = this.plannedLoadingStart;
        data["plannedLoadingEnd"] = this.plannedLoadingEnd;
        data["inRecycleBin"] = this.inRecycleBin;
        data["lockStatus"] = this.lockStatus;
        data["lastFleetComStatus"] = this.lastFleetComStatus;
        data["trackingFrequency"] = this.trackingFrequency;
        data["isBmwJob"] = this.isBmwJob;
        data["customsStatus"] = this.customsStatus;
        data["customerContact"] = this.customerContact;
        data["declarationType"] = this.declarationType;
        data["customsEntryNno"] = this.customsEntryNno;
        data["eadmrnNo"] = this.eadmrnNo;
        data["tadlrnNo"] = this.tadlrnNo;
        data["hmrcStatus"] = this.hmrcStatus;
        return data;
    }
}

export interface ITourListHistoryModel {
    id?: number;
    tourId?: number;
    amcoId?: number;
    destination?: string | undefined;
    targetDateTime?: Date;
    estimatedDateTime?: Date | undefined;
    assignedUser?: string | undefined;
    departmentName?: string | undefined;
    updateTypeName?: string | undefined;
    categoryName?: string | undefined;
    customerName?: string | undefined;
    type?: string | undefined;
    typeName?: string | undefined;
    notesYesNo?: boolean;
    completed?: boolean;
    lastModifiedDate?: Date | undefined;
    lastModifiedBy?: string | undefined;
    vehicleId?: number | undefined;
    destinationLatitude?: number | undefined;
    destinationLongitude?: number | undefined;
    lastLatitude?: number | undefined;
    lastLongitude?: number | undefined;
    regNumber?: string | undefined;
    aheadMinutes?: number | undefined;
    behindMinutes?: number | undefined;
    transportOrderNumber?: string | undefined;
    departmentLookupId?: number;
    categoryLookupId?: number;
    typeLookupId?: number;
    updateTypeLookupId?: number;
    name?: string | undefined;
    city?: string | undefined;
    country?: string | undefined;
    orderNumber?: string | undefined;
    customerNumber?: string | undefined;
    orderdate?: string | undefined;
    orderType?: string | undefined;
    totalSalesInGBP?: string | undefined;
    consignmentNumber?: string | undefined;
    receiverCountry?: string | undefined;
    receiverName?: string | undefined;
    receiverCity?: string | undefined;
    senderCountry?: string | undefined;
    senderName?: string | undefined;
    senderCity?: string | undefined;
    carrier?: string | undefined;
    isCancelled?: boolean;
    collectionAddress?: string | undefined;
    customsAgent?: string | undefined;
    isCritical?: boolean;
    heldAtCustoms?: boolean;
    note?: string | undefined;
    shipmentMode?: string | undefined;
    updateDueSoon?: boolean | undefined;
    updateOverDue?: boolean | undefined;
    trackingUrl?: string | undefined;
    owningUser?: string | undefined;
    deliveryName?: string | undefined;
    lastActionDate?: Date | undefined;
    actualCollectionDate?: Date | undefined;
    actualDeliveryDate?: Date | undefined;
    updateDueDate?: Date | undefined;
    actualDepartureFromCollectionDate?: Date | undefined;
    actualArrivalAtDeliveryDate?: Date | undefined;
    poNumber?: string | undefined;
    plannedDeliveryEnd?: string | undefined;
    plannedDeliveryStart?: string | undefined;
    etAatLoadingPoint?: string | undefined;
    etAatUnLoadingPoint?: string | undefined;
    plannedLoadingStart?: string | undefined;
    plannedLoadingEnd?: string | undefined;
    inRecycleBin?: number;
    lockStatus?: number;
    lastFleetComStatus?: number;
    trackingFrequency?: string | undefined;
    isBmwJob?: boolean | undefined;
    customsStatus?: string | undefined;
    customerContact?: string | undefined;
    declarationType?: string | undefined;
    customsEntryNno?: string | undefined;
    eadmrnNo?: string | undefined;
    tadlrnNo?: string | undefined;
    hmrcStatus?: string | undefined;
}

export abstract class PagedListingRequest implements IPagedListingRequest {
    filter?: string | undefined;
    selectedFilterColumns?: string[] | undefined;
    specialCondition?: Filters[] | undefined;
    dateRangeFilter?: DateRangeFilter | undefined;
    sortBy?: string | undefined;
    sortByOrder?: string | undefined;
    pageSize?: number;
    pageIndex?: number;

    constructor(data?: IPagedListingRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.filter = _data["filter"];
            if (Array.isArray(_data["selectedFilterColumns"])) {
                this.selectedFilterColumns = [] as any;
                for (let item of _data["selectedFilterColumns"])
                    this.selectedFilterColumns!.push(item);
            }
            if (Array.isArray(_data["specialCondition"])) {
                this.specialCondition = [] as any;
                for (let item of _data["specialCondition"])
                    this.specialCondition!.push(Filters.fromJS(item));
            }
            this.dateRangeFilter = _data["dateRangeFilter"] ? DateRangeFilter.fromJS(_data["dateRangeFilter"]) : <any>undefined;
            this.sortBy = _data["sortBy"];
            this.sortByOrder = _data["sortByOrder"];
            this.pageSize = _data["pageSize"];
            this.pageIndex = _data["pageIndex"];
        }
    }

    static fromJS(data: any): PagedListingRequest {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'PagedListingRequest' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["filter"] = this.filter;
        if (Array.isArray(this.selectedFilterColumns)) {
            data["selectedFilterColumns"] = [];
            for (let item of this.selectedFilterColumns)
                data["selectedFilterColumns"].push(item);
        }
        if (Array.isArray(this.specialCondition)) {
            data["specialCondition"] = [];
            for (let item of this.specialCondition)
                data["specialCondition"].push(item.toJSON());
        }
        data["dateRangeFilter"] = this.dateRangeFilter ? this.dateRangeFilter.toJSON() : <any>undefined;
        data["sortBy"] = this.sortBy;
        data["sortByOrder"] = this.sortByOrder;
        data["pageSize"] = this.pageSize;
        data["pageIndex"] = this.pageIndex;
        return data;
    }
}

export interface IPagedListingRequest {
    filter?: string | undefined;
    selectedFilterColumns?: string[] | undefined;
    specialCondition?: Filters[] | undefined;
    dateRangeFilter?: DateRangeFilter | undefined;
    sortBy?: string | undefined;
    sortByOrder?: string | undefined;
    pageSize?: number;
    pageIndex?: number;
}

export class GetCustomsHistoryQuery extends PagedListingRequest implements IGetCustomsHistoryQuery {

    constructor(data?: IGetCustomsHistoryQuery) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): GetCustomsHistoryQuery {
        data = typeof data === 'object' ? data : {};
        let result = new GetCustomsHistoryQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IGetCustomsHistoryQuery extends IPagedListingRequest {
}

export class Filters implements IFilters {
    column?: string | undefined;
    value?: string | undefined;
    filterType?: FilterTypes;
    condition?: string | undefined;

    constructor(data?: IFilters) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.column = _data["column"];
            this.value = _data["value"];
            this.filterType = _data["filterType"];
            this.condition = _data["condition"];
        }
    }

    static fromJS(data: any): Filters {
        data = typeof data === 'object' ? data : {};
        let result = new Filters();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["column"] = this.column;
        data["value"] = this.value;
        data["filterType"] = this.filterType;
        data["condition"] = this.condition;
        return data;
    }
}

export interface IFilters {
    column?: string | undefined;
    value?: string | undefined;
    filterType?: FilterTypes;
    condition?: string | undefined;
}

export enum FilterTypes {
    Contains = 0,
    StartsWith = 1,
    EndsWith = 2,
    Equals = 3,
    NotEquals = 4,
    GreaterThan = 5,
    LessThan = 6,
    GreaterThanOrEqual = 7,
    LessThanOrEqual = 8,
    IsNull = 9,
    IsNotNull = 10,
}

export class DateRangeFilter implements IDateRangeFilter {
    startDate?: Date | undefined;
    endDate?: Date | undefined;

    constructor(data?: IDateRangeFilter) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): DateRangeFilter {
        data = typeof data === 'object' ? data : {};
        let result = new DateRangeFilter();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        return data;
    }
}

export interface IDateRangeFilter {
    startDate?: Date | undefined;
    endDate?: Date | undefined;
}

export class SendCustomsToUiQuery implements ISendCustomsToUiQuery {
    tourIds?: number[] | undefined;

    constructor(data?: ISendCustomsToUiQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["tourIds"])) {
                this.tourIds = [] as any;
                for (let item of _data["tourIds"])
                    this.tourIds!.push(item);
            }
        }
    }

    static fromJS(data: any): SendCustomsToUiQuery {
        data = typeof data === 'object' ? data : {};
        let result = new SendCustomsToUiQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.tourIds)) {
            data["tourIds"] = [];
            for (let item of this.tourIds)
                data["tourIds"].push(item);
        }
        return data;
    }
}

export interface ISendCustomsToUiQuery {
    tourIds?: number[] | undefined;
}

export class DashboardModel2 implements IDashboardModel2 {
    description?: string | undefined;
    count?: number;

    constructor(data?: IDashboardModel2) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.description = _data["description"];
            this.count = _data["count"];
        }
    }

    static fromJS(data: any): DashboardModel2 {
        data = typeof data === 'object' ? data : {};
        let result = new DashboardModel2();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["description"] = this.description;
        data["count"] = this.count;
        return data;
    }
}

export interface IDashboardModel2 {
    description?: string | undefined;
    count?: number;
}

export class CustomsHistoryModel implements ICustomsHistoryModel {
    tourId?: number;
    amcoId?: number;
    message?: string | undefined;
    type?: string | undefined;
    createdBy?: string | undefined;
    createdAt?: Date;

    constructor(data?: ICustomsHistoryModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tourId = _data["tourId"];
            this.amcoId = _data["amcoId"];
            this.message = _data["message"];
            this.type = _data["type"];
            this.createdBy = _data["createdBy"];
            this.createdAt = _data["createdAt"] ? new Date(_data["createdAt"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): CustomsHistoryModel {
        data = typeof data === 'object' ? data : {};
        let result = new CustomsHistoryModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tourId"] = this.tourId;
        data["amcoId"] = this.amcoId;
        data["message"] = this.message;
        data["type"] = this.type;
        data["createdBy"] = this.createdBy;
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : <any>undefined;
        return data;
    }
}

export interface ICustomsHistoryModel {
    tourId?: number;
    amcoId?: number;
    message?: string | undefined;
    type?: string | undefined;
    createdBy?: string | undefined;
    createdAt?: Date;
}

export class DocumentsModel implements IDocumentsModel {
    name?: string | undefined;
    createdDate?: Date;
    type?: string | undefined;
    size?: string | undefined;

    constructor(data?: IDocumentsModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : <any>undefined;
            this.type = _data["type"];
            this.size = _data["size"];
        }
    }

    static fromJS(data: any): DocumentsModel {
        data = typeof data === 'object' ? data : {};
        let result = new DocumentsModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : <any>undefined;
        data["type"] = this.type;
        data["size"] = this.size;
        return data;
    }
}

export interface IDocumentsModel {
    name?: string | undefined;
    createdDate?: Date;
    type?: string | undefined;
    size?: string | undefined;
}

export class DownloadDocumentResult implements IDownloadDocumentResult {
    fileContent?: string | undefined;
    contentType?: string | undefined;
    fileName?: string | undefined;

    constructor(data?: IDownloadDocumentResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fileContent = _data["fileContent"];
            this.contentType = _data["contentType"];
            this.fileName = _data["fileName"];
        }
    }

    static fromJS(data: any): DownloadDocumentResult {
        data = typeof data === 'object' ? data : {};
        let result = new DownloadDocumentResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fileContent"] = this.fileContent;
        data["contentType"] = this.contentType;
        data["fileName"] = this.fileName;
        return data;
    }
}

export interface IDownloadDocumentResult {
    fileContent?: string | undefined;
    contentType?: string | undefined;
    fileName?: string | undefined;
}

export class FileAuditModel implements IFileAuditModel {
    id?: number;
    amcoId?: number;
    toNumber?: string | undefined;
    fileName?: string | undefined;
    fileTypeId?: number;
    createdBy?: string | undefined;
    createdWhen?: Date;
    isDeleted?: boolean;
    description?: string | undefined;

    constructor(data?: IFileAuditModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.amcoId = _data["amcoId"];
            this.toNumber = _data["toNumber"];
            this.fileName = _data["fileName"];
            this.fileTypeId = _data["fileTypeId"];
            this.createdBy = _data["createdBy"];
            this.createdWhen = _data["createdWhen"] ? new Date(_data["createdWhen"].toString()) : <any>undefined;
            this.isDeleted = _data["isDeleted"];
            this.description = _data["description"];
        }
    }

    static fromJS(data: any): FileAuditModel {
        data = typeof data === 'object' ? data : {};
        let result = new FileAuditModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["amcoId"] = this.amcoId;
        data["toNumber"] = this.toNumber;
        data["fileName"] = this.fileName;
        data["fileTypeId"] = this.fileTypeId;
        data["createdBy"] = this.createdBy;
        data["createdWhen"] = this.createdWhen ? this.createdWhen.toISOString() : <any>undefined;
        data["isDeleted"] = this.isDeleted;
        data["description"] = this.description;
        return data;
    }
}

export interface IFileAuditModel {
    id?: number;
    amcoId?: number;
    toNumber?: string | undefined;
    fileName?: string | undefined;
    fileTypeId?: number;
    createdBy?: string | undefined;
    createdWhen?: Date;
    isDeleted?: boolean;
    description?: string | undefined;
}

export class UserModel implements IUserModel {
    id?: string;
    username?: string | undefined;
    firstname?: string | undefined;
    lastname?: string | undefined;
    email?: string | undefined;
    resetPasswordOnNextLogin?: boolean;
    isActiveDirectoryUser?: boolean;
    failedLoginAttempts?: number | undefined;
    lockoutExpiryDate?: Date | undefined;
    isActive?: boolean;
    signalRConnected?: boolean;
    createdBy?: string | undefined;
    createdDate?: Date;
    lastModifiedBy?: string | undefined;
    lastModifiedDate?: Date | undefined;
    roles?: RoleModel[] | undefined;
    tenants?: TenantModel[] | undefined;
    twoFA?: boolean | undefined;
    isLocked?: boolean | undefined;

    constructor(data?: IUserModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.username = _data["username"];
            this.firstname = _data["firstname"];
            this.lastname = _data["lastname"];
            this.email = _data["email"];
            this.resetPasswordOnNextLogin = _data["resetPasswordOnNextLogin"];
            this.isActiveDirectoryUser = _data["isActiveDirectoryUser"];
            this.failedLoginAttempts = _data["failedLoginAttempts"];
            this.lockoutExpiryDate = _data["lockoutExpiryDate"] ? new Date(_data["lockoutExpiryDate"].toString()) : <any>undefined;
            this.isActive = _data["isActive"];
            this.signalRConnected = _data["signalRConnected"];
            this.createdBy = _data["createdBy"];
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : <any>undefined;
            this.lastModifiedBy = _data["lastModifiedBy"];
            this.lastModifiedDate = _data["lastModifiedDate"] ? new Date(_data["lastModifiedDate"].toString()) : <any>undefined;
            if (Array.isArray(_data["roles"])) {
                this.roles = [] as any;
                for (let item of _data["roles"])
                    this.roles!.push(RoleModel.fromJS(item));
            }
            if (Array.isArray(_data["tenants"])) {
                this.tenants = [] as any;
                for (let item of _data["tenants"])
                    this.tenants!.push(TenantModel.fromJS(item));
            }
            this.twoFA = _data["twoFA"];
            this.isLocked = _data["isLocked"];
        }
    }

    static fromJS(data: any): UserModel {
        data = typeof data === 'object' ? data : {};
        let result = new UserModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["username"] = this.username;
        data["firstname"] = this.firstname;
        data["lastname"] = this.lastname;
        data["email"] = this.email;
        data["resetPasswordOnNextLogin"] = this.resetPasswordOnNextLogin;
        data["isActiveDirectoryUser"] = this.isActiveDirectoryUser;
        data["failedLoginAttempts"] = this.failedLoginAttempts;
        data["lockoutExpiryDate"] = this.lockoutExpiryDate ? this.lockoutExpiryDate.toISOString() : <any>undefined;
        data["isActive"] = this.isActive;
        data["signalRConnected"] = this.signalRConnected;
        data["createdBy"] = this.createdBy;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : <any>undefined;
        data["lastModifiedBy"] = this.lastModifiedBy;
        data["lastModifiedDate"] = this.lastModifiedDate ? this.lastModifiedDate.toISOString() : <any>undefined;
        if (Array.isArray(this.roles)) {
            data["roles"] = [];
            for (let item of this.roles)
                data["roles"].push(item.toJSON());
        }
        if (Array.isArray(this.tenants)) {
            data["tenants"] = [];
            for (let item of this.tenants)
                data["tenants"].push(item.toJSON());
        }
        data["twoFA"] = this.twoFA;
        data["isLocked"] = this.isLocked;
        return data;
    }
}

export interface IUserModel {
    id?: string;
    username?: string | undefined;
    firstname?: string | undefined;
    lastname?: string | undefined;
    email?: string | undefined;
    resetPasswordOnNextLogin?: boolean;
    isActiveDirectoryUser?: boolean;
    failedLoginAttempts?: number | undefined;
    lockoutExpiryDate?: Date | undefined;
    isActive?: boolean;
    signalRConnected?: boolean;
    createdBy?: string | undefined;
    createdDate?: Date;
    lastModifiedBy?: string | undefined;
    lastModifiedDate?: Date | undefined;
    roles?: RoleModel[] | undefined;
    tenants?: TenantModel[] | undefined;
    twoFA?: boolean | undefined;
    isLocked?: boolean | undefined;
}

export class RoleModel implements IRoleModel {
    id?: number;
    name?: string | undefined;
    description?: string | undefined;
    enabled?: boolean;
    users?: UserModel[] | undefined;

    constructor(data?: IRoleModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.enabled = _data["enabled"];
            if (Array.isArray(_data["users"])) {
                this.users = [] as any;
                for (let item of _data["users"])
                    this.users!.push(UserModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): RoleModel {
        data = typeof data === 'object' ? data : {};
        let result = new RoleModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["description"] = this.description;
        data["enabled"] = this.enabled;
        if (Array.isArray(this.users)) {
            data["users"] = [];
            for (let item of this.users)
                data["users"].push(item.toJSON());
        }
        return data;
    }
}

export interface IRoleModel {
    id?: number;
    name?: string | undefined;
    description?: string | undefined;
    enabled?: boolean;
    users?: UserModel[] | undefined;
}

export class TenantModel implements ITenantModel {
    id?: string;
    name?: string | undefined;
    enabled?: boolean;
    users?: UserModel[] | undefined;

    constructor(data?: ITenantModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.enabled = _data["enabled"];
            if (Array.isArray(_data["users"])) {
                this.users = [] as any;
                for (let item of _data["users"])
                    this.users!.push(UserModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): TenantModel {
        data = typeof data === 'object' ? data : {};
        let result = new TenantModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["enabled"] = this.enabled;
        if (Array.isArray(this.users)) {
            data["users"] = [];
            for (let item of this.users)
                data["users"].push(item.toJSON());
        }
        return data;
    }
}

export interface ITenantModel {
    id?: string;
    name?: string | undefined;
    enabled?: boolean;
    users?: UserModel[] | undefined;
}

export class ConfirmLogoutCommand implements IConfirmLogoutCommand {
    haveLoggedOut?: boolean;

    constructor(data?: IConfirmLogoutCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.haveLoggedOut = _data["haveLoggedOut"];
        }
    }

    static fromJS(data: any): ConfirmLogoutCommand {
        data = typeof data === 'object' ? data : {};
        let result = new ConfirmLogoutCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["haveLoggedOut"] = this.haveLoggedOut;
        return data;
    }
}

export interface IConfirmLogoutCommand {
    haveLoggedOut?: boolean;
}

export class CreateUpdateDeviceCommand implements ICreateUpdateDeviceCommand {
    versionNumber?: string | undefined;
    playerId?: string | undefined;

    constructor(data?: ICreateUpdateDeviceCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.versionNumber = _data["versionNumber"];
            this.playerId = _data["playerId"];
        }
    }

    static fromJS(data: any): CreateUpdateDeviceCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreateUpdateDeviceCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["versionNumber"] = this.versionNumber;
        data["playerId"] = this.playerId;
        return data;
    }
}

export interface ICreateUpdateDeviceCommand {
    versionNumber?: string | undefined;
    playerId?: string | undefined;
}

export class AddDriverTrackingResponse implements IAddDriverTrackingResponse {
    id?: string;
    name?: string | undefined;
    cellphoneNumber?: string | undefined;
    createdAt?: Date;
    success?: boolean;
    message?: string | undefined;

    constructor(data?: IAddDriverTrackingResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.cellphoneNumber = _data["cellphoneNumber"];
            this.createdAt = _data["createdAt"] ? new Date(_data["createdAt"].toString()) : <any>undefined;
            this.success = _data["success"];
            this.message = _data["message"];
        }
    }

    static fromJS(data: any): AddDriverTrackingResponse {
        data = typeof data === 'object' ? data : {};
        let result = new AddDriverTrackingResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["cellphoneNumber"] = this.cellphoneNumber;
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : <any>undefined;
        data["success"] = this.success;
        data["message"] = this.message;
        return data;
    }
}

export interface IAddDriverTrackingResponse {
    id?: string;
    name?: string | undefined;
    cellphoneNumber?: string | undefined;
    createdAt?: Date;
    success?: boolean;
    message?: string | undefined;
}

export class AddDriverTrackingCommand implements IAddDriverTrackingCommand {
    amcoId?: number;
    name?: string | undefined;
    cellphoneNumber?: string | undefined;

    constructor(data?: IAddDriverTrackingCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.amcoId = _data["amcoId"];
            this.name = _data["name"];
            this.cellphoneNumber = _data["cellphoneNumber"];
        }
    }

    static fromJS(data: any): AddDriverTrackingCommand {
        data = typeof data === 'object' ? data : {};
        let result = new AddDriverTrackingCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["amcoId"] = this.amcoId;
        data["name"] = this.name;
        data["cellphoneNumber"] = this.cellphoneNumber;
        return data;
    }
}

export interface IAddDriverTrackingCommand {
    amcoId?: number;
    name?: string | undefined;
    cellphoneNumber?: string | undefined;
}

export class GetConsignmentNumbersResponse implements IGetConsignmentNumbersResponse {
    success?: boolean;
    consignmentNumbers?: ConsignmentDetailsItem[] | undefined;

    constructor(data?: IGetConsignmentNumbersResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.success = _data["success"];
            if (Array.isArray(_data["consignmentNumbers"])) {
                this.consignmentNumbers = [] as any;
                for (let item of _data["consignmentNumbers"])
                    this.consignmentNumbers!.push(ConsignmentDetailsItem.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetConsignmentNumbersResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetConsignmentNumbersResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        if (Array.isArray(this.consignmentNumbers)) {
            data["consignmentNumbers"] = [];
            for (let item of this.consignmentNumbers)
                data["consignmentNumbers"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetConsignmentNumbersResponse {
    success?: boolean;
    consignmentNumbers?: ConsignmentDetailsItem[] | undefined;
}

export class ConsignmentDetailsItem implements IConsignmentDetailsItem {
    consignmentNumber?: string | undefined;
    senderCountryCode?: string | undefined;
    receiverCountryCode?: string | undefined;
    expectedGoods?: number | undefined;

    constructor(data?: IConsignmentDetailsItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.consignmentNumber = _data["consignmentNumber"];
            this.senderCountryCode = _data["senderCountryCode"];
            this.receiverCountryCode = _data["receiverCountryCode"];
            this.expectedGoods = _data["expectedGoods"];
        }
    }

    static fromJS(data: any): ConsignmentDetailsItem {
        data = typeof data === 'object' ? data : {};
        let result = new ConsignmentDetailsItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["consignmentNumber"] = this.consignmentNumber;
        data["senderCountryCode"] = this.senderCountryCode;
        data["receiverCountryCode"] = this.receiverCountryCode;
        data["expectedGoods"] = this.expectedGoods;
        return data;
    }
}

export interface IConsignmentDetailsItem {
    consignmentNumber?: string | undefined;
    senderCountryCode?: string | undefined;
    receiverCountryCode?: string | undefined;
    expectedGoods?: number | undefined;
}

export class RecordTrackStatusModel implements IRecordTrackStatusModel {
    success?: boolean;

    constructor(data?: IRecordTrackStatusModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.success = _data["success"];
        }
    }

    static fromJS(data: any): RecordTrackStatusModel {
        data = typeof data === 'object' ? data : {};
        let result = new RecordTrackStatusModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        return data;
    }
}

export interface IRecordTrackStatusModel {
    success?: boolean;
}

export class RecordTrackingCommand implements IRecordTrackingCommand {
    tourNumber?: string | undefined;
    status?: string | undefined;
    submittedDateUtc?: Date | undefined;

    constructor(data?: IRecordTrackingCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tourNumber = _data["tourNumber"];
            this.status = _data["status"];
            this.submittedDateUtc = _data["submittedDateUtc"] ? new Date(_data["submittedDateUtc"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): RecordTrackingCommand {
        data = typeof data === 'object' ? data : {};
        let result = new RecordTrackingCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tourNumber"] = this.tourNumber;
        data["status"] = this.status;
        data["submittedDateUtc"] = this.submittedDateUtc ? this.submittedDateUtc.toISOString() : <any>undefined;
        return data;
    }
}

export interface IRecordTrackingCommand {
    tourNumber?: string | undefined;
    status?: string | undefined;
    submittedDateUtc?: Date | undefined;
}

export class CompletePodResponse implements ICompletePodResponse {
    success?: boolean;

    constructor(data?: ICompletePodResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.success = _data["success"];
        }
    }

    static fromJS(data: any): CompletePodResponse {
        data = typeof data === 'object' ? data : {};
        let result = new CompletePodResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        return data;
    }
}

export interface ICompletePodResponse {
    success?: boolean;
}

export class CompletePodCommand implements ICompletePodCommand {
    tourNumber?: string | undefined;
    consignment?: string | undefined;
    base64Images?: string[] | undefined;
    submittedDateUtc?: Date | undefined;

    constructor(data?: ICompletePodCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tourNumber = _data["tourNumber"];
            this.consignment = _data["consignment"];
            if (Array.isArray(_data["base64Images"])) {
                this.base64Images = [] as any;
                for (let item of _data["base64Images"])
                    this.base64Images!.push(item);
            }
            this.submittedDateUtc = _data["submittedDateUtc"] ? new Date(_data["submittedDateUtc"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): CompletePodCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CompletePodCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tourNumber"] = this.tourNumber;
        data["consignment"] = this.consignment;
        if (Array.isArray(this.base64Images)) {
            data["base64Images"] = [];
            for (let item of this.base64Images)
                data["base64Images"].push(item);
        }
        data["submittedDateUtc"] = this.submittedDateUtc ? this.submittedDateUtc.toISOString() : <any>undefined;
        return data;
    }
}

export interface ICompletePodCommand {
    tourNumber?: string | undefined;
    consignment?: string | undefined;
    base64Images?: string[] | undefined;
    submittedDateUtc?: Date | undefined;
}

export class RegisterDriverResponse implements IRegisterDriverResponse {
    success?: boolean;

    constructor(data?: IRegisterDriverResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.success = _data["success"];
        }
    }

    static fromJS(data: any): RegisterDriverResponse {
        data = typeof data === 'object' ? data : {};
        let result = new RegisterDriverResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        return data;
    }
}

export interface IRegisterDriverResponse {
    success?: boolean;
}

export class RegisterDriverCommand implements IRegisterDriverCommand {
    tourNumber?: string | undefined;
    carrierName?: string | undefined;
    consignmentNumber?: string | undefined;

    constructor(data?: IRegisterDriverCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tourNumber = _data["tourNumber"];
            this.carrierName = _data["carrierName"];
            this.consignmentNumber = _data["consignmentNumber"];
        }
    }

    static fromJS(data: any): RegisterDriverCommand {
        data = typeof data === 'object' ? data : {};
        let result = new RegisterDriverCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tourNumber"] = this.tourNumber;
        data["carrierName"] = this.carrierName;
        data["consignmentNumber"] = this.consignmentNumber;
        return data;
    }
}

export interface IRegisterDriverCommand {
    tourNumber?: string | undefined;
    carrierName?: string | undefined;
    consignmentNumber?: string | undefined;
}

export class SendConsignmentStatusResponse implements ISendConsignmentStatusResponse {
    success?: boolean;

    constructor(data?: ISendConsignmentStatusResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.success = _data["success"];
        }
    }

    static fromJS(data: any): SendConsignmentStatusResponse {
        data = typeof data === 'object' ? data : {};
        let result = new SendConsignmentStatusResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        return data;
    }
}

export interface ISendConsignmentStatusResponse {
    success?: boolean;
}

export class SendConsignmentStatusCommand implements ISendConsignmentStatusCommand {
    tourNumber?: string | undefined;
    consignmentNumber?: string | undefined;
    consignmentStatus?: string | undefined;
    timeStampUtc?: string | undefined;
    isWebUiRequest?: boolean;

    constructor(data?: ISendConsignmentStatusCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tourNumber = _data["tourNumber"];
            this.consignmentNumber = _data["consignmentNumber"];
            this.consignmentStatus = _data["consignmentStatus"];
            this.timeStampUtc = _data["timeStampUtc"];
            this.isWebUiRequest = _data["isWebUiRequest"];
        }
    }

    static fromJS(data: any): SendConsignmentStatusCommand {
        data = typeof data === 'object' ? data : {};
        let result = new SendConsignmentStatusCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tourNumber"] = this.tourNumber;
        data["consignmentNumber"] = this.consignmentNumber;
        data["consignmentStatus"] = this.consignmentStatus;
        data["timeStampUtc"] = this.timeStampUtc;
        data["isWebUiRequest"] = this.isWebUiRequest;
        return data;
    }
}

export interface ISendConsignmentStatusCommand {
    tourNumber?: string | undefined;
    consignmentNumber?: string | undefined;
    consignmentStatus?: string | undefined;
    timeStampUtc?: string | undefined;
    isWebUiRequest?: boolean;
}

export class ReportParcelCountDiscrepancyResponse implements IReportParcelCountDiscrepancyResponse {
    success?: boolean;

    constructor(data?: IReportParcelCountDiscrepancyResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.success = _data["success"];
        }
    }

    static fromJS(data: any): ReportParcelCountDiscrepancyResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ReportParcelCountDiscrepancyResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        return data;
    }
}

export interface IReportParcelCountDiscrepancyResponse {
    success?: boolean;
}

export class ReportParcelCountDiscrepancyCommand implements IReportParcelCountDiscrepancyCommand {
    tourNumber?: string | undefined;
    consignmentNumber?: string | undefined;
    actualGoods?: number;

    constructor(data?: IReportParcelCountDiscrepancyCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tourNumber = _data["tourNumber"];
            this.consignmentNumber = _data["consignmentNumber"];
            this.actualGoods = _data["actualGoods"];
        }
    }

    static fromJS(data: any): ReportParcelCountDiscrepancyCommand {
        data = typeof data === 'object' ? data : {};
        let result = new ReportParcelCountDiscrepancyCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tourNumber"] = this.tourNumber;
        data["consignmentNumber"] = this.consignmentNumber;
        data["actualGoods"] = this.actualGoods;
        return data;
    }
}

export interface IReportParcelCountDiscrepancyCommand {
    tourNumber?: string | undefined;
    consignmentNumber?: string | undefined;
    actualGoods?: number;
}

export class ReportDelayResponse implements IReportDelayResponse {
    success?: boolean;
    ifsReference?: string | undefined;
    ifsReason?: string | undefined;
    stagingId?: number | undefined;

    constructor(data?: IReportDelayResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.success = _data["success"];
            this.ifsReference = _data["ifsReference"];
            this.ifsReason = _data["ifsReason"];
            this.stagingId = _data["stagingId"];
        }
    }

    static fromJS(data: any): ReportDelayResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ReportDelayResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        data["ifsReference"] = this.ifsReference;
        data["ifsReason"] = this.ifsReason;
        data["stagingId"] = this.stagingId;
        return data;
    }
}

export interface IReportDelayResponse {
    success?: boolean;
    ifsReference?: string | undefined;
    ifsReason?: string | undefined;
    stagingId?: number | undefined;
}

export class ReportDelayCommand implements IReportDelayCommand {
    amcoId?: number;
    tourId?: number;
    transportOrderNumber?: string | undefined;
    delayReasonCode?: number;
    timeStampUtc?: string | undefined;

    constructor(data?: IReportDelayCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.amcoId = _data["amcoId"];
            this.tourId = _data["tourId"];
            this.transportOrderNumber = _data["transportOrderNumber"];
            this.delayReasonCode = _data["delayReasonCode"];
            this.timeStampUtc = _data["timeStampUtc"];
        }
    }

    static fromJS(data: any): ReportDelayCommand {
        data = typeof data === 'object' ? data : {};
        let result = new ReportDelayCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["amcoId"] = this.amcoId;
        data["tourId"] = this.tourId;
        data["transportOrderNumber"] = this.transportOrderNumber;
        data["delayReasonCode"] = this.delayReasonCode;
        data["timeStampUtc"] = this.timeStampUtc;
        return data;
    }
}

export interface IReportDelayCommand {
    amcoId?: number;
    tourId?: number;
    transportOrderNumber?: string | undefined;
    delayReasonCode?: number;
    timeStampUtc?: string | undefined;
}

export class ReportDelayByTourNumberCommand implements IReportDelayByTourNumberCommand {
    tourNumber?: string | undefined;
    reasonCode?: number;
    recordDate?: string | undefined;

    constructor(data?: IReportDelayByTourNumberCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tourNumber = _data["tourNumber"];
            this.reasonCode = _data["reasonCode"];
            this.recordDate = _data["recordDate"];
        }
    }

    static fromJS(data: any): ReportDelayByTourNumberCommand {
        data = typeof data === 'object' ? data : {};
        let result = new ReportDelayByTourNumberCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tourNumber"] = this.tourNumber;
        data["reasonCode"] = this.reasonCode;
        data["recordDate"] = this.recordDate;
        return data;
    }
}

export interface IReportDelayByTourNumberCommand {
    tourNumber?: string | undefined;
    reasonCode?: number;
    recordDate?: string | undefined;
}

export class EmailDetailsModel implements IEmailDetailsModel {
    amcoid?: number;
    customerName?: string | undefined;
    customerPO?: string | undefined;
    tourType?: string | undefined;
    updateType?: string | undefined;
    notes?: string | undefined;
    location?: string | undefined;
    dateTime?: Date;

    constructor(data?: IEmailDetailsModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.amcoid = _data["amcoid"];
            this.customerName = _data["customerName"];
            this.customerPO = _data["customerPO"];
            this.tourType = _data["tourType"];
            this.updateType = _data["updateType"];
            this.notes = _data["notes"];
            this.location = _data["location"];
            this.dateTime = _data["dateTime"] ? new Date(_data["dateTime"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): EmailDetailsModel {
        data = typeof data === 'object' ? data : {};
        let result = new EmailDetailsModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["amcoid"] = this.amcoid;
        data["customerName"] = this.customerName;
        data["customerPO"] = this.customerPO;
        data["tourType"] = this.tourType;
        data["updateType"] = this.updateType;
        data["notes"] = this.notes;
        data["location"] = this.location;
        data["dateTime"] = this.dateTime ? this.dateTime.toISOString() : <any>undefined;
        return data;
    }
}

export interface IEmailDetailsModel {
    amcoid?: number;
    customerName?: string | undefined;
    customerPO?: string | undefined;
    tourType?: string | undefined;
    updateType?: string | undefined;
    notes?: string | undefined;
    location?: string | undefined;
    dateTime?: Date;
}

export class AdvancedEtaResult implements IAdvancedEtaResult {
    finalEta?: Date;
    baseRouteEta?: Date;
    distanceKm?: number;
    baseDuration?: string;
    weatherDelay?: string;
    weatherSegments?: WeatherSegmentImpact[] | undefined;
    isFullPrediction?: boolean;
    combinedTransportSkipped?: boolean;
    warnings?: string[] | undefined;
    remainingBreakMinutes?: number;
    remainingRestMinutes?: number;
    driverRestDelay?: string;
    driverBreakDelay?: string;
    weekendDelay?: string;
    estimatedPortArrivalUtc?: Date | undefined;
    requiredPortArrivalUtc?: Date | undefined;
    selectedFerryDepartureUtc?: Date | undefined;
    selectedFerryArrivalUtc?: Date | undefined;
    ferryCheckInBuffer?: string;
    ferryWaitTime?: string;
    ferryCrossingTime?: string;
    ptvRouteId?: string | undefined;
    ptvRouteCreatedUtc?: Date | undefined;
    ptvRouteColDel?: string | undefined;
    usedEtaRouteId?: boolean;

    constructor(data?: IAdvancedEtaResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.finalEta = _data["finalEta"] ? new Date(_data["finalEta"].toString()) : <any>undefined;
            this.baseRouteEta = _data["baseRouteEta"] ? new Date(_data["baseRouteEta"].toString()) : <any>undefined;
            this.distanceKm = _data["distanceKm"];
            this.baseDuration = _data["baseDuration"];
            this.weatherDelay = _data["weatherDelay"];
            if (Array.isArray(_data["weatherSegments"])) {
                this.weatherSegments = [] as any;
                for (let item of _data["weatherSegments"])
                    this.weatherSegments!.push(WeatherSegmentImpact.fromJS(item));
            }
            this.isFullPrediction = _data["isFullPrediction"];
            this.combinedTransportSkipped = _data["combinedTransportSkipped"];
            if (Array.isArray(_data["warnings"])) {
                this.warnings = [] as any;
                for (let item of _data["warnings"])
                    this.warnings!.push(item);
            }
            this.remainingBreakMinutes = _data["remainingBreakMinutes"];
            this.remainingRestMinutes = _data["remainingRestMinutes"];
            this.driverRestDelay = _data["driverRestDelay"];
            this.driverBreakDelay = _data["driverBreakDelay"];
            this.weekendDelay = _data["weekendDelay"];
            this.estimatedPortArrivalUtc = _data["estimatedPortArrivalUtc"] ? new Date(_data["estimatedPortArrivalUtc"].toString()) : <any>undefined;
            this.requiredPortArrivalUtc = _data["requiredPortArrivalUtc"] ? new Date(_data["requiredPortArrivalUtc"].toString()) : <any>undefined;
            this.selectedFerryDepartureUtc = _data["selectedFerryDepartureUtc"] ? new Date(_data["selectedFerryDepartureUtc"].toString()) : <any>undefined;
            this.selectedFerryArrivalUtc = _data["selectedFerryArrivalUtc"] ? new Date(_data["selectedFerryArrivalUtc"].toString()) : <any>undefined;
            this.ferryCheckInBuffer = _data["ferryCheckInBuffer"];
            this.ferryWaitTime = _data["ferryWaitTime"];
            this.ferryCrossingTime = _data["ferryCrossingTime"];
            this.ptvRouteId = _data["ptvRouteId"];
            this.ptvRouteCreatedUtc = _data["ptvRouteCreatedUtc"] ? new Date(_data["ptvRouteCreatedUtc"].toString()) : <any>undefined;
            this.ptvRouteColDel = _data["ptvRouteColDel"];
            this.usedEtaRouteId = _data["usedEtaRouteId"];
        }
    }

    static fromJS(data: any): AdvancedEtaResult {
        data = typeof data === 'object' ? data : {};
        let result = new AdvancedEtaResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["finalEta"] = this.finalEta ? this.finalEta.toISOString() : <any>undefined;
        data["baseRouteEta"] = this.baseRouteEta ? this.baseRouteEta.toISOString() : <any>undefined;
        data["distanceKm"] = this.distanceKm;
        data["baseDuration"] = this.baseDuration;
        data["weatherDelay"] = this.weatherDelay;
        if (Array.isArray(this.weatherSegments)) {
            data["weatherSegments"] = [];
            for (let item of this.weatherSegments)
                data["weatherSegments"].push(item.toJSON());
        }
        data["isFullPrediction"] = this.isFullPrediction;
        data["combinedTransportSkipped"] = this.combinedTransportSkipped;
        if (Array.isArray(this.warnings)) {
            data["warnings"] = [];
            for (let item of this.warnings)
                data["warnings"].push(item);
        }
        data["remainingBreakMinutes"] = this.remainingBreakMinutes;
        data["remainingRestMinutes"] = this.remainingRestMinutes;
        data["driverRestDelay"] = this.driverRestDelay;
        data["driverBreakDelay"] = this.driverBreakDelay;
        data["weekendDelay"] = this.weekendDelay;
        data["estimatedPortArrivalUtc"] = this.estimatedPortArrivalUtc ? this.estimatedPortArrivalUtc.toISOString() : <any>undefined;
        data["requiredPortArrivalUtc"] = this.requiredPortArrivalUtc ? this.requiredPortArrivalUtc.toISOString() : <any>undefined;
        data["selectedFerryDepartureUtc"] = this.selectedFerryDepartureUtc ? this.selectedFerryDepartureUtc.toISOString() : <any>undefined;
        data["selectedFerryArrivalUtc"] = this.selectedFerryArrivalUtc ? this.selectedFerryArrivalUtc.toISOString() : <any>undefined;
        data["ferryCheckInBuffer"] = this.ferryCheckInBuffer;
        data["ferryWaitTime"] = this.ferryWaitTime;
        data["ferryCrossingTime"] = this.ferryCrossingTime;
        data["ptvRouteId"] = this.ptvRouteId;
        data["ptvRouteCreatedUtc"] = this.ptvRouteCreatedUtc ? this.ptvRouteCreatedUtc.toISOString() : <any>undefined;
        data["ptvRouteColDel"] = this.ptvRouteColDel;
        data["usedEtaRouteId"] = this.usedEtaRouteId;
        return data;
    }
}

export interface IAdvancedEtaResult {
    finalEta?: Date;
    baseRouteEta?: Date;
    distanceKm?: number;
    baseDuration?: string;
    weatherDelay?: string;
    weatherSegments?: WeatherSegmentImpact[] | undefined;
    isFullPrediction?: boolean;
    combinedTransportSkipped?: boolean;
    warnings?: string[] | undefined;
    remainingBreakMinutes?: number;
    remainingRestMinutes?: number;
    driverRestDelay?: string;
    driverBreakDelay?: string;
    weekendDelay?: string;
    estimatedPortArrivalUtc?: Date | undefined;
    requiredPortArrivalUtc?: Date | undefined;
    selectedFerryDepartureUtc?: Date | undefined;
    selectedFerryArrivalUtc?: Date | undefined;
    ferryCheckInBuffer?: string;
    ferryWaitTime?: string;
    ferryCrossingTime?: string;
    ptvRouteId?: string | undefined;
    ptvRouteCreatedUtc?: Date | undefined;
    ptvRouteColDel?: string | undefined;
    usedEtaRouteId?: boolean;
}

export class WeatherSegmentImpact implements IWeatherSegmentImpact {
    latitude?: number;
    longitude?: number;
    condition?: string | undefined;
    penaltyPercent?: number;
    addedTime?: string;

    constructor(data?: IWeatherSegmentImpact) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.latitude = _data["latitude"];
            this.longitude = _data["longitude"];
            this.condition = _data["condition"];
            this.penaltyPercent = _data["penaltyPercent"];
            this.addedTime = _data["addedTime"];
        }
    }

    static fromJS(data: any): WeatherSegmentImpact {
        data = typeof data === 'object' ? data : {};
        let result = new WeatherSegmentImpact();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["latitude"] = this.latitude;
        data["longitude"] = this.longitude;
        data["condition"] = this.condition;
        data["penaltyPercent"] = this.penaltyPercent;
        data["addedTime"] = this.addedTime;
        return data;
    }
}

export interface IWeatherSegmentImpact {
    latitude?: number;
    longitude?: number;
    condition?: string | undefined;
    penaltyPercent?: number;
    addedTime?: string;
}

export class VehicleEventsModel implements IVehicleEventsModel {
    vehicleNumber?: string | undefined;
    vehicleLicensePlate?: string | undefined;
    vehicleLicenseCountry?: string | undefined;
    trailerNumber?: number;
    trailerLicensePlate?: string | undefined;
    trailerLicenseCountry?: string | undefined;
    tripNumber?: number;
    shipmentCompanyId?: number;
    originalShipmentNumber?: number;
    customerReference?: string | undefined;
    customerReference2?: string | undefined;
    platformReference?: string | undefined;
    platformCustomerName?: string | undefined;
    positionAvailable?: boolean;
    vehicleId?: number;
    positionDateTime?: Date;
    latitude?: number;
    longitude?: number;
    countryCode?: string | undefined;
    zipCode?: string | undefined;
    nearestCity?: string | undefined;
    addressInfo?: string | undefined;
    isManual?: boolean | undefined;
    tourId?: number;
    disabled?: boolean | undefined;

    constructor(data?: IVehicleEventsModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.vehicleNumber = _data["vehicleNumber"];
            this.vehicleLicensePlate = _data["vehicleLicensePlate"];
            this.vehicleLicenseCountry = _data["vehicleLicenseCountry"];
            this.trailerNumber = _data["trailerNumber"];
            this.trailerLicensePlate = _data["trailerLicensePlate"];
            this.trailerLicenseCountry = _data["trailerLicenseCountry"];
            this.tripNumber = _data["tripNumber"];
            this.shipmentCompanyId = _data["shipmentCompanyId"];
            this.originalShipmentNumber = _data["originalShipmentNumber"];
            this.customerReference = _data["customerReference"];
            this.customerReference2 = _data["customerReference2"];
            this.platformReference = _data["platformReference"];
            this.platformCustomerName = _data["platformCustomerName"];
            this.positionAvailable = _data["positionAvailable"];
            this.vehicleId = _data["vehicleId"];
            this.positionDateTime = _data["positionDateTime"] ? new Date(_data["positionDateTime"].toString()) : <any>undefined;
            this.latitude = _data["latitude"];
            this.longitude = _data["longitude"];
            this.countryCode = _data["countryCode"];
            this.zipCode = _data["zipCode"];
            this.nearestCity = _data["nearestCity"];
            this.addressInfo = _data["addressInfo"];
            this.isManual = _data["isManual"];
            this.tourId = _data["tourId"];
            this.disabled = _data["disabled"];
        }
    }

    static fromJS(data: any): VehicleEventsModel {
        data = typeof data === 'object' ? data : {};
        let result = new VehicleEventsModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["vehicleNumber"] = this.vehicleNumber;
        data["vehicleLicensePlate"] = this.vehicleLicensePlate;
        data["vehicleLicenseCountry"] = this.vehicleLicenseCountry;
        data["trailerNumber"] = this.trailerNumber;
        data["trailerLicensePlate"] = this.trailerLicensePlate;
        data["trailerLicenseCountry"] = this.trailerLicenseCountry;
        data["tripNumber"] = this.tripNumber;
        data["shipmentCompanyId"] = this.shipmentCompanyId;
        data["originalShipmentNumber"] = this.originalShipmentNumber;
        data["customerReference"] = this.customerReference;
        data["customerReference2"] = this.customerReference2;
        data["platformReference"] = this.platformReference;
        data["platformCustomerName"] = this.platformCustomerName;
        data["positionAvailable"] = this.positionAvailable;
        data["vehicleId"] = this.vehicleId;
        data["positionDateTime"] = this.positionDateTime ? this.positionDateTime.toISOString() : <any>undefined;
        data["latitude"] = this.latitude;
        data["longitude"] = this.longitude;
        data["countryCode"] = this.countryCode;
        data["zipCode"] = this.zipCode;
        data["nearestCity"] = this.nearestCity;
        data["addressInfo"] = this.addressInfo;
        data["isManual"] = this.isManual;
        data["tourId"] = this.tourId;
        data["disabled"] = this.disabled;
        return data;
    }
}

export interface IVehicleEventsModel {
    vehicleNumber?: string | undefined;
    vehicleLicensePlate?: string | undefined;
    vehicleLicenseCountry?: string | undefined;
    trailerNumber?: number;
    trailerLicensePlate?: string | undefined;
    trailerLicenseCountry?: string | undefined;
    tripNumber?: number;
    shipmentCompanyId?: number;
    originalShipmentNumber?: number;
    customerReference?: string | undefined;
    customerReference2?: string | undefined;
    platformReference?: string | undefined;
    platformCustomerName?: string | undefined;
    positionAvailable?: boolean;
    vehicleId?: number;
    positionDateTime?: Date;
    latitude?: number;
    longitude?: number;
    countryCode?: string | undefined;
    zipCode?: string | undefined;
    nearestCity?: string | undefined;
    addressInfo?: string | undefined;
    isManual?: boolean | undefined;
    tourId?: number;
    disabled?: boolean | undefined;
}

export class GeofenceReplayMarkerModel implements IGeofenceReplayMarkerModel {
    latitude?: number;
    longitude?: number;
    milestoneName?: string | undefined;
    eventTime?: Date;
    vehicleLicensePlate?: string | undefined;
    nearestCity?: string | undefined;
    countryCode?: string | undefined;

    constructor(data?: IGeofenceReplayMarkerModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.latitude = _data["latitude"];
            this.longitude = _data["longitude"];
            this.milestoneName = _data["milestoneName"];
            this.eventTime = _data["eventTime"] ? new Date(_data["eventTime"].toString()) : <any>undefined;
            this.vehicleLicensePlate = _data["vehicleLicensePlate"];
            this.nearestCity = _data["nearestCity"];
            this.countryCode = _data["countryCode"];
        }
    }

    static fromJS(data: any): GeofenceReplayMarkerModel {
        data = typeof data === 'object' ? data : {};
        let result = new GeofenceReplayMarkerModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["latitude"] = this.latitude;
        data["longitude"] = this.longitude;
        data["milestoneName"] = this.milestoneName;
        data["eventTime"] = this.eventTime ? this.eventTime.toISOString() : <any>undefined;
        data["vehicleLicensePlate"] = this.vehicleLicensePlate;
        data["nearestCity"] = this.nearestCity;
        data["countryCode"] = this.countryCode;
        return data;
    }
}

export interface IGeofenceReplayMarkerModel {
    latitude?: number;
    longitude?: number;
    milestoneName?: string | undefined;
    eventTime?: Date;
    vehicleLicensePlate?: string | undefined;
    nearestCity?: string | undefined;
    countryCode?: string | undefined;
}

export class GeofenceLocationModel implements IGeofenceLocationModel {
    id?: number;
    name?: string | undefined;
    latitude?: number;
    longitude?: number;
    radiusMeters?: number;
    locationType?: string | undefined;
    isActive?: boolean;
    polygonPoints?: PolygonPointModel[] | undefined;

    constructor(data?: IGeofenceLocationModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.latitude = _data["latitude"];
            this.longitude = _data["longitude"];
            this.radiusMeters = _data["radiusMeters"];
            this.locationType = _data["locationType"];
            this.isActive = _data["isActive"];
            if (Array.isArray(_data["polygonPoints"])) {
                this.polygonPoints = [] as any;
                for (let item of _data["polygonPoints"])
                    this.polygonPoints!.push(PolygonPointModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GeofenceLocationModel {
        data = typeof data === 'object' ? data : {};
        let result = new GeofenceLocationModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["latitude"] = this.latitude;
        data["longitude"] = this.longitude;
        data["radiusMeters"] = this.radiusMeters;
        data["locationType"] = this.locationType;
        data["isActive"] = this.isActive;
        if (Array.isArray(this.polygonPoints)) {
            data["polygonPoints"] = [];
            for (let item of this.polygonPoints)
                data["polygonPoints"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGeofenceLocationModel {
    id?: number;
    name?: string | undefined;
    latitude?: number;
    longitude?: number;
    radiusMeters?: number;
    locationType?: string | undefined;
    isActive?: boolean;
    polygonPoints?: PolygonPointModel[] | undefined;
}

export class PolygonPointModel implements IPolygonPointModel {
    lat?: number;
    lng?: number;

    constructor(data?: IPolygonPointModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.lat = _data["lat"];
            this.lng = _data["lng"];
        }
    }

    static fromJS(data: any): PolygonPointModel {
        data = typeof data === 'object' ? data : {};
        let result = new PolygonPointModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["lat"] = this.lat;
        data["lng"] = this.lng;
        return data;
    }
}

export interface IPolygonPointModel {
    lat?: number;
    lng?: number;
}

export class LookupModel implements ILookupModel {
    id?: number;
    name?: string | undefined;
    longDescription?: string | undefined;

    constructor(data?: ILookupModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.longDescription = _data["longDescription"];
        }
    }

    static fromJS(data: any): LookupModel {
        data = typeof data === 'object' ? data : {};
        let result = new LookupModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["longDescription"] = this.longDescription;
        return data;
    }
}

export interface ILookupModel {
    id?: number;
    name?: string | undefined;
    longDescription?: string | undefined;
}

export class CountryLookupModel implements ICountryLookupModel {
    id?: number;
    countryCode?: string | undefined;
    countryName?: string | undefined;
    matchcode?: string | undefined;

    constructor(data?: ICountryLookupModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.countryCode = _data["countryCode"];
            this.countryName = _data["countryName"];
            this.matchcode = _data["matchcode"];
        }
    }

    static fromJS(data: any): CountryLookupModel {
        data = typeof data === 'object' ? data : {};
        let result = new CountryLookupModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["countryCode"] = this.countryCode;
        data["countryName"] = this.countryName;
        data["matchcode"] = this.matchcode;
        return data;
    }
}

export interface ICountryLookupModel {
    id?: number;
    countryCode?: string | undefined;
    countryName?: string | undefined;
    matchcode?: string | undefined;
}

export class AddLogsCommand implements IAddLogsCommand {
    mobileLogs?: MobileLogModel[] | undefined;

    constructor(data?: IAddLogsCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["mobileLogs"])) {
                this.mobileLogs = [] as any;
                for (let item of _data["mobileLogs"])
                    this.mobileLogs!.push(MobileLogModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): AddLogsCommand {
        data = typeof data === 'object' ? data : {};
        let result = new AddLogsCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.mobileLogs)) {
            data["mobileLogs"] = [];
            for (let item of this.mobileLogs)
                data["mobileLogs"].push(item.toJSON());
        }
        return data;
    }
}

export interface IAddLogsCommand {
    mobileLogs?: MobileLogModel[] | undefined;
}

export class MobileLogModel implements IMobileLogModel {
    logDateTime?: string | undefined;
    logType?: string | undefined;
    logLocation?: string | undefined;
    logMessage?: string | undefined;
    mobileVersion?: string | undefined;

    constructor(data?: IMobileLogModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.logDateTime = _data["logDateTime"];
            this.logType = _data["logType"];
            this.logLocation = _data["logLocation"];
            this.logMessage = _data["logMessage"];
            this.mobileVersion = _data["mobileVersion"];
        }
    }

    static fromJS(data: any): MobileLogModel {
        data = typeof data === 'object' ? data : {};
        let result = new MobileLogModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["logDateTime"] = this.logDateTime;
        data["logType"] = this.logType;
        data["logLocation"] = this.logLocation;
        data["logMessage"] = this.logMessage;
        data["mobileVersion"] = this.mobileVersion;
        return data;
    }
}

export interface IMobileLogModel {
    logDateTime?: string | undefined;
    logType?: string | undefined;
    logLocation?: string | undefined;
    logMessage?: string | undefined;
    mobileVersion?: string | undefined;
}

export class ActiveTourModel implements IActiveTourModel {
    id?: number;
    tourId?: number;
    amcoId?: number;
    customerPo?: string | undefined;
    toNumber?: string | undefined;
    tourType?: string | undefined;
    senderName?: string | undefined;
    receiverName?: string | undefined;
    updateType?: string | undefined;
    lastUpdate?: Date;
    plannedDeliveryEnd?: Date;
    updateDueDate?: Date | undefined;

    constructor(data?: IActiveTourModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.tourId = _data["tourId"];
            this.amcoId = _data["amcoId"];
            this.customerPo = _data["customerPo"];
            this.toNumber = _data["toNumber"];
            this.tourType = _data["tourType"];
            this.senderName = _data["senderName"];
            this.receiverName = _data["receiverName"];
            this.updateType = _data["updateType"];
            this.lastUpdate = _data["lastUpdate"] ? new Date(_data["lastUpdate"].toString()) : <any>undefined;
            this.plannedDeliveryEnd = _data["plannedDeliveryEnd"] ? new Date(_data["plannedDeliveryEnd"].toString()) : <any>undefined;
            this.updateDueDate = _data["updateDueDate"] ? new Date(_data["updateDueDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): ActiveTourModel {
        data = typeof data === 'object' ? data : {};
        let result = new ActiveTourModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["tourId"] = this.tourId;
        data["amcoId"] = this.amcoId;
        data["customerPo"] = this.customerPo;
        data["toNumber"] = this.toNumber;
        data["tourType"] = this.tourType;
        data["senderName"] = this.senderName;
        data["receiverName"] = this.receiverName;
        data["updateType"] = this.updateType;
        data["lastUpdate"] = this.lastUpdate ? this.lastUpdate.toISOString() : <any>undefined;
        data["plannedDeliveryEnd"] = this.plannedDeliveryEnd ? this.plannedDeliveryEnd.toISOString() : <any>undefined;
        data["updateDueDate"] = this.updateDueDate ? this.updateDueDate.toISOString() : <any>undefined;
        return data;
    }
}

export interface IActiveTourModel {
    id?: number;
    tourId?: number;
    amcoId?: number;
    customerPo?: string | undefined;
    toNumber?: string | undefined;
    tourType?: string | undefined;
    senderName?: string | undefined;
    receiverName?: string | undefined;
    updateType?: string | undefined;
    lastUpdate?: Date;
    plannedDeliveryEnd?: Date;
    updateDueDate?: Date | undefined;
}

export class ActiveTourDetailModel implements IActiveTourDetailModel {
    id?: number;
    amcoId?: number;
    tourId?: number;
    toNumber?: number | undefined;
    destinationLatitude?: number | undefined;
    destinationLongitude?: number | undefined;
    collectionLatitude?: number | undefined;
    collectionLongitude?: number | undefined;
    collectionAddress?: string | undefined;
    deliveryAddress?: string | undefined;
    currentVehicleLatitude?: number | undefined;
    currentVehicleLongitude?: number | undefined;
    currentVehiclepositionDateTime?: Date | undefined;
    licencePlateNumber?: string | undefined;
    type?: string | undefined;
    updateBy?: string | undefined;
    estimatedDateTime?: Date | undefined;
    plannedDeliveryStart?: string | undefined;
    plannedLoadingStart?: string | undefined;
    plannedLoadingEnd?: string | undefined;
    plannedDeliveryEnd?: string | undefined;
    actualCollectionDate?: Date | undefined;
    actualDeliveryDate?: Date | undefined;
    vehicleEvents?: LatLngModel[] | undefined;

    constructor(data?: IActiveTourDetailModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.amcoId = _data["amcoId"];
            this.tourId = _data["tourId"];
            this.toNumber = _data["toNumber"];
            this.destinationLatitude = _data["destinationLatitude"];
            this.destinationLongitude = _data["destinationLongitude"];
            this.collectionLatitude = _data["collectionLatitude"];
            this.collectionLongitude = _data["collectionLongitude"];
            this.collectionAddress = _data["collectionAddress"];
            this.deliveryAddress = _data["deliveryAddress"];
            this.currentVehicleLatitude = _data["currentVehicleLatitude"];
            this.currentVehicleLongitude = _data["currentVehicleLongitude"];
            this.currentVehiclepositionDateTime = _data["currentVehiclepositionDateTime"] ? new Date(_data["currentVehiclepositionDateTime"].toString()) : <any>undefined;
            this.licencePlateNumber = _data["licencePlateNumber"];
            this.type = _data["type"];
            this.updateBy = _data["updateBy"];
            this.estimatedDateTime = _data["estimatedDateTime"] ? new Date(_data["estimatedDateTime"].toString()) : <any>undefined;
            this.plannedDeliveryStart = _data["plannedDeliveryStart"];
            this.plannedLoadingStart = _data["plannedLoadingStart"];
            this.plannedLoadingEnd = _data["plannedLoadingEnd"];
            this.plannedDeliveryEnd = _data["plannedDeliveryEnd"];
            this.actualCollectionDate = _data["actualCollectionDate"] ? new Date(_data["actualCollectionDate"].toString()) : <any>undefined;
            this.actualDeliveryDate = _data["actualDeliveryDate"] ? new Date(_data["actualDeliveryDate"].toString()) : <any>undefined;
            if (Array.isArray(_data["vehicleEvents"])) {
                this.vehicleEvents = [] as any;
                for (let item of _data["vehicleEvents"])
                    this.vehicleEvents!.push(LatLngModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ActiveTourDetailModel {
        data = typeof data === 'object' ? data : {};
        let result = new ActiveTourDetailModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["amcoId"] = this.amcoId;
        data["tourId"] = this.tourId;
        data["toNumber"] = this.toNumber;
        data["destinationLatitude"] = this.destinationLatitude;
        data["destinationLongitude"] = this.destinationLongitude;
        data["collectionLatitude"] = this.collectionLatitude;
        data["collectionLongitude"] = this.collectionLongitude;
        data["collectionAddress"] = this.collectionAddress;
        data["deliveryAddress"] = this.deliveryAddress;
        data["currentVehicleLatitude"] = this.currentVehicleLatitude;
        data["currentVehicleLongitude"] = this.currentVehicleLongitude;
        data["currentVehiclepositionDateTime"] = this.currentVehiclepositionDateTime ? this.currentVehiclepositionDateTime.toISOString() : <any>undefined;
        data["licencePlateNumber"] = this.licencePlateNumber;
        data["type"] = this.type;
        data["updateBy"] = this.updateBy;
        data["estimatedDateTime"] = this.estimatedDateTime ? this.estimatedDateTime.toISOString() : <any>undefined;
        data["plannedDeliveryStart"] = this.plannedDeliveryStart;
        data["plannedLoadingStart"] = this.plannedLoadingStart;
        data["plannedLoadingEnd"] = this.plannedLoadingEnd;
        data["plannedDeliveryEnd"] = this.plannedDeliveryEnd;
        data["actualCollectionDate"] = this.actualCollectionDate ? this.actualCollectionDate.toISOString() : <any>undefined;
        data["actualDeliveryDate"] = this.actualDeliveryDate ? this.actualDeliveryDate.toISOString() : <any>undefined;
        if (Array.isArray(this.vehicleEvents)) {
            data["vehicleEvents"] = [];
            for (let item of this.vehicleEvents)
                data["vehicleEvents"].push(item.toJSON());
        }
        return data;
    }
}

export interface IActiveTourDetailModel {
    id?: number;
    amcoId?: number;
    tourId?: number;
    toNumber?: number | undefined;
    destinationLatitude?: number | undefined;
    destinationLongitude?: number | undefined;
    collectionLatitude?: number | undefined;
    collectionLongitude?: number | undefined;
    collectionAddress?: string | undefined;
    deliveryAddress?: string | undefined;
    currentVehicleLatitude?: number | undefined;
    currentVehicleLongitude?: number | undefined;
    currentVehiclepositionDateTime?: Date | undefined;
    licencePlateNumber?: string | undefined;
    type?: string | undefined;
    updateBy?: string | undefined;
    estimatedDateTime?: Date | undefined;
    plannedDeliveryStart?: string | undefined;
    plannedLoadingStart?: string | undefined;
    plannedLoadingEnd?: string | undefined;
    plannedDeliveryEnd?: string | undefined;
    actualCollectionDate?: Date | undefined;
    actualDeliveryDate?: Date | undefined;
    vehicleEvents?: LatLngModel[] | undefined;
}

export class GetActiveTourDetailsQuery implements IGetActiveTourDetailsQuery {
    id?: number;

    constructor(data?: IGetActiveTourDetailsQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): GetActiveTourDetailsQuery {
        data = typeof data === 'object' ? data : {};
        let result = new GetActiveTourDetailsQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }
}

export interface IGetActiveTourDetailsQuery {
    id?: number;
}

export class GetAllActiveTourDetailsQuery implements IGetAllActiveTourDetailsQuery {
    ids?: number[] | undefined;

    constructor(data?: IGetAllActiveTourDetailsQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["ids"])) {
                this.ids = [] as any;
                for (let item of _data["ids"])
                    this.ids!.push(item);
            }
        }
    }

    static fromJS(data: any): GetAllActiveTourDetailsQuery {
        data = typeof data === 'object' ? data : {};
        let result = new GetAllActiveTourDetailsQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.ids)) {
            data["ids"] = [];
            for (let item of this.ids)
                data["ids"].push(item);
        }
        return data;
    }
}

export interface IGetAllActiveTourDetailsQuery {
    ids?: number[] | undefined;
}

export class GetMyTourHistoryQuery extends PagedListingRequest implements IGetMyTourHistoryQuery {

    constructor(data?: IGetMyTourHistoryQuery) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): GetMyTourHistoryQuery {
        data = typeof data === 'object' ? data : {};
        let result = new GetMyTourHistoryQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IGetMyTourHistoryQuery extends IPagedListingRequest {
}

export class GetMyCustomsHistoryQuery extends PagedListingRequest implements IGetMyCustomsHistoryQuery {

    constructor(data?: IGetMyCustomsHistoryQuery) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): GetMyCustomsHistoryQuery {
        data = typeof data === 'object' ? data : {};
        let result = new GetMyCustomsHistoryQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IGetMyCustomsHistoryQuery extends IPagedListingRequest {
}

export class CustomsDetails implements ICustomsDetails {
    id?: number;
    amcoId?: number;
    customsStatus?: string | undefined;
    consignmentNumber?: string | undefined;
    customerName?: string | undefined;
    customerContact?: string | undefined;
    poNumber?: string | undefined;
    declarationType?: string | undefined;
    plannedLoadingEnd?: string | undefined;
    customsEntryNno?: string | undefined;
    eadmrnNo?: string | undefined;
    tadlrnNo?: string | undefined;
    hmrcStatus?: string | undefined;
    lastModifiedDate?: Date;
    lastModifiedBy?: string | undefined;
    updateDueDate?: Date | undefined;
    departmentLookupId?: number;
    typeLookupId?: number;
    inventoryLinked?: boolean | undefined;
    hasOpenChat?: boolean | undefined;
    tourId?: number;
    goodsCollected?: boolean | undefined;
    etaAtPortOfDeparture?: Date | undefined;
    allocatedUser?: string | undefined;
    targetDateTime?: Date;
    plannedDeliveryEnd?: string | undefined;
    plannedDeliveryStart?: string | undefined;
    plannedLoadingStart?: string | undefined;
    vehicleId?: number | undefined;
    customLastModifiedBy?: string | undefined;
    customLastModifiedDateTime?: Date | undefined;
    customUpdateDueDate?: Date | undefined;

    constructor(data?: ICustomsDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.amcoId = _data["amcoId"];
            this.customsStatus = _data["customsStatus"];
            this.consignmentNumber = _data["consignmentNumber"];
            this.customerName = _data["customerName"];
            this.customerContact = _data["customerContact"];
            this.poNumber = _data["poNumber"];
            this.declarationType = _data["declarationType"];
            this.plannedLoadingEnd = _data["plannedLoadingEnd"];
            this.customsEntryNno = _data["customsEntryNno"];
            this.eadmrnNo = _data["eadmrnNo"];
            this.tadlrnNo = _data["tadlrnNo"];
            this.hmrcStatus = _data["hmrcStatus"];
            this.lastModifiedDate = _data["lastModifiedDate"] ? new Date(_data["lastModifiedDate"].toString()) : <any>undefined;
            this.lastModifiedBy = _data["lastModifiedBy"];
            this.updateDueDate = _data["updateDueDate"] ? new Date(_data["updateDueDate"].toString()) : <any>undefined;
            this.departmentLookupId = _data["departmentLookupId"];
            this.typeLookupId = _data["typeLookupId"];
            this.inventoryLinked = _data["inventoryLinked"];
            this.hasOpenChat = _data["hasOpenChat"];
            this.tourId = _data["tourId"];
            this.goodsCollected = _data["goodsCollected"];
            this.etaAtPortOfDeparture = _data["etaAtPortOfDeparture"] ? new Date(_data["etaAtPortOfDeparture"].toString()) : <any>undefined;
            this.allocatedUser = _data["allocatedUser"];
            this.targetDateTime = _data["targetDateTime"] ? new Date(_data["targetDateTime"].toString()) : <any>undefined;
            this.plannedDeliveryEnd = _data["plannedDeliveryEnd"];
            this.plannedDeliveryStart = _data["plannedDeliveryStart"];
            this.plannedLoadingStart = _data["plannedLoadingStart"];
            this.vehicleId = _data["vehicleId"];
            this.customLastModifiedBy = _data["customLastModifiedBy"];
            this.customLastModifiedDateTime = _data["customLastModifiedDateTime"] ? new Date(_data["customLastModifiedDateTime"].toString()) : <any>undefined;
            this.customUpdateDueDate = _data["customUpdateDueDate"] ? new Date(_data["customUpdateDueDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): CustomsDetails {
        data = typeof data === 'object' ? data : {};
        let result = new CustomsDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["amcoId"] = this.amcoId;
        data["customsStatus"] = this.customsStatus;
        data["consignmentNumber"] = this.consignmentNumber;
        data["customerName"] = this.customerName;
        data["customerContact"] = this.customerContact;
        data["poNumber"] = this.poNumber;
        data["declarationType"] = this.declarationType;
        data["plannedLoadingEnd"] = this.plannedLoadingEnd;
        data["customsEntryNno"] = this.customsEntryNno;
        data["eadmrnNo"] = this.eadmrnNo;
        data["tadlrnNo"] = this.tadlrnNo;
        data["hmrcStatus"] = this.hmrcStatus;
        data["lastModifiedDate"] = this.lastModifiedDate ? this.lastModifiedDate.toISOString() : <any>undefined;
        data["lastModifiedBy"] = this.lastModifiedBy;
        data["updateDueDate"] = this.updateDueDate ? this.updateDueDate.toISOString() : <any>undefined;
        data["departmentLookupId"] = this.departmentLookupId;
        data["typeLookupId"] = this.typeLookupId;
        data["inventoryLinked"] = this.inventoryLinked;
        data["hasOpenChat"] = this.hasOpenChat;
        data["tourId"] = this.tourId;
        data["goodsCollected"] = this.goodsCollected;
        data["etaAtPortOfDeparture"] = this.etaAtPortOfDeparture ? this.etaAtPortOfDeparture.toISOString() : <any>undefined;
        data["allocatedUser"] = this.allocatedUser;
        data["targetDateTime"] = this.targetDateTime ? this.targetDateTime.toISOString() : <any>undefined;
        data["plannedDeliveryEnd"] = this.plannedDeliveryEnd;
        data["plannedDeliveryStart"] = this.plannedDeliveryStart;
        data["plannedLoadingStart"] = this.plannedLoadingStart;
        data["vehicleId"] = this.vehicleId;
        data["customLastModifiedBy"] = this.customLastModifiedBy;
        data["customLastModifiedDateTime"] = this.customLastModifiedDateTime ? this.customLastModifiedDateTime.toISOString() : <any>undefined;
        data["customUpdateDueDate"] = this.customUpdateDueDate ? this.customUpdateDueDate.toISOString() : <any>undefined;
        return data;
    }
}

export interface ICustomsDetails {
    id?: number;
    amcoId?: number;
    customsStatus?: string | undefined;
    consignmentNumber?: string | undefined;
    customerName?: string | undefined;
    customerContact?: string | undefined;
    poNumber?: string | undefined;
    declarationType?: string | undefined;
    plannedLoadingEnd?: string | undefined;
    customsEntryNno?: string | undefined;
    eadmrnNo?: string | undefined;
    tadlrnNo?: string | undefined;
    hmrcStatus?: string | undefined;
    lastModifiedDate?: Date;
    lastModifiedBy?: string | undefined;
    updateDueDate?: Date | undefined;
    departmentLookupId?: number;
    typeLookupId?: number;
    inventoryLinked?: boolean | undefined;
    hasOpenChat?: boolean | undefined;
    tourId?: number;
    goodsCollected?: boolean | undefined;
    etaAtPortOfDeparture?: Date | undefined;
    allocatedUser?: string | undefined;
    targetDateTime?: Date;
    plannedDeliveryEnd?: string | undefined;
    plannedDeliveryStart?: string | undefined;
    plannedLoadingStart?: string | undefined;
    vehicleId?: number | undefined;
    customLastModifiedBy?: string | undefined;
    customLastModifiedDateTime?: Date | undefined;
    customUpdateDueDate?: Date | undefined;
}

export class NotesModel implements INotesModel {
    tourId?: number;
    note?: string | undefined;
    createdBy?: string | undefined;
    createdDate?: Date;

    constructor(data?: INotesModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tourId = _data["tourId"];
            this.note = _data["note"];
            this.createdBy = _data["createdBy"];
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): NotesModel {
        data = typeof data === 'object' ? data : {};
        let result = new NotesModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tourId"] = this.tourId;
        data["note"] = this.note;
        data["createdBy"] = this.createdBy;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : <any>undefined;
        return data;
    }
}

export interface INotesModel {
    tourId?: number;
    note?: string | undefined;
    createdBy?: string | undefined;
    createdDate?: Date;
}

export class SendPushNotificationCommand implements ISendPushNotificationCommand {
    message?: string | undefined;

    constructor(data?: ISendPushNotificationCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.message = _data["message"];
        }
    }

    static fromJS(data: any): SendPushNotificationCommand {
        data = typeof data === 'object' ? data : {};
        let result = new SendPushNotificationCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["message"] = this.message;
        return data;
    }
}

export interface ISendPushNotificationCommand {
    message?: string | undefined;
}

export class PagedListingResponseOfQuoteHeaderModel implements IPagedListingResponseOfQuoteHeaderModel {
    results?: QuoteHeaderModel[] | undefined;
    totalCount?: number;
    totalPages?: number;
    pageIndex?: number;
    pageSize?: number;

    constructor(data?: IPagedListingResponseOfQuoteHeaderModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["results"])) {
                this.results = [] as any;
                for (let item of _data["results"])
                    this.results!.push(QuoteHeaderModel.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
            this.totalPages = _data["totalPages"];
            this.pageIndex = _data["pageIndex"];
            this.pageSize = _data["pageSize"];
        }
    }

    static fromJS(data: any): PagedListingResponseOfQuoteHeaderModel {
        data = typeof data === 'object' ? data : {};
        let result = new PagedListingResponseOfQuoteHeaderModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.results)) {
            data["results"] = [];
            for (let item of this.results)
                data["results"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        data["totalPages"] = this.totalPages;
        data["pageIndex"] = this.pageIndex;
        data["pageSize"] = this.pageSize;
        return data;
    }
}

export interface IPagedListingResponseOfQuoteHeaderModel {
    results?: QuoteHeaderModel[] | undefined;
    totalCount?: number;
    totalPages?: number;
    pageIndex?: number;
    pageSize?: number;
}

export class QuoteHeaderModel implements IQuoteHeaderModel {
    actualDeliveryDate?: Date | undefined;
    id?: number;
    quoteNumber?: string | undefined;
    principleId?: number | undefined;
    desadvNumber?: string | undefined;
    documentDate?: Date | undefined;
    purchaseOrderNumber?: string | undefined;
    requestorEmail?: string | undefined;
    customerName?: string | undefined;
    supplierName?: string | undefined;
    supplierPartyId?: string | undefined;
    supplierAddress1?: string | undefined;
    supplierCity?: string | undefined;
    supplierPostalCode?: string | undefined;
    supplierCountryCode?: string | undefined;
    deliveryPartyName?: string | undefined;
    deliveryPartyId?: string | undefined;
    deliveryAddress1?: string | undefined;
    deliveryCity?: string | undefined;
    deliveryPostalCode?: string | undefined;
    deliveryCountryCode?: string | undefined;
    totalGrossWeight?: number | undefined;
    weightUnitOfMeasure?: string | undefined;
    messageReferenceNumber?: string | undefined;
    interchangeControlReference?: string | undefined;
    sourceEdifactHeaderId?: number | undefined;
    sourceSystem?: string | undefined;
    importedDate?: Date | undefined;
    processedDate?: Date | undefined;
    orderStatusId?: number | undefined;
    orderStatusDescription?: string | undefined;
    vehicleTypeId?: number | undefined;
    vehicleTypeName?: string | undefined;
    estimatedKm?: number | undefined;
    estimatedRatePerKm?: number | undefined;
    estimatedTotal?: number | undefined;
    estimatedEtaUtc?: Date | undefined;
    estimatedBaseRouteEtaUtc?: Date | undefined;
    estimatedBaseDurationMinutes?: number | undefined;
    estimatedWeatherDelayMinutes?: number | undefined;
    estimatedDriverRestDelayMinutes?: number | undefined;
    estimatedDriverBreakDelayMinutes?: number | undefined;
    estimatedWeekendDelayMinutes?: number | undefined;
    estimatedIsFullPrediction?: boolean | undefined;
    estimatedCombinedTransportSkipped?: boolean | undefined;
    estimatedWarningsJson?: string | undefined;
    estimatedRemainingBreakMinutes?: number | undefined;
    estimatedEtaCalculatedUtc?: Date | undefined;
    area?: string | undefined;
    numberOfDrivers?: number | undefined;
    loadingCountry?: string | undefined;
    dischargeCountry?: string | undefined;
    carrier?: string | undefined;
    informationContactNames?: string | undefined;
    informationContactTelephone?: string | undefined;
    informationContactEmail?: string | undefined;
    rawEmailHtml?: string | undefined;
    priority?: string | undefined;
    collectionDatetime?: string | undefined;
    lines?: QuoteLineModel[] | undefined;
    attachments?: QuoteAttachmentModel[] | undefined;
    fieldProvenance?: QuoteFieldProvenanceModel[] | undefined;

    constructor(data?: IQuoteHeaderModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.actualDeliveryDate = _data["actualDeliveryDate"] ? new Date(_data["actualDeliveryDate"].toString()) : <any>undefined;
            this.id = _data["id"];
            this.quoteNumber = _data["quoteNumber"];
            this.principleId = _data["principleId"];
            this.desadvNumber = _data["desadvNumber"];
            this.documentDate = _data["documentDate"] ? new Date(_data["documentDate"].toString()) : <any>undefined;
            this.purchaseOrderNumber = _data["purchaseOrderNumber"];
            this.requestorEmail = _data["requestorEmail"];
            this.customerName = _data["customerName"];
            this.supplierName = _data["supplierName"];
            this.supplierPartyId = _data["supplierPartyId"];
            this.supplierAddress1 = _data["supplierAddress1"];
            this.supplierCity = _data["supplierCity"];
            this.supplierPostalCode = _data["supplierPostalCode"];
            this.supplierCountryCode = _data["supplierCountryCode"];
            this.deliveryPartyName = _data["deliveryPartyName"];
            this.deliveryPartyId = _data["deliveryPartyId"];
            this.deliveryAddress1 = _data["deliveryAddress1"];
            this.deliveryCity = _data["deliveryCity"];
            this.deliveryPostalCode = _data["deliveryPostalCode"];
            this.deliveryCountryCode = _data["deliveryCountryCode"];
            this.totalGrossWeight = _data["totalGrossWeight"];
            this.weightUnitOfMeasure = _data["weightUnitOfMeasure"];
            this.messageReferenceNumber = _data["messageReferenceNumber"];
            this.interchangeControlReference = _data["interchangeControlReference"];
            this.sourceEdifactHeaderId = _data["sourceEdifactHeaderId"];
            this.sourceSystem = _data["sourceSystem"];
            this.importedDate = _data["importedDate"] ? new Date(_data["importedDate"].toString()) : <any>undefined;
            this.processedDate = _data["processedDate"] ? new Date(_data["processedDate"].toString()) : <any>undefined;
            this.orderStatusId = _data["orderStatusId"];
            this.orderStatusDescription = _data["orderStatusDescription"];
            this.vehicleTypeId = _data["vehicleTypeId"];
            this.vehicleTypeName = _data["vehicleTypeName"];
            this.estimatedKm = _data["estimatedKm"];
            this.estimatedRatePerKm = _data["estimatedRatePerKm"];
            this.estimatedTotal = _data["estimatedTotal"];
            this.estimatedEtaUtc = _data["estimatedEtaUtc"] ? new Date(_data["estimatedEtaUtc"].toString()) : <any>undefined;
            this.estimatedBaseRouteEtaUtc = _data["estimatedBaseRouteEtaUtc"] ? new Date(_data["estimatedBaseRouteEtaUtc"].toString()) : <any>undefined;
            this.estimatedBaseDurationMinutes = _data["estimatedBaseDurationMinutes"];
            this.estimatedWeatherDelayMinutes = _data["estimatedWeatherDelayMinutes"];
            this.estimatedDriverRestDelayMinutes = _data["estimatedDriverRestDelayMinutes"];
            this.estimatedDriverBreakDelayMinutes = _data["estimatedDriverBreakDelayMinutes"];
            this.estimatedWeekendDelayMinutes = _data["estimatedWeekendDelayMinutes"];
            this.estimatedIsFullPrediction = _data["estimatedIsFullPrediction"];
            this.estimatedCombinedTransportSkipped = _data["estimatedCombinedTransportSkipped"];
            this.estimatedWarningsJson = _data["estimatedWarningsJson"];
            this.estimatedRemainingBreakMinutes = _data["estimatedRemainingBreakMinutes"];
            this.estimatedEtaCalculatedUtc = _data["estimatedEtaCalculatedUtc"] ? new Date(_data["estimatedEtaCalculatedUtc"].toString()) : <any>undefined;
            this.area = _data["area"];
            this.numberOfDrivers = _data["numberOfDrivers"];
            this.loadingCountry = _data["loadingCountry"];
            this.dischargeCountry = _data["dischargeCountry"];
            this.carrier = _data["carrier"];
            this.informationContactNames = _data["informationContactNames"];
            this.informationContactTelephone = _data["informationContactTelephone"];
            this.informationContactEmail = _data["informationContactEmail"];
            this.rawEmailHtml = _data["rawEmailHtml"];
            this.priority = _data["priority"];
            this.collectionDatetime = _data["collectionDatetime"];
            if (Array.isArray(_data["lines"])) {
                this.lines = [] as any;
                for (let item of _data["lines"])
                    this.lines!.push(QuoteLineModel.fromJS(item));
            }
            if (Array.isArray(_data["attachments"])) {
                this.attachments = [] as any;
                for (let item of _data["attachments"])
                    this.attachments!.push(QuoteAttachmentModel.fromJS(item));
            }
            if (Array.isArray(_data["fieldProvenance"])) {
                this.fieldProvenance = [] as any;
                for (let item of _data["fieldProvenance"])
                    this.fieldProvenance!.push(QuoteFieldProvenanceModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): QuoteHeaderModel {
        data = typeof data === 'object' ? data : {};
        let result = new QuoteHeaderModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["actualDeliveryDate"] = this.actualDeliveryDate ? this.actualDeliveryDate.toISOString() : <any>undefined;
        data["id"] = this.id;
        data["quoteNumber"] = this.quoteNumber;
        data["principleId"] = this.principleId;
        data["desadvNumber"] = this.desadvNumber;
        data["documentDate"] = this.documentDate ? this.documentDate.toISOString() : <any>undefined;
        data["purchaseOrderNumber"] = this.purchaseOrderNumber;
        data["requestorEmail"] = this.requestorEmail;
        data["customerName"] = this.customerName;
        data["supplierName"] = this.supplierName;
        data["supplierPartyId"] = this.supplierPartyId;
        data["supplierAddress1"] = this.supplierAddress1;
        data["supplierCity"] = this.supplierCity;
        data["supplierPostalCode"] = this.supplierPostalCode;
        data["supplierCountryCode"] = this.supplierCountryCode;
        data["deliveryPartyName"] = this.deliveryPartyName;
        data["deliveryPartyId"] = this.deliveryPartyId;
        data["deliveryAddress1"] = this.deliveryAddress1;
        data["deliveryCity"] = this.deliveryCity;
        data["deliveryPostalCode"] = this.deliveryPostalCode;
        data["deliveryCountryCode"] = this.deliveryCountryCode;
        data["totalGrossWeight"] = this.totalGrossWeight;
        data["weightUnitOfMeasure"] = this.weightUnitOfMeasure;
        data["messageReferenceNumber"] = this.messageReferenceNumber;
        data["interchangeControlReference"] = this.interchangeControlReference;
        data["sourceEdifactHeaderId"] = this.sourceEdifactHeaderId;
        data["sourceSystem"] = this.sourceSystem;
        data["importedDate"] = this.importedDate ? this.importedDate.toISOString() : <any>undefined;
        data["processedDate"] = this.processedDate ? this.processedDate.toISOString() : <any>undefined;
        data["orderStatusId"] = this.orderStatusId;
        data["orderStatusDescription"] = this.orderStatusDescription;
        data["vehicleTypeId"] = this.vehicleTypeId;
        data["vehicleTypeName"] = this.vehicleTypeName;
        data["estimatedKm"] = this.estimatedKm;
        data["estimatedRatePerKm"] = this.estimatedRatePerKm;
        data["estimatedTotal"] = this.estimatedTotal;
        data["estimatedEtaUtc"] = this.estimatedEtaUtc ? this.estimatedEtaUtc.toISOString() : <any>undefined;
        data["estimatedBaseRouteEtaUtc"] = this.estimatedBaseRouteEtaUtc ? this.estimatedBaseRouteEtaUtc.toISOString() : <any>undefined;
        data["estimatedBaseDurationMinutes"] = this.estimatedBaseDurationMinutes;
        data["estimatedWeatherDelayMinutes"] = this.estimatedWeatherDelayMinutes;
        data["estimatedDriverRestDelayMinutes"] = this.estimatedDriverRestDelayMinutes;
        data["estimatedDriverBreakDelayMinutes"] = this.estimatedDriverBreakDelayMinutes;
        data["estimatedWeekendDelayMinutes"] = this.estimatedWeekendDelayMinutes;
        data["estimatedIsFullPrediction"] = this.estimatedIsFullPrediction;
        data["estimatedCombinedTransportSkipped"] = this.estimatedCombinedTransportSkipped;
        data["estimatedWarningsJson"] = this.estimatedWarningsJson;
        data["estimatedRemainingBreakMinutes"] = this.estimatedRemainingBreakMinutes;
        data["estimatedEtaCalculatedUtc"] = this.estimatedEtaCalculatedUtc ? this.estimatedEtaCalculatedUtc.toISOString() : <any>undefined;
        data["area"] = this.area;
        data["numberOfDrivers"] = this.numberOfDrivers;
        data["loadingCountry"] = this.loadingCountry;
        data["dischargeCountry"] = this.dischargeCountry;
        data["carrier"] = this.carrier;
        data["informationContactNames"] = this.informationContactNames;
        data["informationContactTelephone"] = this.informationContactTelephone;
        data["informationContactEmail"] = this.informationContactEmail;
        data["rawEmailHtml"] = this.rawEmailHtml;
        data["priority"] = this.priority;
        data["collectionDatetime"] = this.collectionDatetime;
        if (Array.isArray(this.lines)) {
            data["lines"] = [];
            for (let item of this.lines)
                data["lines"].push(item.toJSON());
        }
        if (Array.isArray(this.attachments)) {
            data["attachments"] = [];
            for (let item of this.attachments)
                data["attachments"].push(item.toJSON());
        }
        if (Array.isArray(this.fieldProvenance)) {
            data["fieldProvenance"] = [];
            for (let item of this.fieldProvenance)
                data["fieldProvenance"].push(item.toJSON());
        }
        return data;
    }
}

export interface IQuoteHeaderModel {
    actualDeliveryDate?: Date | undefined;
    id?: number;
    quoteNumber?: string | undefined;
    principleId?: number | undefined;
    desadvNumber?: string | undefined;
    documentDate?: Date | undefined;
    purchaseOrderNumber?: string | undefined;
    requestorEmail?: string | undefined;
    customerName?: string | undefined;
    supplierName?: string | undefined;
    supplierPartyId?: string | undefined;
    supplierAddress1?: string | undefined;
    supplierCity?: string | undefined;
    supplierPostalCode?: string | undefined;
    supplierCountryCode?: string | undefined;
    deliveryPartyName?: string | undefined;
    deliveryPartyId?: string | undefined;
    deliveryAddress1?: string | undefined;
    deliveryCity?: string | undefined;
    deliveryPostalCode?: string | undefined;
    deliveryCountryCode?: string | undefined;
    totalGrossWeight?: number | undefined;
    weightUnitOfMeasure?: string | undefined;
    messageReferenceNumber?: string | undefined;
    interchangeControlReference?: string | undefined;
    sourceEdifactHeaderId?: number | undefined;
    sourceSystem?: string | undefined;
    importedDate?: Date | undefined;
    processedDate?: Date | undefined;
    orderStatusId?: number | undefined;
    orderStatusDescription?: string | undefined;
    vehicleTypeId?: number | undefined;
    vehicleTypeName?: string | undefined;
    estimatedKm?: number | undefined;
    estimatedRatePerKm?: number | undefined;
    estimatedTotal?: number | undefined;
    estimatedEtaUtc?: Date | undefined;
    estimatedBaseRouteEtaUtc?: Date | undefined;
    estimatedBaseDurationMinutes?: number | undefined;
    estimatedWeatherDelayMinutes?: number | undefined;
    estimatedDriverRestDelayMinutes?: number | undefined;
    estimatedDriverBreakDelayMinutes?: number | undefined;
    estimatedWeekendDelayMinutes?: number | undefined;
    estimatedIsFullPrediction?: boolean | undefined;
    estimatedCombinedTransportSkipped?: boolean | undefined;
    estimatedWarningsJson?: string | undefined;
    estimatedRemainingBreakMinutes?: number | undefined;
    estimatedEtaCalculatedUtc?: Date | undefined;
    area?: string | undefined;
    numberOfDrivers?: number | undefined;
    loadingCountry?: string | undefined;
    dischargeCountry?: string | undefined;
    carrier?: string | undefined;
    informationContactNames?: string | undefined;
    informationContactTelephone?: string | undefined;
    informationContactEmail?: string | undefined;
    rawEmailHtml?: string | undefined;
    priority?: string | undefined;
    collectionDatetime?: string | undefined;
    lines?: QuoteLineModel[] | undefined;
    attachments?: QuoteAttachmentModel[] | undefined;
    fieldProvenance?: QuoteFieldProvenanceModel[] | undefined;
}

export class QuoteLineModel implements IQuoteLineModel {
    id?: number;
    quoteHeaderId?: number;
    lineNumber?: number;
    itemNumber?: string | undefined;
    itemDescription?: string | undefined;
    despatchedQuantity?: number | undefined;
    unitOfMeasure?: string | undefined;
    grossWeight?: number | undefined;
    netWeight?: number | undefined;
    length?: number | undefined;
    width?: number | undefined;
    height?: number | undefined;
    dimensionUnitOfMeasure?: string | undefined;
    packagingTypeCode?: string | undefined;
    numberOfPackages?: number | undefined;
    purchaseOrderNumber?: string | undefined;
    sourceEdifactLineId?: number | undefined;
    createdDate?: Date | undefined;
    dangerousGoodsClass?: string | undefined;

    constructor(data?: IQuoteLineModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.quoteHeaderId = _data["quoteHeaderId"];
            this.lineNumber = _data["lineNumber"];
            this.itemNumber = _data["itemNumber"];
            this.itemDescription = _data["itemDescription"];
            this.despatchedQuantity = _data["despatchedQuantity"];
            this.unitOfMeasure = _data["unitOfMeasure"];
            this.grossWeight = _data["grossWeight"];
            this.netWeight = _data["netWeight"];
            this.length = _data["length"];
            this.width = _data["width"];
            this.height = _data["height"];
            this.dimensionUnitOfMeasure = _data["dimensionUnitOfMeasure"];
            this.packagingTypeCode = _data["packagingTypeCode"];
            this.numberOfPackages = _data["numberOfPackages"];
            this.purchaseOrderNumber = _data["purchaseOrderNumber"];
            this.sourceEdifactLineId = _data["sourceEdifactLineId"];
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : <any>undefined;
            this.dangerousGoodsClass = _data["dangerousGoodsClass"];
        }
    }

    static fromJS(data: any): QuoteLineModel {
        data = typeof data === 'object' ? data : {};
        let result = new QuoteLineModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["quoteHeaderId"] = this.quoteHeaderId;
        data["lineNumber"] = this.lineNumber;
        data["itemNumber"] = this.itemNumber;
        data["itemDescription"] = this.itemDescription;
        data["despatchedQuantity"] = this.despatchedQuantity;
        data["unitOfMeasure"] = this.unitOfMeasure;
        data["grossWeight"] = this.grossWeight;
        data["netWeight"] = this.netWeight;
        data["length"] = this.length;
        data["width"] = this.width;
        data["height"] = this.height;
        data["dimensionUnitOfMeasure"] = this.dimensionUnitOfMeasure;
        data["packagingTypeCode"] = this.packagingTypeCode;
        data["numberOfPackages"] = this.numberOfPackages;
        data["purchaseOrderNumber"] = this.purchaseOrderNumber;
        data["sourceEdifactLineId"] = this.sourceEdifactLineId;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : <any>undefined;
        data["dangerousGoodsClass"] = this.dangerousGoodsClass;
        return data;
    }
}

export interface IQuoteLineModel {
    id?: number;
    quoteHeaderId?: number;
    lineNumber?: number;
    itemNumber?: string | undefined;
    itemDescription?: string | undefined;
    despatchedQuantity?: number | undefined;
    unitOfMeasure?: string | undefined;
    grossWeight?: number | undefined;
    netWeight?: number | undefined;
    length?: number | undefined;
    width?: number | undefined;
    height?: number | undefined;
    dimensionUnitOfMeasure?: string | undefined;
    packagingTypeCode?: string | undefined;
    numberOfPackages?: number | undefined;
    purchaseOrderNumber?: string | undefined;
    sourceEdifactLineId?: number | undefined;
    createdDate?: Date | undefined;
    dangerousGoodsClass?: string | undefined;
}

export class QuoteAttachmentModel implements IQuoteAttachmentModel {
    id?: number;
    sourceAttachmentId?: string | undefined;
    fileName?: string | undefined;
    contentType?: string | undefined;
    sizeBytes?: number;

    constructor(data?: IQuoteAttachmentModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.sourceAttachmentId = _data["sourceAttachmentId"];
            this.fileName = _data["fileName"];
            this.contentType = _data["contentType"];
            this.sizeBytes = _data["sizeBytes"];
        }
    }

    static fromJS(data: any): QuoteAttachmentModel {
        data = typeof data === 'object' ? data : {};
        let result = new QuoteAttachmentModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["sourceAttachmentId"] = this.sourceAttachmentId;
        data["fileName"] = this.fileName;
        data["contentType"] = this.contentType;
        data["sizeBytes"] = this.sizeBytes;
        return data;
    }
}

export interface IQuoteAttachmentModel {
    id?: number;
    sourceAttachmentId?: string | undefined;
    fileName?: string | undefined;
    contentType?: string | undefined;
    sizeBytes?: number;
}

export class QuoteFieldProvenanceModel implements IQuoteFieldProvenanceModel {
    fieldName?: string | undefined;
    lineNumber?: number | undefined;
    sourceType?: string | undefined;
    quoteAttachmentId?: number | undefined;
    anchorType?: string | undefined;
    page?: number | undefined;
    textLine?: number | undefined;
    textColumn?: number | undefined;
    sheet?: string | undefined;
    cell?: string | undefined;
    sourceText?: string | undefined;
    matchIndex?: number | undefined;

    constructor(data?: IQuoteFieldProvenanceModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fieldName = _data["fieldName"];
            this.lineNumber = _data["lineNumber"];
            this.sourceType = _data["sourceType"];
            this.quoteAttachmentId = _data["quoteAttachmentId"];
            this.anchorType = _data["anchorType"];
            this.page = _data["page"];
            this.textLine = _data["textLine"];
            this.textColumn = _data["textColumn"];
            this.sheet = _data["sheet"];
            this.cell = _data["cell"];
            this.sourceText = _data["sourceText"];
            this.matchIndex = _data["matchIndex"];
        }
    }

    static fromJS(data: any): QuoteFieldProvenanceModel {
        data = typeof data === 'object' ? data : {};
        let result = new QuoteFieldProvenanceModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fieldName"] = this.fieldName;
        data["lineNumber"] = this.lineNumber;
        data["sourceType"] = this.sourceType;
        data["quoteAttachmentId"] = this.quoteAttachmentId;
        data["anchorType"] = this.anchorType;
        data["page"] = this.page;
        data["textLine"] = this.textLine;
        data["textColumn"] = this.textColumn;
        data["sheet"] = this.sheet;
        data["cell"] = this.cell;
        data["sourceText"] = this.sourceText;
        data["matchIndex"] = this.matchIndex;
        return data;
    }
}

export interface IQuoteFieldProvenanceModel {
    fieldName?: string | undefined;
    lineNumber?: number | undefined;
    sourceType?: string | undefined;
    quoteAttachmentId?: number | undefined;
    anchorType?: string | undefined;
    page?: number | undefined;
    textLine?: number | undefined;
    textColumn?: number | undefined;
    sheet?: string | undefined;
    cell?: string | undefined;
    sourceText?: string | undefined;
    matchIndex?: number | undefined;
}

export class GetQuotesQuery extends PagedListingRequest implements IGetQuotesQuery {

    constructor(data?: IGetQuotesQuery) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): GetQuotesQuery {
        data = typeof data === 'object' ? data : {};
        let result = new GetQuotesQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IGetQuotesQuery extends IPagedListingRequest {
}

export class ProblemDetails implements IProblemDetails {
    type?: string | undefined;
    title?: string | undefined;
    status?: number | undefined;
    detail?: string | undefined;
    instance?: string | undefined;
    extensions?: { [key: string]: any; };

    constructor(data?: IProblemDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.type = _data["type"];
            this.title = _data["title"];
            this.status = _data["status"];
            this.detail = _data["detail"];
            this.instance = _data["instance"];
            if (_data["extensions"]) {
                this.extensions = {} as any;
                for (let key in _data["extensions"]) {
                    if (_data["extensions"].hasOwnProperty(key))
                        (<any>this.extensions)![key] = _data["extensions"][key];
                }
            }
        }
    }

    static fromJS(data: any): ProblemDetails {
        data = typeof data === 'object' ? data : {};
        let result = new ProblemDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["type"] = this.type;
        data["title"] = this.title;
        data["status"] = this.status;
        data["detail"] = this.detail;
        data["instance"] = this.instance;
        if (this.extensions) {
            data["extensions"] = {};
            for (let key in this.extensions) {
                if (this.extensions.hasOwnProperty(key))
                    (<any>data["extensions"])[key] = this.extensions[key];
            }
        }
        return data;
    }
}

export interface IProblemDetails {
    type?: string | undefined;
    title?: string | undefined;
    status?: number | undefined;
    detail?: string | undefined;
    instance?: string | undefined;
    extensions?: { [key: string]: any; };
}

export class QuoteSheetsModel implements IQuoteSheetsModel {
    sheets?: QuoteSheetModel[] | undefined;

    constructor(data?: IQuoteSheetsModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["sheets"])) {
                this.sheets = [] as any;
                for (let item of _data["sheets"])
                    this.sheets!.push(QuoteSheetModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): QuoteSheetsModel {
        data = typeof data === 'object' ? data : {};
        let result = new QuoteSheetsModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.sheets)) {
            data["sheets"] = [];
            for (let item of this.sheets)
                data["sheets"].push(item.toJSON());
        }
        return data;
    }
}

export interface IQuoteSheetsModel {
    sheets?: QuoteSheetModel[] | undefined;
}

export class QuoteSheetModel implements IQuoteSheetModel {
    name?: string | undefined;
    rows?: string[][] | undefined;
    rowCount?: number;
    columnCount?: number;
    truncated?: boolean;

    constructor(data?: IQuoteSheetModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            if (Array.isArray(_data["rows"])) {
                this.rows = [] as any;
                for (let item of _data["rows"])
                    this.rows!.push(item);
            }
            this.rowCount = _data["rowCount"];
            this.columnCount = _data["columnCount"];
            this.truncated = _data["truncated"];
        }
    }

    static fromJS(data: any): QuoteSheetModel {
        data = typeof data === 'object' ? data : {};
        let result = new QuoteSheetModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        if (Array.isArray(this.rows)) {
            data["rows"] = [];
            for (let item of this.rows)
                data["rows"].push(item);
        }
        data["rowCount"] = this.rowCount;
        data["columnCount"] = this.columnCount;
        data["truncated"] = this.truncated;
        return data;
    }
}

export interface IQuoteSheetModel {
    name?: string | undefined;
    rows?: string[][] | undefined;
    rowCount?: number;
    columnCount?: number;
    truncated?: boolean;
}

export class UpdateQuoteStatusCommand implements IUpdateQuoteStatusCommand {
    quoteId?: number;
    orderStatusId?: number;

    constructor(data?: IUpdateQuoteStatusCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.quoteId = _data["quoteId"];
            this.orderStatusId = _data["orderStatusId"];
        }
    }

    static fromJS(data: any): UpdateQuoteStatusCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateQuoteStatusCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["quoteId"] = this.quoteId;
        data["orderStatusId"] = this.orderStatusId;
        return data;
    }
}

export interface IUpdateQuoteStatusCommand {
    quoteId?: number;
    orderStatusId?: number;
}

export class VehicleTypeModel implements IVehicleTypeModel {
    id?: number;
    name?: string | undefined;

    constructor(data?: IVehicleTypeModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): VehicleTypeModel {
        data = typeof data === 'object' ? data : {};
        let result = new VehicleTypeModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }
}

export interface IVehicleTypeModel {
    id?: number;
    name?: string | undefined;
}

export class QuoteVehicleEstimateModel implements IQuoteVehicleEstimateModel {
    vehicleTypeId?: number;
    vehicleTypeName?: string | undefined;
    estimatedKm?: number;
    ratePerKm?: number;
    minRate?: number | undefined;
    minRateApplied?: boolean;
    totalEstimate?: number;
    estimatedEtaUtc?: Date | undefined;
    estimatedBaseRouteEtaUtc?: Date | undefined;
    estimatedBaseDurationMinutes?: number | undefined;
    estimatedWeatherDelayMinutes?: number | undefined;
    estimatedDriverRestDelayMinutes?: number | undefined;
    estimatedDriverBreakDelayMinutes?: number | undefined;
    estimatedWeekendDelayMinutes?: number | undefined;
    estimatedIsFullPrediction?: boolean | undefined;
    estimatedCombinedTransportSkipped?: boolean | undefined;
    estimatedWarningsJson?: string | undefined;
    estimatedRemainingBreakMinutes?: number | undefined;
    estimatedEtaCalculatedUtc?: Date | undefined;
    area?: string | undefined;
    numberOfDrivers?: number;
    loadingCountry?: string | undefined;
    dischargeCountry?: string | undefined;
    carrier?: string | undefined;

    constructor(data?: IQuoteVehicleEstimateModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.vehicleTypeId = _data["vehicleTypeId"];
            this.vehicleTypeName = _data["vehicleTypeName"];
            this.estimatedKm = _data["estimatedKm"];
            this.ratePerKm = _data["ratePerKm"];
            this.minRate = _data["minRate"];
            this.minRateApplied = _data["minRateApplied"];
            this.totalEstimate = _data["totalEstimate"];
            this.estimatedEtaUtc = _data["estimatedEtaUtc"] ? new Date(_data["estimatedEtaUtc"].toString()) : <any>undefined;
            this.estimatedBaseRouteEtaUtc = _data["estimatedBaseRouteEtaUtc"] ? new Date(_data["estimatedBaseRouteEtaUtc"].toString()) : <any>undefined;
            this.estimatedBaseDurationMinutes = _data["estimatedBaseDurationMinutes"];
            this.estimatedWeatherDelayMinutes = _data["estimatedWeatherDelayMinutes"];
            this.estimatedDriverRestDelayMinutes = _data["estimatedDriverRestDelayMinutes"];
            this.estimatedDriverBreakDelayMinutes = _data["estimatedDriverBreakDelayMinutes"];
            this.estimatedWeekendDelayMinutes = _data["estimatedWeekendDelayMinutes"];
            this.estimatedIsFullPrediction = _data["estimatedIsFullPrediction"];
            this.estimatedCombinedTransportSkipped = _data["estimatedCombinedTransportSkipped"];
            this.estimatedWarningsJson = _data["estimatedWarningsJson"];
            this.estimatedRemainingBreakMinutes = _data["estimatedRemainingBreakMinutes"];
            this.estimatedEtaCalculatedUtc = _data["estimatedEtaCalculatedUtc"] ? new Date(_data["estimatedEtaCalculatedUtc"].toString()) : <any>undefined;
            this.area = _data["area"];
            this.numberOfDrivers = _data["numberOfDrivers"];
            this.loadingCountry = _data["loadingCountry"];
            this.dischargeCountry = _data["dischargeCountry"];
            this.carrier = _data["carrier"];
        }
    }

    static fromJS(data: any): QuoteVehicleEstimateModel {
        data = typeof data === 'object' ? data : {};
        let result = new QuoteVehicleEstimateModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["vehicleTypeId"] = this.vehicleTypeId;
        data["vehicleTypeName"] = this.vehicleTypeName;
        data["estimatedKm"] = this.estimatedKm;
        data["ratePerKm"] = this.ratePerKm;
        data["minRate"] = this.minRate;
        data["minRateApplied"] = this.minRateApplied;
        data["totalEstimate"] = this.totalEstimate;
        data["estimatedEtaUtc"] = this.estimatedEtaUtc ? this.estimatedEtaUtc.toISOString() : <any>undefined;
        data["estimatedBaseRouteEtaUtc"] = this.estimatedBaseRouteEtaUtc ? this.estimatedBaseRouteEtaUtc.toISOString() : <any>undefined;
        data["estimatedBaseDurationMinutes"] = this.estimatedBaseDurationMinutes;
        data["estimatedWeatherDelayMinutes"] = this.estimatedWeatherDelayMinutes;
        data["estimatedDriverRestDelayMinutes"] = this.estimatedDriverRestDelayMinutes;
        data["estimatedDriverBreakDelayMinutes"] = this.estimatedDriverBreakDelayMinutes;
        data["estimatedWeekendDelayMinutes"] = this.estimatedWeekendDelayMinutes;
        data["estimatedIsFullPrediction"] = this.estimatedIsFullPrediction;
        data["estimatedCombinedTransportSkipped"] = this.estimatedCombinedTransportSkipped;
        data["estimatedWarningsJson"] = this.estimatedWarningsJson;
        data["estimatedRemainingBreakMinutes"] = this.estimatedRemainingBreakMinutes;
        data["estimatedEtaCalculatedUtc"] = this.estimatedEtaCalculatedUtc ? this.estimatedEtaCalculatedUtc.toISOString() : <any>undefined;
        data["area"] = this.area;
        data["numberOfDrivers"] = this.numberOfDrivers;
        data["loadingCountry"] = this.loadingCountry;
        data["dischargeCountry"] = this.dischargeCountry;
        data["carrier"] = this.carrier;
        return data;
    }
}

export interface IQuoteVehicleEstimateModel {
    vehicleTypeId?: number;
    vehicleTypeName?: string | undefined;
    estimatedKm?: number;
    ratePerKm?: number;
    minRate?: number | undefined;
    minRateApplied?: boolean;
    totalEstimate?: number;
    estimatedEtaUtc?: Date | undefined;
    estimatedBaseRouteEtaUtc?: Date | undefined;
    estimatedBaseDurationMinutes?: number | undefined;
    estimatedWeatherDelayMinutes?: number | undefined;
    estimatedDriverRestDelayMinutes?: number | undefined;
    estimatedDriverBreakDelayMinutes?: number | undefined;
    estimatedWeekendDelayMinutes?: number | undefined;
    estimatedIsFullPrediction?: boolean | undefined;
    estimatedCombinedTransportSkipped?: boolean | undefined;
    estimatedWarningsJson?: string | undefined;
    estimatedRemainingBreakMinutes?: number | undefined;
    estimatedEtaCalculatedUtc?: Date | undefined;
    area?: string | undefined;
    numberOfDrivers?: number;
    loadingCountry?: string | undefined;
    dischargeCountry?: string | undefined;
    carrier?: string | undefined;
}

export class GetQuoteVehicleEstimateQuery implements IGetQuoteVehicleEstimateQuery {
    quoteId?: number;
    vehicleTypeId?: number;
    vehicleTypeName?: string | undefined;
    area?: string | undefined;
    numberOfDrivers?: number;
    loadingCountry?: string | undefined;
    dischargeCountry?: string | undefined;
    carrier?: string | undefined;

    constructor(data?: IGetQuoteVehicleEstimateQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.quoteId = _data["quoteId"];
            this.vehicleTypeId = _data["vehicleTypeId"];
            this.vehicleTypeName = _data["vehicleTypeName"];
            this.area = _data["area"];
            this.numberOfDrivers = _data["numberOfDrivers"];
            this.loadingCountry = _data["loadingCountry"];
            this.dischargeCountry = _data["dischargeCountry"];
            this.carrier = _data["carrier"];
        }
    }

    static fromJS(data: any): GetQuoteVehicleEstimateQuery {
        data = typeof data === 'object' ? data : {};
        let result = new GetQuoteVehicleEstimateQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["quoteId"] = this.quoteId;
        data["vehicleTypeId"] = this.vehicleTypeId;
        data["vehicleTypeName"] = this.vehicleTypeName;
        data["area"] = this.area;
        data["numberOfDrivers"] = this.numberOfDrivers;
        data["loadingCountry"] = this.loadingCountry;
        data["dischargeCountry"] = this.dischargeCountry;
        data["carrier"] = this.carrier;
        return data;
    }
}

export interface IGetQuoteVehicleEstimateQuery {
    quoteId?: number;
    vehicleTypeId?: number;
    vehicleTypeName?: string | undefined;
    area?: string | undefined;
    numberOfDrivers?: number;
    loadingCountry?: string | undefined;
    dischargeCountry?: string | undefined;
    carrier?: string | undefined;
}

export class AssignVehicleTypeToQuoteCommand implements IAssignVehicleTypeToQuoteCommand {
    quoteId?: number;
    vehicleTypeId?: number;
    estimatedKm?: number;
    estimatedRatePerKm?: number;
    estimatedTotal?: number;
    area?: string | undefined;
    numberOfDrivers?: number;
    loadingCountry?: string | undefined;
    dischargeCountry?: string | undefined;
    carrier?: string | undefined;

    constructor(data?: IAssignVehicleTypeToQuoteCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.quoteId = _data["quoteId"];
            this.vehicleTypeId = _data["vehicleTypeId"];
            this.estimatedKm = _data["estimatedKm"];
            this.estimatedRatePerKm = _data["estimatedRatePerKm"];
            this.estimatedTotal = _data["estimatedTotal"];
            this.area = _data["area"];
            this.numberOfDrivers = _data["numberOfDrivers"];
            this.loadingCountry = _data["loadingCountry"];
            this.dischargeCountry = _data["dischargeCountry"];
            this.carrier = _data["carrier"];
        }
    }

    static fromJS(data: any): AssignVehicleTypeToQuoteCommand {
        data = typeof data === 'object' ? data : {};
        let result = new AssignVehicleTypeToQuoteCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["quoteId"] = this.quoteId;
        data["vehicleTypeId"] = this.vehicleTypeId;
        data["estimatedKm"] = this.estimatedKm;
        data["estimatedRatePerKm"] = this.estimatedRatePerKm;
        data["estimatedTotal"] = this.estimatedTotal;
        data["area"] = this.area;
        data["numberOfDrivers"] = this.numberOfDrivers;
        data["loadingCountry"] = this.loadingCountry;
        data["dischargeCountry"] = this.dischargeCountry;
        data["carrier"] = this.carrier;
        return data;
    }
}

export interface IAssignVehicleTypeToQuoteCommand {
    quoteId?: number;
    vehicleTypeId?: number;
    estimatedKm?: number;
    estimatedRatePerKm?: number;
    estimatedTotal?: number;
    area?: string | undefined;
    numberOfDrivers?: number;
    loadingCountry?: string | undefined;
    dischargeCountry?: string | undefined;
    carrier?: string | undefined;
}

export class TourLockedModel implements ITourLockedModel {
    locked?: boolean;
    name?: string | undefined;

    constructor(data?: ITourLockedModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.locked = _data["locked"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): TourLockedModel {
        data = typeof data === 'object' ? data : {};
        let result = new TourLockedModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["locked"] = this.locked;
        data["name"] = this.name;
        return data;
    }
}

export interface ITourLockedModel {
    locked?: boolean;
    name?: string | undefined;
}

export class IngestNormalOrderResponse implements IIngestNormalOrderResponse {
    id?: number;
    customReference2?: string | undefined;
    consignmentNumber?: number;
    success?: boolean;
    message?: string | undefined;
    createdAt?: Date;

    constructor(data?: IIngestNormalOrderResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.customReference2 = _data["customReference2"];
            this.consignmentNumber = _data["consignmentNumber"];
            this.success = _data["success"];
            this.message = _data["message"];
            this.createdAt = _data["createdAt"] ? new Date(_data["createdAt"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): IngestNormalOrderResponse {
        data = typeof data === 'object' ? data : {};
        let result = new IngestNormalOrderResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["customReference2"] = this.customReference2;
        data["consignmentNumber"] = this.consignmentNumber;
        data["success"] = this.success;
        data["message"] = this.message;
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : <any>undefined;
        return data;
    }
}

export interface IIngestNormalOrderResponse {
    id?: number;
    customReference2?: string | undefined;
    consignmentNumber?: number;
    success?: boolean;
    message?: string | undefined;
    createdAt?: Date;
}

export class IngestNormalOrderCommand implements IIngestNormalOrderCommand {
    sendDate!: Date;
    exportItemReference?: string | undefined;
    orderDate!: Date;
    externalNumber?: string | undefined;
    customerRef?: string | undefined;
    customReference2!: string;
    customerBusinessPartnerId!: string;
    customerMatchcode!: string;
    customerName1!: string;
    contactFirstName!: string;
    contactLastName!: string;
    contactEmailAddress!: string;
    consignmentNumber!: number;
    senderName1!: string;
    senderStreet!: string;
    senderLocation1!: string;
    senderZipCode!: string;
    senderCountryCode!: string;
    senderOriginalBusinessPartnerId!: string;
    senderOriginalMatchcode!: string;
    senderOriginalName1!: string;
    receiverName1!: string;
    receiverStreet!: string;
    receiverLocation1!: string;
    receiverZipCode!: string;
    receiverCountryCode!: string;
    receiverOriginalBusinessPartnerId!: string;
    receiverOriginalMatchcode!: string;
    receiverOriginalName1!: string;
    loadingStart!: Date;
    loadingEnd!: Date;
    deliveryStart!: Date;
    deliveryEnd!: Date;
    transportTypeNumber!: number;
    transportTypeMatchcode!: string;
    transportTypeDescription!: string;
    declarationTypeNumber!: number;
    declarationTypeMatchcode!: string;
    declarationTypeDesignation!: string;
    incoterms!: number;
    itemPositionNumber!: number;
    packageNumber!: number;
    packageMatchcode!: string;
    packageShortDesignation!: string;
    lengthInMeters!: number;
    widthInMeters!: number;
    heightInMeters!: number;
    effectiveWeightInKilogram!: number;
    quantity!: number;
    content1!: string;

    constructor(data?: IIngestNormalOrderCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sendDate = _data["sendDate"] ? new Date(_data["sendDate"].toString()) : <any>undefined;
            this.exportItemReference = _data["exportItemReference"];
            this.orderDate = _data["orderDate"] ? new Date(_data["orderDate"].toString()) : <any>undefined;
            this.externalNumber = _data["externalNumber"];
            this.customerRef = _data["customerRef"];
            this.customReference2 = _data["customReference2"];
            this.customerBusinessPartnerId = _data["customerBusinessPartnerId"];
            this.customerMatchcode = _data["customerMatchcode"];
            this.customerName1 = _data["customerName1"];
            this.contactFirstName = _data["contactFirstName"];
            this.contactLastName = _data["contactLastName"];
            this.contactEmailAddress = _data["contactEmailAddress"];
            this.consignmentNumber = _data["consignmentNumber"];
            this.senderName1 = _data["senderName1"];
            this.senderStreet = _data["senderStreet"];
            this.senderLocation1 = _data["senderLocation1"];
            this.senderZipCode = _data["senderZipCode"];
            this.senderCountryCode = _data["senderCountryCode"];
            this.senderOriginalBusinessPartnerId = _data["senderOriginalBusinessPartnerId"];
            this.senderOriginalMatchcode = _data["senderOriginalMatchcode"];
            this.senderOriginalName1 = _data["senderOriginalName1"];
            this.receiverName1 = _data["receiverName1"];
            this.receiverStreet = _data["receiverStreet"];
            this.receiverLocation1 = _data["receiverLocation1"];
            this.receiverZipCode = _data["receiverZipCode"];
            this.receiverCountryCode = _data["receiverCountryCode"];
            this.receiverOriginalBusinessPartnerId = _data["receiverOriginalBusinessPartnerId"];
            this.receiverOriginalMatchcode = _data["receiverOriginalMatchcode"];
            this.receiverOriginalName1 = _data["receiverOriginalName1"];
            this.loadingStart = _data["loadingStart"] ? new Date(_data["loadingStart"].toString()) : <any>undefined;
            this.loadingEnd = _data["loadingEnd"] ? new Date(_data["loadingEnd"].toString()) : <any>undefined;
            this.deliveryStart = _data["deliveryStart"] ? new Date(_data["deliveryStart"].toString()) : <any>undefined;
            this.deliveryEnd = _data["deliveryEnd"] ? new Date(_data["deliveryEnd"].toString()) : <any>undefined;
            this.transportTypeNumber = _data["transportTypeNumber"];
            this.transportTypeMatchcode = _data["transportTypeMatchcode"];
            this.transportTypeDescription = _data["transportTypeDescription"];
            this.declarationTypeNumber = _data["declarationTypeNumber"];
            this.declarationTypeMatchcode = _data["declarationTypeMatchcode"];
            this.declarationTypeDesignation = _data["declarationTypeDesignation"];
            this.incoterms = _data["incoterms"];
            this.itemPositionNumber = _data["itemPositionNumber"];
            this.packageNumber = _data["packageNumber"];
            this.packageMatchcode = _data["packageMatchcode"];
            this.packageShortDesignation = _data["packageShortDesignation"];
            this.lengthInMeters = _data["lengthInMeters"];
            this.widthInMeters = _data["widthInMeters"];
            this.heightInMeters = _data["heightInMeters"];
            this.effectiveWeightInKilogram = _data["effectiveWeightInKilogram"];
            this.quantity = _data["quantity"];
            this.content1 = _data["content1"];
        }
    }

    static fromJS(data: any): IngestNormalOrderCommand {
        data = typeof data === 'object' ? data : {};
        let result = new IngestNormalOrderCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sendDate"] = this.sendDate ? this.sendDate.toISOString() : <any>undefined;
        data["exportItemReference"] = this.exportItemReference;
        data["orderDate"] = this.orderDate ? this.orderDate.toISOString() : <any>undefined;
        data["externalNumber"] = this.externalNumber;
        data["customerRef"] = this.customerRef;
        data["customReference2"] = this.customReference2;
        data["customerBusinessPartnerId"] = this.customerBusinessPartnerId;
        data["customerMatchcode"] = this.customerMatchcode;
        data["customerName1"] = this.customerName1;
        data["contactFirstName"] = this.contactFirstName;
        data["contactLastName"] = this.contactLastName;
        data["contactEmailAddress"] = this.contactEmailAddress;
        data["consignmentNumber"] = this.consignmentNumber;
        data["senderName1"] = this.senderName1;
        data["senderStreet"] = this.senderStreet;
        data["senderLocation1"] = this.senderLocation1;
        data["senderZipCode"] = this.senderZipCode;
        data["senderCountryCode"] = this.senderCountryCode;
        data["senderOriginalBusinessPartnerId"] = this.senderOriginalBusinessPartnerId;
        data["senderOriginalMatchcode"] = this.senderOriginalMatchcode;
        data["senderOriginalName1"] = this.senderOriginalName1;
        data["receiverName1"] = this.receiverName1;
        data["receiverStreet"] = this.receiverStreet;
        data["receiverLocation1"] = this.receiverLocation1;
        data["receiverZipCode"] = this.receiverZipCode;
        data["receiverCountryCode"] = this.receiverCountryCode;
        data["receiverOriginalBusinessPartnerId"] = this.receiverOriginalBusinessPartnerId;
        data["receiverOriginalMatchcode"] = this.receiverOriginalMatchcode;
        data["receiverOriginalName1"] = this.receiverOriginalName1;
        data["loadingStart"] = this.loadingStart ? this.loadingStart.toISOString() : <any>undefined;
        data["loadingEnd"] = this.loadingEnd ? this.loadingEnd.toISOString() : <any>undefined;
        data["deliveryStart"] = this.deliveryStart ? this.deliveryStart.toISOString() : <any>undefined;
        data["deliveryEnd"] = this.deliveryEnd ? this.deliveryEnd.toISOString() : <any>undefined;
        data["transportTypeNumber"] = this.transportTypeNumber;
        data["transportTypeMatchcode"] = this.transportTypeMatchcode;
        data["transportTypeDescription"] = this.transportTypeDescription;
        data["declarationTypeNumber"] = this.declarationTypeNumber;
        data["declarationTypeMatchcode"] = this.declarationTypeMatchcode;
        data["declarationTypeDesignation"] = this.declarationTypeDesignation;
        data["incoterms"] = this.incoterms;
        data["itemPositionNumber"] = this.itemPositionNumber;
        data["packageNumber"] = this.packageNumber;
        data["packageMatchcode"] = this.packageMatchcode;
        data["packageShortDesignation"] = this.packageShortDesignation;
        data["lengthInMeters"] = this.lengthInMeters;
        data["widthInMeters"] = this.widthInMeters;
        data["heightInMeters"] = this.heightInMeters;
        data["effectiveWeightInKilogram"] = this.effectiveWeightInKilogram;
        data["quantity"] = this.quantity;
        data["content1"] = this.content1;
        return data;
    }
}

export interface IIngestNormalOrderCommand {
    sendDate: Date;
    exportItemReference?: string | undefined;
    orderDate: Date;
    externalNumber?: string | undefined;
    customerRef?: string | undefined;
    customReference2: string;
    customerBusinessPartnerId: string;
    customerMatchcode: string;
    customerName1: string;
    contactFirstName: string;
    contactLastName: string;
    contactEmailAddress: string;
    consignmentNumber: number;
    senderName1: string;
    senderStreet: string;
    senderLocation1: string;
    senderZipCode: string;
    senderCountryCode: string;
    senderOriginalBusinessPartnerId: string;
    senderOriginalMatchcode: string;
    senderOriginalName1: string;
    receiverName1: string;
    receiverStreet: string;
    receiverLocation1: string;
    receiverZipCode: string;
    receiverCountryCode: string;
    receiverOriginalBusinessPartnerId: string;
    receiverOriginalMatchcode: string;
    receiverOriginalName1: string;
    loadingStart: Date;
    loadingEnd: Date;
    deliveryStart: Date;
    deliveryEnd: Date;
    transportTypeNumber: number;
    transportTypeMatchcode: string;
    transportTypeDescription: string;
    declarationTypeNumber: number;
    declarationTypeMatchcode: string;
    declarationTypeDesignation: string;
    incoterms: number;
    itemPositionNumber: number;
    packageNumber: number;
    packageMatchcode: string;
    packageShortDesignation: string;
    lengthInMeters: number;
    widthInMeters: number;
    heightInMeters: number;
    effectiveWeightInKilogram: number;
    quantity: number;
    content1: string;
}

export class IngestQuoteResponse implements IIngestQuoteResponse {
    success?: boolean;
    message?: string | undefined;
    quoteHeaderId?: number;
    quoteNumber?: string | undefined;
    desadvNumber?: string | undefined;
    lineCount?: number;
    attachmentCount?: number;
    provenanceCount?: number;
    createdAt?: Date;

    constructor(data?: IIngestQuoteResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.success = _data["success"];
            this.message = _data["message"];
            this.quoteHeaderId = _data["quoteHeaderId"];
            this.quoteNumber = _data["quoteNumber"];
            this.desadvNumber = _data["desadvNumber"];
            this.lineCount = _data["lineCount"];
            this.attachmentCount = _data["attachmentCount"];
            this.provenanceCount = _data["provenanceCount"];
            this.createdAt = _data["createdAt"] ? new Date(_data["createdAt"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): IngestQuoteResponse {
        data = typeof data === 'object' ? data : {};
        let result = new IngestQuoteResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        data["message"] = this.message;
        data["quoteHeaderId"] = this.quoteHeaderId;
        data["quoteNumber"] = this.quoteNumber;
        data["desadvNumber"] = this.desadvNumber;
        data["lineCount"] = this.lineCount;
        data["attachmentCount"] = this.attachmentCount;
        data["provenanceCount"] = this.provenanceCount;
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : <any>undefined;
        return data;
    }
}

export interface IIngestQuoteResponse {
    success?: boolean;
    message?: string | undefined;
    quoteHeaderId?: number;
    quoteNumber?: string | undefined;
    desadvNumber?: string | undefined;
    lineCount?: number;
    attachmentCount?: number;
    provenanceCount?: number;
    createdAt?: Date;
}

export class IngestQuoteCommand implements IIngestQuoteCommand {
    externalOrderNumber?: string | undefined;
    documentDate?: Date | undefined;
    purchaseOrderNumber?: string | undefined;
    requestorEmail?: string | undefined;
    customerName?: string | undefined;
    supplierName?: string | undefined;
    supplierAddress1?: string | undefined;
    supplierCity?: string | undefined;
    supplierPostalCode?: string | undefined;
    supplierCountryCode?: string | undefined;
    deliveryPartyName?: string | undefined;
    deliveryAddress1?: string | undefined;
    deliveryCity?: string | undefined;
    deliveryPostalCode?: string | undefined;
    deliveryCountryCode?: string | undefined;
    totalGrossWeight?: number | undefined;
    weightUnitOfMeasure?: string | undefined;
    messageReferenceNumber?: string | undefined;
    sourceSystem?: string | undefined;
    loadingCountry?: string | undefined;
    dischargeCountry?: string | undefined;
    deliveryDatetime?: Date;
    collectionDatetime?: Date;
    contactNames?: string | undefined;
    contactEmail?: string | undefined;
    contactTelephone?: string | undefined;
    rawEmailHtml?: string | undefined;
    lines?: IngestQuoteLineModel[] | undefined;
    attachments?: IngestQuoteAttachmentModel[] | undefined;
    extractionAuditId?: string | undefined;
    auditSchemaVersion?: string | undefined;
    pdfTextRulesVersion?: string | undefined;
    fieldProvenance?: { [key: string]: IngestQuoteFieldProvenanceModel; } | undefined;

    constructor(data?: IIngestQuoteCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.externalOrderNumber = _data["externalOrderNumber"];
            this.documentDate = _data["documentDate"] ? new Date(_data["documentDate"].toString()) : <any>undefined;
            this.purchaseOrderNumber = _data["purchaseOrderNumber"];
            this.requestorEmail = _data["requestorEmail"];
            this.customerName = _data["customerName"];
            this.supplierName = _data["supplierName"];
            this.supplierAddress1 = _data["supplierAddress1"];
            this.supplierCity = _data["supplierCity"];
            this.supplierPostalCode = _data["supplierPostalCode"];
            this.supplierCountryCode = _data["supplierCountryCode"];
            this.deliveryPartyName = _data["deliveryPartyName"];
            this.deliveryAddress1 = _data["deliveryAddress1"];
            this.deliveryCity = _data["deliveryCity"];
            this.deliveryPostalCode = _data["deliveryPostalCode"];
            this.deliveryCountryCode = _data["deliveryCountryCode"];
            this.totalGrossWeight = _data["totalGrossWeight"];
            this.weightUnitOfMeasure = _data["weightUnitOfMeasure"];
            this.messageReferenceNumber = _data["messageReferenceNumber"];
            this.sourceSystem = _data["sourceSystem"];
            this.loadingCountry = _data["loadingCountry"];
            this.dischargeCountry = _data["dischargeCountry"];
            this.deliveryDatetime = _data["deliveryDatetime"] ? new Date(_data["deliveryDatetime"].toString()) : <any>undefined;
            this.collectionDatetime = _data["collectionDatetime"] ? new Date(_data["collectionDatetime"].toString()) : <any>undefined;
            this.contactNames = _data["contactNames"];
            this.contactEmail = _data["contactEmail"];
            this.contactTelephone = _data["contactTelephone"];
            this.rawEmailHtml = _data["rawEmailHtml"];
            if (Array.isArray(_data["lines"])) {
                this.lines = [] as any;
                for (let item of _data["lines"])
                    this.lines!.push(IngestQuoteLineModel.fromJS(item));
            }
            if (Array.isArray(_data["attachments"])) {
                this.attachments = [] as any;
                for (let item of _data["attachments"])
                    this.attachments!.push(IngestQuoteAttachmentModel.fromJS(item));
            }
            this.extractionAuditId = _data["extractionAuditId"];
            this.auditSchemaVersion = _data["auditSchemaVersion"];
            this.pdfTextRulesVersion = _data["pdfTextRulesVersion"];
            if (_data["fieldProvenance"]) {
                this.fieldProvenance = {} as any;
                for (let key in _data["fieldProvenance"]) {
                    if (_data["fieldProvenance"].hasOwnProperty(key))
                        (<any>this.fieldProvenance)![key] = _data["fieldProvenance"][key] ? IngestQuoteFieldProvenanceModel.fromJS(_data["fieldProvenance"][key]) : new IngestQuoteFieldProvenanceModel();
                }
            }
        }
    }

    static fromJS(data: any): IngestQuoteCommand {
        data = typeof data === 'object' ? data : {};
        let result = new IngestQuoteCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["externalOrderNumber"] = this.externalOrderNumber;
        data["documentDate"] = this.documentDate ? this.documentDate.toISOString() : <any>undefined;
        data["purchaseOrderNumber"] = this.purchaseOrderNumber;
        data["requestorEmail"] = this.requestorEmail;
        data["customerName"] = this.customerName;
        data["supplierName"] = this.supplierName;
        data["supplierAddress1"] = this.supplierAddress1;
        data["supplierCity"] = this.supplierCity;
        data["supplierPostalCode"] = this.supplierPostalCode;
        data["supplierCountryCode"] = this.supplierCountryCode;
        data["deliveryPartyName"] = this.deliveryPartyName;
        data["deliveryAddress1"] = this.deliveryAddress1;
        data["deliveryCity"] = this.deliveryCity;
        data["deliveryPostalCode"] = this.deliveryPostalCode;
        data["deliveryCountryCode"] = this.deliveryCountryCode;
        data["totalGrossWeight"] = this.totalGrossWeight;
        data["weightUnitOfMeasure"] = this.weightUnitOfMeasure;
        data["messageReferenceNumber"] = this.messageReferenceNumber;
        data["sourceSystem"] = this.sourceSystem;
        data["loadingCountry"] = this.loadingCountry;
        data["dischargeCountry"] = this.dischargeCountry;
        data["deliveryDatetime"] = this.deliveryDatetime ? this.deliveryDatetime.toISOString() : <any>undefined;
        data["collectionDatetime"] = this.collectionDatetime ? this.collectionDatetime.toISOString() : <any>undefined;
        data["contactNames"] = this.contactNames;
        data["contactEmail"] = this.contactEmail;
        data["contactTelephone"] = this.contactTelephone;
        data["rawEmailHtml"] = this.rawEmailHtml;
        if (Array.isArray(this.lines)) {
            data["lines"] = [];
            for (let item of this.lines)
                data["lines"].push(item.toJSON());
        }
        if (Array.isArray(this.attachments)) {
            data["attachments"] = [];
            for (let item of this.attachments)
                data["attachments"].push(item.toJSON());
        }
        data["extractionAuditId"] = this.extractionAuditId;
        data["auditSchemaVersion"] = this.auditSchemaVersion;
        data["pdfTextRulesVersion"] = this.pdfTextRulesVersion;
        if (this.fieldProvenance) {
            data["fieldProvenance"] = {};
            for (let key in this.fieldProvenance) {
                if (this.fieldProvenance.hasOwnProperty(key))
                    (<any>data["fieldProvenance"])[key] = this.fieldProvenance[key] ? this.fieldProvenance[key].toJSON() : <any>undefined;
            }
        }
        return data;
    }
}

export interface IIngestQuoteCommand {
    externalOrderNumber?: string | undefined;
    documentDate?: Date | undefined;
    purchaseOrderNumber?: string | undefined;
    requestorEmail?: string | undefined;
    customerName?: string | undefined;
    supplierName?: string | undefined;
    supplierAddress1?: string | undefined;
    supplierCity?: string | undefined;
    supplierPostalCode?: string | undefined;
    supplierCountryCode?: string | undefined;
    deliveryPartyName?: string | undefined;
    deliveryAddress1?: string | undefined;
    deliveryCity?: string | undefined;
    deliveryPostalCode?: string | undefined;
    deliveryCountryCode?: string | undefined;
    totalGrossWeight?: number | undefined;
    weightUnitOfMeasure?: string | undefined;
    messageReferenceNumber?: string | undefined;
    sourceSystem?: string | undefined;
    loadingCountry?: string | undefined;
    dischargeCountry?: string | undefined;
    deliveryDatetime?: Date;
    collectionDatetime?: Date;
    contactNames?: string | undefined;
    contactEmail?: string | undefined;
    contactTelephone?: string | undefined;
    rawEmailHtml?: string | undefined;
    lines?: IngestQuoteLineModel[] | undefined;
    attachments?: IngestQuoteAttachmentModel[] | undefined;
    extractionAuditId?: string | undefined;
    auditSchemaVersion?: string | undefined;
    pdfTextRulesVersion?: string | undefined;
    fieldProvenance?: { [key: string]: IngestQuoteFieldProvenanceModel; } | undefined;
}

export class IngestQuoteLineModel implements IIngestQuoteLineModel {
    lineNumber?: number;
    itemNumber!: string;
    itemDescription?: string | undefined;
    despatchedQuantity?: number | undefined;
    unitOfMeasure?: string | undefined;
    grossWeight?: number | undefined;
    netWeight?: number | undefined;
    length?: number | undefined;
    width?: number | undefined;
    height?: number | undefined;
    dimensionUnitOfMeasure?: string | undefined;
    numberOfPackages?: number | undefined;
    purchaseOrderNumber?: string | undefined;

    constructor(data?: IIngestQuoteLineModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.lineNumber = _data["lineNumber"];
            this.itemNumber = _data["itemNumber"];
            this.itemDescription = _data["itemDescription"];
            this.despatchedQuantity = _data["despatchedQuantity"];
            this.unitOfMeasure = _data["unitOfMeasure"];
            this.grossWeight = _data["grossWeight"];
            this.netWeight = _data["netWeight"];
            this.length = _data["length"];
            this.width = _data["width"];
            this.height = _data["height"];
            this.dimensionUnitOfMeasure = _data["dimensionUnitOfMeasure"];
            this.numberOfPackages = _data["numberOfPackages"];
            this.purchaseOrderNumber = _data["purchaseOrderNumber"];
        }
    }

    static fromJS(data: any): IngestQuoteLineModel {
        data = typeof data === 'object' ? data : {};
        let result = new IngestQuoteLineModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["lineNumber"] = this.lineNumber;
        data["itemNumber"] = this.itemNumber;
        data["itemDescription"] = this.itemDescription;
        data["despatchedQuantity"] = this.despatchedQuantity;
        data["unitOfMeasure"] = this.unitOfMeasure;
        data["grossWeight"] = this.grossWeight;
        data["netWeight"] = this.netWeight;
        data["length"] = this.length;
        data["width"] = this.width;
        data["height"] = this.height;
        data["dimensionUnitOfMeasure"] = this.dimensionUnitOfMeasure;
        data["numberOfPackages"] = this.numberOfPackages;
        data["purchaseOrderNumber"] = this.purchaseOrderNumber;
        return data;
    }
}

export interface IIngestQuoteLineModel {
    lineNumber?: number;
    itemNumber: string;
    itemDescription?: string | undefined;
    despatchedQuantity?: number | undefined;
    unitOfMeasure?: string | undefined;
    grossWeight?: number | undefined;
    netWeight?: number | undefined;
    length?: number | undefined;
    width?: number | undefined;
    height?: number | undefined;
    dimensionUnitOfMeasure?: string | undefined;
    numberOfPackages?: number | undefined;
    purchaseOrderNumber?: string | undefined;
}

export class IngestQuoteAttachmentModel implements IIngestQuoteAttachmentModel {
    id!: string;
    filename!: string;
    contentType?: string | undefined;
    contentBase64!: string;

    constructor(data?: IIngestQuoteAttachmentModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.filename = _data["filename"];
            this.contentType = _data["contentType"];
            this.contentBase64 = _data["contentBase64"];
        }
    }

    static fromJS(data: any): IngestQuoteAttachmentModel {
        data = typeof data === 'object' ? data : {};
        let result = new IngestQuoteAttachmentModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["filename"] = this.filename;
        data["contentType"] = this.contentType;
        data["contentBase64"] = this.contentBase64;
        return data;
    }
}

export interface IIngestQuoteAttachmentModel {
    id: string;
    filename: string;
    contentType?: string | undefined;
    contentBase64: string;
}

export class IngestQuoteFieldProvenanceModel implements IIngestQuoteFieldProvenanceModel {
    sourceType?: string | undefined;
    sourceId?: string | undefined;
    anchorType?: string | undefined;
    page?: number | undefined;
    line?: number | undefined;
    column?: number | undefined;
    sheet?: string | undefined;
    cell?: string | undefined;
    sourceText?: string | undefined;
    matchIndex?: number | undefined;

    constructor(data?: IIngestQuoteFieldProvenanceModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sourceType = _data["sourceType"];
            this.sourceId = _data["sourceId"];
            this.anchorType = _data["anchorType"];
            this.page = _data["page"];
            this.line = _data["line"];
            this.column = _data["column"];
            this.sheet = _data["sheet"];
            this.cell = _data["cell"];
            this.sourceText = _data["sourceText"];
            this.matchIndex = _data["matchIndex"];
        }
    }

    static fromJS(data: any): IngestQuoteFieldProvenanceModel {
        data = typeof data === 'object' ? data : {};
        let result = new IngestQuoteFieldProvenanceModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sourceType"] = this.sourceType;
        data["sourceId"] = this.sourceId;
        data["anchorType"] = this.anchorType;
        data["page"] = this.page;
        data["line"] = this.line;
        data["column"] = this.column;
        data["sheet"] = this.sheet;
        data["cell"] = this.cell;
        data["sourceText"] = this.sourceText;
        data["matchIndex"] = this.matchIndex;
        return data;
    }
}

export interface IIngestQuoteFieldProvenanceModel {
    sourceType?: string | undefined;
    sourceId?: string | undefined;
    anchorType?: string | undefined;
    page?: number | undefined;
    line?: number | undefined;
    column?: number | undefined;
    sheet?: string | undefined;
    cell?: string | undefined;
    sourceText?: string | undefined;
    matchIndex?: number | undefined;
}

export enum RoleEnum {
    Administrator = 1,
    UserManagement = 2,
    Manager = 3,
    Customer = 4,
    User = 5,
    CustomerAdmin = 6,
    TourAdmin = 7,
    UncancelTour = 8,
    TenantManagement = 9,
    FeatureRole = 10,
    Quotes = 11,
    ControlTower = 12,
    ControlTowerUser = 13,
    Customs = 14,
}

export class TicketsModel implements ITicketsModel {
    id?: number;
    description?: string | undefined;
    longDescription?: string | undefined;
    createdBy?: string | undefined;
    createdDate?: Date;
    comments?: string | undefined;
    resolution?: string | undefined;
    status?: string | undefined;

    constructor(data?: ITicketsModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.description = _data["description"];
            this.longDescription = _data["longDescription"];
            this.createdBy = _data["createdBy"];
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : <any>undefined;
            this.comments = _data["comments"];
            this.resolution = _data["resolution"];
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): TicketsModel {
        data = typeof data === 'object' ? data : {};
        let result = new TicketsModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["description"] = this.description;
        data["longDescription"] = this.longDescription;
        data["createdBy"] = this.createdBy;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : <any>undefined;
        data["comments"] = this.comments;
        data["resolution"] = this.resolution;
        data["status"] = this.status;
        return data;
    }
}

export interface ITicketsModel {
    id?: number;
    description?: string | undefined;
    longDescription?: string | undefined;
    createdBy?: string | undefined;
    createdDate?: Date;
    comments?: string | undefined;
    resolution?: string | undefined;
    status?: string | undefined;
}

export class PagedListingResponseOfAdminTourModel implements IPagedListingResponseOfAdminTourModel {
    results?: AdminTourModel[] | undefined;
    totalCount?: number;
    totalPages?: number;
    pageIndex?: number;
    pageSize?: number;

    constructor(data?: IPagedListingResponseOfAdminTourModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["results"])) {
                this.results = [] as any;
                for (let item of _data["results"])
                    this.results!.push(AdminTourModel.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
            this.totalPages = _data["totalPages"];
            this.pageIndex = _data["pageIndex"];
            this.pageSize = _data["pageSize"];
        }
    }

    static fromJS(data: any): PagedListingResponseOfAdminTourModel {
        data = typeof data === 'object' ? data : {};
        let result = new PagedListingResponseOfAdminTourModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.results)) {
            data["results"] = [];
            for (let item of this.results)
                data["results"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        data["totalPages"] = this.totalPages;
        data["pageIndex"] = this.pageIndex;
        data["pageSize"] = this.pageSize;
        return data;
    }
}

export interface IPagedListingResponseOfAdminTourModel {
    results?: AdminTourModel[] | undefined;
    totalCount?: number;
    totalPages?: number;
    pageIndex?: number;
    pageSize?: number;
}

export class AdminTourModel implements IAdminTourModel {
    totalRecord?: number;
    id?: number;
    tourId?: number;
    amcoId?: number;
    customerName?: string | undefined;
    completed?: boolean;
    isCancelled?: boolean;
    isDeleted?: boolean;
    updateDueDate?: Date | undefined;
    plannedDeliveryEnd?: Date | undefined;
    lastFleetComStatus?: number;
    lockStatus?: number;
    trackingFrequency?: string | undefined;
    inRecycleBin?: number | undefined;
    type?: string | undefined;
    departmentName?: string | undefined;
    updateTypeName?: string | undefined;
    categoryName?: string | undefined;
    typeName?: string | undefined;
    transportOrderNumber?: string | undefined;
    isBmwVehicleEventWarning?: boolean | undefined;
    isBmwCollectionTrackingWarning?: boolean | undefined;
    isBmwNoLocationWarning?: boolean | undefined;

    constructor(data?: IAdminTourModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalRecord = _data["totalRecord"];
            this.id = _data["id"];
            this.tourId = _data["tourId"];
            this.amcoId = _data["amcoId"];
            this.customerName = _data["customerName"];
            this.completed = _data["completed"];
            this.isCancelled = _data["isCancelled"];
            this.isDeleted = _data["isDeleted"];
            this.updateDueDate = _data["updateDueDate"] ? new Date(_data["updateDueDate"].toString()) : <any>undefined;
            this.plannedDeliveryEnd = _data["plannedDeliveryEnd"] ? new Date(_data["plannedDeliveryEnd"].toString()) : <any>undefined;
            this.lastFleetComStatus = _data["lastFleetComStatus"];
            this.lockStatus = _data["lockStatus"];
            this.trackingFrequency = _data["trackingFrequency"];
            this.inRecycleBin = _data["inRecycleBin"];
            this.type = _data["type"];
            this.departmentName = _data["departmentName"];
            this.updateTypeName = _data["updateTypeName"];
            this.categoryName = _data["categoryName"];
            this.typeName = _data["typeName"];
            this.transportOrderNumber = _data["transportOrderNumber"];
            this.isBmwVehicleEventWarning = _data["isBmwVehicleEventWarning"];
            this.isBmwCollectionTrackingWarning = _data["isBmwCollectionTrackingWarning"];
            this.isBmwNoLocationWarning = _data["isBmwNoLocationWarning"];
        }
    }

    static fromJS(data: any): AdminTourModel {
        data = typeof data === 'object' ? data : {};
        let result = new AdminTourModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalRecord"] = this.totalRecord;
        data["id"] = this.id;
        data["tourId"] = this.tourId;
        data["amcoId"] = this.amcoId;
        data["customerName"] = this.customerName;
        data["completed"] = this.completed;
        data["isCancelled"] = this.isCancelled;
        data["isDeleted"] = this.isDeleted;
        data["updateDueDate"] = this.updateDueDate ? this.updateDueDate.toISOString() : <any>undefined;
        data["plannedDeliveryEnd"] = this.plannedDeliveryEnd ? this.plannedDeliveryEnd.toISOString() : <any>undefined;
        data["lastFleetComStatus"] = this.lastFleetComStatus;
        data["lockStatus"] = this.lockStatus;
        data["trackingFrequency"] = this.trackingFrequency;
        data["inRecycleBin"] = this.inRecycleBin;
        data["type"] = this.type;
        data["departmentName"] = this.departmentName;
        data["updateTypeName"] = this.updateTypeName;
        data["categoryName"] = this.categoryName;
        data["typeName"] = this.typeName;
        data["transportOrderNumber"] = this.transportOrderNumber;
        data["isBmwVehicleEventWarning"] = this.isBmwVehicleEventWarning;
        data["isBmwCollectionTrackingWarning"] = this.isBmwCollectionTrackingWarning;
        data["isBmwNoLocationWarning"] = this.isBmwNoLocationWarning;
        return data;
    }
}

export interface IAdminTourModel {
    totalRecord?: number;
    id?: number;
    tourId?: number;
    amcoId?: number;
    customerName?: string | undefined;
    completed?: boolean;
    isCancelled?: boolean;
    isDeleted?: boolean;
    updateDueDate?: Date | undefined;
    plannedDeliveryEnd?: Date | undefined;
    lastFleetComStatus?: number;
    lockStatus?: number;
    trackingFrequency?: string | undefined;
    inRecycleBin?: number | undefined;
    type?: string | undefined;
    departmentName?: string | undefined;
    updateTypeName?: string | undefined;
    categoryName?: string | undefined;
    typeName?: string | undefined;
    transportOrderNumber?: string | undefined;
    isBmwVehicleEventWarning?: boolean | undefined;
    isBmwCollectionTrackingWarning?: boolean | undefined;
    isBmwNoLocationWarning?: boolean | undefined;
}

export class GetAdminTourListQuery extends PagedListingRequest implements IGetAdminTourListQuery {
    viewToursNotNoTourScreen?: boolean;
    viewCancelledTours?: boolean;

    constructor(data?: IGetAdminTourListQuery) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.viewToursNotNoTourScreen = _data["viewToursNotNoTourScreen"];
            this.viewCancelledTours = _data["viewCancelledTours"];
        }
    }

    static fromJS(data: any): GetAdminTourListQuery {
        data = typeof data === 'object' ? data : {};
        let result = new GetAdminTourListQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["viewToursNotNoTourScreen"] = this.viewToursNotNoTourScreen;
        data["viewCancelledTours"] = this.viewCancelledTours;
        super.toJSON(data);
        return data;
    }
}

export interface IGetAdminTourListQuery extends IPagedListingRequest {
    viewToursNotNoTourScreen?: boolean;
    viewCancelledTours?: boolean;
}

export class GetTourHistoryQuery extends PagedListingRequest implements IGetTourHistoryQuery {

    constructor(data?: IGetTourHistoryQuery) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): GetTourHistoryQuery {
        data = typeof data === 'object' ? data : {};
        let result = new GetTourHistoryQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IGetTourHistoryQuery extends IPagedListingRequest {
}

export class AuditGoogleApiCommand implements IAuditGoogleApiCommand {
    updateType?: string | undefined;

    constructor(data?: IAuditGoogleApiCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.updateType = _data["updateType"];
        }
    }

    static fromJS(data: any): AuditGoogleApiCommand {
        data = typeof data === 'object' ? data : {};
        let result = new AuditGoogleApiCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["updateType"] = this.updateType;
        return data;
    }
}

export interface IAuditGoogleApiCommand {
    updateType?: string | undefined;
}

export class TourHistoryModel implements ITourHistoryModel {
    groupId?: number;
    id?: number;
    updateType?: string | undefined;
    date?: Date | undefined;
    updatedAt?: Date;
    user?: string | undefined;
    note?: string | undefined;
    requiresValidation?: boolean | undefined;
    approved?: boolean | undefined;
    rejectionComments?: string | undefined;
    disabled?: boolean | undefined;
    vehicleLat?: number | undefined;
    vehicleLng?: number | undefined;
    place?: string | undefined;
    vehicleDistance?: string | undefined;
    vehicleDur?: string | undefined;

    constructor(data?: ITourHistoryModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.groupId = _data["groupId"];
            this.id = _data["id"];
            this.updateType = _data["updateType"];
            this.date = _data["date"] ? new Date(_data["date"].toString()) : <any>undefined;
            this.updatedAt = _data["updatedAt"] ? new Date(_data["updatedAt"].toString()) : <any>undefined;
            this.user = _data["user"];
            this.note = _data["note"];
            this.requiresValidation = _data["requiresValidation"];
            this.approved = _data["approved"];
            this.rejectionComments = _data["rejectionComments"];
            this.disabled = _data["disabled"];
            this.vehicleLat = _data["vehicleLat"];
            this.vehicleLng = _data["vehicleLng"];
            this.place = _data["place"];
            this.vehicleDistance = _data["vehicleDistance"];
            this.vehicleDur = _data["vehicleDur"];
        }
    }

    static fromJS(data: any): TourHistoryModel {
        data = typeof data === 'object' ? data : {};
        let result = new TourHistoryModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["groupId"] = this.groupId;
        data["id"] = this.id;
        data["updateType"] = this.updateType;
        data["date"] = this.date ? this.date.toISOString() : <any>undefined;
        data["updatedAt"] = this.updatedAt ? this.updatedAt.toISOString() : <any>undefined;
        data["user"] = this.user;
        data["note"] = this.note;
        data["requiresValidation"] = this.requiresValidation;
        data["approved"] = this.approved;
        data["rejectionComments"] = this.rejectionComments;
        data["disabled"] = this.disabled;
        data["vehicleLat"] = this.vehicleLat;
        data["vehicleLng"] = this.vehicleLng;
        data["place"] = this.place;
        data["vehicleDistance"] = this.vehicleDistance;
        data["vehicleDur"] = this.vehicleDur;
        return data;
    }
}

export interface ITourHistoryModel {
    groupId?: number;
    id?: number;
    updateType?: string | undefined;
    date?: Date | undefined;
    updatedAt?: Date;
    user?: string | undefined;
    note?: string | undefined;
    requiresValidation?: boolean | undefined;
    approved?: boolean | undefined;
    rejectionComments?: string | undefined;
    disabled?: boolean | undefined;
    vehicleLat?: number | undefined;
    vehicleLng?: number | undefined;
    place?: string | undefined;
    vehicleDistance?: string | undefined;
    vehicleDur?: string | undefined;
}

export class UpdateTrackingUrlCommand implements IUpdateTrackingUrlCommand {
    id?: number;
    trackingUrl?: string | undefined;

    constructor(data?: IUpdateTrackingUrlCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.trackingUrl = _data["trackingUrl"];
        }
    }

    static fromJS(data: any): UpdateTrackingUrlCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateTrackingUrlCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["trackingUrl"] = this.trackingUrl;
        return data;
    }
}

export interface IUpdateTrackingUrlCommand {
    id?: number;
    trackingUrl?: string | undefined;
}

export class LoggedIssueModel implements ILoggedIssueModel {
    id?: number;
    tourId?: number;
    causeOfIssue?: string | undefined;
    impact?: string | undefined;
    reasonForIssue?: string | undefined;
    createdBy?: string | undefined;
    createdDate?: Date;
    isLoggedByCustomer?: boolean;
    details?: string | undefined;
    estimatedDatetime?: Date;
    disabled?: boolean | undefined;
    status?: boolean | undefined;
    priority?: string | undefined;
    managerActions?: string | undefined;
    issueActions?: string | undefined;

    constructor(data?: ILoggedIssueModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.tourId = _data["tourId"];
            this.causeOfIssue = _data["causeOfIssue"];
            this.impact = _data["impact"];
            this.reasonForIssue = _data["reasonForIssue"];
            this.createdBy = _data["createdBy"];
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : <any>undefined;
            this.isLoggedByCustomer = _data["isLoggedByCustomer"];
            this.details = _data["details"];
            this.estimatedDatetime = _data["estimatedDatetime"] ? new Date(_data["estimatedDatetime"].toString()) : <any>undefined;
            this.disabled = _data["disabled"];
            this.status = _data["status"];
            this.priority = _data["priority"];
            this.managerActions = _data["managerActions"];
            this.issueActions = _data["issueActions"];
        }
    }

    static fromJS(data: any): LoggedIssueModel {
        data = typeof data === 'object' ? data : {};
        let result = new LoggedIssueModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["tourId"] = this.tourId;
        data["causeOfIssue"] = this.causeOfIssue;
        data["impact"] = this.impact;
        data["reasonForIssue"] = this.reasonForIssue;
        data["createdBy"] = this.createdBy;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : <any>undefined;
        data["isLoggedByCustomer"] = this.isLoggedByCustomer;
        data["details"] = this.details;
        data["estimatedDatetime"] = this.estimatedDatetime ? this.estimatedDatetime.toISOString() : <any>undefined;
        data["disabled"] = this.disabled;
        data["status"] = this.status;
        data["priority"] = this.priority;
        data["managerActions"] = this.managerActions;
        data["issueActions"] = this.issueActions;
        return data;
    }
}

export interface ILoggedIssueModel {
    id?: number;
    tourId?: number;
    causeOfIssue?: string | undefined;
    impact?: string | undefined;
    reasonForIssue?: string | undefined;
    createdBy?: string | undefined;
    createdDate?: Date;
    isLoggedByCustomer?: boolean;
    details?: string | undefined;
    estimatedDatetime?: Date;
    disabled?: boolean | undefined;
    status?: boolean | undefined;
    priority?: string | undefined;
    managerActions?: string | undefined;
    issueActions?: string | undefined;
}

export class SendToursToUIQuery implements ISendToursToUIQuery {
    tourIds?: number[] | undefined;

    constructor(data?: ISendToursToUIQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["tourIds"])) {
                this.tourIds = [] as any;
                for (let item of _data["tourIds"])
                    this.tourIds!.push(item);
            }
        }
    }

    static fromJS(data: any): SendToursToUIQuery {
        data = typeof data === 'object' ? data : {};
        let result = new SendToursToUIQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.tourIds)) {
            data["tourIds"] = [];
            for (let item of this.tourIds)
                data["tourIds"].push(item);
        }
        return data;
    }
}

export interface ISendToursToUIQuery {
    tourIds?: number[] | undefined;
}

export class DistanceModel implements IDistanceModel {
    distance?: string | undefined;
    duration?: string | undefined;

    constructor(data?: IDistanceModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.distance = _data["distance"];
            this.duration = _data["duration"];
        }
    }

    static fromJS(data: any): DistanceModel {
        data = typeof data === 'object' ? data : {};
        let result = new DistanceModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["distance"] = this.distance;
        data["duration"] = this.duration;
        return data;
    }
}

export interface IDistanceModel {
    distance?: string | undefined;
    duration?: string | undefined;
}

export class TourVehicleRouteModel implements ITourVehicleRouteModel {
    id?: number;
    tourId?: number;
    vehicleId?: number;
    routeData?: string | undefined;

    constructor(data?: ITourVehicleRouteModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.tourId = _data["tourId"];
            this.vehicleId = _data["vehicleId"];
            this.routeData = _data["routeData"];
        }
    }

    static fromJS(data: any): TourVehicleRouteModel {
        data = typeof data === 'object' ? data : {};
        let result = new TourVehicleRouteModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["tourId"] = this.tourId;
        data["vehicleId"] = this.vehicleId;
        data["routeData"] = this.routeData;
        return data;
    }
}

export interface ITourVehicleRouteModel {
    id?: number;
    tourId?: number;
    vehicleId?: number;
    routeData?: string | undefined;
}

export class PagedListingResponseOfTransportModel implements IPagedListingResponseOfTransportModel {
    results?: TransportModel[] | undefined;
    totalCount?: number;
    totalPages?: number;
    pageIndex?: number;
    pageSize?: number;

    constructor(data?: IPagedListingResponseOfTransportModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["results"])) {
                this.results = [] as any;
                for (let item of _data["results"])
                    this.results!.push(TransportModel.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
            this.totalPages = _data["totalPages"];
            this.pageIndex = _data["pageIndex"];
            this.pageSize = _data["pageSize"];
        }
    }

    static fromJS(data: any): PagedListingResponseOfTransportModel {
        data = typeof data === 'object' ? data : {};
        let result = new PagedListingResponseOfTransportModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.results)) {
            data["results"] = [];
            for (let item of this.results)
                data["results"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        data["totalPages"] = this.totalPages;
        data["pageIndex"] = this.pageIndex;
        data["pageSize"] = this.pageSize;
        return data;
    }
}

export interface IPagedListingResponseOfTransportModel {
    results?: TransportModel[] | undefined;
    totalCount?: number;
    totalPages?: number;
    pageIndex?: number;
    pageSize?: number;
}

export class TransportModel implements ITransportModel {
    createdDate?: Date | undefined;
    assigned_carrier_id?: number | undefined;
    assigned_carrier_name?: string | undefined;
    assigned_creditor_number?: string | undefined;
    attachments?: AttachmentModel[] | undefined;
    auction_comment?: string | undefined;
    auction_comment_plain_text?: string | undefined;
    auction_end_date?: Date | undefined;
    auction_end_time?: string | undefined;
    auction_offer_edit_end_date?: Date | undefined;
    auction_offer_edit_end_time?: string | undefined;
    auction_offer_withdrawal_end_date?: Date | undefined;
    auction_offer_withdrawal_end_time?: string | undefined;
    auction_start_date?: Date | undefined;
    auction_start_time?: string | undefined;
    bookings?: BookingModel[] | undefined;
    carrier_disponent_email?: string | undefined;
    carrier_disponent_id?: number | undefined;
    carrier_disponent_name?: string | undefined;
    carrier_number?: string | undefined;
    changed?: number | undefined;
    comment?: string | undefined;
    comment_plain_text?: string | undefined;
    company_address?: string | undefined;
    company_city?: string | undefined;
    company_country_id?: string | undefined;
    company_id?: number | undefined;
    company_name?: string | undefined;
    company_region?: string | undefined;
    company_zip_address?: string | undefined;
    contacts?: ContactModel[] | undefined;
    currency_id?: string | undefined;
    disponent_firstname?: string | undefined;
    disponent_id?: number | undefined;
    disponent_lastname?: string | undefined;
    disponent_phone?: string | undefined;
    document_reference?: string | undefined;
    end_city?: string | undefined;
    end_country_id?: string | undefined;
    end_date?: Date | undefined;
    end_region?: string | undefined;
    end_time?: string | undefined;
    end_zip?: string | undefined;
    external_transport_number?: string | undefined;
    handling_units?: HandlingUnitModel[] | undefined;
    id?: number;
    internal_comment?: string | undefined;
    length?: number | undefined;
    length_unit?: string | undefined;
    loading_datetime_offer_requested?: boolean | undefined;
    number?: string | undefined;
    offer?: OfferModel[] | undefined;
    offer_price_disabled?: boolean | undefined;
    owner?: string | undefined;
    parameters?: ParameterModel[] | undefined;
    partial_accept?: number | undefined;
    plant?: string | undefined;
    price_additional1?: number | undefined;
    price_additional1_desc?: string | undefined;
    price_additional2?: number | undefined;
    price_additional2_desc?: string | undefined;
    price_additional3?: number | undefined;
    price_additional3_desc?: string | undefined;
    price_basic?: number | undefined;
    price_max?: number | undefined;
    price_min?: number | undefined;
    price_offered?: number | undefined;
    qualifier?: string | undefined;
    required_delivery_item_fields?: RequiredDeliveryItemFieldsModel | undefined;
    required_delivery_parameters?: RequiredDeliveryParametersModel[] | undefined;
    required_offer_parameters?: RequiredOfferParameterModel[] | undefined;
    required_price_components?: RequiredPriceComponentModel[] | undefined;
    required_transport_parameters?: RequiredTransportParameterModel[] | undefined;
    route?: number | undefined;
    route_unit?: string | undefined;
    shadow_nto?: number | undefined;
    shipments?: ShipmentModel[] | undefined;
    start_city?: string | undefined;
    start_country_id?: string | undefined;
    start_date?: Date | undefined;
    start_region?: string | undefined;
    start_time?: string | undefined;
    start_zip?: string | undefined;
    status?: string | undefined;
    stops?: StopModel[] | undefined;
    storage_position_count?: number | undefined;
    timestamp?: Date | undefined;
    tpw_link?: string | undefined;
    transport_group_id?: string | undefined;
    tsm_light_login_link?: string | undefined;
    unloading_datetime_offer_requested?: boolean | undefined;
    vehicle_id?: string | undefined;
    vehicle_name?: string | undefined;
    volume?: number | undefined;
    volume_unit?: string | undefined;
    weight?: number | undefined;
    weight_unit?: string | undefined;

    constructor(data?: ITransportModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : <any>undefined;
            this.assigned_carrier_id = _data["assigned_carrier_id"];
            this.assigned_carrier_name = _data["assigned_carrier_name"];
            this.assigned_creditor_number = _data["assigned_creditor_number"];
            if (Array.isArray(_data["attachments"])) {
                this.attachments = [] as any;
                for (let item of _data["attachments"])
                    this.attachments!.push(AttachmentModel.fromJS(item));
            }
            this.auction_comment = _data["auction_comment"];
            this.auction_comment_plain_text = _data["auction_comment_plain_text"];
            this.auction_end_date = _data["auction_end_date"] ? new Date(_data["auction_end_date"].toString()) : <any>undefined;
            this.auction_end_time = _data["auction_end_time"];
            this.auction_offer_edit_end_date = _data["auction_offer_edit_end_date"] ? new Date(_data["auction_offer_edit_end_date"].toString()) : <any>undefined;
            this.auction_offer_edit_end_time = _data["auction_offer_edit_end_time"];
            this.auction_offer_withdrawal_end_date = _data["auction_offer_withdrawal_end_date"] ? new Date(_data["auction_offer_withdrawal_end_date"].toString()) : <any>undefined;
            this.auction_offer_withdrawal_end_time = _data["auction_offer_withdrawal_end_time"];
            this.auction_start_date = _data["auction_start_date"] ? new Date(_data["auction_start_date"].toString()) : <any>undefined;
            this.auction_start_time = _data["auction_start_time"];
            if (Array.isArray(_data["bookings"])) {
                this.bookings = [] as any;
                for (let item of _data["bookings"])
                    this.bookings!.push(BookingModel.fromJS(item));
            }
            this.carrier_disponent_email = _data["carrier_disponent_email"];
            this.carrier_disponent_id = _data["carrier_disponent_id"];
            this.carrier_disponent_name = _data["carrier_disponent_name"];
            this.carrier_number = _data["carrier_number"];
            this.changed = _data["changed"];
            this.comment = _data["comment"];
            this.comment_plain_text = _data["comment_plain_text"];
            this.company_address = _data["company_address"];
            this.company_city = _data["company_city"];
            this.company_country_id = _data["company_country_id"];
            this.company_id = _data["company_id"];
            this.company_name = _data["company_name"];
            this.company_region = _data["company_region"];
            this.company_zip_address = _data["company_zip_address"];
            if (Array.isArray(_data["contacts"])) {
                this.contacts = [] as any;
                for (let item of _data["contacts"])
                    this.contacts!.push(ContactModel.fromJS(item));
            }
            this.currency_id = _data["currency_id"];
            this.disponent_firstname = _data["disponent_firstname"];
            this.disponent_id = _data["disponent_id"];
            this.disponent_lastname = _data["disponent_lastname"];
            this.disponent_phone = _data["disponent_phone"];
            this.document_reference = _data["document_reference"];
            this.end_city = _data["end_city"];
            this.end_country_id = _data["end_country_id"];
            this.end_date = _data["end_date"] ? new Date(_data["end_date"].toString()) : <any>undefined;
            this.end_region = _data["end_region"];
            this.end_time = _data["end_time"];
            this.end_zip = _data["end_zip"];
            this.external_transport_number = _data["external_transport_number"];
            if (Array.isArray(_data["handling_units"])) {
                this.handling_units = [] as any;
                for (let item of _data["handling_units"])
                    this.handling_units!.push(HandlingUnitModel.fromJS(item));
            }
            this.id = _data["id"];
            this.internal_comment = _data["internal_comment"];
            this.length = _data["length"];
            this.length_unit = _data["length_unit"];
            this.loading_datetime_offer_requested = _data["loading_datetime_offer_requested"];
            this.number = _data["number"];
            if (Array.isArray(_data["offer"])) {
                this.offer = [] as any;
                for (let item of _data["offer"])
                    this.offer!.push(OfferModel.fromJS(item));
            }
            this.offer_price_disabled = _data["offer_price_disabled"];
            this.owner = _data["owner"];
            if (Array.isArray(_data["parameters"])) {
                this.parameters = [] as any;
                for (let item of _data["parameters"])
                    this.parameters!.push(ParameterModel.fromJS(item));
            }
            this.partial_accept = _data["partial_accept"];
            this.plant = _data["plant"];
            this.price_additional1 = _data["price_additional1"];
            this.price_additional1_desc = _data["price_additional1_desc"];
            this.price_additional2 = _data["price_additional2"];
            this.price_additional2_desc = _data["price_additional2_desc"];
            this.price_additional3 = _data["price_additional3"];
            this.price_additional3_desc = _data["price_additional3_desc"];
            this.price_basic = _data["price_basic"];
            this.price_max = _data["price_max"];
            this.price_min = _data["price_min"];
            this.price_offered = _data["price_offered"];
            this.qualifier = _data["qualifier"];
            this.required_delivery_item_fields = _data["required_delivery_item_fields"] ? RequiredDeliveryItemFieldsModel.fromJS(_data["required_delivery_item_fields"]) : <any>undefined;
            if (Array.isArray(_data["required_delivery_parameters"])) {
                this.required_delivery_parameters = [] as any;
                for (let item of _data["required_delivery_parameters"])
                    this.required_delivery_parameters!.push(RequiredDeliveryParametersModel.fromJS(item));
            }
            if (Array.isArray(_data["required_offer_parameters"])) {
                this.required_offer_parameters = [] as any;
                for (let item of _data["required_offer_parameters"])
                    this.required_offer_parameters!.push(RequiredOfferParameterModel.fromJS(item));
            }
            if (Array.isArray(_data["required_price_components"])) {
                this.required_price_components = [] as any;
                for (let item of _data["required_price_components"])
                    this.required_price_components!.push(RequiredPriceComponentModel.fromJS(item));
            }
            if (Array.isArray(_data["required_transport_parameters"])) {
                this.required_transport_parameters = [] as any;
                for (let item of _data["required_transport_parameters"])
                    this.required_transport_parameters!.push(RequiredTransportParameterModel.fromJS(item));
            }
            this.route = _data["route"];
            this.route_unit = _data["route_unit"];
            this.shadow_nto = _data["shadow_nto"];
            if (Array.isArray(_data["shipments"])) {
                this.shipments = [] as any;
                for (let item of _data["shipments"])
                    this.shipments!.push(ShipmentModel.fromJS(item));
            }
            this.start_city = _data["start_city"];
            this.start_country_id = _data["start_country_id"];
            this.start_date = _data["start_date"] ? new Date(_data["start_date"].toString()) : <any>undefined;
            this.start_region = _data["start_region"];
            this.start_time = _data["start_time"];
            this.start_zip = _data["start_zip"];
            this.status = _data["status"];
            if (Array.isArray(_data["stops"])) {
                this.stops = [] as any;
                for (let item of _data["stops"])
                    this.stops!.push(StopModel.fromJS(item));
            }
            this.storage_position_count = _data["storage_position_count"];
            this.timestamp = _data["timestamp"] ? new Date(_data["timestamp"].toString()) : <any>undefined;
            this.tpw_link = _data["tpw_link"];
            this.transport_group_id = _data["transport_group_id"];
            this.tsm_light_login_link = _data["tsm_light_login_link"];
            this.unloading_datetime_offer_requested = _data["unloading_datetime_offer_requested"];
            this.vehicle_id = _data["vehicle_id"];
            this.vehicle_name = _data["vehicle_name"];
            this.volume = _data["volume"];
            this.volume_unit = _data["volume_unit"];
            this.weight = _data["weight"];
            this.weight_unit = _data["weight_unit"];
        }
    }

    static fromJS(data: any): TransportModel {
        data = typeof data === 'object' ? data : {};
        let result = new TransportModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : <any>undefined;
        data["assigned_carrier_id"] = this.assigned_carrier_id;
        data["assigned_carrier_name"] = this.assigned_carrier_name;
        data["assigned_creditor_number"] = this.assigned_creditor_number;
        if (Array.isArray(this.attachments)) {
            data["attachments"] = [];
            for (let item of this.attachments)
                data["attachments"].push(item.toJSON());
        }
        data["auction_comment"] = this.auction_comment;
        data["auction_comment_plain_text"] = this.auction_comment_plain_text;
        data["auction_end_date"] = this.auction_end_date ? this.auction_end_date.toISOString() : <any>undefined;
        data["auction_end_time"] = this.auction_end_time;
        data["auction_offer_edit_end_date"] = this.auction_offer_edit_end_date ? this.auction_offer_edit_end_date.toISOString() : <any>undefined;
        data["auction_offer_edit_end_time"] = this.auction_offer_edit_end_time;
        data["auction_offer_withdrawal_end_date"] = this.auction_offer_withdrawal_end_date ? this.auction_offer_withdrawal_end_date.toISOString() : <any>undefined;
        data["auction_offer_withdrawal_end_time"] = this.auction_offer_withdrawal_end_time;
        data["auction_start_date"] = this.auction_start_date ? this.auction_start_date.toISOString() : <any>undefined;
        data["auction_start_time"] = this.auction_start_time;
        if (Array.isArray(this.bookings)) {
            data["bookings"] = [];
            for (let item of this.bookings)
                data["bookings"].push(item.toJSON());
        }
        data["carrier_disponent_email"] = this.carrier_disponent_email;
        data["carrier_disponent_id"] = this.carrier_disponent_id;
        data["carrier_disponent_name"] = this.carrier_disponent_name;
        data["carrier_number"] = this.carrier_number;
        data["changed"] = this.changed;
        data["comment"] = this.comment;
        data["comment_plain_text"] = this.comment_plain_text;
        data["company_address"] = this.company_address;
        data["company_city"] = this.company_city;
        data["company_country_id"] = this.company_country_id;
        data["company_id"] = this.company_id;
        data["company_name"] = this.company_name;
        data["company_region"] = this.company_region;
        data["company_zip_address"] = this.company_zip_address;
        if (Array.isArray(this.contacts)) {
            data["contacts"] = [];
            for (let item of this.contacts)
                data["contacts"].push(item.toJSON());
        }
        data["currency_id"] = this.currency_id;
        data["disponent_firstname"] = this.disponent_firstname;
        data["disponent_id"] = this.disponent_id;
        data["disponent_lastname"] = this.disponent_lastname;
        data["disponent_phone"] = this.disponent_phone;
        data["document_reference"] = this.document_reference;
        data["end_city"] = this.end_city;
        data["end_country_id"] = this.end_country_id;
        data["end_date"] = this.end_date ? this.end_date.toISOString() : <any>undefined;
        data["end_region"] = this.end_region;
        data["end_time"] = this.end_time;
        data["end_zip"] = this.end_zip;
        data["external_transport_number"] = this.external_transport_number;
        if (Array.isArray(this.handling_units)) {
            data["handling_units"] = [];
            for (let item of this.handling_units)
                data["handling_units"].push(item.toJSON());
        }
        data["id"] = this.id;
        data["internal_comment"] = this.internal_comment;
        data["length"] = this.length;
        data["length_unit"] = this.length_unit;
        data["loading_datetime_offer_requested"] = this.loading_datetime_offer_requested;
        data["number"] = this.number;
        if (Array.isArray(this.offer)) {
            data["offer"] = [];
            for (let item of this.offer)
                data["offer"].push(item.toJSON());
        }
        data["offer_price_disabled"] = this.offer_price_disabled;
        data["owner"] = this.owner;
        if (Array.isArray(this.parameters)) {
            data["parameters"] = [];
            for (let item of this.parameters)
                data["parameters"].push(item.toJSON());
        }
        data["partial_accept"] = this.partial_accept;
        data["plant"] = this.plant;
        data["price_additional1"] = this.price_additional1;
        data["price_additional1_desc"] = this.price_additional1_desc;
        data["price_additional2"] = this.price_additional2;
        data["price_additional2_desc"] = this.price_additional2_desc;
        data["price_additional3"] = this.price_additional3;
        data["price_additional3_desc"] = this.price_additional3_desc;
        data["price_basic"] = this.price_basic;
        data["price_max"] = this.price_max;
        data["price_min"] = this.price_min;
        data["price_offered"] = this.price_offered;
        data["qualifier"] = this.qualifier;
        data["required_delivery_item_fields"] = this.required_delivery_item_fields ? this.required_delivery_item_fields.toJSON() : <any>undefined;
        if (Array.isArray(this.required_delivery_parameters)) {
            data["required_delivery_parameters"] = [];
            for (let item of this.required_delivery_parameters)
                data["required_delivery_parameters"].push(item.toJSON());
        }
        if (Array.isArray(this.required_offer_parameters)) {
            data["required_offer_parameters"] = [];
            for (let item of this.required_offer_parameters)
                data["required_offer_parameters"].push(item.toJSON());
        }
        if (Array.isArray(this.required_price_components)) {
            data["required_price_components"] = [];
            for (let item of this.required_price_components)
                data["required_price_components"].push(item.toJSON());
        }
        if (Array.isArray(this.required_transport_parameters)) {
            data["required_transport_parameters"] = [];
            for (let item of this.required_transport_parameters)
                data["required_transport_parameters"].push(item.toJSON());
        }
        data["route"] = this.route;
        data["route_unit"] = this.route_unit;
        data["shadow_nto"] = this.shadow_nto;
        if (Array.isArray(this.shipments)) {
            data["shipments"] = [];
            for (let item of this.shipments)
                data["shipments"].push(item.toJSON());
        }
        data["start_city"] = this.start_city;
        data["start_country_id"] = this.start_country_id;
        data["start_date"] = this.start_date ? this.start_date.toISOString() : <any>undefined;
        data["start_region"] = this.start_region;
        data["start_time"] = this.start_time;
        data["start_zip"] = this.start_zip;
        data["status"] = this.status;
        if (Array.isArray(this.stops)) {
            data["stops"] = [];
            for (let item of this.stops)
                data["stops"].push(item.toJSON());
        }
        data["storage_position_count"] = this.storage_position_count;
        data["timestamp"] = this.timestamp ? this.timestamp.toISOString() : <any>undefined;
        data["tpw_link"] = this.tpw_link;
        data["transport_group_id"] = this.transport_group_id;
        data["tsm_light_login_link"] = this.tsm_light_login_link;
        data["unloading_datetime_offer_requested"] = this.unloading_datetime_offer_requested;
        data["vehicle_id"] = this.vehicle_id;
        data["vehicle_name"] = this.vehicle_name;
        data["volume"] = this.volume;
        data["volume_unit"] = this.volume_unit;
        data["weight"] = this.weight;
        data["weight_unit"] = this.weight_unit;
        return data;
    }
}

export interface ITransportModel {
    createdDate?: Date | undefined;
    assigned_carrier_id?: number | undefined;
    assigned_carrier_name?: string | undefined;
    assigned_creditor_number?: string | undefined;
    attachments?: AttachmentModel[] | undefined;
    auction_comment?: string | undefined;
    auction_comment_plain_text?: string | undefined;
    auction_end_date?: Date | undefined;
    auction_end_time?: string | undefined;
    auction_offer_edit_end_date?: Date | undefined;
    auction_offer_edit_end_time?: string | undefined;
    auction_offer_withdrawal_end_date?: Date | undefined;
    auction_offer_withdrawal_end_time?: string | undefined;
    auction_start_date?: Date | undefined;
    auction_start_time?: string | undefined;
    bookings?: BookingModel[] | undefined;
    carrier_disponent_email?: string | undefined;
    carrier_disponent_id?: number | undefined;
    carrier_disponent_name?: string | undefined;
    carrier_number?: string | undefined;
    changed?: number | undefined;
    comment?: string | undefined;
    comment_plain_text?: string | undefined;
    company_address?: string | undefined;
    company_city?: string | undefined;
    company_country_id?: string | undefined;
    company_id?: number | undefined;
    company_name?: string | undefined;
    company_region?: string | undefined;
    company_zip_address?: string | undefined;
    contacts?: ContactModel[] | undefined;
    currency_id?: string | undefined;
    disponent_firstname?: string | undefined;
    disponent_id?: number | undefined;
    disponent_lastname?: string | undefined;
    disponent_phone?: string | undefined;
    document_reference?: string | undefined;
    end_city?: string | undefined;
    end_country_id?: string | undefined;
    end_date?: Date | undefined;
    end_region?: string | undefined;
    end_time?: string | undefined;
    end_zip?: string | undefined;
    external_transport_number?: string | undefined;
    handling_units?: HandlingUnitModel[] | undefined;
    id?: number;
    internal_comment?: string | undefined;
    length?: number | undefined;
    length_unit?: string | undefined;
    loading_datetime_offer_requested?: boolean | undefined;
    number?: string | undefined;
    offer?: OfferModel[] | undefined;
    offer_price_disabled?: boolean | undefined;
    owner?: string | undefined;
    parameters?: ParameterModel[] | undefined;
    partial_accept?: number | undefined;
    plant?: string | undefined;
    price_additional1?: number | undefined;
    price_additional1_desc?: string | undefined;
    price_additional2?: number | undefined;
    price_additional2_desc?: string | undefined;
    price_additional3?: number | undefined;
    price_additional3_desc?: string | undefined;
    price_basic?: number | undefined;
    price_max?: number | undefined;
    price_min?: number | undefined;
    price_offered?: number | undefined;
    qualifier?: string | undefined;
    required_delivery_item_fields?: RequiredDeliveryItemFieldsModel | undefined;
    required_delivery_parameters?: RequiredDeliveryParametersModel[] | undefined;
    required_offer_parameters?: RequiredOfferParameterModel[] | undefined;
    required_price_components?: RequiredPriceComponentModel[] | undefined;
    required_transport_parameters?: RequiredTransportParameterModel[] | undefined;
    route?: number | undefined;
    route_unit?: string | undefined;
    shadow_nto?: number | undefined;
    shipments?: ShipmentModel[] | undefined;
    start_city?: string | undefined;
    start_country_id?: string | undefined;
    start_date?: Date | undefined;
    start_region?: string | undefined;
    start_time?: string | undefined;
    start_zip?: string | undefined;
    status?: string | undefined;
    stops?: StopModel[] | undefined;
    storage_position_count?: number | undefined;
    timestamp?: Date | undefined;
    tpw_link?: string | undefined;
    transport_group_id?: string | undefined;
    tsm_light_login_link?: string | undefined;
    unloading_datetime_offer_requested?: boolean | undefined;
    vehicle_id?: string | undefined;
    vehicle_name?: string | undefined;
    volume?: number | undefined;
    volume_unit?: string | undefined;
    weight?: number | undefined;
    weight_unit?: string | undefined;
}

export class AttachmentModel implements IAttachmentModel {
    description?: string | undefined;
    link?: string | undefined;
    shipmentNumber?: string | undefined;

    constructor(data?: IAttachmentModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.description = _data["description"];
            this.link = _data["link"];
            this.shipmentNumber = _data["shipmentNumber"];
        }
    }

    static fromJS(data: any): AttachmentModel {
        data = typeof data === 'object' ? data : {};
        let result = new AttachmentModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["description"] = this.description;
        data["link"] = this.link;
        data["shipmentNumber"] = this.shipmentNumber;
        return data;
    }
}

export interface IAttachmentModel {
    description?: string | undefined;
    link?: string | undefined;
    shipmentNumber?: string | undefined;
}

export class BookingModel implements IBookingModel {
    bookingId?: number | undefined;
    dateTimeBegin?: Date | undefined;
    dateTimeEnd?: Date | undefined;
    dispatchStatusList?: DispatchStatusModel[] | undefined;
    extensionList?: ExtensionModel[] | undefined;
    gate?: string | undefined;
    licencePlate?: string | undefined;
    loading_type?: string | undefined;
    location?: string | undefined;

    constructor(data?: IBookingModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.bookingId = _data["bookingId"];
            this.dateTimeBegin = _data["dateTimeBegin"] ? new Date(_data["dateTimeBegin"].toString()) : <any>undefined;
            this.dateTimeEnd = _data["dateTimeEnd"] ? new Date(_data["dateTimeEnd"].toString()) : <any>undefined;
            if (Array.isArray(_data["dispatchStatusList"])) {
                this.dispatchStatusList = [] as any;
                for (let item of _data["dispatchStatusList"])
                    this.dispatchStatusList!.push(DispatchStatusModel.fromJS(item));
            }
            if (Array.isArray(_data["extensionList"])) {
                this.extensionList = [] as any;
                for (let item of _data["extensionList"])
                    this.extensionList!.push(ExtensionModel.fromJS(item));
            }
            this.gate = _data["gate"];
            this.licencePlate = _data["licencePlate"];
            this.loading_type = _data["loading_type"];
            this.location = _data["location"];
        }
    }

    static fromJS(data: any): BookingModel {
        data = typeof data === 'object' ? data : {};
        let result = new BookingModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["bookingId"] = this.bookingId;
        data["dateTimeBegin"] = this.dateTimeBegin ? this.dateTimeBegin.toISOString() : <any>undefined;
        data["dateTimeEnd"] = this.dateTimeEnd ? this.dateTimeEnd.toISOString() : <any>undefined;
        if (Array.isArray(this.dispatchStatusList)) {
            data["dispatchStatusList"] = [];
            for (let item of this.dispatchStatusList)
                data["dispatchStatusList"].push(item.toJSON());
        }
        if (Array.isArray(this.extensionList)) {
            data["extensionList"] = [];
            for (let item of this.extensionList)
                data["extensionList"].push(item.toJSON());
        }
        data["gate"] = this.gate;
        data["licencePlate"] = this.licencePlate;
        data["loading_type"] = this.loading_type;
        data["location"] = this.location;
        return data;
    }
}

export interface IBookingModel {
    bookingId?: number | undefined;
    dateTimeBegin?: Date | undefined;
    dateTimeEnd?: Date | undefined;
    dispatchStatusList?: DispatchStatusModel[] | undefined;
    extensionList?: ExtensionModel[] | undefined;
    gate?: string | undefined;
    licencePlate?: string | undefined;
    loading_type?: string | undefined;
    location?: string | undefined;
}

export class DispatchStatusModel implements IDispatchStatusModel {
    qualifier?: string | undefined;
    timestamp?: Date | undefined;

    constructor(data?: IDispatchStatusModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.qualifier = _data["qualifier"];
            this.timestamp = _data["timestamp"] ? new Date(_data["timestamp"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): DispatchStatusModel {
        data = typeof data === 'object' ? data : {};
        let result = new DispatchStatusModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["qualifier"] = this.qualifier;
        data["timestamp"] = this.timestamp ? this.timestamp.toISOString() : <any>undefined;
        return data;
    }
}

export interface IDispatchStatusModel {
    qualifier?: string | undefined;
    timestamp?: Date | undefined;
}

export class ExtensionModel implements IExtensionModel {
    qualifier?: string | undefined;
    value?: string | undefined;

    constructor(data?: IExtensionModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.qualifier = _data["qualifier"];
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): ExtensionModel {
        data = typeof data === 'object' ? data : {};
        let result = new ExtensionModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["qualifier"] = this.qualifier;
        data["value"] = this.value;
        return data;
    }
}

export interface IExtensionModel {
    qualifier?: string | undefined;
    value?: string | undefined;
}

export class ContactModel implements IContactModel {
    city?: string | undefined;
    country_id?: string | undefined;
    email?: string | undefined;
    name?: string | undefined;
    phone?: string | undefined;
    region?: string | undefined;
    street?: string | undefined;
    type?: string | undefined;
    zip?: string | undefined;

    constructor(data?: IContactModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.city = _data["city"];
            this.country_id = _data["country_id"];
            this.email = _data["email"];
            this.name = _data["name"];
            this.phone = _data["phone"];
            this.region = _data["region"];
            this.street = _data["street"];
            this.type = _data["type"];
            this.zip = _data["zip"];
        }
    }

    static fromJS(data: any): ContactModel {
        data = typeof data === 'object' ? data : {};
        let result = new ContactModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["city"] = this.city;
        data["country_id"] = this.country_id;
        data["email"] = this.email;
        data["name"] = this.name;
        data["phone"] = this.phone;
        data["region"] = this.region;
        data["street"] = this.street;
        data["type"] = this.type;
        data["zip"] = this.zip;
        return data;
    }
}

export interface IContactModel {
    city?: string | undefined;
    country_id?: string | undefined;
    email?: string | undefined;
    name?: string | undefined;
    phone?: string | undefined;
    region?: string | undefined;
    street?: string | undefined;
    type?: string | undefined;
    zip?: string | undefined;
}

export class HandlingUnitModel implements IHandlingUnitModel {
    amount?: number | undefined;
    qualifier?: string | undefined;

    constructor(data?: IHandlingUnitModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.amount = _data["amount"];
            this.qualifier = _data["qualifier"];
        }
    }

    static fromJS(data: any): HandlingUnitModel {
        data = typeof data === 'object' ? data : {};
        let result = new HandlingUnitModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["amount"] = this.amount;
        data["qualifier"] = this.qualifier;
        return data;
    }
}

export interface IHandlingUnitModel {
    amount?: number | undefined;
    qualifier?: string | undefined;
}

export class OfferModel implements IOfferModel {
    additional_expenses_included?: string | undefined;
    binding_until_date?: string | undefined;
    binding_until_time?: string | undefined;
    comment?: string | undefined;
    comment_plain_text?: string | undefined;
    creditor_number?: string | undefined;
    currency_id?: string | undefined;
    disponent_name?: string | undefined;
    id?: number | undefined;
    price?: number | undefined;
    qualifier?: string | undefined;
    timestamp?: Date | undefined;
    tour_id?: number | undefined;

    constructor(data?: IOfferModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.additional_expenses_included = _data["additional_expenses_included"];
            this.binding_until_date = _data["binding_until_date"];
            this.binding_until_time = _data["binding_until_time"];
            this.comment = _data["comment"];
            this.comment_plain_text = _data["comment_plain_text"];
            this.creditor_number = _data["creditor_number"];
            this.currency_id = _data["currency_id"];
            this.disponent_name = _data["disponent_name"];
            this.id = _data["id"];
            this.price = _data["price"];
            this.qualifier = _data["qualifier"];
            this.timestamp = _data["timestamp"] ? new Date(_data["timestamp"].toString()) : <any>undefined;
            this.tour_id = _data["tour_id"];
        }
    }

    static fromJS(data: any): OfferModel {
        data = typeof data === 'object' ? data : {};
        let result = new OfferModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["additional_expenses_included"] = this.additional_expenses_included;
        data["binding_until_date"] = this.binding_until_date;
        data["binding_until_time"] = this.binding_until_time;
        data["comment"] = this.comment;
        data["comment_plain_text"] = this.comment_plain_text;
        data["creditor_number"] = this.creditor_number;
        data["currency_id"] = this.currency_id;
        data["disponent_name"] = this.disponent_name;
        data["id"] = this.id;
        data["price"] = this.price;
        data["qualifier"] = this.qualifier;
        data["timestamp"] = this.timestamp ? this.timestamp.toISOString() : <any>undefined;
        data["tour_id"] = this.tour_id;
        return data;
    }
}

export interface IOfferModel {
    additional_expenses_included?: string | undefined;
    binding_until_date?: string | undefined;
    binding_until_time?: string | undefined;
    comment?: string | undefined;
    comment_plain_text?: string | undefined;
    creditor_number?: string | undefined;
    currency_id?: string | undefined;
    disponent_name?: string | undefined;
    id?: number | undefined;
    price?: number | undefined;
    qualifier?: string | undefined;
    timestamp?: Date | undefined;
    tour_id?: number | undefined;
}

export class ParameterModel implements IParameterModel {
    description?: string | undefined;
    editable?: string | undefined;
    mandatory?: boolean | undefined;
    qualifier?: string | undefined;
    value?: string | undefined;

    constructor(data?: IParameterModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.description = _data["description"];
            this.editable = _data["editable"];
            this.mandatory = _data["mandatory"];
            this.qualifier = _data["qualifier"];
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): ParameterModel {
        data = typeof data === 'object' ? data : {};
        let result = new ParameterModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["description"] = this.description;
        data["editable"] = this.editable;
        data["mandatory"] = this.mandatory;
        data["qualifier"] = this.qualifier;
        data["value"] = this.value;
        return data;
    }
}

export interface IParameterModel {
    description?: string | undefined;
    editable?: string | undefined;
    mandatory?: boolean | undefined;
    qualifier?: string | undefined;
    value?: string | undefined;
}

export class RequiredDeliveryItemFieldsModel implements IRequiredDeliveryItemFieldsModel {
    parameters?: RequiredDeliveryItemFieldsParametersModel[] | undefined;
    quantities?: RequiredDeliveryItemFieldsQuantitiesModel[] | undefined;

    constructor(data?: IRequiredDeliveryItemFieldsModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["parameters"])) {
                this.parameters = [] as any;
                for (let item of _data["parameters"])
                    this.parameters!.push(RequiredDeliveryItemFieldsParametersModel.fromJS(item));
            }
            if (Array.isArray(_data["quantities"])) {
                this.quantities = [] as any;
                for (let item of _data["quantities"])
                    this.quantities!.push(RequiredDeliveryItemFieldsQuantitiesModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): RequiredDeliveryItemFieldsModel {
        data = typeof data === 'object' ? data : {};
        let result = new RequiredDeliveryItemFieldsModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.parameters)) {
            data["parameters"] = [];
            for (let item of this.parameters)
                data["parameters"].push(item.toJSON());
        }
        if (Array.isArray(this.quantities)) {
            data["quantities"] = [];
            for (let item of this.quantities)
                data["quantities"].push(item.toJSON());
        }
        return data;
    }
}

export interface IRequiredDeliveryItemFieldsModel {
    parameters?: RequiredDeliveryItemFieldsParametersModel[] | undefined;
    quantities?: RequiredDeliveryItemFieldsQuantitiesModel[] | undefined;
}

export class RequiredDeliveryItemFieldsParametersModel implements IRequiredDeliveryItemFieldsParametersModel {
    qualifier?: string | undefined;

    constructor(data?: IRequiredDeliveryItemFieldsParametersModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.qualifier = _data["qualifier"];
        }
    }

    static fromJS(data: any): RequiredDeliveryItemFieldsParametersModel {
        data = typeof data === 'object' ? data : {};
        let result = new RequiredDeliveryItemFieldsParametersModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["qualifier"] = this.qualifier;
        return data;
    }
}

export interface IRequiredDeliveryItemFieldsParametersModel {
    qualifier?: string | undefined;
}

export class RequiredDeliveryItemFieldsQuantitiesModel implements IRequiredDeliveryItemFieldsQuantitiesModel {
    qualifier?: string | undefined;

    constructor(data?: IRequiredDeliveryItemFieldsQuantitiesModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.qualifier = _data["qualifier"];
        }
    }

    static fromJS(data: any): RequiredDeliveryItemFieldsQuantitiesModel {
        data = typeof data === 'object' ? data : {};
        let result = new RequiredDeliveryItemFieldsQuantitiesModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["qualifier"] = this.qualifier;
        return data;
    }
}

export interface IRequiredDeliveryItemFieldsQuantitiesModel {
    qualifier?: string | undefined;
}

export class RequiredDeliveryParametersModel implements IRequiredDeliveryParametersModel {
    editable?: string | undefined;
    mandatory?: boolean | undefined;
    qualifier?: string | undefined;

    constructor(data?: IRequiredDeliveryParametersModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.editable = _data["editable"];
            this.mandatory = _data["mandatory"];
            this.qualifier = _data["qualifier"];
        }
    }

    static fromJS(data: any): RequiredDeliveryParametersModel {
        data = typeof data === 'object' ? data : {};
        let result = new RequiredDeliveryParametersModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["editable"] = this.editable;
        data["mandatory"] = this.mandatory;
        data["qualifier"] = this.qualifier;
        return data;
    }
}

export interface IRequiredDeliveryParametersModel {
    editable?: string | undefined;
    mandatory?: boolean | undefined;
    qualifier?: string | undefined;
}

export class RequiredOfferParameterModel implements IRequiredOfferParameterModel {
    qualifier?: string | undefined;
    optional?: boolean | undefined;

    constructor(data?: IRequiredOfferParameterModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.qualifier = _data["qualifier"];
            this.optional = _data["optional"];
        }
    }

    static fromJS(data: any): RequiredOfferParameterModel {
        data = typeof data === 'object' ? data : {};
        let result = new RequiredOfferParameterModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["qualifier"] = this.qualifier;
        data["optional"] = this.optional;
        return data;
    }
}

export interface IRequiredOfferParameterModel {
    qualifier?: string | undefined;
    optional?: boolean | undefined;
}

export class RequiredPriceComponentModel implements IRequiredPriceComponentModel {
    name?: string | undefined;
    optional?: boolean | undefined;
    parameters?: ParametersModel[] | undefined;
    qualifier?: string | undefined;

    constructor(data?: IRequiredPriceComponentModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.optional = _data["optional"];
            if (Array.isArray(_data["parameters"])) {
                this.parameters = [] as any;
                for (let item of _data["parameters"])
                    this.parameters!.push(ParametersModel.fromJS(item));
            }
            this.qualifier = _data["qualifier"];
        }
    }

    static fromJS(data: any): RequiredPriceComponentModel {
        data = typeof data === 'object' ? data : {};
        let result = new RequiredPriceComponentModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["optional"] = this.optional;
        if (Array.isArray(this.parameters)) {
            data["parameters"] = [];
            for (let item of this.parameters)
                data["parameters"].push(item.toJSON());
        }
        data["qualifier"] = this.qualifier;
        return data;
    }
}

export interface IRequiredPriceComponentModel {
    name?: string | undefined;
    optional?: boolean | undefined;
    parameters?: ParametersModel[] | undefined;
    qualifier?: string | undefined;
}

export class ParametersModel implements IParametersModel {
    description?: string | undefined;
    editable?: string | undefined;
    mandatory?: boolean | undefined;
    qualifier?: string | undefined;
    value?: string | undefined;

    constructor(data?: IParametersModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.description = _data["description"];
            this.editable = _data["editable"];
            this.mandatory = _data["mandatory"];
            this.qualifier = _data["qualifier"];
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): ParametersModel {
        data = typeof data === 'object' ? data : {};
        let result = new ParametersModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["description"] = this.description;
        data["editable"] = this.editable;
        data["mandatory"] = this.mandatory;
        data["qualifier"] = this.qualifier;
        data["value"] = this.value;
        return data;
    }
}

export interface IParametersModel {
    description?: string | undefined;
    editable?: string | undefined;
    mandatory?: boolean | undefined;
    qualifier?: string | undefined;
    value?: string | undefined;
}

export class RequiredTransportParameterModel implements IRequiredTransportParameterModel {
    editable?: string | undefined;
    mandatory?: boolean | undefined;
    qualifier?: string | undefined;

    constructor(data?: IRequiredTransportParameterModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.editable = _data["editable"];
            this.mandatory = _data["mandatory"];
            this.qualifier = _data["qualifier"];
        }
    }

    static fromJS(data: any): RequiredTransportParameterModel {
        data = typeof data === 'object' ? data : {};
        let result = new RequiredTransportParameterModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["editable"] = this.editable;
        data["mandatory"] = this.mandatory;
        data["qualifier"] = this.qualifier;
        return data;
    }
}

export interface IRequiredTransportParameterModel {
    editable?: string | undefined;
    mandatory?: boolean | undefined;
    qualifier?: string | undefined;
}

export class ShipmentModel implements IShipmentModel {
    comment?: string | undefined;
    comment_plain_text?: string | undefined;
    customer_name?: string | undefined;
    customer_number?: string | undefined;
    dlclass?: string | undefined;
    dlnumber?: string | undefined;
    faktura?: string | undefined;
    handling_units?: HandlingUnitModel[] | undefined;
    id?: number | undefined;
    index?: number | undefined;
    items?: ItemModel[] | undefined;
    length?: number | undefined;
    length_unit?: string | undefined;
    loading_stop_ids?: string[] | undefined;
    number?: string | undefined;
    owner?: string | undefined;
    parameters?: ParametersModel[] | undefined;
    route?: number | undefined;
    route_unit?: string | undefined;
    stations?: StationModel[] | undefined;
    storage_position_count?: number | undefined;
    tour_id?: number | undefined;
    unloading_stop_ids?: string[] | undefined;
    vehicle_id?: string | undefined;
    vehicle_name?: string | undefined;
    volume?: number | undefined;
    volume_unit?: string | undefined;
    weight?: number | undefined;
    weight_unit?: string | undefined;

    constructor(data?: IShipmentModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.comment = _data["comment"];
            this.comment_plain_text = _data["comment_plain_text"];
            this.customer_name = _data["customer_name"];
            this.customer_number = _data["customer_number"];
            this.dlclass = _data["dlclass"];
            this.dlnumber = _data["dlnumber"];
            this.faktura = _data["faktura"];
            if (Array.isArray(_data["handling_units"])) {
                this.handling_units = [] as any;
                for (let item of _data["handling_units"])
                    this.handling_units!.push(HandlingUnitModel.fromJS(item));
            }
            this.id = _data["id"];
            this.index = _data["index"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(ItemModel.fromJS(item));
            }
            this.length = _data["length"];
            this.length_unit = _data["length_unit"];
            if (Array.isArray(_data["loading_stop_ids"])) {
                this.loading_stop_ids = [] as any;
                for (let item of _data["loading_stop_ids"])
                    this.loading_stop_ids!.push(item);
            }
            this.number = _data["number"];
            this.owner = _data["owner"];
            if (Array.isArray(_data["parameters"])) {
                this.parameters = [] as any;
                for (let item of _data["parameters"])
                    this.parameters!.push(ParametersModel.fromJS(item));
            }
            this.route = _data["route"];
            this.route_unit = _data["route_unit"];
            if (Array.isArray(_data["stations"])) {
                this.stations = [] as any;
                for (let item of _data["stations"])
                    this.stations!.push(StationModel.fromJS(item));
            }
            this.storage_position_count = _data["storage_position_count"];
            this.tour_id = _data["tour_id"];
            if (Array.isArray(_data["unloading_stop_ids"])) {
                this.unloading_stop_ids = [] as any;
                for (let item of _data["unloading_stop_ids"])
                    this.unloading_stop_ids!.push(item);
            }
            this.vehicle_id = _data["vehicle_id"];
            this.vehicle_name = _data["vehicle_name"];
            this.volume = _data["volume"];
            this.volume_unit = _data["volume_unit"];
            this.weight = _data["weight"];
            this.weight_unit = _data["weight_unit"];
        }
    }

    static fromJS(data: any): ShipmentModel {
        data = typeof data === 'object' ? data : {};
        let result = new ShipmentModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["comment"] = this.comment;
        data["comment_plain_text"] = this.comment_plain_text;
        data["customer_name"] = this.customer_name;
        data["customer_number"] = this.customer_number;
        data["dlclass"] = this.dlclass;
        data["dlnumber"] = this.dlnumber;
        data["faktura"] = this.faktura;
        if (Array.isArray(this.handling_units)) {
            data["handling_units"] = [];
            for (let item of this.handling_units)
                data["handling_units"].push(item.toJSON());
        }
        data["id"] = this.id;
        data["index"] = this.index;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["length"] = this.length;
        data["length_unit"] = this.length_unit;
        if (Array.isArray(this.loading_stop_ids)) {
            data["loading_stop_ids"] = [];
            for (let item of this.loading_stop_ids)
                data["loading_stop_ids"].push(item);
        }
        data["number"] = this.number;
        data["owner"] = this.owner;
        if (Array.isArray(this.parameters)) {
            data["parameters"] = [];
            for (let item of this.parameters)
                data["parameters"].push(item.toJSON());
        }
        data["route"] = this.route;
        data["route_unit"] = this.route_unit;
        if (Array.isArray(this.stations)) {
            data["stations"] = [];
            for (let item of this.stations)
                data["stations"].push(item.toJSON());
        }
        data["storage_position_count"] = this.storage_position_count;
        data["tour_id"] = this.tour_id;
        if (Array.isArray(this.unloading_stop_ids)) {
            data["unloading_stop_ids"] = [];
            for (let item of this.unloading_stop_ids)
                data["unloading_stop_ids"].push(item);
        }
        data["vehicle_id"] = this.vehicle_id;
        data["vehicle_name"] = this.vehicle_name;
        data["volume"] = this.volume;
        data["volume_unit"] = this.volume_unit;
        data["weight"] = this.weight;
        data["weight_unit"] = this.weight_unit;
        return data;
    }
}

export interface IShipmentModel {
    comment?: string | undefined;
    comment_plain_text?: string | undefined;
    customer_name?: string | undefined;
    customer_number?: string | undefined;
    dlclass?: string | undefined;
    dlnumber?: string | undefined;
    faktura?: string | undefined;
    handling_units?: HandlingUnitModel[] | undefined;
    id?: number | undefined;
    index?: number | undefined;
    items?: ItemModel[] | undefined;
    length?: number | undefined;
    length_unit?: string | undefined;
    loading_stop_ids?: string[] | undefined;
    number?: string | undefined;
    owner?: string | undefined;
    parameters?: ParametersModel[] | undefined;
    route?: number | undefined;
    route_unit?: string | undefined;
    stations?: StationModel[] | undefined;
    storage_position_count?: number | undefined;
    tour_id?: number | undefined;
    unloading_stop_ids?: string[] | undefined;
    vehicle_id?: string | undefined;
    vehicle_name?: string | undefined;
    volume?: number | undefined;
    volume_unit?: string | undefined;
    weight?: number | undefined;
    weight_unit?: string | undefined;
}

export class ItemModel implements IItemModel {
    description?: string | undefined;
    id?: string | undefined;
    material_number?: string | undefined;
    parameters?: ParametersModel[] | undefined;
    pos_index?: number | undefined;
    pos_number?: string | undefined;
    quantities?: QuantitieModel[] | undefined;
    short_description?: string | undefined;

    constructor(data?: IItemModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.description = _data["description"];
            this.id = _data["id"];
            this.material_number = _data["material_number"];
            if (Array.isArray(_data["parameters"])) {
                this.parameters = [] as any;
                for (let item of _data["parameters"])
                    this.parameters!.push(ParametersModel.fromJS(item));
            }
            this.pos_index = _data["pos_index"];
            this.pos_number = _data["pos_number"];
            if (Array.isArray(_data["quantities"])) {
                this.quantities = [] as any;
                for (let item of _data["quantities"])
                    this.quantities!.push(QuantitieModel.fromJS(item));
            }
            this.short_description = _data["short_description"];
        }
    }

    static fromJS(data: any): ItemModel {
        data = typeof data === 'object' ? data : {};
        let result = new ItemModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["description"] = this.description;
        data["id"] = this.id;
        data["material_number"] = this.material_number;
        if (Array.isArray(this.parameters)) {
            data["parameters"] = [];
            for (let item of this.parameters)
                data["parameters"].push(item.toJSON());
        }
        data["pos_index"] = this.pos_index;
        data["pos_number"] = this.pos_number;
        if (Array.isArray(this.quantities)) {
            data["quantities"] = [];
            for (let item of this.quantities)
                data["quantities"].push(item.toJSON());
        }
        data["short_description"] = this.short_description;
        return data;
    }
}

export interface IItemModel {
    description?: string | undefined;
    id?: string | undefined;
    material_number?: string | undefined;
    parameters?: ParametersModel[] | undefined;
    pos_index?: number | undefined;
    pos_number?: string | undefined;
    quantities?: QuantitieModel[] | undefined;
    short_description?: string | undefined;
}

export class QuantitieModel implements IQuantitieModel {
    qualifier?: string | undefined;
    unit?: string | undefined;
    value?: number | undefined;

    constructor(data?: IQuantitieModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.qualifier = _data["qualifier"];
            this.unit = _data["unit"];
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): QuantitieModel {
        data = typeof data === 'object' ? data : {};
        let result = new QuantitieModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["qualifier"] = this.qualifier;
        data["unit"] = this.unit;
        data["value"] = this.value;
        return data;
    }
}

export interface IQuantitieModel {
    qualifier?: string | undefined;
    unit?: string | undefined;
    value?: number | undefined;
}

export class StationModel implements IStationModel {
    address?: string | undefined;
    avis?: string | undefined;
    city?: string | undefined;
    comment?: string | undefined;
    comment_plain_text?: string | undefined;
    company_name?: string | undefined;
    country_id?: string | undefined;
    fixed_date_loading?: Date | undefined;
    fixed_date_unloading?: Date | undefined;
    from_date?: Date | undefined;
    from_time?: string | undefined;
    id?: string | undefined;
    loading_name?: string | undefined;
    loadingramp?: string | undefined;
    region?: string | undefined;
    shipment_id?: string | undefined;
    transportunit_count?: number | undefined;
    transportunit_exchange?: boolean | undefined;
    transportunit_name?: string | undefined;
    transportunit_pileable?: boolean | undefined;
    type?: string | undefined;
    until_date?: Date | undefined;
    until_time?: string | undefined;
    zip?: string | undefined;

    constructor(data?: IStationModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.address = _data["address"];
            this.avis = _data["avis"];
            this.city = _data["city"];
            this.comment = _data["comment"];
            this.comment_plain_text = _data["comment_plain_text"];
            this.company_name = _data["company_name"];
            this.country_id = _data["country_id"];
            this.fixed_date_loading = _data["fixed_date_loading"] ? new Date(_data["fixed_date_loading"].toString()) : <any>undefined;
            this.fixed_date_unloading = _data["fixed_date_unloading"] ? new Date(_data["fixed_date_unloading"].toString()) : <any>undefined;
            this.from_date = _data["from_date"] ? new Date(_data["from_date"].toString()) : <any>undefined;
            this.from_time = _data["from_time"];
            this.id = _data["id"];
            this.loading_name = _data["loading_name"];
            this.loadingramp = _data["loadingramp"];
            this.region = _data["region"];
            this.shipment_id = _data["shipment_id"];
            this.transportunit_count = _data["transportunit_count"];
            this.transportunit_exchange = _data["transportunit_exchange"];
            this.transportunit_name = _data["transportunit_name"];
            this.transportunit_pileable = _data["transportunit_pileable"];
            this.type = _data["type"];
            this.until_date = _data["until_date"] ? new Date(_data["until_date"].toString()) : <any>undefined;
            this.until_time = _data["until_time"];
            this.zip = _data["zip"];
        }
    }

    static fromJS(data: any): StationModel {
        data = typeof data === 'object' ? data : {};
        let result = new StationModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["address"] = this.address;
        data["avis"] = this.avis;
        data["city"] = this.city;
        data["comment"] = this.comment;
        data["comment_plain_text"] = this.comment_plain_text;
        data["company_name"] = this.company_name;
        data["country_id"] = this.country_id;
        data["fixed_date_loading"] = this.fixed_date_loading ? this.fixed_date_loading.toISOString() : <any>undefined;
        data["fixed_date_unloading"] = this.fixed_date_unloading ? this.fixed_date_unloading.toISOString() : <any>undefined;
        data["from_date"] = this.from_date ? this.from_date.toISOString() : <any>undefined;
        data["from_time"] = this.from_time;
        data["id"] = this.id;
        data["loading_name"] = this.loading_name;
        data["loadingramp"] = this.loadingramp;
        data["region"] = this.region;
        data["shipment_id"] = this.shipment_id;
        data["transportunit_count"] = this.transportunit_count;
        data["transportunit_exchange"] = this.transportunit_exchange;
        data["transportunit_name"] = this.transportunit_name;
        data["transportunit_pileable"] = this.transportunit_pileable;
        data["type"] = this.type;
        data["until_date"] = this.until_date ? this.until_date.toISOString() : <any>undefined;
        data["until_time"] = this.until_time;
        data["zip"] = this.zip;
        return data;
    }
}

export interface IStationModel {
    address?: string | undefined;
    avis?: string | undefined;
    city?: string | undefined;
    comment?: string | undefined;
    comment_plain_text?: string | undefined;
    company_name?: string | undefined;
    country_id?: string | undefined;
    fixed_date_loading?: Date | undefined;
    fixed_date_unloading?: Date | undefined;
    from_date?: Date | undefined;
    from_time?: string | undefined;
    id?: string | undefined;
    loading_name?: string | undefined;
    loadingramp?: string | undefined;
    region?: string | undefined;
    shipment_id?: string | undefined;
    transportunit_count?: number | undefined;
    transportunit_exchange?: boolean | undefined;
    transportunit_name?: string | undefined;
    transportunit_pileable?: boolean | undefined;
    type?: string | undefined;
    until_date?: Date | undefined;
    until_time?: string | undefined;
    zip?: string | undefined;
}

export class StopModel implements IStopModel {
    date_time_period?: DateTimePeriodModel | undefined;
    id?: string | undefined;
    index?: number | undefined;
    location?: LocationModel | undefined;

    constructor(data?: IStopModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.date_time_period = _data["date_time_period"] ? DateTimePeriodModel.fromJS(_data["date_time_period"]) : <any>undefined;
            this.id = _data["id"];
            this.index = _data["index"];
            this.location = _data["location"] ? LocationModel.fromJS(_data["location"]) : <any>undefined;
        }
    }

    static fromJS(data: any): StopModel {
        data = typeof data === 'object' ? data : {};
        let result = new StopModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["date_time_period"] = this.date_time_period ? this.date_time_period.toJSON() : <any>undefined;
        data["id"] = this.id;
        data["index"] = this.index;
        data["location"] = this.location ? this.location.toJSON() : <any>undefined;
        return data;
    }
}

export interface IStopModel {
    date_time_period?: DateTimePeriodModel | undefined;
    id?: string | undefined;
    index?: number | undefined;
    location?: LocationModel | undefined;
}

export class DateTimePeriodModel implements IDateTimePeriodModel {
    end?: Date | undefined;
    start?: Date | undefined;
    timezone?: string | undefined;

    constructor(data?: IDateTimePeriodModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.end = _data["end"] ? new Date(_data["end"].toString()) : <any>undefined;
            this.start = _data["start"] ? new Date(_data["start"].toString()) : <any>undefined;
            this.timezone = _data["timezone"];
        }
    }

    static fromJS(data: any): DateTimePeriodModel {
        data = typeof data === 'object' ? data : {};
        let result = new DateTimePeriodModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["end"] = this.end ? this.end.toISOString() : <any>undefined;
        data["start"] = this.start ? this.start.toISOString() : <any>undefined;
        data["timezone"] = this.timezone;
        return data;
    }
}

export interface IDateTimePeriodModel {
    end?: Date | undefined;
    start?: Date | undefined;
    timezone?: string | undefined;
}

export class LocationModel implements ILocationModel {
    address?: string | undefined;
    avis?: string | undefined;
    city?: string | undefined;
    comment?: string | undefined;
    company_name?: string | undefined;
    country_id?: string | undefined;
    latitude?: number | undefined;
    longitude?: number | undefined;
    zip?: string | undefined;

    constructor(data?: ILocationModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.address = _data["address"];
            this.avis = _data["avis"];
            this.city = _data["city"];
            this.comment = _data["comment"];
            this.company_name = _data["company_name"];
            this.country_id = _data["country_id"];
            this.latitude = _data["latitude"];
            this.longitude = _data["longitude"];
            this.zip = _data["zip"];
        }
    }

    static fromJS(data: any): LocationModel {
        data = typeof data === 'object' ? data : {};
        let result = new LocationModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["address"] = this.address;
        data["avis"] = this.avis;
        data["city"] = this.city;
        data["comment"] = this.comment;
        data["company_name"] = this.company_name;
        data["country_id"] = this.country_id;
        data["latitude"] = this.latitude;
        data["longitude"] = this.longitude;
        data["zip"] = this.zip;
        return data;
    }
}

export interface ILocationModel {
    address?: string | undefined;
    avis?: string | undefined;
    city?: string | undefined;
    comment?: string | undefined;
    company_name?: string | undefined;
    country_id?: string | undefined;
    latitude?: number | undefined;
    longitude?: number | undefined;
    zip?: string | undefined;
}

export class GetTransportQuery extends PagedListingRequest implements IGetTransportQuery {

    constructor(data?: IGetTransportQuery) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): GetTransportQuery {
        data = typeof data === 'object' ? data : {};
        let result = new GetTransportQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IGetTransportQuery extends IPagedListingRequest {
}

export class UpdateTypeModel implements IUpdateTypeModel {
    id?: number;
    name?: string | undefined;

    constructor(data?: IUpdateTypeModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): UpdateTypeModel {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateTypeModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }
}

export interface IUpdateTypeModel {
    id?: number;
    name?: string | undefined;
}

export class UpdateTypeConnectionsModel implements IUpdateTypeConnectionsModel {
    id?: number;
    name?: string | undefined;
    parentId?: string | undefined;
    childId?: string | undefined;

    constructor(data?: IUpdateTypeConnectionsModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.parentId = _data["parentId"];
            this.childId = _data["childId"];
        }
    }

    static fromJS(data: any): UpdateTypeConnectionsModel {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateTypeConnectionsModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["parentId"] = this.parentId;
        data["childId"] = this.childId;
        return data;
    }
}

export interface IUpdateTypeConnectionsModel {
    id?: number;
    name?: string | undefined;
    parentId?: string | undefined;
    childId?: string | undefined;
}

export class IssuedTokenModel implements IIssuedTokenModel {
    token?: string | undefined;
    expiresIn?: number;

    constructor(data?: IIssuedTokenModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.token = _data["token"];
            this.expiresIn = _data["expiresIn"];
        }
    }

    static fromJS(data: any): IssuedTokenModel {
        data = typeof data === 'object' ? data : {};
        let result = new IssuedTokenModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["token"] = this.token;
        data["expiresIn"] = this.expiresIn;
        return data;
    }
}

export interface IIssuedTokenModel {
    token?: string | undefined;
    expiresIn?: number;
}

export class AuthenticateUserCommand implements IAuthenticateUserCommand {
    username?: string | undefined;
    password?: string | undefined;

    constructor(data?: IAuthenticateUserCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.username = _data["username"];
            this.password = _data["password"];
        }
    }

    static fromJS(data: any): AuthenticateUserCommand {
        data = typeof data === 'object' ? data : {};
        let result = new AuthenticateUserCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["username"] = this.username;
        data["password"] = this.password;
        return data;
    }
}

export interface IAuthenticateUserCommand {
    username?: string | undefined;
    password?: string | undefined;
}

export class CreateUserCommand implements ICreateUserCommand {
    username?: string | undefined;
    firstname?: string | undefined;
    lastname?: string | undefined;
    password?: string | undefined;
    email?: string | undefined;
    isActiveDirectoryUser?: boolean;
    roles?: RoleEnum[] | undefined;
    tenants?: string[] | undefined;
    reports?: any[] | undefined;
    customerId?: number[] | undefined;

    constructor(data?: ICreateUserCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.username = _data["username"];
            this.firstname = _data["firstname"];
            this.lastname = _data["lastname"];
            this.password = _data["password"];
            this.email = _data["email"];
            this.isActiveDirectoryUser = _data["isActiveDirectoryUser"];
            if (Array.isArray(_data["roles"])) {
                this.roles = [] as any;
                for (let item of _data["roles"])
                    this.roles!.push(item);
            }
            if (Array.isArray(_data["tenants"])) {
                this.tenants = [] as any;
                for (let item of _data["tenants"])
                    this.tenants!.push(item);
            }
            if (Array.isArray(_data["reports"])) {
                this.reports = [] as any;
                for (let item of _data["reports"])
                    this.reports!.push(item);
            }
            if (Array.isArray(_data["customerId"])) {
                this.customerId = [] as any;
                for (let item of _data["customerId"])
                    this.customerId!.push(item);
            }
        }
    }

    static fromJS(data: any): CreateUserCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreateUserCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["username"] = this.username;
        data["firstname"] = this.firstname;
        data["lastname"] = this.lastname;
        data["password"] = this.password;
        data["email"] = this.email;
        data["isActiveDirectoryUser"] = this.isActiveDirectoryUser;
        if (Array.isArray(this.roles)) {
            data["roles"] = [];
            for (let item of this.roles)
                data["roles"].push(item);
        }
        if (Array.isArray(this.tenants)) {
            data["tenants"] = [];
            for (let item of this.tenants)
                data["tenants"].push(item);
        }
        if (Array.isArray(this.reports)) {
            data["reports"] = [];
            for (let item of this.reports)
                data["reports"].push(item);
        }
        if (Array.isArray(this.customerId)) {
            data["customerId"] = [];
            for (let item of this.customerId)
                data["customerId"].push(item);
        }
        return data;
    }
}

export interface ICreateUserCommand {
    username?: string | undefined;
    firstname?: string | undefined;
    lastname?: string | undefined;
    password?: string | undefined;
    email?: string | undefined;
    isActiveDirectoryUser?: boolean;
    roles?: RoleEnum[] | undefined;
    tenants?: string[] | undefined;
    reports?: any[] | undefined;
    customerId?: number[] | undefined;
}

export class UpdateUserCommand implements IUpdateUserCommand {
    userId?: string;
    username?: string | undefined;
    firstname?: string | undefined;
    lastname?: string | undefined;
    email?: string | undefined;
    roles?: RoleEnum[] | undefined;
    tenants?: string[] | undefined;
    reports?: any[] | undefined;

    constructor(data?: IUpdateUserCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.username = _data["username"];
            this.firstname = _data["firstname"];
            this.lastname = _data["lastname"];
            this.email = _data["email"];
            if (Array.isArray(_data["roles"])) {
                this.roles = [] as any;
                for (let item of _data["roles"])
                    this.roles!.push(item);
            }
            if (Array.isArray(_data["tenants"])) {
                this.tenants = [] as any;
                for (let item of _data["tenants"])
                    this.tenants!.push(item);
            }
            if (Array.isArray(_data["reports"])) {
                this.reports = [] as any;
                for (let item of _data["reports"])
                    this.reports!.push(item);
            }
        }
    }

    static fromJS(data: any): UpdateUserCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateUserCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["username"] = this.username;
        data["firstname"] = this.firstname;
        data["lastname"] = this.lastname;
        data["email"] = this.email;
        if (Array.isArray(this.roles)) {
            data["roles"] = [];
            for (let item of this.roles)
                data["roles"].push(item);
        }
        if (Array.isArray(this.tenants)) {
            data["tenants"] = [];
            for (let item of this.tenants)
                data["tenants"].push(item);
        }
        if (Array.isArray(this.reports)) {
            data["reports"] = [];
            for (let item of this.reports)
                data["reports"].push(item);
        }
        return data;
    }
}

export interface IUpdateUserCommand {
    userId?: string;
    username?: string | undefined;
    firstname?: string | undefined;
    lastname?: string | undefined;
    email?: string | undefined;
    roles?: RoleEnum[] | undefined;
    tenants?: string[] | undefined;
    reports?: any[] | undefined;
}

export class ActiveDirectoryUserModel implements IActiveDirectoryUserModel {
    guid?: string | undefined;
    samAccountName?: string | undefined;
    userPrincipalName?: string | undefined;
    name?: string | undefined;
    givenName?: string | undefined;
    surname?: string | undefined;
    emailAddress?: string | undefined;
    isAccountLockedOut?: boolean;
    enabled?: boolean | undefined;

    constructor(data?: IActiveDirectoryUserModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.guid = _data["guid"];
            this.samAccountName = _data["samAccountName"];
            this.userPrincipalName = _data["userPrincipalName"];
            this.name = _data["name"];
            this.givenName = _data["givenName"];
            this.surname = _data["surname"];
            this.emailAddress = _data["emailAddress"];
            this.isAccountLockedOut = _data["isAccountLockedOut"];
            this.enabled = _data["enabled"];
        }
    }

    static fromJS(data: any): ActiveDirectoryUserModel {
        data = typeof data === 'object' ? data : {};
        let result = new ActiveDirectoryUserModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["guid"] = this.guid;
        data["samAccountName"] = this.samAccountName;
        data["userPrincipalName"] = this.userPrincipalName;
        data["name"] = this.name;
        data["givenName"] = this.givenName;
        data["surname"] = this.surname;
        data["emailAddress"] = this.emailAddress;
        data["isAccountLockedOut"] = this.isAccountLockedOut;
        data["enabled"] = this.enabled;
        return data;
    }
}

export interface IActiveDirectoryUserModel {
    guid?: string | undefined;
    samAccountName?: string | undefined;
    userPrincipalName?: string | undefined;
    name?: string | undefined;
    givenName?: string | undefined;
    surname?: string | undefined;
    emailAddress?: string | undefined;
    isAccountLockedOut?: boolean;
    enabled?: boolean | undefined;
}

export class ResetPasswordResponse implements IResetPasswordResponse {
    username?: string | undefined;

    constructor(data?: IResetPasswordResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.username = _data["username"];
        }
    }

    static fromJS(data: any): ResetPasswordResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ResetPasswordResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["username"] = this.username;
        return data;
    }
}

export interface IResetPasswordResponse {
    username?: string | undefined;
}

export class ResetPasswordCommand implements IResetPasswordCommand {
    hash?: string | undefined;
    password?: string | undefined;

    constructor(data?: IResetPasswordCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.hash = _data["hash"];
            this.password = _data["password"];
        }
    }

    static fromJS(data: any): ResetPasswordCommand {
        data = typeof data === 'object' ? data : {};
        let result = new ResetPasswordCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["hash"] = this.hash;
        data["password"] = this.password;
        return data;
    }
}

export interface IResetPasswordCommand {
    hash?: string | undefined;
    password?: string | undefined;
}

export class RequestPasswordResetResponse implements IRequestPasswordResetResponse {
    emailAddress?: string | undefined;

    constructor(data?: IRequestPasswordResetResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.emailAddress = _data["emailAddress"];
        }
    }

    static fromJS(data: any): RequestPasswordResetResponse {
        data = typeof data === 'object' ? data : {};
        let result = new RequestPasswordResetResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["emailAddress"] = this.emailAddress;
        return data;
    }
}

export interface IRequestPasswordResetResponse {
    emailAddress?: string | undefined;
}

export class RequestPasswordResetCommand implements IRequestPasswordResetCommand {
    username?: string | undefined;

    constructor(data?: IRequestPasswordResetCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.username = _data["username"];
        }
    }

    static fromJS(data: any): RequestPasswordResetCommand {
        data = typeof data === 'object' ? data : {};
        let result = new RequestPasswordResetCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["username"] = this.username;
        return data;
    }
}

export interface IRequestPasswordResetCommand {
    username?: string | undefined;
}

export class QrCodeSetupModel implements IQrCodeSetupModel {
    qrCodeSetupImageUrl?: string;
    manualEntryKey?: string;

    constructor(data?: IQrCodeSetupModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.qrCodeSetupImageUrl = _data["qrCodeSetupImageUrl"];
            this.manualEntryKey = _data["manualEntryKey"];
        }
    }

    static fromJS(data: any): QrCodeSetupModel {
        data = typeof data === 'object' ? data : {};
        let result = new QrCodeSetupModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["qrCodeSetupImageUrl"] = this.qrCodeSetupImageUrl;
        data["manualEntryKey"] = this.manualEntryKey;
        return data;
    }
}

export interface IQrCodeSetupModel {
    qrCodeSetupImageUrl?: string;
    manualEntryKey?: string;
}

export class PinRequestModel implements IPinRequestModel {
    key?: string;

    constructor(data?: IPinRequestModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.key = _data["key"];
        }
    }

    static fromJS(data: any): PinRequestModel {
        data = typeof data === 'object' ? data : {};
        let result = new PinRequestModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["key"] = this.key;
        return data;
    }
}

export interface IPinRequestModel {
    key?: string;
}

export class VehicleModel implements IVehicleModel {
    id?: number;
    regNumber?: string | undefined;
    trackingId?: string | undefined;
    unitType?: string | undefined;
    lastRXDate?: Date;
    lastLatitude?: number | undefined;
    lastLongitude?: number | undefined;
    latestLatitude?: number | undefined;
    latestLongitude?: number | undefined;
    latestPositionDateTime?: Date | undefined;

    constructor(data?: IVehicleModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.regNumber = _data["regNumber"];
            this.trackingId = _data["trackingId"];
            this.unitType = _data["unitType"];
            this.lastRXDate = _data["lastRXDate"] ? new Date(_data["lastRXDate"].toString()) : <any>undefined;
            this.lastLatitude = _data["lastLatitude"];
            this.lastLongitude = _data["lastLongitude"];
            this.latestLatitude = _data["latestLatitude"];
            this.latestLongitude = _data["latestLongitude"];
            this.latestPositionDateTime = _data["latestPositionDateTime"] ? new Date(_data["latestPositionDateTime"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): VehicleModel {
        data = typeof data === 'object' ? data : {};
        let result = new VehicleModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["regNumber"] = this.regNumber;
        data["trackingId"] = this.trackingId;
        data["unitType"] = this.unitType;
        data["lastRXDate"] = this.lastRXDate ? this.lastRXDate.toISOString() : <any>undefined;
        data["lastLatitude"] = this.lastLatitude;
        data["lastLongitude"] = this.lastLongitude;
        data["latestLatitude"] = this.latestLatitude;
        data["latestLongitude"] = this.latestLongitude;
        data["latestPositionDateTime"] = this.latestPositionDateTime ? this.latestPositionDateTime.toISOString() : <any>undefined;
        return data;
    }
}

export interface IVehicleModel {
    id?: number;
    regNumber?: string | undefined;
    trackingId?: string | undefined;
    unitType?: string | undefined;
    lastRXDate?: Date;
    lastLatitude?: number | undefined;
    lastLongitude?: number | undefined;
    latestLatitude?: number | undefined;
    latestLongitude?: number | undefined;
    latestPositionDateTime?: Date | undefined;
}

export class VehicleRegistrationLookupModel implements IVehicleRegistrationLookupModel {
    carrierName?: string | undefined;
    plateNumber?: string | undefined;
    provider?: string | undefined;

    constructor(data?: IVehicleRegistrationLookupModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.carrierName = _data["carrierName"];
            this.plateNumber = _data["plateNumber"];
            this.provider = _data["provider"];
        }
    }

    static fromJS(data: any): VehicleRegistrationLookupModel {
        data = typeof data === 'object' ? data : {};
        let result = new VehicleRegistrationLookupModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["carrierName"] = this.carrierName;
        data["plateNumber"] = this.plateNumber;
        data["provider"] = this.provider;
        return data;
    }
}

export interface IVehicleRegistrationLookupModel {
    carrierName?: string | undefined;
    plateNumber?: string | undefined;
    provider?: string | undefined;
}

export class VehicleTypesSpeedModel implements IVehicleTypesSpeedModel {
    id?: number;
    transitTimes?: string | undefined;
    speed?: number;
    type?: number;

    constructor(data?: IVehicleTypesSpeedModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.transitTimes = _data["transitTimes"];
            this.speed = _data["speed"];
            this.type = _data["type"];
        }
    }

    static fromJS(data: any): VehicleTypesSpeedModel {
        data = typeof data === 'object' ? data : {};
        let result = new VehicleTypesSpeedModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["transitTimes"] = this.transitTimes;
        data["speed"] = this.speed;
        data["type"] = this.type;
        return data;
    }
}

export interface IVehicleTypesSpeedModel {
    id?: number;
    transitTimes?: string | undefined;
    speed?: number;
    type?: number;
}

export interface FileResponse {
    data: Blob;
    status: number;
    fileName?: string;
    headers?: { [name: string]: any };
}

export class SwaggerException extends Error {
    message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isSwaggerException = true;

    static isSwaggerException(obj: any): obj is SwaggerException {
        return obj.isSwaggerException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): Observable<any> {
    if (result !== null && result !== undefined)
        return _observableThrow(result);
    else
        return _observableThrow(new SwaggerException(message, status, response, headers, null));
}

function blobToText(blob: any): Observable<string> {
    return new Observable<string>((observer: any) => {
        if (!blob) {
            observer.next("");
            observer.complete();
        } else {
            let reader = new FileReader();
            reader.onload = event => {
                observer.next((event.target as any).result);
                observer.complete();
            };
            reader.readAsText(blob);
        }
    });
}